import {makeArr, MS_DAY} from '../tools/CommonJS';
import {isTalDemo} from './AppContext';
import {HA_topics, HA_Remedies}  from './MisconData';
import {actionDefsArr, activeStateDefsOpts, actionOptsDefs, metricOptsDefs} from './ActionData';
import {Benchmark_cisProfiles, Benchmark_topics, Comp_remedies} from './BenchmarkData';
import {c_accessFull, c_accessView} from './CommonUIData';
import {netscanMock} from './mocks/NetscanMock';
import type {Mocks} from './MockDataTypes';
import type {ClientUpdateListResponseItem} from '../api/models/client-update-list-response-item';
import type {AnalyzerServicesV2MisconGroupTopicGraphItem} from '../api/models/analyzer-services-v2-miscon-group-topic-graph-item';

/* global setTimeout */  // This file is excluded from the browser-globals eslint block (see eslint.config.js ignores).

export const mockData = {} as Mocks;

if (import.meta.env.VITE_ENV === 'dev') {
	// A page of rows, for the mocks whose call site did not ask for a length.
	const PAGE_LEN = 100;

	// Attack Surface (Network Scanner) alt fallbacks — served on demo tenants (isTalDemo) and dev builds, until the backend read handlers return live data.
	mockData.netscanDiscoveryOverview = netscanMock.discoveryOverview;
	mockData.netscanTargetOverview = netscanMock.targetOverview;
	mockData.netscanOverview = netscanMock.overview;
	mockData.netscanScanners = netscanMock.scanners;
	mockData.netscanTargets = netscanMock.targetsList;
	mockData.netscanCreateTarget = netscanMock.createTarget;
	mockData.netscanEditTarget = netscanMock.editTarget;
	mockData.netscanDeleteTarget = netscanMock.deleteTarget;
	mockData.netscanStartScan = netscanMock.startScan;
	mockData.netscanEditScan = netscanMock.editScan;
	mockData.netscanDeactivateScan = netscanMock.deactivateScan;
	mockData.netscanActivateScan = netscanMock.activateScan;
	mockData.netscanDeleteScan = netscanMock.deleteScan;
	mockData.netscanScanResults = netscanMock.scanResults;
	mockData.netscanCombiField = netscanMock.combiField;
	mockData.netscanUnmanagedDevice = netscanMock.unmanagedDevice;
	mockData.netscanRemoveScanner = netscanMock.removeScanner;
	mockData.netscanDeployableDevices = netscanMock.deployableDevices;
	mockData.netscanDeployScanner = netscanMock.deployScanner;
	mockData.netscanHistory = netscanMock.history;
	mockData.netscanHistoryCombiField = netscanMock.historyCombiField;
    //End of Attack Surface

	mockData.groupsInfo = ({groupId}) =>
		groupId === 1002? {'log':[{'byUser':{'user':'GYTPOL', 'userName':null, 'title':null}, 'date':'2024-10-06T07:53:33.999475Z', 'operation':'create'}], 'usedBy':[{'actionType':'clientUpdate', 'id':35, 'isActive':true}], 'criterias':[{'criteriaId':9, 'criteria':{'isExactComputerOu':false, 'isExactOs':false, 'ungrouped':false, 'selTarget':'server', 'domain':null, 'computerOu':null, 'device':null, 'os':null, 'ip':null, 'isListExclude':false, 'list':null, 'listIds':null, 'isCriteriaExclude':false, 'groupId':0, 'socket':null, 'recalc':0, 'from':0, 'len':0, 'exportName':null}, 'totalDevices':6}]} :
			groupId === 5? {
'log':[{'byUser':{'user':'g@acme.com', 'userName':null, 'title':null}, 'date':'2023-11-11T20:25:52.99233Z', 'operation':'create'}],
'usedBy':[],
'criterias':[
{
'criteriaId':651,
'criteria':{
'isExactComputerOu':false,
'isExactOs':false,
'ungrouped':false,
'selTarget':null,
'domain':null,
'computerOu':null,
'device':null,
'os':null,
'ip':null,
'isListExclude':false,
'list':[
'SERVER-2008-4',
'SERVER-2022',
'GYTPOLQA-SQL',
'DC2022',
'GYTPOL',
'SERVER2019',
'SERVER-SPLUNK',
'FRUSMAN-DC01',
'QA-SELENIUM',
'GYTPOLQA-DC',
'SERVER-2016',
'SERVER-2008-2',
'GYTPOLSERVER-QA',
'SERVER-2012'
],
'listIds':null,
'isCriteriaExclude':false,
'groupId':0,
'socket':null,
'recalc':0,
'from':0,
'len':0,
'exportName':null
},
'totalDevices':1
}
]
} :
				groupId === 6? {
'log': [
{'byUser': {'user': 'g@acme.com', 'userName': null, 'title': null}, 'date': '2024-04-21T09:05:07.028459Z', 'operation': 'create'},
{'byUser': {'user': 'g@acme.com', 'userName': null, 'title': null}, 'date': '2024-04-21T09:05:45.90787Z', 'operation': 'update'},
{'byUser': {'user': 'a@acme.com', 'userName': null, 'title': null}, 'date': '2024-05-16T08:57:04.352841Z', 'operation': 'update'}
],
'usedBy': [{'actionType': 'clientUpdate', 'id': 69, 'isActive': false}],
'criterias': [
{'criteriaId': 313, 'criteria': {'isExactComputerOu':false, 'isExactOs':false, 'ungrouped':false, 'selTarget': null, 'domain': null, 'computerOu': null, 'device': null, 'os': null, 'ip': '192.168.0', 'isListExclude': true, 'list': [], 'listIds': [], 'isCriteriaExclude': false, 'groupId': 0, 'socket': null, 'recalc': 0, 'from': 0, 'len': 0, 'exportName': null}, 'totalDevices': 11},
{
'criteriaId': 359,
'criteria': {
'isExactComputerOu':false,
'isExactOs':false,
'ungrouped':false,
'selTarget': null,
'domain': null,
'computerOu': null,
'device': null,
'os': null,
'ip': null,
'isListExclude': false,
'list': [
'GYTPOL',
'WIN10',
'WINDOWS72'
],
'listIds': [565],
'isCriteriaExclude': false,
'groupId': 0,
'socket': null,
'recalc': 0,
'from': 0,
'len': 0,
'exportName': null
},
'totalDevices': 4
}
]
} :
					{log: [], usedBy: [], criterias: []};       // Any other group: nothing recorded against it.

	mockData.generalCombiDevices = () => ({
'data':[
{'device':'ARIE-CENTOS', 'deviceId': 9001, 'deviceGuid':'18694d56-6e1e-f2d5-991f-7c863ac852a7', 'os':'Centos 8', 'clientVer':'1.19.1.19', 'scanTime':'2024-06-14T08:49:53Z', 'computerOu':'', 'ip':'192.168.111.135', 'mac':'00:0c:29:c8:52:a7', 'hwInfo':{'HW_CPU':'2 X 12th Gen Intel(R) Core(TM) i5-1235U', 'HW_Model':'154', 'HW_RAM':'1'}},
{'device':'GYTPOL', 'deviceId': 9002, 'deviceGuid':'c671e238-3417-4f19-95a8-d6c8acf8e501', 'os':'Win Server 2022 Standard', 'clientVer':'2.33.5.0', 'scanTime':'2024-06-13T07:33:19.859108Z', 'computerOu':'CN=GYTPOL/Frusman Services', 'ip':'192.168.111.128', 'mac':null, 'hwInfo':{'HW_CPU':'8 x 12th Gen Intel(R) Core(TM) i5-1235U', 'HW_Model':'VMware, Inc. VMware7,1', 'HW_RAM':'4'}},
{'device':'GYTPOLQA-DC', 'deviceId': 9003, 'deviceGuid':'bc3dead4-3e30-4ea1-9bfc-faaa681e926e', 'os':'Win Server 2019 Datacenter', 'clientVer':'2.33.4.0', 'scanTime':'2024-06-14T10:36:19.151001Z', 'computerOu':'Domain Controllers', 'ip':'192.168.0.100', 'mac':null, 'hwInfo':{'HW_CPU':null, 'HW_Model':null, 'HW_RAM':null}},
{'device':'GYTPOLQA-SQL', 'deviceId': 9004, 'deviceGuid':'a1500700-49ec-44bb-9738-b45f67e1134f', 'os':'Win Server 2019 Datacenter', 'clientVer':'2.33.3.0', 'scanTime':'2024-06-05T11:11:55.451845Z', 'computerOu':'Server', 'ip':'192.168.0.104', 'mac':null, 'hwInfo':{'HW_CPU':'1 x Intel(R) Xeon(R) Platinum 8370C CPU @ 2.80GHz', 'HW_Model':'Microsoft Corporation Virtual Machine', 'HW_RAM':'2'}},
{'device':'GYTPOLSERVER-QA', 'deviceId': 9005, 'deviceGuid':'907bb42b-1c16-4991-8dfb-540a53a4690f', 'os':'Win Server 2019 Datacenter', 'clientVer':'2.33.3.0', 'scanTime':'2024-06-14T06:26:41.068351Z', 'computerOu':'Server', 'ip':'192.168.0.101', 'mac':null, 'hwInfo':{'HW_CPU':'1 x Intel(R) Xeon(R) Platinum 8370C CPU @ 2.80GHz', 'HW_Model':'Microsoft Corporation Virtual Machine', 'HW_RAM':'2'}},
{'device':'REDHAT-SAAS', 'deviceId': 9006, 'deviceGuid':'113f7ce8-849e-9d4a-9523-7ae8f87b875b', 'os':'Redhat 9.0', 'clientVer':'1.19.1.19', 'scanTime':'2024-06-14T09:23:00Z', 'computerOu':'', 'ip':'N/A', 'mac':'N/A', 'hwInfo':{'HW_CPU':'1 X Intel(R) Xeon(R) Platinum 8370C CPU @ 2.80GHz', 'HW_Model':'106', 'HW_RAM':'1'}},
{'device':'SERVER-2008-4', 'deviceId': 9007, 'deviceGuid':'6f062eb9-97fc-433c-9e2b-22556ce26a4d', 'os':'Win Server 2008 R2 Standard ', 'clientVer':'2.33.5.0', 'scanTime':'2024-06-14T09:28:40.410145Z', 'computerOu':'Server', 'ip':'192.168.0.116', 'mac':null, 'hwInfo':{'HW_CPU':'1 x Intel(R) Xeon(R) Platinum 8370C CPU @ 2.80GHz', 'HW_Model':'Microsoft Corporation Virtual Machine', 'HW_RAM':'2'}},
{'device':'SERVER-2016', 'deviceId': 9008, 'deviceGuid':'f1a1a010-a1ee-4847-95cf-622ea3ef6dc8', 'os':'Win Server 2016 Standard', 'clientVer':'2.33.5.0', 'scanTime':'2024-06-14T08:22:01.363248Z', 'computerOu':'Endpoints-Windows', 'ip':'192.168.0.113', 'mac':null, 'hwInfo':{'HW_CPU':'1 x Intel(R) Xeon(R) Platinum 8370C CPU @ 2.80GHz', 'HW_Model':'Microsoft Corporation Virtual Machine', 'HW_RAM':'2'}},
{'device':'SERVER-SPLUNK', 'deviceId': 9009, 'deviceGuid':'25e56cc1-64f3-4630-b742-dc04892c28fe', 'os':'Win Server 2019 Datacenter', 'clientVer':'2.33.5.0', 'scanTime':'2024-06-14T07:15:52.531331Z', 'computerOu':'CN=SERVER-SPLUNK/Server', 'ip':'192.168.0.117', 'mac':null, 'hwInfo':{'HW_CPU':'1 x Intel(R) Xeon(R) Platinum 8370C CPU @ 2.80GHz', 'HW_Model':'Microsoft Corporation Virtual Machine', 'HW_RAM':'2'}},
{'device':'STORSVC', 'deviceId': 9010, 'deviceGuid':'aadceac2-e161-4ee9-849c-9e7a743429a7', 'os':'Win 10 Enterprise', 'clientVer':'2.33.5.0', 'scanTime':'2024-06-05T11:35:41.755831Z', 'computerOu':'CN=STORSVC/CN=Computers', 'ip':'192.168.111.133', 'mac':null, 'hwInfo':{'HW_CPU':'4 x 12th Gen Intel(R) Core(TM) i5-1235U', 'HW_Model':'VMware, Inc. VMware7,1', 'HW_RAM':'4'}},
{'device':'SUSE', 'deviceId': 9011, 'deviceGuid':'e9281b57-184e-5a49-9eb0-d92ebededabd', 'os':'Sles 15-SP5', 'clientVer':'1.19.1.17', 'scanTime':'2024-06-14T07:35:00Z', 'computerOu':'', 'ip':'192.168.0.120', 'mac':'00:15:5d:00:04:26', 'hwInfo':{'HW_CPU':'1 X Intel(R) Xeon(R) Platinum 8370C CPU @ 2.80GHz', 'HW_Model':'106', 'HW_RAM':'1'}},
{'device':'UBUNTU24', 'deviceId': 9012, 'deviceGuid':'c19b06b9-2fc2-1a4d-a2a7-9dec163dc4cd', 'os':'Ubuntu 24.04', 'clientVer':'1.19.1.19', 'scanTime':'2024-06-14T07:23:56Z', 'computerOu':'', 'ip':'192.168.0.119', 'mac':'00:15:5d:00:04:25', 'hwInfo':{'HW_CPU':'1 X Intel(R) Xeon(R) Platinum 8370C CPU @ 2.80GHz', 'HW_Model':'106', 'HW_RAM':'1'}},
{'device':'WIN10', 'deviceId': 9013, 'deviceGuid':'06e2dd34-424f-4552-a1a6-97321f9fcf28', 'os':'Win 10 Enterprise', 'clientVer':'2.33.3.0', 'scanTime':'2024-06-02T09:23:39.716012Z', 'computerOu':'Endpoints-Windows', 'ip':'192.168.0.105', 'mac':null, 'hwInfo':{'HW_CPU':'1 x Intel(R) Xeon(R) Platinum 8370C CPU @ 2.80GHz', 'HW_Model':'Microsoft Corporation Virtual Machine', 'HW_RAM':'2'}},
{'device':'WIN11', 'deviceId': 9014, 'deviceGuid':'4d266922-6ebc-423a-a4b6-d3c4ad0294ce', 'os':'Win 11 Education N', 'clientVer':'2.33.5.0', 'scanTime':'2024-06-13T19:22:36.848778Z', 'computerOu':'CN=Computers', 'ip':'192.168.0.109', 'mac':null, 'hwInfo':{'HW_CPU':'2 x Intel(R) Xeon(R) Platinum 8370C CPU @ 2.80GHz', 'HW_Model':'Microsoft Corporation Virtual Machine', 'HW_RAM':'2'}},
{'device':'WINDOWS7', 'deviceId': 9015, 'deviceGuid':'c218fad9-2922-4f42-989b-1cf40098f6c0', 'os':'Win 7 Enterprise ', 'clientVer':'2.33.5.0', 'scanTime':'2024-06-13T18:24:41.020861Z', 'computerOu':'Endpoints-Windows', 'ip':'192.168.0.103', 'mac':null, 'hwInfo':{'HW_CPU':'1 x Intel(R) Xeon(R) Platinum 8370C CPU @ 2.80GHz', 'HW_Model':'Microsoft Corporation Virtual Machine', 'HW_RAM':'2'}},
{'device':'YURY’S MACBOOK PRO', 'deviceId': 9016, 'deviceGuid':'924948ec-0d01-57d2-9e54-fca1f021b2bd', 'os':'macOS 14.2.1', 'clientVer':'1.17.1.15', 'scanTime':'2024-06-03T09:25:00Z', 'computerOu':'', 'ip':'10.0.0.27', 'mac':'6c:7e:67:c4:18:08', 'hwInfo':{'HW_CPU':'N/A', 'HW_Model':'N/A', 'HW_RAM':'16'}}
],
'rowCount':16
});
	mockData.fieldApi = comb => req => ({data: makeArr(req.len ?? PAGE_LEN).map(i => `${comb.h} ${(req.from ?? 0) + i}`), [req.api !== '/api/v2/actions_combi-field'? 'deviceIds' : 'deviceGuid']: makeArr(req.len ?? PAGE_LEN).map(i => `GUID-${(req.from ?? 0) + i}`), paramExtra: makeArr(100).map(i => 'param' + i), rowCount: 203});
	mockData.fieldApiClientVer = () => ({
data: [
'1.15.1.13',
'2.31.8.0',
'2.31.8.0',
'1.15.1.13',
'1.15.1.13',
'1.23.1224.0',
'2.31.6.0',
'2.31.4.0',
'1.14.1.13',
'1.14.1.11',
'2.31.1.0',
'1.14.1.11'
],
rowCount: 12
});
	mockData.fieldApiActionDatum = () => ({data: Object.keys(actionOptsDefs)});
	mockData.fieldApiTopicCodes = () => ({data: Object.keys(metricOptsDefs)});
	mockData.fieldApiOsVer = () => ({
data: [
'Windows 95 (Build 950)',
'Windows 2000 Professional (Build 2195)',
'Windows 7 Ultimate (Build 7600/7601 for SP1)',
'Windows 11 Pro (Build 22000)'
]
});
	mockData.fieldApiBenchmarkProfile = () => ({
'data': [
'xccdf_org.cisecurity.benchmarks_profile_Level_1_L1_-_CorporateEnterprise_Environment_general_use',
'xccdf_org.cisecurity.benchmarks_profile_Level_2_L2_-_High_SecuritySensitive_Data_Environment_limited_functionality'
],
'paramExtra': null,
'rowCount': 2
});

	// One key behind /api/v2/devices_combi-list-${module}: the device columns are shared, the
	// module payload is not, so each module gets its own response.
	mockData.devicesCombiList = req => {
		const alerts = (n: number, max: number) => makeArr(n).map(() => Math.random() > 0.85 ? 0 : Math.random()*max |0);
        // Spelled out rather than mapped over statsBarDefs, which also holds the mute and
        // approval buckets the payload keeps outside taskStatusCounts.
		const taskCounts = () => {
			const n = () => Math.random() > 0.6 ? Math.random()*1e4 |0 : 0;
			return {
pending: n(),
				success: n(),
				reverting: n(),
				reverted: n(),
				cancelled: n(),
				failed: n(),
				revertCancelled: n(),
				revertFailed: n()
};
		};
		const row = (i: number) => ({
			device: `Device ${(req.from ?? 0) + i}`,
			deviceId: (req.from ?? 0) + i + 1,
			pendingReboot: !(i % 7),
			clientVer: '22.1.7',
			lastConnectedUserName: i % 3 ? undefined : 'renee',
			os: 'Windows 11 Pro',
			ip: '223.11.34.150',
			mac: 'f4:60:e2:a3:f8:ce',
			scanTime: '2024-05-24T06:21:00.188624Z',
			sumItMins: +(Math.random() < 0.8) * Math.random()*1e5 |0
		});
		const idxs = makeArr(req.len), rowCount = 1000;
		switch ((req.api ?? '').afterLast('-')) {
			case 'activity':
				return {
rowCount,
					data: idxs.map(i => ({
...row(i),
						activity: {
							registrationDate: new Date(Date.now() - Math.random() * 365 * MS_DAY).toISOString(),
							isActive: Math.random() > 0.8,
							isDecommissioned: Math.random() > 0.8,
							isRecurring: Math.random() > 0.8
						}
}))
};
			case 'appcontrol':
				return {
rowCount,
					data: idxs.map(i => ({
...row(i),
						appcontrol: Math.random() < 0.15
							? {applications: Math.random()*1e3 |0}
							: {applications: Math.random()*1e3 |0, alerts: alerts(3, 1e3)}
}))
};
			case 'vuln':
				return {rowCount, data: idxs.map(i => ({...row(i), vuln: {alerts: alerts(3, 1e3)}}))};
			case 'patch':
				return {rowCount, data: idxs.map(i => ({...row(i), patch: {alerts: alerts(3, 100)}}))};
			case 'benchmark':
				return {rowCount, data: idxs.map(i => ({...row(i), benchmark: {alerts: alerts(2, 1e5)}}))};
			case 'actions':
				return {
rowCount,
					data: idxs.map(i => ({
...row(i),
						actions: {
							mute: Math.random()*100 |0,
							pendingApproval: Math.random()*10 |0,
							taskStatusCounts: taskCounts()
						}
}))
};
			default:
				return {rowCount, data: idxs.map(i => ({...row(i), miscon: {alerts: alerts(3, 1e5)}}))};
		}
	};

	mockData.deviceGetInfo = () => ({'domain': 'alpha.gytpol.com', 'computerOu': 'Endpoints-Windows', 'os': 'Win Server 2022 Datacenter', 'ip': '192.168.226.29', 'mac': '1d:1d:1d:1d:1d:1d', 'hwInfo': {'HW_CPU': '2 X 12th Gen Intel(R) Core(TM) i7-1285G7 @ 2.00GHz', 'HW_Model': 'Latitude 5029', 'HW_RAM': '4GB'}, 'scanTime': '2025-11-03T16:02:23.47692Z'});

	mockData.patchManagementDevices = (req: {from?: number, len?: number} = {}) => {
		const base = [
			{device: 'WIN-PROD-01', deviceId: 9001, severity: 'Installed', alertsBad: 0, mutedAlerts: 2, lastConnectedUserName: 'admin'},
			{device: 'WIN-PROD-02', deviceId: 9002, severity: 'Critical', alertsBad: 1, lastConnectedUserName: 'jsmith'},
			{device: 'WIN-PROD-03', deviceId: 9003, severity: 'Critical', alertsBad: 1, mutedAlerts: 5},
			{device: 'WIN-PROD-04', deviceId: 9004, severity: 'Installed', alertsBad: 0, lastConnectedUserName: 'mwilliams'},
			{device: 'WIN-PROD-05', deviceId: 9005, severity: 'Medium', alertsBad: 1, mutedAlerts: 3, lastConnectedUserName: 'jdoe'}
		].map((d, i) => ({
			...d,
			alertsOk: d.alertsBad ? 0 : 1,
			alertsNew: 0,
			repeated: 0,
			pending: 0,
			remediable: d.alertsBad,
			patchable: !!d.alertsBad,
			hasReversible: true,
			mutedAlerts: d.mutedAlerts ?? 0,
			lastScan: new Date(Date.now() - (i + 1) * 7 * MS_DAY).toISOString()
		}));
		const from = req.from ?? 0, len = req.len ?? PAGE_LEN;
		return {data: base.slice(from, from + len), rowCount: base.length, severitiesTotal: {Critical: 2, Medium: 1, Low: 0, Installed: 2}};
	};
	mockData.patchManagementInfo = () => ({
		description: '2024-03 Cumulative Update for Windows 11 22H2 x64 — 3 zero-day exploits patched, apply immediately',
		category: 'Cumulative Update',
		severity: 'Critical',
		source: 'Microsoft Update',
		rebootRequired: true,
		releaseDate: '2024-03-12T00:00:00Z'
	});

	mockData.deviceInformation = () => ({
'deviceInfo': {
'deviceId': 210,
'isDecommissioned': false,
'hostname': 'DEBIAN11',
'OS': 'Debian 11.11',
'IP': '192.168.0.109',
'lastConnectedUserName': null,
'lastReport': '2024-11-18T10:59:08Z',
'groupMembership': [
{'groupId': 210, 'groupName': 'Any'},
{'groupId': 1010, 'groupName': 'Debian Linux'},
{'groupId': 565, 'groupName': 'cis group save as a grpup'}
],
'clientVersion': '1.28.1.25',
'isVDI': false,
'orgUnit': '',
'lastRemediation': '2024-11-12T10:58:53.653898Z',
'labels': null,
'metadata': {'UserScanTimes': null, DomainName: 'a.localeasmin', 'RsopRepositoryId': 0, 'PowershellVersion': '', 'IsVdi': false, 'LastConnectedUserName': null, 'IpAddress': '192.168.0.109', 'Os': 'Debian 11.11', 'OsFamily': 1, 'OsDistroFamily': 1, 'ComputerName': 'DEBIAN11', 'ComputerOu': '', 'MacAddress': '00:15:5d:00:04:0d', 'HW_CPU': '1 X Intel(R) Xeon(R) CPU E5-2673 v4 @ 2.30GHz', 'HW_Model': 'Virtual Machine', 'HW_RAM': '1', 'IsServer': false, 'IsCloud': false, 'IsVpn': false, 'IsDC': false, 'IsRemote': false, 'AgentUuid': '71b026ba-7e48-49e8-87a2-a8654febdf5f'}
},
'deviceMiscon': {
'high': {'gytAptMissingSecurityRepositories': 1, 'gytGshadowPerm': 1, 'gytPtrace': 1, 'gytShadowPerm': 1, 'gytSwap': 1},
'medium': {'gytAvahi': 1, 'gytCronDirsPerm': 5, 'gytCronTabPerm': 1, 'gytFirewall': 1, 'gytHomePerm': 1, 'gytPasswordsUserInactiveDays': 2, 'gytPasswordsUserMaxDays': 2, 'gytPasswordsUserMinDays': 2, 'gytSGID': 6, 'gytSudoNotLogIO': 1, 'gytSudoNotUsePty': 1, 'gytSUID': 22},
'low': {},
'passed': {'gytGroupPerm': 1, 'gytHostsPerm': 1, 'gytPasswdPerm': 1, 'gytPasswordsUserWarnAge': 2, 'gytSudoersPerm': 2, 'gytSudoNotUseSecurePath': 1},
'graph': [
{'date': '2024-09-04T00:00:38.093112Z', 'low': 0, 'medium': 46, 'high': 6, 'passed': 8},
{'date': '2024-09-05T00:00:52.121219Z', 'low': 0, 'medium': 46, 'high': 6, 'passed': 8},
{'date': '2024-09-06T00:00:44.482017Z', 'low': 0, 'medium': 46, 'high': 6, 'passed': 8},
{'date': '2024-09-07T00:00:28.186054Z', 'low': 0, 'medium': 46, 'high': 6, 'passed': 8},
{'date': '2024-09-08T00:00:43.485286Z', 'low': 0, 'medium': 46, 'high': 6, 'passed': 8},
{'date': '2024-09-09T00:01:11.925026Z', 'low': 0, 'medium': 46, 'high': 6, 'passed': 8},
{'date': '2024-09-10T00:03:19.157848Z', 'low': 0, 'medium': 46, 'high': 6, 'passed': 8},
{'date': '2024-09-11T00:00:46.073567Z', 'low': 0, 'medium': 46, 'high': 6, 'passed': 8},
{'date': '2024-09-12T00:00:36.134594Z', 'low': 0, 'medium': 46, 'high': 6, 'passed': 8},
{'date': '2024-09-13T00:01:14.427341Z', 'low': 0, 'medium': 46, 'high': 6, 'passed': 8},
{'date': '2024-09-14T00:00:31.436708Z', 'low': 0, 'medium': 46, 'high': 6, 'passed': 8},
{'date': '2024-09-15T00:01:09.332342Z', 'low': 0, 'medium': 46, 'high': 6, 'passed': 8},
{'date': '2024-09-16T00:00:32.71914Z', 'low': 0, 'medium': 46, 'high': 6, 'passed': 8},
{'date': '2024-09-17T00:00:48.341506Z', 'low': 0, 'medium': 46, 'high': 6, 'passed': 8},
{'date': '2024-09-18T00:00:41.167789Z', 'low': 0, 'medium': 46, 'high': 5, 'passed': 8},
{'date': '2024-09-19T00:00:34.928364Z', 'low': 0, 'medium': 46, 'high': 5, 'passed': 8},
{'date': '2024-09-20T00:00:30.722814Z', 'low': 0, 'medium': 46, 'high': 5, 'passed': 8},
{'date': '2024-09-21T00:01:24.822224Z', 'low': 0, 'medium': 46, 'high': 5, 'passed': 8},
{'date': '2024-09-22T00:00:33.027417Z', 'low': 0, 'medium': 46, 'high': 5, 'passed': 8},
{'date': '2024-09-23T00:01:14.131776Z', 'low': 0, 'medium': 46, 'high': 5, 'passed': 8},
{'date': '2024-09-24T00:01:22.538253Z', 'low': 0, 'medium': 46, 'high': 5, 'passed': 8},
{'date': '2024-09-25T00:01:25.542117Z', 'low': 0, 'medium': 46, 'high': 5, 'passed': 8},
{'date': '2024-09-26T00:01:20.230203Z', 'low': 0, 'medium': 46, 'high': 5, 'passed': 8},
{'date': '2024-09-27T00:01:50.621484Z', 'low': 0, 'medium': 46, 'high': 5, 'passed': 8},
{'date': '2024-09-28T00:01:25.424275Z', 'low': 0, 'medium': 46, 'high': 5, 'passed': 8},
{'date': '2024-09-29T00:01:20.062421Z', 'low': 0, 'medium': 46, 'high': 5, 'passed': 8},
{'date': '2024-09-30T00:00:36.930171Z', 'low': 0, 'medium': 46, 'high': 5, 'passed': 8},
{'date': '2024-10-01T00:00:39.129782Z', 'low': 0, 'medium': 46, 'high': 5, 'passed': 8},
{'date': '2024-10-02T00:00:38.832103Z', 'low': 0, 'medium': 46, 'high': 5, 'passed': 8},
{'date': '2024-10-03T00:00:35.15287Z', 'low': 0, 'medium': 46, 'high': 5, 'passed': 8},
{'date': '2024-10-04T00:01:09.057747Z', 'low': 0, 'medium': 46, 'high': 5, 'passed': 8},
{'date': '2024-10-05T00:00:31.750269Z', 'low': 0, 'medium': 46, 'high': 5, 'passed': 8},
{'date': '2024-10-06T00:01:48.934291Z', 'low': 0, 'medium': 46, 'high': 5, 'passed': 8},
{'date': '2024-10-07T00:01:15.225227Z', 'low': 0, 'medium': 46, 'high': 5, 'passed': 8},
{'date': '2024-10-08T00:01:17.233833Z', 'low': 0, 'medium': 45, 'high': 6, 'passed': 8},
{'date': '2024-10-09T00:01:50.527896Z', 'low': 0, 'medium': 45, 'high': 6, 'passed': 8},
{'date': '2024-10-10T00:02:13.520991Z', 'low': 0, 'medium': 45, 'high': 6, 'passed': 8},
{'date': '2024-10-11T00:01:50.141713Z', 'low': 0, 'medium': 45, 'high': 6, 'passed': 8},
{'date': '2024-10-12T00:01:21.92717Z', 'low': 0, 'medium': 45, 'high': 6, 'passed': 8},
{'date': '2024-10-13T00:01:13.544583Z', 'low': 0, 'medium': 45, 'high': 6, 'passed': 8},
{'date': '2024-10-14T00:01:28.030452Z', 'low': 0, 'medium': 45, 'high': 6, 'passed': 8},
{'date': '2024-10-15T00:01:34.623119Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-10-16T00:01:37.998273Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-10-17T00:02:07.014856Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-10-18T00:01:20.008426Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-10-19T00:01:27.301959Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-10-20T00:01:41.421029Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-10-21T00:01:35.91268Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-10-22T00:01:30.673846Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-10-23T00:01:31.214479Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-10-24T00:01:29.91357Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-10-25T00:01:27.85315Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-10-26T00:01:35.011715Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-10-27T00:01:27.198765Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-10-28T00:01:21.91466Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-10-29T00:01:31.972235Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-10-30T00:01:26.008456Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-10-31T00:01:22.815424Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-11-01T00:01:40.017661Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-11-02T00:01:43.504041Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-11-03T00:01:39.520987Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-11-04T00:02:38.238586Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-11-05T04:01:40.351109Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-11-06T04:01:21.255211Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-11-07T04:01:29.157068Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-11-08T04:00:58.913659Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-11-09T04:01:05.959982Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-11-10T04:00:46.130968Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-11-11T04:01:07.14601Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-11-12T04:01:08.074903Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-11-13T04:00:47.674026Z', 'low': 0, 'medium': 45, 'high': 7, 'passed': 8},
{'date': '2024-11-14T04:00:57.990075Z', 'low': 0, 'medium': 45, 'high': 6, 'passed': 8},
{'date': '2024-11-15T04:01:00.530527Z', 'low': 0, 'medium': 45, 'high': 6, 'passed': 8},
{'date': '2024-11-16T04:01:04.496688Z', 'low': 0, 'medium': 45, 'high': 6, 'passed': 8},
{'date': '2024-11-17T04:01:05.356773Z', 'low': 0, 'medium': 45, 'high': 6, 'passed': 8},
{'date': '2024-11-18T04:00:59.943198Z', 'low': 0, 'medium': 45, 'high': 6, 'passed': 8},
{'date': '2024-11-19T04:00:53.317553Z', 'low': 0, 'medium': 45, 'high': 6, 'passed': 8},
{'date': '2024-11-20T04:01:03.751856Z', 'low': 0, 'medium': 45, 'high': 6, 'passed': 8}
],
'itMinutes': 131
},
'deviceCompliance': {
'current': [
{
'benchmarkOrg': 'CIS',
'benchmakeName': 'CIS_Debian_Linux_11_STIG_Benchmark_v1.0.0-xccdf.xml',
'compliedCount': 0,
'notCompliedCount': 241,
'compliedTopics': [],
'notCompliedTopics': [
'Ensure_AIDE_is_installed',
'Ensure_AIDE_is_installed',
'Ensure_AIDE_is_installed',
'Ensure_AppArmor_is_installed',
'Ensure_AppArmor_is_installed',
'Ensure_Avahi_Server_is_not_installed',
'Ensure_Avahi_Server_is_not_installed',
'Ensure_CUPS_is_not_installed',
'Ensure_CUPS_is_not_installed',
'Ensure_Endpoint_Security_for_Linux_Threat_Prevention_is_installed',
'Ensure_GDM_automatic_mounting_of_removable_media_is_disabled',
'Ensure_GDM_automatic_mounting_of_removable_media_is_disabled',
'Ensure_GDM_autorun-never_is_enabled',
'Ensure_GDM_autorun-never_is_enabled',
'Ensure_GDM_autorun-never_is_not_overridden',
'Ensure_GDM_autorun-never_is_not_overridden',
'Ensure_GDM_disable-user-list_option_is_enabled',
'Ensure_GDM_disable-user-list_option_is_enabled',
'Ensure_GDM_disabling_automatic_mounting_of_removable_media_is_not_overridden',
'Ensure_GDM_disabling_automatic_mounting_of_removable_media_is_not_overridden',
'Ensure_GDM_login_banner_is_configured',
'Ensure_GDM_login_banner_is_configured',
'Ensure_GDM_screen_locks_cannot_be_overridden',
'Ensure_GDM_screen_locks_cannot_be_overridden',
'Ensure_GDM_screen_locks_when_the_user_is_idle',
'Ensure_GDM_screen_locks_when_the_user_is_idle',
'Ensure_GDM_screen_locks_when_the_user_is_idle',
'Ensure_GNOME_Display_Manager_is_removed',
'Ensure_IPv6_status_is_identified',
'Ensure_IPv6_status_is_identified',
'Ensure_PKI_local_cache_of_revocation_data',
'Ensure_Personal_Identity_Verification_credentials_are_electronically_verified',
'Ensure_SSH_is_installed_and_active',
'Ensure_a_nftables_table_exists',
'Ensure_a_nftables_table_exists',
'Ensure_actions_as_another_user_are_always_logged',
'Ensure_actions_as_another_user_are_always_logged',
'Ensure_address_space_layout_randomization_ASLR_is_enabled',
'Ensure_address_space_layout_randomization_ASLR_is_enabled',
'Ensure_all_AppArmor_Profiles_are_enforcing',
'Ensure_all_logfiles_have_appropriate_access_configured',
'Ensure_all_logfiles_have_appropriate_access_configured',
'Ensure_all_logfiles_have_appropriate_access_configured',
'Ensure_audit_backlog_limit_is_sufficient',
'Ensure_audit_log_files_are_mode_0600_or_more_restrictive',
'Ensure_audit_log_files_are_mode_0640_or_more_restrictive',
'Ensure_auditd_is_installed',
'Ensure_auditd_service_is_enabled_and_active',
'Ensure_auditing_for_processes_that_start_prior_to_auditd_is_enabled',
'Ensure_bluetooth_services_are_not_in_use',
'Ensure_bluetooth_services_are_not_in_use',
'Ensure_bogus_icmp_responses_are_ignored',
'Ensure_bogus_icmp_responses_are_ignored',
'Ensure_broadcast_icmp_requests_are_ignored',
'Ensure_broadcast_icmp_requests_are_ignored',
'Ensure_certificates_are_validated_by_constructing_a_certification_path_to_an_accepted_trust_anchor',
'Ensure_changes_to_system_administration_scope_sudoers_is_collected',
'Ensure_core_dumps_are_restricted',
'Ensure_core_dumps_are_restricted',
'Ensure_cryptographic_mechanisms_are_used_to_protect_the_integrity_of_audit_tools',
'Ensure_cryptographic_mechanisms_are_used_to_protect_the_integrity_of_audit_tools',
'Ensure_dccp_kernel_module_is_not_available',
'Ensure_default_user_shell_timeout_is_configured',
'Ensure_default_user_shell_timeout_is_configured',
'Ensure_discretionary_access_control_permission_modification_events_are_collected',
'Ensure_discretionary_access_control_permission_modification_events_are_collected',
'Ensure_dmesg_restrict_is_enabled',
'Ensure_etcsslcerts_only_contains_certificate_files_whose_sha256_fingerprint_match_the_fingerprint_of_DoD_PKI-established_certificate_authorities',
'Ensure_events_that_modify_date_and_time_information_are_collected',
'Ensure_events_that_modify_the_sudo_log_file_are_collected',
'Ensure_events_that_modify_the_sudo_log_file_are_collected',
'Ensure_events_that_modify_the_systems_Mandatory_Access_Controls_are_collected',
'Ensure_events_that_modify_the_systems_network_environment_are_collected',
'Ensure_events_that_modify_usergroup_information_are_collected',
'Ensure_file_deletion_events_by_users_are_collected',
'Ensure_freevxfs_kernel_module_is_not_available',
'Ensure_freevxfs_kernel_module_is_not_available',
'Ensure_hfs_kernel_module_is_not_available',
'Ensure_hfs_kernel_module_is_not_available',
'Ensure_hfsplus_kernel_module_is_not_available',
'Ensure_hfsplus_kernel_module_is_not_available',
'Ensure_icmp_redirects_are_not_accepted',
'Ensure_icmp_redirects_are_not_accepted',
'Ensure_ip6tables_firewall_rules_exist_for_all_open_ports',
'Ensure_ip6tables_firewall_rules_exist_for_all_open_ports',
'Ensure_ip6tables_loopback_traffic_is_configured',
'Ensure_ip6tables_loopback_traffic_is_configured',
'Ensure_ip_forwarding_is_disabled',
'Ensure_ip_forwarding_is_disabled',
'Ensure_iptables_default_deny_firewall_policy',
'Ensure_iptables_default_deny_firewall_policy',
'Ensure_iptables_firewall_rules_exist_for_all_open_ports',
'Ensure_iptables_firewall_rules_exist_for_all_open_ports',
'Ensure_iptables_loopback_traffic_is_configured',
'Ensure_iptables_loopback_traffic_is_configured',
'Ensure_iptables_packages_are_installed',
'Ensure_iptables_packages_are_installed',
'Ensure_ipv6_router_advertisements_are_not_accepted',
'Ensure_ipv6_router_advertisements_are_not_accepted',
'Ensure_jffs2_kernel_module_is_not_available',
'Ensure_jffs2_kernel_module_is_not_available',
'Ensure_kernel_module_loading_unloading_and_modification_is_collected',
'Ensure_kernel_module_loading_unloading_and_modification_is_collected',
'Ensure_local_interactive_user_home_directories_are_configured',
'Ensure_local_interactive_user_home_directories_are_configured',
'Ensure_local_login_warning_banner_is_configured_properly',
'Ensure_local_login_warning_banner_is_configured_properly',
'Ensure_login_and_logout_events_are_collected',
'Ensure_message_of_the_day_is_configured_properly',
'Ensure_message_of_the_day_is_configured_properly',
'Ensure_nftables_base_chains_exist',
'Ensure_nftables_base_chains_exist',
'Ensure_nftables_is_not_installed_with_iptables',
'Ensure_nftables_is_not_installed_with_iptables',
'Ensure_nftables_loopback_traffic_is_configured',
'Ensure_nftables_loopback_traffic_is_configured',
'Ensure_nftables_service_is_enabled',
'Ensure_nftables_service_is_enabled',
'Ensure_nodev_option_set_on_home_partition',
'Ensure_nodev_option_set_on_home_partition',
'Ensure_nodev_option_set_on_tmp_partition',
'Ensure_nodev_option_set_on_tmp_partition',
'Ensure_nodev_option_set_on_var_partition',
'Ensure_nodev_option_set_on_var_partition',
'Ensure_nodev_option_set_on_varlog_partition',
'Ensure_nodev_option_set_on_varlog_partition',
'Ensure_nodev_option_set_on_varlogaudit_partition',
'Ensure_nodev_option_set_on_varlogaudit_partition',
'Ensure_nodev_option_set_on_vartmp_partition',
'Ensure_nodev_option_set_on_vartmp_partition',
'Ensure_noexec_option_set_on_devshm_partition',
'Ensure_noexec_option_set_on_devshm_partition',
'Ensure_noexec_option_set_on_tmp_partition',
'Ensure_noexec_option_set_on_tmp_partition',
'Ensure_noexec_option_set_on_varlog_partition',
'Ensure_noexec_option_set_on_varlog_partition',
'Ensure_noexec_option_set_on_varlogaudit_partition',
'Ensure_noexec_option_set_on_varlogaudit_partition',
'Ensure_noexec_option_set_on_vartmp_partition',
'Ensure_noexec_option_set_on_vartmp_partition',
'Ensure_nosuid_option_set_on_home_partition',
'Ensure_nosuid_option_set_on_home_partition',
'Ensure_nosuid_option_set_on_tmp_partition',
'Ensure_nosuid_option_set_on_tmp_partition',
'Ensure_nosuid_option_set_on_var_partition',
'Ensure_nosuid_option_set_on_var_partition',
'Ensure_nosuid_option_set_on_varlog_partition',
'Ensure_nosuid_option_set_on_varlog_partition',
'Ensure_nosuid_option_set_on_varlogaudit_partition',
'Ensure_nosuid_option_set_on_varlogaudit_partition',
'Ensure_nosuid_option_set_on_vartmp_partition',
'Ensure_nosuid_option_set_on_vartmp_partition',
'Ensure_only_authorized_groups_own_audit_log_files',
'Ensure_only_authorized_groups_own_audit_log_files',
'Ensure_only_authorized_users_own_audit_log_files',
'Ensure_only_authorized_users_own_audit_log_files',
'Ensure_overlayfs_kernel_module_is_not_available',
'Ensure_overlayfs_kernel_module_is_not_available',
'Ensure_packet_redirect_sending_is_disabled',
'Ensure_packet_redirect_sending_is_disabled',
'Ensure_permissions_on_bootloader_config_are_configured',
'Ensure_permissions_on_bootloader_config_are_configured',
'Ensure_permissions_on_etccrontab_are_configured',
'Ensure_permissions_on_etccrontab_are_configured',
'Ensure_ptrace_scope_is_restricted',
'Ensure_ptrace_scope_is_restricted',
'Ensure_rds_kernel_module_is_not_available',
'Ensure_remote_login_warning_banner_is_configured_properly',
'Ensure_remote_login_warning_banner_is_configured_properly',
'Ensure_reverse_path_filtering_is_enabled',
'Ensure_reverse_path_filtering_is_enabled',
'Ensure_root_account_is_locked',
'Ensure_sctp_kernel_module_is_not_available',
'Ensure_secure_icmp_redirects_are_not_accepted',
'Ensure_secure_icmp_redirects_are_not_accepted',
'Ensure_separate_partition_exists_for_home',
'Ensure_separate_partition_exists_for_var',
'Ensure_separate_partition_exists_for_varlog',
'Ensure_separate_partition_exists_for_varlogaudit',
'Ensure_separate_partition_exists_for_vartmp',
'Ensure_session_initiation_information_is_collected',
'Ensure_source_routed_packets_are_not_accepted',
'Ensure_source_routed_packets_are_not_accepted',
'Ensure_squashfs_kernel_module_is_not_available',
'Ensure_successful_and_unsuccessful_attempts_to_use_the_apparmor_parser_command_are_recorded',
'Ensure_successful_and_unsuccessful_attempts_to_use_the_chacl_command_are_recorded',
'Ensure_successful_and_unsuccessful_attempts_to_use_the_chage_command_are_recorded',
'Ensure_successful_and_unsuccessful_attempts_to_use_the_chcon_command_are_recorded',
'Ensure_successful_and_unsuccessful_attempts_to_use_the_chsh_command_are_recorded',
'Ensure_successful_and_unsuccessful_attempts_to_use_the_crontab_command_are_recorded',
'Ensure_successful_and_unsuccessful_attempts_to_use_the_fdisk_command_are_recorded',
'Ensure_successful_and_unsuccessful_attempts_to_use_the_gpasswd_command_are_recorded',
'Ensure_successful_and_unsuccessful_attempts_to_use_the_newgrp_command_are_recorded',
'Ensure_successful_and_unsuccessful_attempts_to_use_the_pam_timestamp_check_command_are_recorded',
'Ensure_successful_and_unsuccessful_attempts_to_use_the_passwd_command_are_recorded',
'Ensure_successful_and_unsuccessful_attempts_to_use_the_setfacl_command_are_recorded',
'Ensure_successful_and_unsuccessful_attempts_to_use_the_sudoedit_command_are_recorded',
'Ensure_successful_and_unsuccessful_attempts_to_use_the_unix_update_command_are_recorded',
'Ensure_successful_and_unsuccessful_attempts_to_use_the_usermod_command_are_recorded',
'Ensure_successful_and_unsuccessful_uses_of_the_chfn_command_are_collected',
'Ensure_successful_and_unsuccessful_uses_of_the_ssh-agent_command_are_collected',
'Ensure_successful_and_unsuccessful_uses_of_the_ssh-keysign_command_are_collected',
'Ensure_successful_and_unsuccessful_uses_of_the_su_command_are_collected',
'Ensure_successful_and_unsuccessful_uses_of_the_sudo_command_are_recorded',
'Ensure_successful_file_system_mounts_are_collected',
'Ensure_suspicious_packets_are_logged',
'Ensure_suspicious_packets_are_logged',
'Ensure_system_command_files_are_group-owned_by_root',
'Ensure_system_timezone_is_set_to_UTC_or_GMT',
'Ensure_systemd-journal-remote_is_enabled',
'Ensure_systemd-journal-remote_is_enabled',
'Ensure_tcp_syn_Cookies_is_enabled',
'Ensure_tcp_syn_Cookies_is_enabled',
'Ensure_tcp_syn_Cookies_is_enabled',
'Ensure_telnet_client_is_not_installed',
'Ensure_telnet_client_is_not_installed',
'Ensure_the_Ctrl-Alt-Delete_key_sequence_is_disabled',
'Ensure_the_audit_configuration_is_immutable',
'Ensure_the_audit_log_directory_is_0750_or_more_restrictive',
'Ensure_the_libpam-pkcs11_package_is_installed',
'Ensure_the_opensc-pcks11_is_installed',
'Ensure_tipc_kernel_module_is_not_available',
'Ensure_tmp_is_a_separate_partition',
'Ensure_tmp_is_a_separate_partition',
'Ensure_udf_kernel_module_is_not_available',
'Ensure_ufw_firewall_rules_exist_for_all_open_ports',
'Ensure_ufw_firewall_rules_exist_for_all_open_ports',
'Ensure_ufw_is_installed',
'Ensure_ufw_is_installed',
'Ensure_ufw_is_installed',
'Ensure_ufw_service_is_enabled',
'Ensure_ufw_service_is_enabled',
'Ensure_ufw_service_is_enabled',
'Ensure_unsuccessful_file_access_attempts_are_collected',
'Ensure_usb-storage_kernel_module_is_not_available',
'Ensure_usb-storage_kernel_module_is_not_available',
'Ensure_usb-storage_kernel_module_is_not_available',
'Ensure_use_of_privileged_commands_are_collected',
'Ensure_varlog_is_group-owned_by_syslog',
'Ensure_varlogsyslog_is_owned_by_syslog',
'Ensure_vlock_is_installed'
]
},
{
'benchmarkOrg': 'CIS',
'benchmakeName': 'CIS_Debian_Linux_11_STIG_Benchmark_v1.0.0-xccdf.xml',
'compliedCount': 208,
'notCompliedCount': 0,
'compliedTopics': [
'Ensure_AppArmor_is_installed_enabled_and_active',
'Ensure_Automatic_Error_Reporting_is_not_enabled',
'Ensure_Automatic_Error_Reporting_is_not_enabled',
'Ensure_DHCP_Server_is_not_installed',
'Ensure_DHCP_Server_is_not_installed',
'Ensure_DNS_Server_is_not_installed',
'Ensure_DNS_Server_is_not_installed',
'Ensure_FTP_Server_is_not_installed',
'Ensure_FTP_Server_is_not_installed',
'Ensure_HTTP_Proxy_Server_is_not_installed',
'Ensure_HTTP_Proxy_Server_is_not_installed',
'Ensure_HTTP_server_is_not_installed',
'Ensure_HTTP_server_is_not_installed',
'Ensure_IMAP_and_POP3_server_are_not_installed',
'Ensure_IMAP_and_POP3_server_are_not_installed',
'Ensure_LDAP_client_is_not_installed',
'Ensure_LDAP_client_is_not_installed',
'Ensure_LDAP_server_is_not_installed',
'Ensure_LDAP_server_is_not_installed',
'Ensure_NFS_is_not_installed',
'Ensure_NFS_is_not_installed',
'Ensure_NIS_Client_is_not_installed',
'Ensure_NIS_Client_is_not_installed',
'Ensure_NIS_Server_is_not_installed',
'Ensure_NIS_Server_is_not_installed',
'Ensure_SNMP_Server_is_not_installed',
'Ensure_SNMP_Server_is_not_installed',
'Ensure_SSH_AllowTcpForwarding_is_disabled',
'Ensure_SSH_HostbasedAuthentication_is_disabled',
'Ensure_SSH_HostbasedAuthentication_is_disabled',
'Ensure_SSH_Idle_Timeout_Interval_is_configured',
'Ensure_SSH_Idle_Timeout_Interval_is_configured',
'Ensure_SSH_IgnoreRhosts_is_enabled',
'Ensure_SSH_IgnoreRhosts_is_enabled',
'Ensure_SSH_LogLevel_is_appropriate',
'Ensure_SSH_LogLevel_is_appropriate',
'Ensure_SSH_LoginGraceTime_is_set_to_one_minute_or_less',
'Ensure_SSH_LoginGraceTime_is_set_to_one_minute_or_less',
'Ensure_SSH_MaxAuthTries_is_set_to_4_or_less',
'Ensure_SSH_MaxAuthTries_is_set_to_4_or_less',
'Ensure_SSH_MaxSessions_is_set_to_10_or_less',
'Ensure_SSH_MaxSessions_is_set_to_10_or_less',
'Ensure_SSH_MaxStartups_is_configured',
'Ensure_SSH_MaxStartups_is_configured',
'Ensure_SSH_PAM_is_enabled',
'Ensure_SSH_PAM_is_enabled',
'Ensure_SSH_PAM_is_enabled',
'Ensure_SSH_PermitEmptyPasswords_is_disabled',
'Ensure_SSH_PermitEmptyPasswords_is_disabled',
'Ensure_SSH_PermitEmptyPasswords_is_disabled',
'Ensure_SSH_PermitUserEnvironment_is_disabled',
'Ensure_SSH_PermitUserEnvironment_is_disabled',
'Ensure_SSH_PermitUserEnvironment_is_disabled',
'Ensure_SSH_X11_forwarding_is_disabled',
'Ensure_SSH_X11_forwarding_is_disabled',
'Ensure_SSH_access_is_limited',
'Ensure_SSH_access_is_limited',
'Ensure_SSH_root_login_is_disabled',
'Ensure_SSH_root_login_is_disabled',
'Ensure_SSH_warning_banner_is_configured',
'Ensure_SSH_warning_banner_is_configured',
'Ensure_Samba_is_not_installed',
'Ensure_Samba_is_not_installed',
'Ensure_XDNX_support_is_enabled',
'Ensure_XDNX_support_is_enabled',
'Ensure_XDNX_support_is_enabled',
'Ensure__RPC_is_not_installed',
'Ensure__RPC_is_not_installed',
'Ensure_a_single_time_synchronization_daemon_is_in_use',
'Ensure_a_single_time_synchronization_daemon_is_in_use',
'Ensure_all_AppArmor_Profiles_are_in_enforce_or_complain_mode',
'Ensure_all_AppArmor_Profiles_are_in_enforce_or_complain_mode',
'Ensure_all_groups_in_etcpasswd_exist_in_etcgroup',
'Ensure_all_groups_in_etcpasswd_exist_in_etcgroup',
'Ensure_all_users_last_password_change_date_is_in_the_past',
'Ensure_all_users_last_password_change_date_is_in_the_past',
'Ensure_at_is_restricted_to_authorized_users',
'Ensure_at_is_restricted_to_authorized_users',
'Ensure_audit_configuration_files_are_640_or_more_restrictive',
'Ensure_audit_tools_are_755_or_more_restrictive',
'Ensure_chrony_is_enabled_and_running',
'Ensure_chrony_is_enabled_and_running',
'Ensure_chrony_is_running_as_user__chrony',
'Ensure_chrony_is_running_as_user__chrony',
'Ensure_cramfs_kernel_module_is_not_available',
'Ensure_cramfs_kernel_module_is_not_available',
'Ensure_cron_daemon_is_enabled_and_active',
'Ensure_cron_daemon_is_enabled_and_active',
'Ensure_devshm_is_a_separate_partition',
'Ensure_devshm_is_a_separate_partition',
'Ensure_directories_that_contain_system_commands_are_group-owned_by_root',
'Ensure_directories_that_contain_system_commands_are_owned_by_root',
'Ensure_directories_that_contain_system_commands_set_to_0755_or_more_restrictive',
'Ensure_dnsmasq_is_not_installed',
'Ensure_dnsmasq_is_not_installed',
'Ensure_iptables-persistent_is_not_installed_with_ufw',
'Ensure_iptables-persistent_is_not_installed_with_ufw',
'Ensure_journald_is_not_configured_to_receive_logs_from_a_remote_client',
'Ensure_journald_is_not_configured_to_receive_logs_from_a_remote_client',
'Ensure_journald_service_is_enabled',
'Ensure_journald_service_is_enabled',
'Ensure_local_interactive_user_dot_files_access_is_configured',
'Ensure_local_interactive_user_dot_files_access_is_configured',
'Ensure_nftables_is_installed',
'Ensure_nftables_is_installed',
'Ensure_no_duplicate_UIDs_exist',
'Ensure_no_duplicate_UIDs_exist',
'Ensure_no_duplicate_UIDs_exist',
'Ensure_no_unowned_or_ungrouped_files_or_directories_exist',
'Ensure_no_unowned_or_ungrouped_files_or_directories_exist',
'Ensure_nodev_option_set_on_devshm_partition',
'Ensure_nodev_option_set_on_devshm_partition',
'Ensure_nosuid_option_set_on_devshm_partition',
'Ensure_nosuid_option_set_on_devshm_partition',
'Ensure_ntp_access_control_is_configured',
'Ensure_ntp_access_control_is_configured',
'Ensure_ntp_is_enabled_and_running',
'Ensure_ntp_is_enabled_and_running',
'Ensure_ntp_is_running_as_user_ntp',
'Ensure_ntp_is_running_as_user_ntp',
'Ensure_only_FIPS_validated_Key_Exchange_algorithms_are_used',
'Ensure_only_authorized_groups_own_audit_configuration_files',
'Ensure_only_authorized_groups_own_audit_configuration_files',
'Ensure_only_authorized_groups_own_audit_tools',
'Ensure_only_authorized_groups_own_audit_tools',
'Ensure_only_authorized_users_own_audit_configuration_files',
'Ensure_only_authorized_users_own_audit_configuration_files',
'Ensure_only_authorized_users_own_audit_tools',
'Ensure_only_strong_Ciphers_are_used',
'Ensure_only_strong_Ciphers_are_used',
'Ensure_only_strong_Key_Exchange_algorithms_are_used',
'Ensure_only_strong_Key_Exchange_algorithms_are_used',
'Ensure_only_strong_MAC_algorithms_are_used',
'Ensure_only_strong_MAC_algorithms_are_used',
'Ensure_permissions_on_SSH_private_host_key_files_are_configured',
'Ensure_permissions_on_SSH_private_host_key_files_are_configured',
'Ensure_permissions_on_SSH_public_host_key_files_are_configured',
'Ensure_permissions_on_SSH_public_host_key_files_are_configured',
'Ensure_permissions_on_etcgroup-_are_configured',
'Ensure_permissions_on_etcgroup-_are_configured',
'Ensure_permissions_on_etcgroup_are_configured',
'Ensure_permissions_on_etcgroup_are_configured',
'Ensure_permissions_on_etcgshadow-_are_configured',
'Ensure_permissions_on_etcgshadow-_are_configured',
'Ensure_permissions_on_etcgshadow_are_configured',
'Ensure_permissions_on_etcgshadow_are_configured',
'Ensure_permissions_on_etcissue.net_are_configured',
'Ensure_permissions_on_etcissue.net_are_configured',
'Ensure_permissions_on_etcissue_are_configured',
'Ensure_permissions_on_etcissue_are_configured',
'Ensure_permissions_on_etcmotd_are_configured',
'Ensure_permissions_on_etcmotd_are_configured',
'Ensure_permissions_on_etcpasswd-_are_configured',
'Ensure_permissions_on_etcpasswd-_are_configured',
'Ensure_permissions_on_etcpasswd_are_configured',
'Ensure_permissions_on_etcpasswd_are_configured',
'Ensure_permissions_on_etcshadow-_are_configured',
'Ensure_permissions_on_etcshadow-_are_configured',
'Ensure_permissions_on_etcshadow_are_configured',
'Ensure_permissions_on_etcshadow_are_configured',
'Ensure_permissions_on_etcshells_are_configured',
'Ensure_permissions_on_etcshells_are_configured',
'Ensure_permissions_on_etcsshsshd_config_are_configured',
'Ensure_permissions_on_etcsshsshd_config_are_configured',
'Ensure_prelink_is_not_installed',
'Ensure_prelink_is_not_installed',
'Ensure_root_PATH_Integrity',
'Ensure_root_PATH_Integrity',
'Ensure_rsh-server_is_not_installed',
'Ensure_rsh_client_is_not_installed',
'Ensure_rsh_client_is_not_installed',
'Ensure_rsync_service_is_either_not_installed_or_is_masked',
'Ensure_rsync_service_is_either_not_installed_or_is_masked',
'Ensure_rsyslog_is_installed',
'Ensure_rsyslog_is_installed',
'Ensure_rsyslog_is_installed',
'Ensure_rsyslog_service_is_enabled',
'Ensure_rsyslog_service_is_enabled',
'Ensure_sticky_bit_is_set_on_all_world-writable_directories',
'Ensure_sticky_bit_is_set_on_all_world-writable_directories',
'Ensure_sticky_bit_is_set_on_all_world-writable_directories',
'Ensure_sudo_is_installed',
'Ensure_sudo_is_installed',
'Ensure_system_accounts_are_secured',
'Ensure_system_accounts_are_secured',
'Ensure_system_command_files_are_owned_by_root',
'Ensure_system_library_directories_are_0755_or_more_restrictive',
'Ensure_system_library_directories_are_group-owned_by_root',
'Ensure_system_library_directories_are_owned_by_root',
'Ensure_systemd-journal-remote_is_installed',
'Ensure_systemd-journal-remote_is_installed',
'Ensure_systemd-timesyncd_is_enabled_and_running',
'Ensure_systemd-timesyncd_is_enabled_and_running',
'Ensure_talk_client_is_not_installed',
'Ensure_talk_client_is_not_installed',
'Ensure_telnetd_is_not_installed',
'Ensure_ufw_is_uninstalled_or_disabled_with_iptables',
'Ensure_ufw_is_uninstalled_or_disabled_with_iptables',
'Ensure_ufw_is_uninstalled_or_disabled_with_nftables',
'Ensure_ufw_is_uninstalled_or_disabled_with_nftables',
'Ensure_users_session_lock_is_enabled',
'Ensure_varlogsyslog_is_0640_or_more_restrictive',
'Ensure_varlogsyslog_is_group-owned_by_adm',
'Ensure_wireless_interfaces_are_disabled',
'Ensure_wireless_interfaces_are_disabled',
'Ensure_wireless_interfaces_are_disabled',
'Ensure_world_writable_files_and_directories_are_secured',
'Ensure_world_writable_files_and_directories_are_secured'
],
'notCompliedTopics': []
}
],
'benchmarkGraphs': [
{
'benchmarkOrg': 'CIS',
'benchmarkName': 'CIS_Debian_Linux_11_STIG_Benchmark_v1.0.0-xccdf.xml',
'graph': [
{'date': '2024-11-17T04:01:05.356773Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-10-15T00:01:34.623119Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-11-11T04:01:07.14601Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-10-14T00:01:28.030452Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-11-03T00:01:39.520987Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-11-12T04:01:08.074903Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-10-22T00:01:30.673846Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-10-29T00:01:31.972235Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-10-31T00:01:22.815424Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-10-17T00:02:07.014856Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-10-30T00:01:26.008456Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-11-16T04:01:04.496688Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-11-10T04:00:46.130968Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-10-25T00:01:27.85315Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-10-21T00:01:35.91268Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-10-23T00:01:31.214479Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-11-07T04:01:29.157068Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-10-18T00:01:20.008426Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-11-08T04:00:58.913659Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-10-27T00:01:27.198765Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-11-18T04:00:59.943198Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-11-19T04:00:53.317553Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-11-06T04:01:21.255211Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-11-13T04:00:47.674026Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-10-24T00:01:29.91357Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-11-09T04:01:05.959982Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-10-19T00:01:27.301959Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-11-05T04:01:40.351109Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-11-02T00:01:43.504041Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-10-28T00:01:21.91466Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-11-01T00:01:40.017661Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-11-15T04:01:00.530527Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-11-04T00:02:38.238586Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-11-14T04:00:57.990075Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-10-16T00:01:37.998273Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-10-26T00:01:35.011715Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-10-20T00:01:41.421029Z', 'compiledCount': 208, 'notCompiledCount': 0},
{'date': '2024-11-20T04:01:03.751856Z', 'compiledCount': 208, 'notCompiledCount': 0}
]
},
{
'benchmarkOrg': 'CIS',
'benchmarkName': null,
'graph': [
{'date': '2024-10-04T00:01:09.057747Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-09-14T00:00:31.436708Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-10-01T00:00:39.129782Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-09-13T00:01:14.427341Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-09-07T00:00:28.186054Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-10-10T00:02:13.520991Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-09-28T00:01:25.424275Z', 'compiledCount': 186, 'notCompiledCount': 0},
{'date': '2024-09-30T00:00:36.930171Z', 'compiledCount': 186, 'notCompiledCount': 0},
{'date': '2024-09-10T00:03:19.157848Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-09-09T00:01:11.925026Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-10-12T00:01:21.92717Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-09-04T00:00:38.093112Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-10-09T00:01:50.527896Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-09-29T00:01:20.062421Z', 'compiledCount': 186, 'notCompiledCount': 0},
{'date': '2024-10-08T00:01:17.233833Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-09-17T00:00:48.341506Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-09-24T00:01:22.538253Z', 'compiledCount': 186, 'notCompiledCount': 0},
{'date': '2024-09-11T00:00:46.073567Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-09-16T00:00:32.71914Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-10-06T00:01:48.934291Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-09-25T00:01:25.542117Z', 'compiledCount': 186, 'notCompiledCount': 0},
{'date': '2024-09-27T00:01:50.621484Z', 'compiledCount': 186, 'notCompiledCount': 0},
{'date': '2024-09-06T00:00:44.482017Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-09-19T00:00:34.928364Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-09-21T00:01:24.822224Z', 'compiledCount': 186, 'notCompiledCount': 0},
{'date': '2024-09-12T00:00:36.134594Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-10-07T00:01:15.225227Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-09-23T00:01:14.131776Z', 'compiledCount': 186, 'notCompiledCount': 0},
{'date': '2024-10-13T00:01:13.544583Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-09-15T00:01:09.332342Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-09-05T00:00:52.121219Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-10-02T00:00:38.832103Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-09-26T00:01:20.230203Z', 'compiledCount': 186, 'notCompiledCount': 0},
{'date': '2024-10-05T00:00:31.750269Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-10-11T00:01:50.141713Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-10-03T00:00:35.15287Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-09-20T00:00:30.722814Z', 'compiledCount': 186, 'notCompiledCount': 0},
{'date': '2024-09-18T00:00:41.167789Z', 'compiledCount': 188, 'notCompiledCount': 0},
{'date': '2024-09-22T00:00:33.027417Z', 'compiledCount': 186, 'notCompiledCount': 0},
{'date': '2024-09-08T00:00:43.485286Z', 'compiledCount': 188, 'notCompiledCount': 0}
]
}
],
'itMinutes': 2
},
'deviceRemediation': {
'graph': [
{'date': '2024-10-26T00:01:34.625118Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-11-03T00:01:39.208514Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-11-09T04:01:05.461798Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-11-11T04:01:06.550536Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-10-27T00:01:26.805048Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-10-31T00:01:22.425599Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-11-04T00:02:37.838272Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-11-07T04:01:28.568077Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-11-10T04:00:45.535338Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-10-28T00:01:21.221013Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-11-01T00:01:39.712418Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-11-05T04:01:40.036747Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-11-08T04:00:58.416192Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-10-29T00:01:31.653592Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-11-02T00:01:43.197577Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-11-06T04:01:20.652733Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-09-04T00:00:37.685876Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 50},
{'date': '2024-09-05T00:00:51.721204Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 50},
{'date': '2024-09-06T00:00:44.081185Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 50},
{'date': '2024-09-07T00:00:27.581641Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 50},
{'date': '2024-09-08T00:00:43.076718Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 50},
{'date': '2024-09-09T00:01:11.523024Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 50},
{'date': '2024-09-10T00:03:18.760725Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 50},
{'date': '2024-09-11T00:00:45.57074Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 50},
{'date': '2024-09-12T00:00:35.534008Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 50},
{'date': '2024-09-13T00:01:14.019585Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 50},
{'date': '2024-09-14T00:00:30.823389Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 50},
{'date': '2024-09-15T00:01:08.836741Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 50},
{'date': '2024-09-16T00:00:32.222321Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 50},
{'date': '2024-09-17T00:00:47.633905Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 50},
{'date': '2024-09-18T00:00:40.736413Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-09-19T00:00:34.518943Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-09-20T00:00:30.222431Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-09-21T00:01:24.323843Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-09-22T00:00:32.62869Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-09-23T00:01:13.435519Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-09-24T00:01:22.121701Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-09-25T00:01:25.034743Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-09-26T00:01:19.625965Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-09-27T00:01:50.219786Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-09-28T00:01:24.928225Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-09-29T00:01:19.522505Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-09-30T00:00:36.520739Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-10-01T00:00:38.636707Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-10-02T00:00:38.325722Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-10-03T00:00:34.666876Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-10-04T00:01:08.521945Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-10-05T00:00:31.16313Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-10-06T00:01:48.529243Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-10-07T00:01:14.736928Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-10-08T00:01:16.728899Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-10-09T00:01:50.126413Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-10-10T00:02:13.120027Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-10-11T00:01:49.730797Z', 'pending': 1, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 48},
{'date': '2024-10-12T00:01:21.529295Z', 'pending': 1, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 48},
{'date': '2024-10-13T00:01:12.936489Z', 'pending': 1, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 48},
{'date': '2024-10-14T00:01:27.628463Z', 'pending': 0, 'success': 1, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 0, 'unassigned': 49},
{'date': '2024-10-15T00:01:34.308436Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 0, 'reverting': 0, 'reverted': 1, 'unassigned': 50},
{'date': '2024-10-16T00:01:37.614085Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-10-17T00:02:06.709029Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-10-18T00:01:19.613795Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-10-19T00:01:26.912486Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-10-20T00:01:40.811649Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-10-21T00:01:35.527017Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-10-22T00:01:30.365049Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-10-23T00:01:30.906195Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-10-24T00:01:29.599464Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-10-25T00:01:27.468021Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-10-30T00:01:25.615969Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-11-12T04:01:07.561773Z', 'pending': 0, 'success': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-11-13T04:00:47.159507Z', 'pending': 0, 'success': 1, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-11-14T04:00:57.492095Z', 'pending': 0, 'success': 1, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-11-15T04:01:00.028631Z', 'pending': 0, 'success': 1, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-11-16T04:01:03.994986Z', 'pending': 0, 'success': 1, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-11-17T04:01:04.855443Z', 'pending': 0, 'success': 1, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-11-18T04:00:59.435874Z', 'pending': 0, 'success': 1, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-11-19T04:00:52.813825Z', 'pending': 0, 'success': 1, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49},
{'date': '2024-11-20T04:01:03.064416Z', 'pending': 0, 'success': 1, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0, 'cancelled': 1, 'reverting': 0, 'reverted': 1, 'unassigned': 49}
],
'remediations': [
{'topicCode': 'gytCUPS', 'latestUpdateDt': '2024-11-12T10:58:53.653898Z', 'user': null, 'state': 'Success'},
{'topicCode': 'gytCUPS', 'latestUpdateDt': '2024-10-15T13:27:47.631101Z', 'user': null, 'state': 'Stopped by user ba@acme.com'},
{'topicCode': 'gytCUPS', 'latestUpdateDt': '2024-10-14T06:59:06.497797Z', 'user': null, 'state': 'Success'}
]
},
'deviceMutedRules': {'rules': [{'ruleId': 337, 'topicCode': 'gytRootDisabled', 'remark': null, 'byUser': 'gus@acme.com', 'addDate': '2024-07-01T09:23:20.976544Z'}]},
'deviceRevertTasks': {'tasks': [{'byUser': null, 'date': '2024-10-14T06:59:06.497797Z', 'topicCode': 'gytCUPS'}]},
'FTE': 330184,
'error': null
});

	mockData.altGroupTopics = () => ({'calcState': 0, 'cacheTime': new Date(Date.now() - Math.random() * 1000*60*60).toISOString(), topics: Object.keys(HA_topics).filter(_k => Math.random() >= 0).map(topicCode => ({topicCode, graph: makeArr(Math.random() * 30 |0).reduce((a, b) => ((a[b] = {date: new Date(Date.now() - (30-b)*86400000).toISOString(), value: (a[b-1]?.value ?? 1000) + (Math.random()*100) * (a[b-1]?.value < a[b-2]?.value && Math.random() < 0.9 || Math.random() > 0.9? -1 : 1) |0}), a), [] as AnalyzerServicesV2MisconGroupTopicGraphItem[]), repeated: +(Math.random() > 0.5) * Math.random() * 1000 |0, mutedAlerts:+(Math.random() > 0.5) * Math.random() * 1000 |0, remediated: +(Math.random() > 0.5) * Math.random() * 1000 |0, alertsOk: +(Math.random() > 0.2) * Math.random() * 10000 |0, alertsBad: +(Math.random() > 0.2) * Math.random() * 10000 |0, alertsNew: +(Math.random() > 0.5) * Math.random() * 1000 |0, devicesOk: +(Math.random() > 0.2) * Math.random() * 10000 |0, devicesBad: +(Math.random() > 0.2) * Math.random() * 10000 |0}))});
	mockData.altGroupTopicsVdi = () => ({
'calcState': 0,
'cacheTime': '2025-06-17T10:03:39.275Z',
'byVdi': [
{
'vdiPrefix': 'VDI',
'topics': [
{
'topicCode': 'gytNetLogonEvents',
'graph': [
1031,
996,
954,
860,
805,
784,
750,
840,
867
],
'mutedAlerts': 2,
alertsNew: 1,
'alertsOk': 0,
'alertsBad': 707,
'devicesOk': 7534,
'devicesBad': 4805
}
]
}
]
});

	mockData.altComplianceTopics = () => ({
topics: Object.entries<{profiles: number[]}>(Benchmark_topics.cis.rules).map(([
topicCode,
ruleInfo
], i) => ({'topicCode': topicCode, 'profile': cisProfiles[ruleInfo.profiles[0]].id+(cisProfiles[ruleInfo.profiles[0]].id.includes('Application')? '_Version_4' : ''), 'os': i % 3 ? 'Microsoft Windows 10 Stand-alone' : 'Microsoft Windows 11', mutedAlerts: 3- (i % 3), 'devicesOk': 3- (i % 3), 'devicesBad': i % 3, 'devicesUnmeasured': 0})).flat(),
'calcState': 0,
'cacheTime': new Date(Date.now() - Math.random() * 1000*60*60*8).toISOString()
});

	const cisProfiles = Benchmark_cisProfiles as Record<string, {id: string}>;
	mockData.mochInventory = () => ({
'selTargets': [
{'devices': 1694, 'selTarget': 'debian'},
{'devices': 1764, 'selTarget': 'server !dc'},
{'devices': 266, 'selTarget': 'suse'},
{'devices': 6230, 'selTarget': '!vdi !server'},
{'devices': 2268, 'selTarget': 'mac'},
{'devices': 56, 'selTarget': 'dc'},
{'devices': 1680, 'selTarget': 'rhel'}
]
});

	mockData.cveInfo = () => ({
		'cve': 'CVE-2012-1775',
		'description': 'Stack-based buffer overflow in VideoLAN VLC media player before 2.0.1 allows remote attackers to execute arbitrary code via a crafted MMS:// stream.',
		'cvss': 9.3,
		'cvssVector': 'AV:N/AC:M/Au:N/C:C/I:C/A:C',
		'impactScore': 10,
		'exploitabilityScore': 8.6,
		'severity': 'High',
		'cisakev': false,
		'publishDate': '2012-03-19T09:55:01Z'
	});

	mockData.executiveSummaryMoch = () => ({
'data': [
{
'OS': 'Windows',
'graph': [
{'date': '2024-07-14T00:01:37.275468Z', 'value': 9},
{'date': '2024-07-13T00:01:43.380741Z', 'value': 9},
{'date': '2024-07-12T00:01:19.887135Z', 'value': 9},
{'date': '2024-07-11T00:01:47.184018Z', 'value': 8},
{'date': '2024-07-10T00:00:48.391079Z', 'value': 8},
{'date': '2024-07-09T00:01:33.777787Z', 'value': 9},
{'date': '2024-07-08T00:01:38.873031Z', 'value': 9},
{'date': '2024-07-07T00:00:45.986384Z', 'value': 9},
{'date': '2024-07-06T00:01:27.797474Z', 'value': 9},
{'date': '2024-07-05T00:01:37.773356Z', 'value': 9},
{'date': '2024-07-04T00:01:23.975149Z', 'value': 9},
{'date': '2024-07-03T00:01:25.573563Z', 'value': 9},
{'date': '2024-07-02T00:01:19.177146Z', 'value': 10},
{'date': '2024-07-01T00:00:50.172793Z', 'value': 11},
{'date': '2024-06-30T00:01:05.630301Z', 'value': 11},
{'date': '2024-06-29T00:01:13.941654Z', 'value': 11},
{'date': '2024-06-28T00:01:05.257128Z', 'value': 11},
{'date': '2024-06-27T00:01:15.926169Z', 'value': 10},
{'date': '2024-06-26T00:01:10.227369Z', 'value': 10},
{'date': '2024-06-25T00:01:04.232177Z', 'value': 10},
{'date': '2024-06-24T00:01:09.430653Z', 'value': 9},
{'date': '2024-06-23T00:01:13.07666Z', 'value': 9},
{'date': '2024-06-22T00:01:14.131627Z', 'value': 9},
{'date': '2024-06-21T00:01:07.329734Z', 'value': 9},
{'date': '2024-06-20T00:00:58.734369Z', 'value': 9},
{'date': '2024-06-19T00:01:17.432434Z', 'value': 11},
{'date': '2024-06-18T00:01:11.52475Z', 'value': 11},
{'date': '2024-06-17T00:01:08.12609Z', 'value': 10},
{'date': '2024-06-16T00:01:01.531537Z', 'value': 11},
{'date': '2024-06-14T12:01:08.531742Z', 'value': 11},
{'date': '2024-06-13T12:01:02.655126Z', 'value': 11},
{'date': '2024-06-12T00:00:59.128227Z', 'value': 11},
{'date': '2024-06-10T12:00:59.240309Z', 'value': 11},
{'date': '2024-06-09T00:01:04.631426Z', 'value': 10},
{'date': '2024-06-08T00:00:55.83731Z', 'value': 11},
{'date': '2024-06-06T12:01:04.72595Z', 'value': 11},
{'date': '2024-06-05T00:01:00.627937Z', 'value': 10},
{'date': '2024-06-03T12:01:04.926196Z', 'value': 10},
{'date': '2024-06-02T00:02:00.333735Z', 'value': 11},
{'date': '2024-06-01T00:01:44.626906Z', 'value': 10},
{'date': '2024-05-30T12:02:03.632423Z', 'value': 10},
{'date': '2024-05-29T12:02:02.951093Z', 'value': 10},
{'date': '2024-05-28T00:01:51.731614Z', 'value': 10},
{'date': '2024-05-26T12:01:56.628098Z', 'value': 9},
{'date': '2024-05-25T00:01:47.23414Z', 'value': 9},
{'date': '2024-05-23T12:01:47.029114Z', 'value': 9},
{'date': '2024-05-22T00:01:42.22735Z', 'value': 8},
{'date': '2024-05-20T12:01:44.445997Z', 'value': 9},
{'date': '2024-05-19T00:01:47.433222Z', 'value': 7},
{'date': '2024-05-18T00:01:38.838865Z', 'value': 7},
{'date': '2024-05-17T00:01:30.438359Z', 'value': 7},
{'date': '2024-05-15T12:01:36.73974Z', 'value': 8},
{'date': '2024-05-14T12:01:34.03965Z', 'value': 8},
{'date': '2024-05-13T00:01:44.331524Z', 'value': 8},
{'date': '2024-05-12T00:01:36.930308Z', 'value': 8},
{'date': '2024-05-10T12:01:46.746983Z', 'value': 8},
{'date': '2024-05-09T12:01:35.442937Z', 'value': 8},
{'date': '2024-05-08T12:01:30.228991Z', 'value': 8},
{'date': '2024-05-07T00:01:51.856125Z', 'value': 8},
{'date': '2024-05-06T00:01:46.526072Z', 'value': 8},
{'date': '2024-05-05T00:01:38.734398Z', 'value': 8},
{'date': '2024-05-04T00:01:36.926854Z', 'value': 8},
{'date': '2024-05-02T12:01:48.339086Z', 'value': 8},
{'date': '2024-05-01T00:01:53.641276Z', 'value': 8},
{'date': '2024-04-30T00:01:32.436276Z', 'value': 8},
{'date': '2024-04-28T12:01:42.827332Z', 'value': 8},
{'date': '2024-04-27T12:01:31.836722Z', 'value': 8},
{'date': '2024-04-26T00:01:51.333912Z', 'value': 8},
{'date': '2024-04-25T00:01:32.026909Z', 'value': 8},
{'date': '2024-04-23T12:01:47.136997Z', 'value': 7},
{'date': '2024-04-22T00:01:41.434517Z', 'value': 7},
{'date': '2024-04-20T12:01:48.747201Z', 'value': 7},
{'date': '2024-04-19T12:01:39.629344Z', 'value': 7},
{'date': '2024-04-18T00:01:53.337746Z', 'value': 7},
{'date': '2024-04-17T00:01:30.257114Z', 'value': 7},
{'date': '2024-04-15T12:01:32.134707Z', 'value': 7},
{'date': '2024-04-14T00:01:35.236733Z', 'value': 7},
{'date': '2024-04-13T00:01:30.336471Z', 'value': 7},
{'date': '2024-04-11T12:01:42.433517Z', 'value': 7},
{'date': '2024-04-10T00:01:52.128539Z', 'value': 8},
{'date': '2024-04-09T00:01:48.927089Z', 'value': 8},
{'date': '2024-04-08T00:01:40.627319Z', 'value': 8},
{'date': '2024-04-07T00:01:39.246607Z', 'value': 8},
{'date': '2024-04-05T12:01:31.526188Z', 'value': 8},
{'date': '2024-04-04T00:01:30.940089Z', 'value': 8},
{'date': '2024-04-03T00:01:29.138239Z', 'value': 8},
{'date': '2024-04-01T12:01:44.445513Z', 'value': 8},
{'date': '2024-03-31T12:01:30.334054Z', 'value': 8},
{'date': '2024-03-30T00:01:31.233018Z', 'value': 8},
{'date': '2024-03-28T12:01:47.432908Z', 'value': 8},
{'date': '2024-03-27T12:01:35.428646Z', 'value': 8},
{'date': '2024-03-26T00:01:32.526347Z', 'value': 5},
{'date': '2024-03-25T00:01:31.329645Z', 'value': 5},
{'date': '2024-03-23T12:01:46.825814Z', 'value': 4},
{'date': '2024-03-22T12:01:32.049221Z', 'value': 4},
{'date': '2024-03-21T00:01:46.433282Z', 'value': 4},
{'date': '2024-03-19T12:01:50.337535Z', 'value': 4},
{'date': '2024-03-18T12:01:26.626709Z', 'value': 4}
],
'totalByTimePeriod': 14
},
{
'OS': 'Linux',
'graph': [
{'date': '2024-07-14T00:01:37.275468Z', 'value': 5},
{'date': '2024-07-13T00:01:43.380741Z', 'value': 5},
{'date': '2024-07-12T00:01:19.887135Z', 'value': 5},
{'date': '2024-07-11T00:01:47.184018Z', 'value': 5},
{'date': '2024-07-10T00:00:48.391079Z', 'value': 4},
{'date': '2024-07-09T00:01:33.777787Z', 'value': 4},
{'date': '2024-07-08T00:01:38.873031Z', 'value': 4},
{'date': '2024-07-07T00:00:45.986384Z', 'value': 5},
{'date': '2024-07-06T00:01:27.797474Z', 'value': 5},
{'date': '2024-07-05T00:01:37.773356Z', 'value': 5},
{'date': '2024-07-04T00:01:23.975149Z', 'value': 5},
{'date': '2024-07-03T00:01:25.573563Z', 'value': 5},
{'date': '2024-07-02T00:01:19.177146Z', 'value': 6},
{'date': '2024-07-01T00:00:50.172793Z', 'value': 6},
{'date': '2024-06-30T00:01:05.630301Z', 'value': 6},
{'date': '2024-06-29T00:01:13.941654Z', 'value': 6},
{'date': '2024-06-28T00:01:05.257128Z', 'value': 6},
{'date': '2024-06-27T00:01:15.926169Z', 'value': 5},
{'date': '2024-06-26T00:01:10.227369Z', 'value': 5},
{'date': '2024-06-25T00:01:04.232177Z', 'value': 6},
{'date': '2024-06-24T00:01:09.430653Z', 'value': 5},
{'date': '2024-06-23T00:01:13.07666Z', 'value': 4},
{'date': '2024-06-22T00:01:14.131627Z', 'value': 4},
{'date': '2024-06-21T00:01:07.329734Z', 'value': 4},
{'date': '2024-06-20T00:00:58.734369Z', 'value': 4},
{'date': '2024-06-19T00:01:17.432434Z', 'value': 4},
{'date': '2024-06-18T00:01:11.52475Z', 'value': 4},
{'date': '2024-06-17T00:01:08.12609Z', 'value': 4},
{'date': '2024-06-16T00:01:01.531537Z', 'value': 4},
{'date': '2024-06-14T12:01:08.531742Z', 'value': 4},
{'date': '2024-06-13T12:01:02.655126Z', 'value': 3},
{'date': '2024-06-12T00:00:59.128227Z', 'value': 3},
{'date': '2024-06-10T12:00:59.240309Z', 'value': 3},
{'date': '2024-06-09T00:01:04.631426Z', 'value': 3},
{'date': '2024-06-08T00:00:55.83731Z', 'value': 3},
{'date': '2024-06-06T12:01:04.72595Z', 'value': 3},
{'date': '2024-06-05T00:01:00.627937Z', 'value': 4},
{'date': '2024-06-03T12:01:04.926196Z', 'value': 4},
{'date': '2024-06-02T00:02:00.333735Z', 'value': 4},
{'date': '2024-06-01T00:01:44.626906Z', 'value': 4},
{'date': '2024-05-30T12:02:03.632423Z', 'value': 4},
{'date': '2024-05-29T12:02:02.951093Z', 'value': 4},
{'date': '2024-05-28T00:01:51.731614Z', 'value': 4},
{'date': '2024-05-26T12:01:56.628098Z', 'value': 4},
{'date': '2024-05-25T00:01:47.23414Z', 'value': 4},
{'date': '2024-05-23T12:01:47.029114Z', 'value': 4},
{'date': '2024-05-22T00:01:42.22735Z', 'value': 2},
{'date': '2024-05-20T12:01:44.445997Z', 'value': 2},
{'date': '2024-05-19T00:01:47.433222Z', 'value': 2},
{'date': '2024-05-18T00:01:38.838865Z', 'value': 2},
{'date': '2024-05-17T00:01:30.438359Z', 'value': 2},
{'date': '2024-05-15T12:01:36.73974Z', 'value': 2},
{'date': '2024-05-14T12:01:34.03965Z', 'value': 2},
{'date': '2024-05-13T00:01:44.331524Z', 'value': 2},
{'date': '2024-05-12T00:01:36.930308Z', 'value': 2},
{'date': '2024-05-10T12:01:46.746983Z', 'value': 2},
{'date': '2024-05-09T12:01:35.442937Z', 'value': 2},
{'date': '2024-05-08T12:01:30.228991Z', 'value': 2},
{'date': '2024-05-07T00:01:51.856125Z', 'value': 2},
{'date': '2024-05-06T00:01:46.526072Z', 'value': 2},
{'date': '2024-05-05T00:01:38.734398Z', 'value': 2},
{'date': '2024-05-04T00:01:36.926854Z', 'value': 2},
{'date': '2024-05-02T12:01:48.339086Z', 'value': 3},
{'date': '2024-05-01T00:01:53.641276Z', 'value': 3},
{'date': '2024-04-30T00:01:32.436276Z', 'value': 3},
{'date': '2024-04-28T12:01:42.827332Z', 'value': 3},
{'date': '2024-04-27T12:01:31.836722Z', 'value': 3},
{'date': '2024-04-26T00:01:51.333912Z', 'value': 3},
{'date': '2024-04-25T00:01:32.026909Z', 'value': 3},
{'date': '2024-04-23T12:01:47.136997Z', 'value': 3},
{'date': '2024-04-22T00:01:41.434517Z', 'value': 3},
{'date': '2024-04-20T12:01:48.747201Z', 'value': 3},
{'date': '2024-04-19T12:01:39.629344Z', 'value': 3},
{'date': '2024-04-18T00:01:53.337746Z', 'value': 2},
{'date': '2024-04-17T00:01:30.257114Z', 'value': 2},
{'date': '2024-04-15T12:01:32.134707Z', 'value': 3},
{'date': '2024-04-14T00:01:35.236733Z', 'value': 3},
{'date': '2024-04-13T00:01:30.336471Z', 'value': 3},
{'date': '2024-04-11T12:01:42.433517Z', 'value': 3},
{'date': '2024-04-10T00:01:52.128539Z', 'value': 3},
{'date': '2024-04-09T00:01:48.927089Z', 'value': 3},
{'date': '2024-04-08T00:01:40.627319Z', 'value': 3},
{'date': '2024-04-07T00:01:39.246607Z', 'value': 3},
{'date': '2024-04-05T12:01:31.526188Z', 'value': 3},
{'date': '2024-04-04T00:01:30.940089Z', 'value': 3},
{'date': '2024-04-03T00:01:29.138239Z', 'value': 3},
{'date': '2024-04-01T12:01:44.445513Z', 'value': 3},
{'date': '2024-03-31T12:01:30.334054Z', 'value': 3},
{'date': '2024-03-30T00:01:31.233018Z', 'value': 3},
{'date': '2024-03-28T12:01:47.432908Z', 'value': 3},
{'date': '2024-03-27T12:01:35.428646Z', 'value': 3},
{'date': '2024-03-26T00:01:32.526347Z', 'value': 2},
{'date': '2024-03-25T00:01:31.329645Z', 'value': 2},
{'date': '2024-03-23T12:01:46.825814Z', 'value': 1},
{'date': '2024-03-22T12:01:32.049221Z', 'value': 1},
{'date': '2024-03-21T00:01:46.433282Z', 'value': 1}
],
'totalByTimePeriod': 7
},
{
'OS': 'macOS',
'graph': [
{'date': '2024-07-14T00:01:37.275468Z', 'value': 1},
{'date': '2024-07-13T00:01:43.380741Z', 'value': 1},
{'date': '2024-07-12T00:01:19.887135Z', 'value': 1},
{'date': '2024-07-11T00:01:47.184018Z', 'value': 1},
{'date': '2024-07-10T00:00:48.391079Z', 'value': 1},
{'date': '2024-07-09T00:01:33.777787Z', 'value': 1},
{'date': '2024-06-17T00:01:08.12609Z', 'value': 1},
{'date': '2024-06-16T00:01:01.531537Z', 'value': 1},
{'date': '2024-06-14T12:01:08.531742Z', 'value': 1},
{'date': '2024-06-13T12:01:02.655126Z', 'value': 1},
{'date': '2024-06-12T00:00:59.128227Z', 'value': 1},
{'date': '2024-06-10T12:00:59.240309Z', 'value': 2},
{'date': '2024-06-09T00:01:04.631426Z', 'value': 2},
{'date': '2024-06-08T00:00:55.83731Z', 'value': 2},
{'date': '2024-06-06T12:01:04.72595Z', 'value': 2},
{'date': '2024-06-05T00:01:00.627937Z', 'value': 2},
{'date': '2024-06-03T12:01:04.926196Z', 'value': 2},
{'date': '2024-06-02T00:02:00.333735Z', 'value': 2},
{'date': '2024-06-01T00:01:44.626906Z', 'value': 2},
{'date': '2024-05-30T12:02:03.632423Z', 'value': 2},
{'date': '2024-05-29T12:02:02.951093Z', 'value': 2},
{'date': '2024-05-28T00:01:51.731614Z', 'value': 2},
{'date': '2024-05-26T12:01:56.628098Z', 'value': 2},
{'date': '2024-05-25T00:01:47.23414Z', 'value': 2},
{'date': '2024-05-23T12:01:47.029114Z', 'value': 2},
{'date': '2024-05-22T00:01:42.22735Z', 'value': 2},
{'date': '2024-05-20T12:01:44.445997Z', 'value': 1},
{'date': '2024-05-19T00:01:47.433222Z', 'value': 1},
{'date': '2024-05-18T00:01:38.838865Z', 'value': 1},
{'date': '2024-05-17T00:01:30.438359Z', 'value': 1},
{'date': '2024-05-15T12:01:36.73974Z', 'value': 2},
{'date': '2024-05-14T12:01:34.03965Z', 'value': 2},
{'date': '2024-05-13T00:01:44.331524Z', 'value': 2},
{'date': '2024-05-12T00:01:36.930308Z', 'value': 2},
{'date': '2024-05-10T12:01:46.746983Z', 'value': 2},
{'date': '2024-05-09T12:01:35.442937Z', 'value': 2},
{'date': '2024-05-08T12:01:30.228991Z', 'value': 2},
{'date': '2024-05-07T00:01:51.856125Z', 'value': 2},
{'date': '2024-05-06T00:01:46.526072Z', 'value': 2},
{'date': '2024-05-05T00:01:38.734398Z', 'value': 2},
{'date': '2024-05-04T00:01:36.926854Z', 'value': 2},
{'date': '2024-05-02T12:01:48.339086Z', 'value': 2},
{'date': '2024-05-01T00:01:53.641276Z', 'value': 2},
{'date': '2024-04-30T00:01:32.436276Z', 'value': 2},
{'date': '2024-04-28T12:01:42.827332Z', 'value': 2},
{'date': '2024-04-27T12:01:31.836722Z', 'value': 2},
{'date': '2024-04-26T00:01:51.333912Z', 'value': 2},
{'date': '2024-04-25T00:01:32.026909Z', 'value': 2},
{'date': '2024-04-23T12:01:47.136997Z', 'value': 2},
{'date': '2024-04-22T00:01:41.434517Z', 'value': 2},
{'date': '2024-04-20T12:01:48.747201Z', 'value': 2},
{'date': '2024-04-19T12:01:39.629344Z', 'value': 2},
{'date': '2024-04-18T00:01:53.337746Z', 'value': 1},
{'date': '2024-04-17T00:01:30.257114Z', 'value': 1}
],
'totalByTimePeriod': 2
}
],
'error': null
});

	mockData.actionResults = req => ({data: makeArr(req?.len ?? PAGE_LEN).map((_, i) => mockData.mochActionResult(i, req)), rowCount: 1235});

	mockData.altIntuneConfig = () => ({
'result': null,
'data': [
{'topicCode': 'gyt1001LackMFAAuthentication', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:30:27.132487Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1002BlockLegacyAuthentication', 'isAlert': true, 'lastUpdateTime': '2024-06-26T23:30:27.964681Z', 'firstPassedTime': null, 'firstAlertTime': '2024-04-02T08:15:05.104124Z', 'payload': 'null'},
{'topicCode': 'gyt1010RestrictGuestAccessToCloudAppsManager', 'isAlert': true, 'lastUpdateTime': '2024-06-26T23:30:58.217515Z', 'firstPassedTime': null, 'firstAlertTime': '2024-04-25T09:28:49.006495Z', 'payload': 'null'},
{'topicCode': 'gyt1013RequireDeviceCompliance', 'isAlert': true, 'lastUpdateTime': '2024-06-26T23:30:58.38218Z', 'firstPassedTime': null, 'firstAlertTime': '2024-04-02T08:15:39.839725Z', 'payload': 'null'},
{'topicCode': 'gyt1014UnmanagedDeviceAccess', 'isAlert': true, 'lastUpdateTime': '2024-06-26T23:30:59.201658Z', 'firstPassedTime': null, 'firstAlertTime': '2024-04-02T08:15:40.143372Z', 'payload': 'null'},
{'topicCode': 'gyt1016LackRestricationsForCloudManagementInterfaces', 'isAlert': true, 'lastUpdateTime': '2024-06-26T23:30:59.372118Z', 'firstPassedTime': null, 'firstAlertTime': '2024-04-02T08:15:40.45178Z', 'payload': 'null'},
{'topicCode': 'gyt1032PoliciesDisabled', 'isAlert': true, 'lastUpdateTime': '2024-06-26T23:30:59.529435Z', 'firstPassedTime': null, 'firstAlertTime': '2024-04-02T08:15:40.86984Z', 'payload': '{"Policies Names":["(temp) session timeout"]}'},
{'topicCode': 'gyt1034PoliciesWithoutAssignedUsers', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:30:59.852746Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1087RiskEventTypeOnFailedLoginUnknownFutureValue', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.334511Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1088RiskEventTypeOnFailedLoginRiskEventTypeUnlikelyTravel', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.339676Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1090RiskEventTypeOnFailedLoginAnonymizedIPAddress', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.349464Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1091RiskEventTypeOnFailedLoginGeneric', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.354377Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1092RiskEventTypeOnFailedLoginInvestigationsThreatIntelligence', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.359443Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1101RiskEventTypeOnFailedLoginUnfamiliarFeatures', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.454878Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1102RiskEventTypeOnFailedLoginUnknownFutureValue', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.459736Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1036NoSignInForLongTime', 'isAlert': true, 'lastUpdateTime': '2024-06-26T23:38:39.832415Z', 'firstPassedTime': '2024-04-30T12:32:36.535127Z', 'firstAlertTime': '2024-05-02T11:31:14.343592Z'},
{'topicCode': 'gyt1009AuditLogNoMFAForMediumRiskAuthentication', 'isAlert': false, 'lastUpdateTime': '2024-04-05T23:30:47.942384Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1010RestrictGuestAccessToCloudApps', 'isAlert': true, 'lastUpdateTime': '2024-04-05T23:30:51.402523Z', 'firstPassedTime': null, 'firstAlertTime': '2024-04-02T08:15:39.523513Z', 'payload': 'null'},
{'topicCode': 'gyt1037NoSignInForLongTime', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:39.838454Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1038NoSignInForLongTime', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:39.84364Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1044RiskEventTypeOnSucessfullLoginAdminConfirmedUserCompromised', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:39.848393Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1047RiskEventTypeOnSucessfullLoginInvestigationsThreatIntelligence', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:39.92506Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1048RiskEventTypeOnSucessfullLoginInvestigationsThreatIntelligenceSigninLinked', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:39.929848Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1049RiskEventTypeOnSucessfullLoginLeakedCredentials', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:39.934309Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1061RiskEventTypeOnSucessfullLoginGeneric', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.028006Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1017DisableTokenPersistence', 'isAlert': true, 'lastUpdateTime': '2024-04-05T23:30:52.914228Z', 'firstPassedTime': null, 'firstAlertTime': '2024-04-02T08:15:42.2361Z', 'payload': '{"Admin Roles Names Without Token Persistace List":["Identity Governance Administrator","User Administrator","Billing Administrator","Conditional Access Administrator","Service Support Administrator","Azure AD Joined Device Local Administrator","Global Administrator","License Administrator","Compliance Data Administrator","Helpdesk Administrator","Cloud Application Administrator","Security Administrator","Intune Administrator"]}'},
{'topicCode': 'gyt1008DeviceNotManaged', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.133712Z', 'firstPassedTime': '2024-06-08T11:36:23.64545Z', 'firstAlertTime': '2024-04-25T09:35:27.871823Z', 'payload': 'null'},
{'topicCode': 'gyt1009DeviceNotManaged', 'isAlert': true, 'lastUpdateTime': '2024-06-26T23:38:40.138662Z', 'firstPassedTime': null, 'firstAlertTime': '2024-04-25T09:35:27.876458Z'},
{'topicCode': 'gyt1105RiskLevelHighDuringSignin', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.148666Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1086RiskEventTypeOnFailedLoginUnfamiliarFeatures', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.329729Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1033PoliciesInReportOnlyState', 'isAlert': true, 'lastUpdateTime': '2024-06-26T23:30:59.685691Z', 'firstPassedTime': null, 'firstAlertTime': '2024-04-02T08:15:41.240072Z', 'payload': '{"Policies Names":["sdasdasdasdasdRequire multifactor authentication for adminsddddddddd"]}'},
{'topicCode': 'gyt1104RiskLevelHighDuringSignin', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.14369Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1050RiskEventTypeOnSucessfullLoginMaliciousIPAddress', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:39.938846Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1051RiskEventTypeOnSucessfullLoginMaliciousIPAddressValidCredentialsBlockedIP', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:39.943374Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1052RiskEventTypeOnSucessfullLoginMalwareInfectedIPAddress', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:39.947729Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1053RiskEventTypeOnSucessfullLoginMcasImpossibleTravel', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:39.952094Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1054RiskEventTypeOnSucessfullLoginMcasSuspiciousInboxManipulationRules', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:39.956725Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1055RiskEventTypeOnSucessfullLoginSuspiciousIPAddress', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:39.961217Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1056RiskEventTypeOnSucessfullLoginUnfamiliarFeatures', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:39.965611Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1057RiskEventTypeOnSucessfullLoginUnknownFutureValue', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:39.969984Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1058RiskEventTypeOnSucessfullLoginRiskEventTypeUnlikelyTravel', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:39.974421Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1059RiskEventTypeOnSucessfullLoginAdminConfirmedUserCompromised', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:39.978988Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1060RiskEventTypeOnSucessfullLoginAnonymizedIPAddress', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.023162Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1062RiskEventTypeOnSucessfullLoginInvestigationsThreatIntelligence', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.032599Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1063RiskEventTypeOnSucessfullLoginInvestigationsThreatIntelligenceSigninLinked', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.037099Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1064RiskEventTypeOnSucessfullLoginLeakedCredentials', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.041738Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1065RiskEventTypeOnSucessfullLoginMaliciousIPAddress', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.046145Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1066RiskEventTypeOnSucessfullLoginMaliciousIPAddressValidCredentialsBlockedIP', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.050673Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1067RiskEventTypeOnSucessfullLoginMalwareInfectedIPAddress', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.055192Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1068RiskEventTypeOnSucessfullLoginMcasImpossibleTravel', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.059682Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1069RiskEventTypeOnSucessfullLoginMcasSuspiciousInboxManipulationRules', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.064098Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1070RiskEventTypeOnSucessfullLoginSuspiciousIPAddress', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.068787Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1071RiskEventTypeOnSucessfullLoginUnfamiliarFeatures', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.073431Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1072RiskEventTypeOnSucessfullLoginUnknownFutureValue', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.077972Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1073RiskEventTypeOnSucessfullLoginRiskEventTypeUnlikelyTravel', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.082406Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1041NoCompliant', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.123236Z', 'firstPassedTime': '2024-06-08T11:36:23.636367Z', 'firstAlertTime': '2024-04-25T09:35:27.862873Z', 'payload': 'null'},
{'topicCode': 'gyt1042NoCompliant', 'isAlert': true, 'lastUpdateTime': '2024-06-26T23:38:40.128691Z', 'firstPassedTime': null, 'firstAlertTime': '2024-04-25T09:35:27.867393Z'},
{'topicCode': 'gyt1089RiskEventTypeOnFailedLoginAdminConfirmedUserCompromised', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.344573Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1093RiskEventTypeOnFailedLoginInvestigationsThreatIntelligenceSigninLinked', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.364384Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1100RiskEventTypeOnFailedLoginSuspiciousIPAddress', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.450064Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1008RestrictLegacyAuthenticationProtocols', 'isAlert': true, 'lastUpdateTime': '2024-06-26T23:30:28.15152Z', 'firstPassedTime': null, 'firstAlertTime': '2024-04-02T08:15:05.823828Z', 'payload': 'null'},
{'topicCode': 'gyt1003NoMFAForMediumRiskUsers', 'isAlert': true, 'lastUpdateTime': '2024-06-26T23:30:28.343491Z', 'firstPassedTime': null, 'firstAlertTime': '2024-04-02T08:15:06.146382Z', 'payload': 'null'},
{'topicCode': 'gyt1004NoMFAForMediumRiskAuthentication', 'isAlert': true, 'lastUpdateTime': '2024-06-26T23:30:28.50992Z', 'firstPassedTime': null, 'firstAlertTime': '2024-04-02T08:15:06.329099Z', 'payload': 'null'},
{'topicCode': 'gyt1005BlockHighUserRisk', 'isAlert': true, 'lastUpdateTime': '2024-06-26T23:30:28.674709Z', 'firstPassedTime': null, 'firstAlertTime': '2024-04-02T08:15:06.484585Z', 'payload': 'null'},
{'topicCode': 'gyt1006BlockHighSignInRisk', 'isAlert': true, 'lastUpdateTime': '2024-06-26T23:30:28.846793Z', 'firstPassedTime': null, 'firstAlertTime': '2024-04-02T08:15:06.699572Z', 'payload': 'null'},
{'topicCode': 'gyt1007LimitLoginAllowedCountries', 'isAlert': true, 'lastUpdateTime': '2024-06-26T23:30:29.008477Z', 'firstPassedTime': null, 'firstAlertTime': '2024-04-02T08:15:06.895074Z', 'payload': 'null'},
{'topicCode': 'gyt1095RiskEventTypeOnFailedLoginMaliciousIPAddress', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.425012Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1096RiskEventTypeOnFailedLoginMaliciousIPAddressValidCredentialsBlockedIP', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.430086Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1097RiskEventTypeOnFailedLoginMalwareInfectedIPAddress', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.434993Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1098RiskEventTypeOnFailedLoginMcasImpossibleTravel', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.439982Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1099RiskEventTypeOnFailedLoginMcasSuspiciousInboxManipulationRules', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.44501Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1035PoliciesWithoutAssignedTargets', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:31:00.024812Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1017DisableTokenPersistenceManager', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:31:00.317097Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1039NoSignInAtAll', 'isAlert': true, 'lastUpdateTime': '2024-06-26T23:38:39.230644Z', 'firstPassedTime': null, 'firstAlertTime': '2024-04-25T09:35:27.510735Z'},
{'topicCode': 'gyt1040NoSignInAtAll', 'isAlert': true, 'lastUpdateTime': '2024-06-26T23:38:39.23687Z', 'firstPassedTime': null, 'firstAlertTime': '2024-04-25T09:35:27.515994Z'},
{'topicCode': 'gyt1045RiskEventTypeOnSucessfullLoginAnonymizedIPAddress', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:39.853034Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1046RiskEventTypeOnSucessfullLoginGeneric', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:39.857586Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1106RiskLevelMediumDuringSignin', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.153381Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1107RiskLevelMediumDuringSignin', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.158536Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1074RiskEventTypeOnFailedLoginAdminConfirmedUserCompromised', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.22526Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1075RiskEventTypeOnFailedLoginAnonymizedIPAddress', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.230278Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1076RiskEventTypeOnFailedLoginGeneric', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.234995Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1077RiskEventTypeOnFailedLoginInvestigationsThreatIntelligence', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.239658Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1078RiskEventTypeOnFailedLoginInvestigationsThreatIntelligenceSigninLinked', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.244156Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1079RiskEventTypeOnFailedLoginLeakedCredentials', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.248893Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1080RiskEventTypeOnFailedLoginMaliciousIPAddress', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.253562Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1081RiskEventTypeOnFailedLoginMaliciousIPAddressValidCredentialsBlockedIP', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.25816Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1082RiskEventTypeOnFailedLoginMalwareInfectedIPAddress', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.262665Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1083RiskEventTypeOnFailedLoginMcasImpossibleTravel', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.267339Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1084RiskEventTypeOnFailedLoginMcasSuspiciousInboxManipulationRules', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.271944Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1085RiskEventTypeOnFailedLoginSuspiciousIPAddress', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.324818Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1094RiskEventTypeOnFailedLoginLeakedCredentials', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.369076Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'},
{'topicCode': 'gyt1103RiskEventTypeOnFailedLoginRiskEventTypeUnlikelyTravel', 'isAlert': false, 'lastUpdateTime': '2024-06-26T23:38:40.464432Z', 'firstPassedTime': null, 'firstAlertTime': null, 'payload': 'null'}
]
});

	mockData.notifTotals = () => ({
'data': [
{'type': 'clientLog', 'count': 8},
{'type': 'offlineExport', 'count': 52}
]
});
	mockData.statsModules = () => ({
modules: [
{module: 'miscon', alerts: 7492},
{module: 'benchmark', alerts: 7492},
{module: 'ad', alerts: 7492},
{module: 'gp', alerts: 7492}
]
});

	mockData.mochOsGraphs = () => ({
'graph': [
{'date': '2024-05-04T00:01:36.926854Z', 'windows': 8, 'linux': 2, 'mac': 2, 'networkSensor': 1},
{'date': '2024-06-18T00:01:11.52475Z', 'windows': 11, 'linux': 4, 'mac': 0, 'networkSensor': 1},
{'date': '2024-06-01T00:01:44.626906Z', 'windows': 10, 'linux': 4, 'mac': 2},
{'date': '2024-05-30T12:02:03.632423Z', 'windows': 10, 'linux': 4, 'mac': 2},
{'date': '2024-04-26T00:01:51.333912Z', 'windows': 8, 'linux': 3, 'mac': 2},
{'date': '2024-04-01T12:01:44.445513Z', 'windows': 8, 'linux': 3, 'mac': 0},
{'date': '2024-05-22T00:01:42.22735Z', 'windows': 8, 'linux': 2, 'mac': 2},
{'date': '2024-05-14T12:01:34.03965Z', 'windows': 8, 'linux': 2, 'mac': 2},
{'date': '2024-03-26T00:01:32.526347Z', 'windows': 5, 'linux': 2, 'mac': 0},
{'date': '2024-06-06T12:01:04.72595Z', 'windows': 11, 'linux': 3, 'mac': 2},
{'date': '2024-06-30T00:01:05.630301Z', 'windows': 11, 'linux': 6, 'mac': 0},
{'date': '2024-07-05T00:01:37.773356Z', 'windows': 9, 'linux': 5, 'mac': 0},
{'date': '2024-03-27T12:01:35.428646Z', 'windows': 8, 'linux': 3, 'mac': 0},
{'date': '2024-04-03T00:01:29.138239Z', 'windows': 8, 'linux': 3, 'mac': 0},
{'date': '2024-05-10T12:01:46.746983Z', 'windows': 8, 'linux': 2, 'mac': 2},
{'date': '2024-04-15T12:01:32.134707Z', 'windows': 7, 'linux': 3, 'mac': 0},
{'date': '2024-06-19T00:01:17.432434Z', 'windows': 11, 'linux': 4, 'mac': 0},
{'date': '2024-04-05T12:01:31.526188Z', 'windows': 8, 'linux': 3, 'mac': 0},
{'date': '2024-04-17T00:01:30.257114Z', 'windows': 7, 'linux': 2, 'mac': 1},
{'date': '2024-06-23T00:01:13.07666Z', 'windows': 9, 'linux': 4, 'mac': 0},
{'date': '2024-07-06T00:01:27.797474Z', 'windows': 9, 'linux': 5, 'mac': 0},
{'date': '2024-04-10T00:01:52.128539Z', 'windows': 8, 'linux': 3, 'mac': 0},
{'date': '2024-07-01T00:00:50.172793Z', 'windows': 11, 'linux': 6, 'mac': 0},
{'date': '2024-07-03T00:01:25.573563Z', 'windows': 9, 'linux': 5, 'mac': 0},
{'date': '2024-04-22T00:01:41.434517Z', 'windows': 7, 'linux': 3, 'mac': 2},
{'date': '2024-06-27T00:01:15.926169Z', 'windows': 10, 'linux': 5, 'mac': 0},
{'date': '2024-03-28T12:01:47.432908Z', 'windows': 8, 'linux': 3, 'mac': 0},
{'date': '2024-04-04T00:01:30.940089Z', 'windows': 8, 'linux': 3, 'mac': 0},
{'date': '2024-04-20T12:01:48.747201Z', 'windows': 7, 'linux': 3, 'mac': 2},
{'date': '2024-06-08T00:00:55.83731Z', 'windows': 11, 'linux': 3, 'mac': 2},
{'date': '2024-05-07T00:01:51.856125Z', 'windows': 8, 'linux': 2, 'mac': 2},
{'date': '2024-06-24T00:01:09.430653Z', 'windows': 9, 'linux': 5, 'mac': 0},
{'date': '2024-06-05T00:01:00.627937Z', 'windows': 10, 'linux': 4, 'mac': 2},
{'date': '2024-03-31T12:01:30.334054Z', 'windows': 8, 'linux': 3, 'mac': 0},
{'date': '2024-03-23T12:01:46.825814Z', 'windows': 4, 'linux': 1, 'mac': 0},
{'date': '2024-04-08T00:01:40.627319Z', 'windows': 8, 'linux': 3, 'mac': 0},
{'date': '2024-03-22T12:01:32.049221Z', 'windows': 4, 'linux': 1, 'mac': 0},
{'date': '2024-05-12T00:01:36.930308Z', 'windows': 8, 'linux': 2, 'mac': 2},
{'date': '2024-06-02T00:02:00.333735Z', 'windows': 11, 'linux': 4, 'mac': 2},
{'date': '2024-05-09T12:01:35.442937Z', 'windows': 8, 'linux': 2, 'mac': 2},
{'date': '2024-04-28T12:01:42.827332Z', 'windows': 8, 'linux': 3, 'mac': 2},
{'date': '2024-07-08T00:01:38.873031Z', 'windows': 9, 'linux': 4, 'mac': 0},
{'date': '2024-05-02T12:01:48.339086Z', 'windows': 8, 'linux': 3, 'mac': 2},
{'date': '2024-07-09T00:01:33.777787Z', 'windows': 9, 'linux': 4, 'mac': 1},
{'date': '2024-06-22T00:01:14.131627Z', 'windows': 9, 'linux': 4, 'mac': 0},
{'date': '2024-03-30T00:01:31.233018Z', 'windows': 8, 'linux': 3, 'mac': 0},
{'date': '2024-06-03T12:01:04.926196Z', 'windows': 10, 'linux': 4, 'mac': 2},
{'date': '2024-06-20T00:00:58.734369Z', 'windows': 9, 'linux': 4, 'mac': 0},
{'date': '2024-06-21T00:01:07.329734Z', 'windows': 9, 'linux': 4, 'mac': 0},
{'date': '2024-05-05T00:01:38.734398Z', 'windows': 8, 'linux': 2, 'mac': 2},
{'date': '2024-04-11T12:01:42.433517Z', 'windows': 7, 'linux': 3, 'mac': 0},
{'date': '2024-04-25T00:01:32.026909Z', 'windows': 8, 'linux': 3, 'mac': 2},
{'date': '2024-06-25T00:01:04.232177Z', 'windows': 10, 'linux': 6, 'mac': 0},
{'date': '2024-04-13T00:01:30.336471Z', 'windows': 7, 'linux': 3, 'mac': 0},
{'date': '2024-07-04T00:01:23.975149Z', 'windows': 9, 'linux': 5, 'mac': 0},
{'date': '2024-03-19T12:01:50.337535Z', 'windows': 4, 'linux': 0, 'mac': 0},
{'date': '2024-03-18T12:01:26.626709Z', 'windows': 4, 'linux': 0, 'mac': 0},
{'date': '2024-06-09T00:01:04.631426Z', 'windows': 10, 'linux': 3, 'mac': 2},
{'date': '2024-06-17T00:01:08.12609Z', 'windows': 10, 'linux': 4, 'mac': 1},
{'date': '2024-04-18T00:01:53.337746Z', 'windows': 7, 'linux': 2, 'mac': 1},
{'date': '2024-05-01T00:01:53.641276Z', 'windows': 8, 'linux': 3, 'mac': 2},
{'date': '2024-05-18T00:01:38.838865Z', 'windows': 7, 'linux': 2, 'mac': 1},
{'date': '2024-06-16T00:01:01.531537Z', 'windows': 11, 'linux': 4, 'mac': 1},
{'date': '2024-07-02T00:01:19.177146Z', 'windows': 10, 'linux': 6, 'mac': 0},
{'date': '2024-05-19T00:01:47.433222Z', 'windows': 7, 'linux': 2, 'mac': 1},
{'date': '2024-07-07T00:00:45.986384Z', 'windows': 9, 'linux': 5, 'mac': 0},
{'date': '2024-05-06T00:01:46.526072Z', 'windows': 8, 'linux': 2, 'mac': 2},
{'date': '2024-06-10T12:00:59.240309Z', 'windows': 11, 'linux': 3, 'mac': 2},
{'date': '2024-06-13T12:01:02.655126Z', 'windows': 11, 'linux': 3, 'mac': 1},
{'date': '2024-04-30T00:01:32.436276Z', 'windows': 8, 'linux': 3, 'mac': 2},
{'date': '2024-06-26T00:01:10.227369Z', 'windows': 10, 'linux': 5, 'mac': 0},
{'date': '2024-05-17T00:01:30.438359Z', 'windows': 7, 'linux': 2, 'mac': 1},
{'date': '2024-06-28T00:01:05.257128Z', 'windows': 11, 'linux': 6, 'mac': 0},
{'date': '2024-05-29T12:02:02.951093Z', 'windows': 10, 'linux': 4, 'mac': 2},
{'date': '2024-04-07T00:01:39.246607Z', 'windows': 8, 'linux': 3, 'mac': 0},
{'date': '2024-05-08T12:01:30.228991Z', 'windows': 8, 'linux': 2, 'mac': 2},
{'date': '2024-06-14T12:01:08.531742Z', 'windows': 11, 'linux': 4, 'mac': 1},
{'date': '2024-06-12T00:00:59.128227Z', 'windows': 11, 'linux': 3, 'mac': 1},
{'date': '2024-05-13T00:01:44.331524Z', 'windows': 8, 'linux': 2, 'mac': 2},
{'date': '2024-06-29T00:01:13.941654Z', 'windows': 11, 'linux': 6, 'mac': 0},
{'date': '2024-05-28T00:01:51.731614Z', 'windows': 10, 'linux': 4, 'mac': 2},
{'date': '2024-07-11T00:01:47.184018Z', 'windows': 8, 'linux': 5, 'mac': 1},
{'date': '2024-03-21T00:01:46.433282Z', 'windows': 4, 'linux': 1, 'mac': 0},
{'date': '2024-04-09T00:01:48.927089Z', 'windows': 8, 'linux': 3, 'mac': 0},
{'date': '2024-04-27T12:01:31.836722Z', 'windows': 8, 'linux': 3, 'mac': 2},
{'date': '2024-05-20T12:01:44.445997Z', 'windows': 9, 'linux': 2, 'mac': 1},
{'date': '2024-05-25T00:01:47.23414Z', 'windows': 9, 'linux': 4, 'mac': 2},
{'date': '2024-04-14T00:01:35.236733Z', 'windows': 7, 'linux': 3, 'mac': 0},
{'date': '2024-07-10T00:00:48.391079Z', 'windows': 8, 'linux': 4, 'mac': 1},
{'date': '2024-04-23T12:01:47.136997Z', 'windows': 7, 'linux': 3, 'mac': 2},
{'date': '2024-05-15T12:01:36.73974Z', 'windows': 8, 'linux': 2, 'mac': 2},
{'date': '2024-04-19T12:01:39.629344Z', 'windows': 7, 'linux': 3, 'mac': 2},
{'date': '2024-05-23T12:01:47.029114Z', 'windows': 9, 'linux': 4, 'mac': 2},
{'date': '2024-05-26T12:01:56.628098Z', 'windows': 9, 'linux': 4, 'mac': 2},
{'date': '2024-03-25T00:01:31.329645Z', 'windows': 5, 'linux': 2, 'mac': 0}
]
});

	mockData.mochLastestVers = () => ({
'data': [
{channel: 'latest', 'clientType': 'AD Domain Agent', 'clientVer': '1.24.0808.0', url: ' ', 'releaseDate': '0001-01-01T00:00:00', 'whatsNew': '', 'urlExpire': '2024-12-17T12:47:32.045561Z'},
{channel: 'latest', 'clientType': 'AD GPO Assessor', 'clientVer': '1.28.1.25', 'url': '', 'releaseDate': '0001-01-01T00:00:00', 'whatsNew': '', 'urlExpire': '2024-12-17T12:47:32.045561Z'},
{channel: 'latest', 'clientType': 'Linux aarch64 (rpm)', 'clientVer': '2.0.0.4-git-feature', 'releaseDate': '0001-01-01T00:00:00', 'whatsNew': '', 'url': 'sd', 'urlExpire': '2024-12-17T12:47:32.045561Z'},
{channel: 'latest', 'clientType': 'Windows x64', 'clientVer': '2.33.6.0', 'releaseDate': '0001-01-01T00:00:00', 'whatsNew': '', 'url': 'sd', 'urlExpire': '2024-12-17T11:00:09.644592Z'},
{channel: 'latest', 'clientType': 'Apple silicon Mac', 'clientVer': '1.20.1.17', 'releaseDate': '0001-01-01T00:00:00', 'whatsNew': '', 'url': 'dsf', 'urlExpire': '2024-12-17T11:00:10.236252Z'},
{channel: 'latest', 'clientType': 'Windows x86', 'clientVer': '2.33.6.0', 'releaseDate': '0001-01-01T00:00:00', 'whatsNew': '', 'url': 'sa', 'urlExpire': '2024-12-17T11:00:10.137495Z'},
{channel: 'latest', 'clientType': 'Linux x86_64 (deb)', 'clientVer': '2.0.0.4-git-feature', 'releaseDate': '0001-01-01T00:00:00', 'whatsNew': '', 'url': 'k', 'urlExpire': '2024-12-17T12:47:31.445284Z'},
{channel: 'latest', 'clientType': 'Linux x86_64 (rpm)', 'clientVer': '2.0.0.4-git-feature', 'releaseDate': '0001-01-01T00:00:00', 'whatsNew': '', 'url': 'k', 'urlExpire': '2024-12-17T12:47:31.843548Z'},
{channel: 'latest', 'clientType': 'Intel Mac', 'clientVer': '1.20.1.17', 'releaseDate': '0001-01-01T00:00:00', 'whatsNew': '', 'url': 'k', 'urlExpire': '2024-12-17T11:00:10.152629Z'},
{channel: 'stable', 'clientType': 'AD Domain Agent', 'clientVer': '1.24.0808.0', url: ' ', 'releaseDate': '0001-01-01T00:00:00', 'whatsNew': '', 'urlExpire': '2024-12-17T12:47:32.045561Z'},
{channel: 'stable', 'clientType': 'AD GPO Assessor', 'clientVer': '1.24.0808.0', 'url': '', 'releaseDate': '0001-01-01T00:00:00', 'whatsNew': '', 'urlExpire': '2024-12-17T12:47:32.045561Z'},
{channel: 'stable', 'clientType': 'Linux aarch64 (rpm)', 'clientVer': '2.0.0.4', 'releaseDate': '0001-01-01T00:00:00', 'whatsNew': '', 'url': 'sd', 'urlExpire': '2024-12-17T12:47:32.045561Z'},
{channel: 'stable', 'clientType': 'Windows x64', 'clientVer': '2.33.6.0', 'releaseDate': '0001-01-01T00:00:00', 'whatsNew': '', 'url': 'sd', 'urlExpire': '2024-12-17T11:00:09.644592Z'},
{channel: 'stable', 'clientType': 'Apple silicon Mac', 'clientVer': '1.20.1.17', 'releaseDate': '0001-01-01T00:00:00', 'whatsNew': '', 'url': 'dsf', 'urlExpire': '2024-12-17T11:00:10.236252Z'},
{channel: 'stable', 'clientType': 'Windows x86', 'clientVer': '2.33.6.0', 'releaseDate': '0001-01-01T00:00:00', 'whatsNew': '', 'url': 'sa', 'urlExpire': '2024-12-17T11:00:10.137495Z'},
{channel: 'stable', 'clientType': 'Linux x86_64 (deb)', 'clientVer': '2.0.0.4', 'releaseDate': '0001-01-01T00:00:00', 'whatsNew': '', 'url': 'k', 'urlExpire': '2024-12-17T12:47:31.445284Z'},
{channel: 'stable', 'clientType': 'Linux x86_64 (rpm)', 'clientVer': '2.0.0.4', 'releaseDate': '0001-01-01T00:00:00', 'whatsNew': '', 'url': 'k', 'urlExpire': '2024-12-17T12:47:31.843548Z'},
{channel: 'stable', 'clientType': 'Intel Mac', 'clientVer': '1.20.1.17', 'releaseDate': '0001-01-01T00:00:00', 'whatsNew': '', 'url': 'k', 'urlExpire': '2024-12-17T11:00:10.152629Z'}
]
});

	mockData.mochClientUpdateBatch = () => ({
'data':[
{'channel': 'stable', 'ruleId':34, 'ruleName':'Linux', 'log':[{'byUser':'gust_abc@acme.com', 'date':'2024-03-26T10:33:23.141721Z', 'operation':'create'}], 'groupId':1010, 'groupName':'Debian Linux', 'isGroupDeleted':false, 'isEnabled':true, 'exclusionStart': 780, 'exclusionWindow': 60, 'exclusionWeekDay': 'Everyday', 'applyScheme':'afterTime', 'afterTime':720, 'timezone':180, 'weekDay':null, 'window':240, 'numComputers':Math.random()*350000 |0, 'numToUpdate':1},
{
'channel': 'latest',
'ruleId':67,
'ruleName':'AllEndpoints',
'log':[
{'byUser':'gust_abc@acme.com', 'date':'2024-03-26T12:56:44.153587Z', 'operation':'create'},
{'byUser':'gust_abc@acme.com', 'date':'2024-04-01T12:40:50.736152Z', 'operation':'update'},
{'byUser':'a_abc@acme.com', 'date':'2024-04-24T18:11:16.527324Z', 'operation':'update'}
],
'groupId':0,
'groupName':null,
'isGroupDeleted':false,
'isEnabled':false,
'applyScheme':'asap',
'afterTime':0,
'timezone':180,
'weekDay':'Sunday',
'window':0,
'numComputers':999,
'numToUpdate':8
},
{'channel': 'stable', 'ruleId':68, 'ruleName':'Ubuntu', 'log':[{'byUser':'gust_abc@acme.com', 'date':'2024-03-27T07:06:35.543297Z', 'operation':'create'}], 'groupId':119, 'groupName':'Ubuntu', 'isGroupDeleted':false, 'isEnabled':true, 'applyScheme':'asap', 'afterTime':0, 'timezone':0, 'weekDay':null, 'window':0, 'numComputers':1, 'numToUpdate':0},
{'channel': 'latest', 'ruleId':69, 'ruleName':'Olds', 'log':[{'byUser':'gust_abc@acme.com', 'date':'2024-03-27T07:08:16.242687Z', 'operation':'create'}], 'groupId':120, 'groupName':'OldsWindows', 'isGroupDeleted':false, 'isEnabled':true, 'applyScheme':'nextWeekDay', 'afterTime':480, 'timezone':0, 'weekDay':'Thursday', 'window':240, 'numComputers':2, 'numToUpdate':2},
{'channel': 'stable', 'ruleId':166, 'ruleName':'TestforQA', 'log':[{'byUser':'gust_abc@acme.com', 'date':'2024-04-09T19:01:03.525381Z', 'operation':'create'}], 'groupId':118, 'groupName':'Allwin10', 'isGroupDeleted':true, 'isEnabled':true, 'applyScheme':'nextWeekDay', 'afterTime':90, 'timezone':180, 'weekDay':'Sunday', 'window':0, 'numComputers':2, 'numToUpdate':2},
{'channel': 'latest', 'ruleId':168, 'ruleName':'MAC', 'log':[{'byUser':'gust_abc@acme.com', 'date':'2024-04-17T04:41:44.638848Z', 'operation':'create'}], 'groupId':1013, 'groupName':'macOS', 'isGroupDeleted':false, 'isEnabled':true, 'applyScheme':'asap', 'afterTime':0, 'timezone':180, 'weekDay':'Sunday', 'window':0, 'numComputers':2, 'numToUpdate':0},
{
'channel': 'stable',
'ruleId':171,
'ruleName':'All',
'log':[
{'byUser':'a_abc@acme.com', 'date':'2024-04-24T18:20:17.549727Z', 'operation':'create'},
{'byUser':'a_abc@acme.com', 'date':'2024-04-24T18:20:38.411047Z', 'operation':'update'},
{'byUser':'a_abc@acme.com', 'date':'2024-04-24T18:20:45.141376Z', 'operation':'update'}
],
'groupId':210,
'groupName':'Any',
'isGroupDeleted':false,
'isEnabled':true,
'applyScheme':'asap',
'afterTime':0,
'timezone':180,
'weekDay':'Sunday',
'window':0,
'numComputers':999,
'numToUpdate':8
}
]
});

	mockData.mochClientHealth = () => ({
'data': [
{'clientVer': '1.0.0', 'types': [{'os': 'AD Domain Agent', 'groupId': null, 'count': 2502, 'fqdn': 'test-gytpol', 'ipAddress': '127.0.1.1', 'reported': [{'period': '1d', 'periodOrder': 0, 'count': 1}]}]},
{'clientVer': '2.5.0', 'types': [{'os': 'AD Assessor', 'count': 1, 'fqdn': 'dc01.contoso.com', 'groupId': null, 'ipAddress': '192.168.1.100', 'reported': [{'count': 1, 'period': '1d', 'periodOrder': 0}]}]},
{'clientVer': '1.2.3', 'types': [{'os': 'AD Assessor', 'count': 1, 'fqdn': 'dev.contoso.com', 'groupId': null, 'ipAddress': '192.168.1.1', 'reported': [{'count': 1, 'period': '1d', 'periodOrder': 0}]}]},
{
'clientVer': '1.25.1202.0',
		'types': [
{'os': 'AD Assessor', 'count': 1, 'fqdn': 'test.dsrq1.example.com', 'groupId': null, 'ipAddress': '10.90.51.243', 'reported': [{'count': 1, 'period': '1d', 'periodOrder': 0}]},
{
'os': 'AD Assessor',
			'count': 1,
			'fqdn': 'test2.dsrq1.example.com',
			'groupId': null,
			'ipAddress': '10.90.51.81',
			'reported': [{'count': 1, 'period': '1d', 'periodOrder': 0}]
}
]
},
{
'clientVer': '2.37.7.0',
'types': [
{'os': 'Windows', 'groupId': 1003, 'count': 6454, 'reported': [{'period': '1d', 'periodOrder': 0, 'count': 6454}]},
{'os': 'Windows', 'groupId': 1005, 'count': 100, 'reported': [{'period': '1d', 'periodOrder': 0, 'count': 100}]},
{'os': 'Windows', 'groupId': 1006, 'count': 2000, 'reported': [{'period': '1d', 'periodOrder': 0, 'count': 2000}]}
]
},
{'clientVer': '2.33.6.0', 'types': [{'os': 'Windows', 'groupId': 1003, 'count': 946, 'reported': [{'period': '1d', 'periodOrder': 0, 'count': 946}]}]},
{'clientVer': '1.27.1.22', 'types': [{'os': 'macOS', 'groupId': 1013, 'count': 1, 'reported': [{'period': '1d', 'periodOrder': 0, 'count': 1}]}]},
{
'clientVer': '1.20.1.21',
'types': [
{'os': 'Linux', 'groupId': 1010, 'count': 1000, 'reported': [{'period': '1d', 'periodOrder': 0, 'count': 1000}]},
{'os': 'Linux', 'groupId': 1011, 'count': 1000, 'reported': [{'period': '1d', 'periodOrder': 0, 'count': 1000}]},
{'os': 'macOS', 'groupId': 1013, 'count': 999, 'reported': [{'period': '1d', 'periodOrder': 0, 'count': 999}]},
{'os': 'Linux', 'groupId': 1014, 'count': 500, 'reported': [{'period': '1d', 'periodOrder': 0, 'count': 500}]}
]
}
]
});

	mockData.mochActionLog = inp => req => ({
data: [
{'ruleId': 5078740, 'state': 'active', 'actionType': 'patch', 'actionDatum': 'download-and-install-os-patch', 'errorString': null, 'errorDate': null, 'remark': 'March cumulative \u2014 throttled rollout.', 'latestActivity': '2026-07-18T09:30:00Z', 'taskStatusCounts': {'pending': 9, 'success': 41, 'pendingReboot': 17, 'reverting': 0, 'reverted': 0, 'cancelled': 0, 'failed': 3, 'revertFailed': 0, 'revertCancelled': 0}, 'canRevert': true, 'user': 'miki.h@remedio.io', 'applyScheme': 'asap', 'afterTime': 0, 'timezone': 180, 'weekDay': null, 'window': 0, 'criteria': {'deviceId': 0, 'from': 0, 'groupId': 0, 'isExactComputerOu': false, 'isExactCve': false, 'isExactOs': false, 'isExactParam': false, 'isExactProduct': false, 'isExactVendor': false, 'len': 0, 'recalc': 0, 'ungrouped': false, 'actionType': 'remediate', 'actionDatum': 'download-and-install-os-patch', 'by': 'topicCode', 'topicCode': 'KB5078740', 'benchmarkOrg': 'OS_PATCH_MANAGEMENT', 'product': null, 'list': ['KB5078740'], 'listParamExtra': [], 'isListExclude': false}, 'log': [{'byUser': {'user': 'miki.h@remedio.io', 'userName': 'Miki H', 'title': null}, 'date': '2026-07-18T09:30:00Z', 'operation': 'create', 'notes': null}], 'approvalRequestId': null, 'approvalRequestIdExtra': null},
{
'ruleId': 17657,
'state': 'done',
'actionType': 'muteAlert',
'actionDatum': null,
'errorString': null,
'errorDate': null,
'remark': null,
'latestActivity': '2026-06-07T05:19:07.046637Z',
'taskStatusCounts': {'pendingReboot': 0, 'pending': 0, 'success': 0, 'reverting': 0, 'reverted': 0, 'cancelled': 1, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0},
'canRevert': false,
'user': 'ori@gytpol.com',
'applyScheme': 'asap',
'afterTime': 0,
'timezone': 180,
'weekDay': null,
'window': 0,
'criteria': {'deviceId': 0, 'from': 0, 'groupId': 0, 'isExactComputerOu': false, 'isExactCve': false, 'isExactOs': false, 'isExactParam': false, 'isExactProduct': false, 'isExactVendor': false, 'len': 0, 'recalc': 0, 'ungrouped': false, 'actionType': 'muteAlert', 'actionDatum': null, 'by': 'devices', 'topicCode': 'CVE-2026-46710', 'benchmarkOrg': 'APP_VULN_ASSESSMENT', 'listParamExtra': [], 'product': 'Notepad++ exe (x64)', paramExtra: '1.2.3', 'isListExclude': true, 'list': []},
'log': [
{'byUser': {'user': 'ori@gytpol.com', 'userName': null, 'title': ''}, 'date': '2026-06-07T05:19:07.046637Z', 'operation': 'deactivate', 'notes': null},
{'byUser': {'user': 'brachi@remedio.io', 'userName': 'brachi brachi', 'title': null}, 'date': '2026-06-04T20:09:04.047676Z', 'operation': 'create', 'notes': null}
],
'approvalRequestId': null,
'approvalRequestIdExtra': null
},
{'ruleId': 9100, 'state': 'active', 'actionType': 'remediate', 'actionDatum': null, 'errorString': null, 'errorDate': null, 'remark': null, 'latestActivity': '2026-06-20T10:00:00Z', 'taskStatusCounts': {'pendingReboot': 0, 'pending': 0, 'success': 2, 'reverting': 0, 'reverted': 0, 'cancelled': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0}, 'canRevert': true, 'user': 'yarden@gytpol.com', 'applyScheme': 'asap', 'afterTime': 0, 'timezone': 180, 'weekDay': null, 'window': 0, 'criteria': {'deviceId': 0, 'from': 0, 'groupId': 0, 'isExactComputerOu': false, 'isExactCve': false, 'isExactOs': false, 'isExactParam': false, 'isExactProduct': false, 'isExactVendor': false, 'len': 0, 'recalc': 0, 'ungrouped': false, 'actionType': 'remediate', 'by': 'devices', 'benchmarkOrg': 'CIS', 'policyId': '0199c1a7-1111-7aaa-8bbb-aa0817740001', 'policyName': 'AlmaLinux 8 - test', 'baseBenchmark': 'AlmaLinux_OS_8-3.0.0', 'ruleId': 'almalinux_os_8-3.0.0-1.7.4-ensure_access_to_etcmotd_is_configured', 'ruleName': 'Ensure access to /etc/motd is configured', 'list': [], 'listParamExtra': [], 'isListExclude': true}, 'log': [{'byUser': {'user': 'yarden@gytpol.com', 'userName': 'Jordan', 'title': 'VP UI'}, 'date': '2026-06-20T10:00:00Z', 'operation': 'create', 'notes': null}], 'approvalRequestId': null, 'approvalRequestIdExtra': null},
{
'ruleId': 826,
		'state': 'active',
		'actionType': 'muteAlert',
		'actionDatum': null,
		'errorString': null,
		'errorDate': null,
		'remark': null,
		'latestActivity': '2026-03-15T07:07:36.505698Z',
		'taskStatusCounts': {'pendingReboot': 0, 'pending': 0, 'success': 1, 'reverting': 0, 'reverted': 0, 'cancelled': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0},
		'canRevert': false,
		'user': 'yarden@gytpol.com',
		'applyScheme': 'asap',
		'afterTime': 0,
		'timezone': 120,
		'weekDay': null,
		'window': 0,
		'criteria': {'deviceId': 0, 'from': 0, 'groupId': 0, 'isExactComputerOu': false, 'isExactCve': false, 'isExactOs': false, 'isExactProduct': false, 'isExactVendor': false, 'isListExclude': false, 'len': 0, 'recalc': 0, 'ungrouped': false, 'actionType': 'muteAlert', 'actionDatum': null, 'by': 'alerts', 'topicCode': 'CVE-2023-46814', 'param': '188', 'isExactParam': true, 'benchmarkOrg': 'APP_VULN_ASSESSMENT', 'listParamExtra': ['1.0.0'], 'product': 'VLC media player (x86)', 'list': ['188']},
		'log': [{'byUser': {'user': 'yarden@gytpol.com', 'userName': 'Jordan', 'title': 'VP UI'}, 'date': '2026-03-15T07:07:36.505698Z', 'operation': 'create', 'notes': null}],
		'approvalRequestId': null,
		'approvalRequestIdExtra': null
},
{
'canRevert': false,
		'ruleId': 793,
		'state': 'deactivating',
		'actionType': 'remediate',
		'actionDatum': 'uninstall-generic',
		'errorString': null,
		'errorDate': null,
		'remark': null,
		'latestActivity': '2026-03-14T19:31:56.7198Z',
		'taskStatusCounts': {'pendingReboot': 0, 'pending': 1, 'success': 0, 'reverting': 0, 'reverted': 0, 'cancelled': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0},
		'user': 'yarden@gytpol.com',
		'applyScheme': 'asap',
		'afterTime': 0,
		'timezone': 120,
		'weekDay': null,
		'window': 0,
		'criteria': {'deviceId': 0, 'from': 0, 'groupId': 0, 'isExactComputerOu': false, 'isExactCve': false, 'isExactOs': false, 'isExactParam': false, 'isExactProduct': false, 'isExactVendor': false, 'len': 0, 'recalc': 0, 'ungrouped': false, 'actionType': 'remediate', 'actionDatum': 'uninstall-generic', 'by': 'devices', 'topicCode': 'Microsoft Corporation | BitLocker Drive Encryption', 'benchmarkOrg': 'APP_CONTROL', 'listParamExtra': [], 'isListExclude': true, 'list': []},
		'log': [
{'byUser': {'user': 'yarden@gytpol.com', 'userName': 'Jordan', 'title': 'VP UI'}, 'date': '2026-03-14T19:31:56.7198Z', 'operation': 'deactivate', 'notes': null},
{'byUser': {'user': 'yarden@gytpol.com', 'userName': 'Jordan', 'title': 'VP UI'}, 'date': '2026-03-14T19:31:15.417678Z', 'operation': 'create', 'notes': null}
],
		'approvalRequestId': null,
		'approvalRequestIdExtra': null
},
{
'ruleId': 9001,
		'state': 'activating',
		'actionType': 'remediate',
		'actionDatum': 'disableOfficeHTML',
		'errorString': null,
		'errorDate': null,
		'remark': null,
		'latestActivity': '2026-05-06T07:45:28.302927Z',
		'taskStatusCounts': {'pendingReboot': 0, 'pending': 0, 'success': 0, 'reverting': 0, 'reverted': 0, 'cancelled': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0},
		'canRevert': false,
		'user': 'yarden@gytpol.com',
		'applyScheme': 'asap',
		'afterTime': 0,
		'timezone': 180,
		'weekDay': null,
		'window': 0,
		'criteria': {'deviceId': 0, 'from': 0, 'groupId': 0, 'isExactComputerOu': false, 'isExactCve': false, 'isExactOs': false, 'isExactParam': false, 'isExactProduct': false, 'isExactVendor': false, 'len': 0, 'recalc': 0, 'ungrouped': false, 'actionType': 'remediate', 'actionDatum': 'disableOfficeHTML', 'by': 'alerts', 'topicCode': 'gytOfficeHTML', 'listParamExtra': [], 'isListExclude': true, 'list': []},
		'log': [{'byUser': {'user': 'yarden@gytpol.com', 'userName': 'Jordan', 'title': null}, 'date': '2026-05-06T07:45:28.302927Z', 'operation': 'create', 'notes': null}],
		'approvalRequestId': null,
		'approvalRequestIdExtra': null,
		'tasksExpanding': true
},
{
'canRevert': false,
		'ruleId': 4726,
		'state': 'active',
		'actionType': 'generic',
		'actionDatum': 'add-labels',
		'errorString': null,
		'errorDate': null,
		'remark': null,
		'latestActivity': '2025-09-30T13:13:05.676261Z',
		'taskStatusCounts': {'pendingReboot': 0, 'pending': 1, 'success': 0, 'reverting': 0, 'reverted': 0, 'cancelled': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0},
		'user': 'sh@gytpol.com',
		'applyScheme': 'asap',
		'afterTime': 0,
		'timezone': 180,
		'weekDay': null,
		'window': 0,
		'criteria': {'deviceId': 0, 'from': 0, 'groupId': 0, 'isExactComputerOu': false, 'isExactCve': false, 'isExactOs': false, 'isExactParam': false, 'isExactProduct': false, 'isExactVendor': false, 'isListExclude': false, 'len': 0, 'recalc': 0, 'ungrouped': false, 'actionType': 'generic', 'actionDatum': 'add-labels', 'by': 'devices', 'genericActionParam': 'sdfgsdfg,fghjgfj,fghjfghjfgj,dfgert,nvbcn,werws,dfgtrhbn,yukyum,ertdfb,fghjgfjs', 'list': [], 'listIds': [565]},
		'log': [{'byUser': {'user': 'com@gytpol.com', 'userName': 'Some-very-long-given-name-and-check-2.11.1', 'title': ''}, 'date': '2025-09-30T13:13:05.676261Z', 'operation': 'create', 'notes': null}],
		'approvalRequestId': null,
		'approvalRequestIdExtra': null
},
...makeArr(req.len).map(i => ({
'ruleId': (req.from ?? 0) + i,
		'canRevert': i % 2 === 0,
		'state': activeStateDefsOpts[i % 8]?.k,
		'actionType': actionDefsArr[i % 5]?.k,
		'actionDatum': !i? null :actionDefsArr[i % 5]?.k === 'generic' ? 'set-labels' : 'macDisableSMBShare',
		expiration: '2024-07-08T13:13:29.166799Z',
		'errorString': 'Cannot fully activate rule 2113.\nAlert 38856 is already remediated by rule 1915.\nAlert 39220 is already remediated by rule 1915.',
		'errorDate': null,
		'remark': null,
		'latestActivity': '2024-07-08T13:13:29.166799Z',
		log: [
{byUser: {user: 'george@acme.com', userName: 'George Mann'}, date: '2024-07-08T13:13:29.166799Z', operation: 'revert'},
{byUser: {user: 'george@acme.com', userName: 'George Mann'}, date: '2024-07-08T13:13:29.166799Z', operation: 'revert-task', deviceName: 'macbook'},
{byUser: {user: 'george@acme.com', userName: 'George Mann'}, date: '2024-07-08T13:13:29.166799Z', operation: 'done', deviceName: 'macbook'},
{byUser: {user: 'george@acme.com', userName: 'George Mann'}, date: '2024-07-08T13:13:29.166799Z', operation: 'done', deviceName: 'macbook'},
{byUser: {user: 'george@acme.com', userName: 'George Mann'}, date: '2024-07-08T13:13:29.166799Z', operation: 'done', deviceName: 'macbook'},
{byUser: {user: 'george@acme.com', userName: 'George Mann'}, date: '2024-07-08T13:13:29.166799Z', operation: 'done', deviceName: 'macbook'},
{byUser: {user: 'george@acme.com', userName: 'George Mann'}, date: '2024-07-08T13:13:29.166799Z', operation: 'done', deviceName: 'macbook'},
{byUser: {user: 'george@acme.com', userName: 'George Mann'}, date: '2024-07-08T13:13:29.166799Z', operation: 'done', deviceName: 'macbook'},
{byUser: {user: 'george@acme.com', userName: 'George Mann'}, date: '2024-07-08T13:13:29.166799Z', operation: 'done', deviceName: 'macbook'},
{byUser: {user: 'george@acme.com', userName: 'George Mann'}, date: '2024-07-08T13:13:29.166799Z', operation: 'done', deviceName: 'macbook'},
{byUser: {user: 'george@acme.com', userName: 'George Mann'}, date: '2024-07-08T13:13:29.166799Z', operation: 'done', deviceName: 'macbook'},
{byUser: {user: 'george@acme.com', userName: 'George Mann'}, date: '2024-07-08T13:13:29.166799Z', operation: 'done', deviceName: 'macbook'},
{byUser: {user: 'george@acme.com', userName: 'George Mann'}, date: '2024-07-08T13:13:29.166799Z', operation: 'done', deviceName: 'macbook'},
{byUser: {user: 'george@acme.com', userName: 'George Mann'}, date: '2024-07-08T13:13:29.166799Z', operation: 'done', deviceName: 'macbook'}
],
		'taskStatusCounts': {'pending': 0, 'success': 5, 'pendingReboot': 12, 'reverting': 4, 'reverted': 5, 'cancelled': 23, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 40},
		'user': 'g@acme.com',
		'applyScheme': 'nextWeekDay',
		'afterTime': 0,
		'timezone': 120,
		'weekDay': 'Sunday',
		'window': 180,
		'criteria': {
'isExactComputerOu': false,
'isExactCve': false,
'isExactOs': false,
'isExactProduct': false,
'isExactVendor': false,
'ungrouped': false,
'actionType': 'remediate',
'actionDatum':!i? null : actionDefsArr[i % 5]?.k === 'generic' ? 'set-labels' : 'macDisableSMBShare',
'by': i % 2 ? 'alerts' : 'devices',
'topicCode': 'gytShare',
'selTarget': null,
'deviceId': 0,
'param': null,
'paramExtra': null,
'isExactParam': false,
'benchmarkOrg': null,
'benchmarkVer': null,
'benchmarkProfiles': [
'xccdf_org.cisecurity.benchmarks_profile_Level_1_-_Domain_Controller',
'xccdf_org.cisecurity.benchmarks_profile_Level_1_-_Member_Server',
'xccdf_org.cisecurity.benchmarks_profile_Level_1_L1_-_CorporateEnterprise_Environment_general_use'
],
'listParamExtra': null,
'severities': null,
'groupId': 0,
'domain': null,
'os': null,
...(!i && {'policyId': 'L1_Ensure_Relax_minimum_password_length_limits_is_set_to_Enabled', ruleId: 'L1_Ensure_Relax_minimum_password_length_limits_is_set_to_Enabled', ruleName: 'Disable SMBv1Disable SMBv1Disable SMBv1Disable SMBv1Disable SMBv1Disable SMBv1Disable SMBv1', policyName: 'Windows Baseline'}),
'computerOu': null,
'device': null,
'ip': null,
'clientVer': null,
'isListExclude': true,
'list': [],
'listIds': [],
'socket': null,
'genericActionParam': 'Shahaer,add,tsaj,sdcz,asf,er',
'recalc': 0 as const,
'from': 0,
'len': 0,
'exportName': null
},
		'approvalRequestId': null,
		'approvalRequestIdExtra': null
})).filter(d => (!inp.actionTypes?.length || inp.actionTypes.includes(d.actionType)))
],
	rowCount: 1234
});

	mockData.getUserPerms = () => ({
oUser: {'userType': 'Local', user: 'george@acme.com', userName: 'George Mann'},
perms: [
{groupId: 0, access: c_accessFull, networkAdmin: true},
{groupId: 2, access: c_accessView}
]
});
	mockData.getUserPermsLimited = () => ({oUser: {user: 'george@acme.com', userName: 'George Mann'}, perms: [{groupId: 2, access: c_accessView}]});
	mockData.getUserPermsViewOnly = () => ({
'data':[
{
'roleId':34,
'roleName':'Admin',
'perms':[{'groupId':1000, 'access':'full'}],
'members':[
't@acme.com',
'y@acme.com',
'g@acme.com'
],
'log':[
{'byUser':{'user':'(System)'}, 'date':'2024-02-25T15:38:49.059757Z', 'perms':[{'groupId':1000, 'access':'full'}], 'members':['t@acme.com']},
{
'byUser':{'user':'t@acme.com'},
'date':'2024-02-26T07:54:55.868774Z',
'perms':[{'groupId':1000, 'access':'full'}],
'members':[
't@acme.com',
'y@acme.com'
]
},
{
'byUser':{'user':'t@acme.com'},
'date':'2024-03-03T04:15:29.464477Z',
'perms':[{'groupId':1000, 'access':'full'}],
'members':[
't@acme.com',
'y@acme.com',
'g@acme.com'
]
}
]
}
]
});

	mockData.groupList = () => ({
'data':[
{'groupId':6, 'groupName':'Endpoints', 'groupDesc':null, 'totalDevices':3, 'createdBy':{'user':'g@acme.com', 'userName':null, 'title':null}, 'lastChanged':'2023-02-19T07:57:38.923199Z', 'isBuiltIn':false},
{'groupId':1, 'groupName':'Linux', 'groupDesc':null, 'totalDevices':3, 'createdBy':{'user':'t@acme.com', 'userName':null, 'title':null}, 'lastChanged':'2023-02-07T14:09:16.270914Z', 'isBuiltIn':false},
{'groupId':4, 'groupName':'Linux All', 'groupDesc':null, 'totalDevices':5, 'createdBy':{'user':'g@acme.com', 'userName':null, 'title':null}, 'lastChanged':'2023-02-19T06:35:56.611723Z', 'isBuiltIn':false},
{'groupId':67, 'groupName':'Mac', 'groupDesc':null, 'totalDevices':0, 'createdBy':{'user':'g@acme.com', 'userName':null, 'title':null}, 'lastChanged':'2023-12-19T08:51:10.22585Z', 'isBuiltIn':false},
{'groupId':166, 'groupName':'Newtest', 'groupDesc':null, 'totalDevices':1, 'createdBy':{'user':'g@acme.com', 'userName':null, 'title':null}, 'lastChanged':'2023-09-03T07:43:00.405073Z', 'isBuiltIn':false},
{'groupId':5, 'groupName':'Servers', 'groupDesc':null, 'totalDevices':4, 'createdBy':{'user':'g@acme.com', 'userName':null, 'title':null}, 'lastChanged':'2023-02-19T07:56:56.406819Z', 'isBuiltIn':false},
{'groupId':199, 'groupName':'Test', 'groupDesc':null, 'totalDevices':1, 'createdBy':{'user':'g@acme.com', 'userName':null, 'title':null}, 'lastChanged':'2024-02-06T15:35:27.070221Z', 'isBuiltIn':false},
{'groupId':8, 'groupName':'test before rem', 'groupDesc':null, 'totalDevices':3, 'createdBy':{'user':'g@acme.com', 'userName':null, 'title':null}, 'lastChanged':'2023-03-07T14:44:17.097913Z', 'isBuiltIn':false},
{'groupId':34, 'groupName':'test for linux wndows', 'groupDesc':null, 'totalDevices':3, 'createdBy':{'user':'g@acme.com', 'userName':null, 'title':null}, 'lastChanged':'2023-03-22T17:51:07.601761Z', 'isBuiltIn':false},
{'groupId':3, 'groupName':'Win 11 EP', 'groupDesc':null, 'totalDevices':1, 'createdBy':{'user':'t@acme.com', 'userName':null, 'title':null}, 'lastChanged':'2023-02-07T13:57:37.324271Z', 'isBuiltIn':false},
{'groupId':232, 'groupName':'Winservee11', 'groupDesc':null, 'totalDevices':2, 'createdBy':{'user':'g@acme.com', 'userName':null, 'title':null}, 'lastChanged':'2024-03-21T14:47:25.566819Z', 'isBuiltIn':false},
{'groupId':100, 'groupName':null, 'groupDesc':null, 'totalDevices':1, 'createdBy':{'user':'y@acme.com', 'userName':null, 'title':null}, 'lastChanged':'2023-08-08T14:52:24.995414Z', 'isBuiltIn':false},
{'groupId':133, 'groupName':null, 'groupDesc':null, 'totalDevices':0, 'createdBy':{'user':'y@acme.com', 'userName':null, 'title':null}, 'lastChanged':'2023-08-09T08:36:30.11983Z', 'isBuiltIn':false},
{'groupId':1010, 'groupName':'Debian Linux Computers', 'groupDesc':'A built-in group which includes all Debian Linux\u00A0computers.', 'totalDevices':2, 'createdBy':{'user':'GYTPOL', 'userName':null, 'title':null}, 'lastChanged':'2024-04-03T09:48:48.529139Z', 'isBuiltIn':true},
{'groupId':1012, 'groupName':'Linux Unknown Computers', 'groupDesc':'A built-in group which includes any non-SUSE/Red Hat/Debian Linux computer.', 'totalDevices':0, 'createdBy':{'user':'GYTPOL', 'userName':null, 'title':null}, 'lastChanged':'2024-04-03T09:48:48.529139Z', 'isBuiltIn':true},
{'groupId':1013, 'groupName':'macOS Computers', 'groupDesc':'A built-in group which includes all macOS computers.', 'totalDevices':1, 'createdBy':{'user':'GYTPOL', 'userName':null, 'title':null}, 'lastChanged':'2024-04-03T09:48:48.529139Z', 'isBuiltIn':true},
{'groupId':1011, 'groupName':'Red Hat Linux Computers', 'groupDesc':'A built-in group which includes all Red Hat Linux computers.', 'totalDevices':2, 'createdBy':{'user':'GYTPOL', 'userName':null, 'title':null}, 'lastChanged':'2024-04-03T09:48:48.529139Z', 'isBuiltIn':true},
{'groupId':1014, 'groupName':'SUSE Linux Computers', 'groupDesc':'A built-in group which includes all SUSE Linux computers.', 'totalDevices':1, 'createdBy':{'user':'GYTPOL', 'userName':null, 'title':null}, 'lastChanged':'2024-04-03T09:48:48.529139Z', 'isBuiltIn':true},
{'groupId':1005, 'groupName':'Windows DC Servers', 'groupDesc':'A built-in group which includes all Windows Domain Controller server computers.', 'totalDevices':1, 'createdBy':{'user':'GYTPOL', 'userName':null, 'title':null}, 'lastChanged':'2024-04-03T09:48:48.529139Z', 'isBuiltIn':true},
{'groupId':1001, 'groupName':'Windows Endpoints', 'groupDesc':'A built-in group which includes all Windows computers which are not servers.', 'totalDevices':3, 'createdBy':{'user':'GYTPOL', 'userName':null, 'title':null}, 'lastChanged':'2024-04-03T09:48:48.529139Z', 'isBuiltIn':true},
{'groupId':1006, 'groupName':'Windows Non-DC Servers', 'groupDesc':'A built-in group which includes all Windows servers which are not Domain Controllers.', 'totalDevices':3, 'createdBy':{'user':'GYTPOL', 'userName':null, 'title':null}, 'lastChanged':'2024-04-03T09:48:48.529139Z', 'isBuiltIn':true},
{'groupId':1003, 'groupName':'Windows Non-VDI Endpoints', 'groupDesc':'A built-in group which includes all Windows computers which not servers and not VDIs.', 'totalDevices':3, 'createdBy':{'user':'GYTPOL', 'userName':null, 'title':null}, 'lastChanged':'2024-04-03T09:48:48.529139Z', 'isBuiltIn':true},
{'groupId':1002, 'groupName':'Windows Servers', 'groupDesc':'A built-in group which includes all Windows server computers.', 'totalDevices':4, 'createdBy':{'user':'GYTPOL', 'userName':null, 'title':null}, 'lastChanged':'2024-04-03T09:48:48.529139Z', 'isBuiltIn':true},
{'groupId':1004, 'groupName':'Windows VDI Endpoints', 'groupDesc':'A built-in group which includes all Windows VDI computers.', 'totalDevices':0, 'createdBy':{'user':'GYTPOL', 'userName':null, 'title':null}, 'lastChanged':'2024-04-03T09:48:48.529139Z', 'isBuiltIn':true}
]
});

	mockData.getDomains = () => ({
domains: [
'gytpol.com',
''
]
});

	mockData.combiFields = (combis, ic) => () => ({data: makeArr(100).map(i => combis[ic].h + ' ' + i), deviceIds: makeArr(100).map(i => 'dev' + i), paramExtra: makeArr(100).map(i => 'param' + i), rowCount: 203});

	mockData.licenseGet = () => ({
'data': [
{
'startDate': '2024-01-01T00:00:00Z',
'endDate': '2024-10-06T00:00:00Z',
'devices': {
'': {
'modules': [
'miscon',
'adgpo',
'benchmark',
'intune'
],
'devices': 20100,
'activeDevices': 16949
}
}
},
{
'startDate': '2024-10-06T00:00:00Z',
'endDate': '2030-10-06T00:00:00Z',
'devices': {
'': {
'modules': [
'miscon',
'customcis',
'gpovalidation',
'adgpo',
'benchmark',
'intune',
'vuln_assessment',
'app_control',
'aigovernance',
'patch_management',
'network_scanner'
],
'devices': 17000,
'activeDevices': 16949
}
}
}
]
});

	mockData.gpoTopicsMaintenance = () => ({
'topics': [
{'domain': 'DemoBank', 'topic': 'GPO with SID Account Under Delegation', 'topicCode': null, 'subcategory': 'Group Policy Cleanup', 'order': 115, 'badgeCode': 3, 'message': 'The GPO has unknown account which inherits permissions.', 'suggestion': 'Review the GPO and remove the irrelevant SID account.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'medium', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'GPO without User Settings', 'topicCode': null, 'subcategory': 'Group Policy Performance', 'order': 315, 'badgeCode': 3, 'message': 'DemoBank has detected that there are no user settings, but the the GPO status is still enabled for users as well.', 'suggestion': 'It is recommended to disable user section under the details tab via the GPMC and choose: user configuration settings disabled. Make sure Domain Computers group is delegated as Read under Delegation tab.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': 'Missing user settings', 'registryPath': null, 'reference': null, 'badge': 'medium', 'count': 8, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'GPO is Disabled', 'topicCode': null, 'subcategory': 'Group Policy Cleanup', 'order': 140, 'badgeCode': 3, 'message': 'The GPO cannot be applied because its status is set to DisabledAllSettings (showing first 300 alerts).', 'suggestion': 'Review the GPOs status in the Details tab, or consider removing it.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'medium', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'Disable Google Chrome tasks', 'topicCode': null, 'subcategory': 'Group Policy General', 'order': 225, 'badgeCode': 3, 'message': 'DemoBank has detected Google Chrome tasks are misconfigured. ;Make sure you downloaded Goolge chrome ADMX and placed it in the sysvol directory, if not - download it and load it into your sysvol reposiroty.', 'suggestion': 'It is recommended to delete google chrome tasks (GoogleUpdateTaskMachineCore and GoogleUpdateTaskMachineUA) from the task scheduler (via GPP under computer configuration) in order to prevent the tasks access to the internet and download updates without IT control. Choose one of the policies listed below and set the scheduler in order to make it both to desktops (at least Windows 7) and servers (at least Windows Server 2008).', 'policyPath': 'Computer Configuration/Preferenced/Scheduled Tasks.', 'recommendedState': null, 'minOsType': 'At least Windows 7 and Windows Server 2008.', 'settingName': 'Delete GoogleUpdateTaskMachineCore and GoogleUpdateTaskMachineUA tasks', 'registryPath': null, 'reference': null, 'badge': 'medium', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'GPO without Computer Settings', 'topicCode': null, 'subcategory': 'Group Policy Performance', 'order': 320, 'badgeCode': 3, 'message': 'DemoBank has detected that there are no computer settings, but the the GPO status is still enabled for computers as well.', 'suggestion': 'It is recommended to disable computer section under the details tab via the GPMC and choose: computer configuration settings disabled. Make sure Domain Computers group is delegated as Read under Delegation tab.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': 'Missing computer settings', 'registryPath': null, 'reference': null, 'badge': 'medium', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'Unlinked GPOs', 'topicCode': null, 'subcategory': 'Group Policy Cleanup', 'order': 120, 'badgeCode': 3, 'message': 'The GPO cannot be applied because it is not linked to any OU, and its state is considered as Unlinked (showing first 300 alerts).', 'suggestion': 'Link the GPO to an OU, or consider removing it.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'medium', 'count': 3, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'Eventlog settings', 'topicCode': null, 'subcategory': 'Group Policy Collections', 'order': 450, 'badgeCode': 2, 'message': 'DemoBank has detected more than one GPO that contain settings for the same program.', 'suggestion': 'Consider merging them together into a single GPO.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': 'Audit', 'registryPath': null, 'reference': null, 'badge': 'low', 'count': 2, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'Empty OUs', 'topicCode': null, 'subcategory': 'Active Directory OUs General', 'order': 715, 'badgeCode': 2, 'message': 'DemoBank has detected there are no objects under the OU (showing first 300 alerts).', 'suggestion': 'Remove the irrelevant OU unless you use it for tests or this OU should has objects in the feuture.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'low', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'Restricted Groups settings', 'topicCode': null, 'subcategory': 'Group Policy Collections', 'order': 435, 'badgeCode': 2, 'message': 'DemoBank has detected more than one GPO that contain settings for the same program.', 'suggestion': 'Consider merging them together into a single GPO.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': 'Restricted Groups', 'registryPath': null, 'reference': null, 'badge': 'low', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'PKI settings', 'topicCode': null, 'subcategory': 'Group Policy Collections', 'order': 425, 'badgeCode': 2, 'message': 'DemoBank has detected more than one GPO that contain settings for the same program.', 'suggestion': 'Consider merging them together into a single GPO.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': 'PKI', 'registryPath': null, 'reference': null, 'badge': 'low', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'Empty Active Directory Groups', 'topicCode': null, 'subcategory': 'Active Directory Cleanup', 'order': 615, 'badgeCode': 2, 'message': 'DemoBank has detected there are Active Directory Groups with no members.', 'suggestion': 'Remove the irrelevant Groups unless you use it for tests or the Group should has members in the feuture (showing first 300 alerts).', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'low', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'Disabled Users', 'topicCode': null, 'subcategory': 'Active Directory Accounts', 'order': 515, 'badgeCode': 2, 'message': 'DemoBank has detected disabled users within the organization (showing first 300 alerts).', 'suggestion': 'If the user is irrelevant, delete it. Otherwise, do not remove the user and keep monitoring for changes.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'low', 'count': 5, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'GPO GUID Equals to GPO Name', 'topicCode': null, 'subcategory': 'Group Policy Cleanup', 'order': 135, 'badgeCode': 1, 'message': 'All of the policies have names and are not equal to their GPO identifier.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'Computer Accounts in the Delegation Tab', 'topicCode': null, 'subcategory': 'Group Policy General', 'order': 220, 'badgeCode': 1, 'message': 'All of the policies have Domain Computers AD group under delegation tab.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'GPO with Link Disabled', 'topicCode': null, 'subcategory': 'Group Policy Cleanup', 'order': 125, 'badgeCode': 1, 'message': 'You have no GPOs with link disabled.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'OUs with Block Inheritance', 'topicCode': null, 'subcategory': 'Group Policy General', 'order': 210, 'badgeCode': 1, 'message': 'You have no OUs with block inheritance flag on.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'Office settings', 'topicCode': null, 'subcategory': 'Group Policy Collections', 'order': 410, 'badgeCode': 1, 'message': 'DemoBank has detected more than one GPO that contain settings for the same program.', 'suggestion': 'If the organization have Office on the computers, it is highly recommneded to use GPMC to define Office settings, such as macro, folders location, internet access and much more.', 'policyPath': 'Computer Configuration (or: User Configuration)/Policies/Administrative Templates/Windows Components/Office', 'recommendedState': null, 'minOsType': null, 'settingName': 'Missing Office settings', 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'Disabled Computers', 'topicCode': null, 'subcategory': 'Active Directory Accounts', 'order': 520, 'badgeCode': 1, 'message': 'No disabled computers accounts were found.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'Complied: Active Directory OU inheritance', 'topicCode': null, 'subcategory': 'Active Directory OUs General', 'order': 710, 'badgeCode': 1, 'message': 'No Active Directory OU inheritance were found.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': 'Active Directory', 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'Locked-Out Users', 'topicCode': null, 'subcategory': 'Active Directory Accounts', 'order': 510, 'badgeCode': 1, 'message': 'No locked out user accounts were found.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'GPP Shortcut settings', 'topicCode': null, 'subcategory': 'Group Policy Collections', 'order': 445, 'badgeCode': 1, 'message': 'DemoBank has detected more than one GPO that contain settings for the same program.', 'suggestion': 'If your organization use many shortcuts on the users computer, use GPMC to define shortcuts settings.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': 'Missing Shortcut settings', 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'Audit and Advanced Audit', 'topicCode': null, 'subcategory': 'Group Policy General', 'order': 215, 'badgeCode': 1, 'message': 'The GPOs do not have Audit and Advanced Audit together in the same policy.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'GPO with Single User Account Under Delegation', 'topicCode': null, 'subcategory': 'Group Policy Cleanup', 'order': 145, 'badgeCode': 1, 'message': 'The policies have no single user accounts under the delegation tab.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'Users and Computers under AD-Root', 'topicCode': null, 'subcategory': 'Active Directory OUs General', 'order': 725, 'badgeCode': 1, 'message': 'You have no objects under the AD Root.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'Browser settings', 'topicCode': null, 'subcategory': 'Group Policy Collections', 'order': 415, 'badgeCode': 1, 'message': 'DemoBank has detected more than one GPO that contain settings for the same program family.', 'suggestion': 'If the organization have IE and (or) Chrome on the computers, it is highly recommneded to use GPMC to define IE settings, such as home page, password manager, trusted sites and much more.', 'policyPath': 'Computer Configuration (or: User Configuration)/Policies/Administrative Templates/Internet Explorer (or:Google)', 'recommendedState': null, 'minOsType': null, 'settingName': 'Missing IE and Chrome settings', 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'GPO Security Filtering', 'topicCode': null, 'subcategory': 'Group Policy Cleanup', 'order': 130, 'badgeCode': 1, 'message': 'All of the policies have security filtering.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'Internet Explorer Maintenance (IEM)', 'topicCode': null, 'subcategory': 'Group Policy Performance', 'order': 310, 'badgeCode': 1, 'message': 'The GPOs do not have IEM settings.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'Local Users and Groups settings', 'topicCode': null, 'subcategory': 'Group Policy Collections', 'order': 430, 'badgeCode': 1, 'message': 'DemoBank has detected more than one GPO that contain settings for the same program.', 'suggestion': 'If the organization have Local Users and Groups, it is highly recommended to use GPMC to define settings, such as local administrator user, administrators group and more.', 'policyPath': 'Computer Configuration (or: User Configuration)/Preferences/Control Panel Settings/Local Users and Groups', 'recommendedState': null, 'minOsType': null, 'settingName': 'Missing Local Users and Groups settings', 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'Screen Saver settings are spreaded across several GPOs', 'topicCode': null, 'subcategory': 'Group Policy Collections', 'order': 455, 'badgeCode': 1, 'message': 'DemoBank has detected more than one GPO that contain settings for the same program.', 'suggestion': 'If your implement screen saver in the organization, it is recommended to use GPMC to define screen saver settings, such as password protect screen saver, background and more.', 'policyPath': 'Computer Configuration (or: User Configuration)/Policies/Administrative Templates/Windows Components/Control Panel', 'recommendedState': null, 'minOsType': null, 'settingName': 'Missing Screen Saver settings', 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'DemoBank', 'topic': 'Services settings', 'topicCode': null, 'subcategory': 'Group Policy Collections', 'order': 440, 'badgeCode': 1, 'message': 'DemoBank has detected more than one GPO that contain settings for the same program.', 'suggestion': 'It is highly recommended to use GPMC to define Services, such as audio services, Xbox services, and much more to decrease the attack surface.', 'policyPath': 'Computer Configuration/Policies/Windows Settings/Security Settings/System Services', 'recommendedState': null, 'minOsType': null, 'settingName': 'Missing Services settings', 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null}
]
});
	mockData.gpoTopicsAd = () => ({
'topics': [
{'domain': 'domain.com', 'topic': 'Protected Users Group', 'topicCode': 'gytProtectedUsers', 'subcategory': 'AD Sensitive Permissions', 'order': 85, 'badgeCode': 4, 'message': 'This security group is designed as part of a strategy to manage credential exposure within the enterprise. `\n        Members of this group automatically have non-configurable protections applied to their accounts. `\n        Membership in the Protected Users group is meant to be restrictive and proactively secure by default.', 'suggestion': 'Since this solution is applicable only on Domain Controllers 2012 R2 and above - add all the users listed below to this group to increase the security: no more NTLM, DES, RC4; `\n        Prevent password caching, reduce Kerberos ticket lifetime and prevents kerberos delegation. `\n        See more: https://docs.microsoft.com/en-us/windows-server/security/credentials-protection-and-management/protected-users-security-group .', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'high', 'count': 17, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Fine Grained Password Policy Missing', 'topicCode': 'gytAdacEmptyPasswordPolicy', 'subcategory': 'AD Policy Objects', 'order': 150, 'badgeCode': 3, 'message': 'Gytpol detected the organization does not use AD Fine Grained Password Policy.', 'suggestion': 'It is recommended to use password policy for different use-cases. The most common is for high privilege users. Read more: https://docs.microsoft.com/en-us/windows-server/identity/ad-ds/get-started/adac/introduction-to-active-directory-administrative-center-enhancements--level-100-#fine_grained_pswd_policy_mgmt.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'medium', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'KRBTGT User Password', 'topicCode': 'gytKRBTGT', 'subcategory': 'Kerberos', 'order': 177, 'badgeCode': 3, 'message': 'The password of KRBTGT user has not been set more that 180 days ago. The KRBTGT account is critical for AD domain Kerberos authentication and if not properly protected, enables an attacker to create their own Kerberos TGT “Golden Tickets.” These special TGTs provide the attacker with access to anything and everything Kerberos enabled on the network without having to add themselves to AD groups.', 'suggestion': 'It is highly recommended to change the password once in 180 days. Follow this link for more info of how to do it: https://docs.microsoft.com/en-us/windows-server/identity/ad-ds/manage/ad-forest-recovery-resetting-the-krbtgt-password.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'medium', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'AD Manual Groups File Missing', 'topicCode': null, 'subcategory': 'AD Sensitive Permissions - DOMAIN', 'order': 153, 'badgeCode': 3, 'message': 'Gytpol detected the file in which helps detecting AD group changes added by Gytpol Admins is missing.', 'suggestion': 'Reinstall GytpolServer or ask for a higher version to install and upgrade the existing installation.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'medium', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Users with AdminCount = 1', 'topicCode': 'gytAdminCountUsers', 'subcategory': 'AD Sensitive Permissions', 'order': 121, 'badgeCode': 3, 'message': 'The AdminCount comes from the fact when a user, group, or computer is added, either directly or transitively, to any of a specific set of protected groups its value is updated to 1 (showing first 300 alerts).', 'suggestion': 'Please check and filter out the objects in which they should be part of administrative groups. The rest - remove them from any sensitive group.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'medium', 'count': 3, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Server accounts: password is over 90 days', 'topicCode': 'gytADComputerPwdLastSetSrv', 'subcategory': 'AD Policy Objects', 'order': 151, 'badgeCode': 3, 'message': 'The following server accounts did not changed their password over 90 days, while they need to change by default between 30 to 90 days (showing first 300 alerts).', 'suggestion': 'Check the server computer accounts. In case they are irrelevant - delete those computer accounts. Otherwise, change the group policy to enfore it once in 30-90 days. Reference: https://docs.microsoft.com/en-us/windows/security/threat-protection/security-policy-settings/domain-member-maximum-machine-account-password-age.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'medium', 'count': 2, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'KRBTGT Supported Encryption Types', 'topicCode': 'gytKRBTGTSupportEncrypt', 'subcategory': 'Kerberos', 'order': 176, 'badgeCode': 3, 'message': 'The encryption type of KRBTGT user is not strong enough. There are several kerberos attacks using the encryption type and therefore your organization might be at risk.', 'suggestion': 'It is recommended to use stronger encryption type, such as AES128 and AES256. After changing it - make sure ou reset the password to the KRBTGT user as mentioned under topic "KRBTGT User Password". Important notice: you can change the encryption only if you have Windows OS supported the encryption type (Windows 7, Windows Server 2008 and above), as well as non-Windows clients that maybe using AD for Kerberos auth (Linux, NAS & Network devices). For more information: https://techcommunity.microsoft.com/t5/core-infrastructure-and-security/decrypting-the-selection-of-supported-kerberos-encryption-types/ba-p/1628797', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'medium', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'High-Privilege Users Password Last Set', 'topicCode': 'gytPassLastSetAdmins', 'subcategory': 'AD Privilege Users', 'order': 500, 'badgeCode': 3, 'message': 'Gytpol has detected the administrators of this domain did not change their passwords in the past 90 days.', 'suggestion': 'It is highly recommended to change the password frequently. Many attacks rely on passwords that were not changed in a while. You can choose to use Fine Grained Password Policy.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'medium', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Built-in Administrator Account Logon', 'topicCode': 'gytBuiltInAdminLogin', 'subcategory': 'AD Privilege Users', 'order': 540, 'badgeCode': 3, 'message': 'Gytpol has detected the Built-in Administrator account has been used recently.', 'suggestion': 'It is highly recommended to Disable this account since this account cannot be locked. This account has the maximum permissions in the domain and many attacks rely on this account. Make sure there are no SPNs or Services or Tasks running with this account: you can use Gytpol Misconfiguration to validate it.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'medium', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Group Policy Creator Owners AD Group Membership Changed Over 30 Days', 'topicCode': 'gytGroup Policy Creator Owners', 'subcategory': 'AD Sensitive Permissions', 'order': 153, 'badgeCode': 2, 'message': 'Gytpol detected Sensitive AD group membership changes.', 'suggestion': 'Review each item and filter out the irrelevant(s).', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'low', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Administrators AD Group Membership Changed Over 30 Days', 'topicCode': 'gytAdministrators', 'subcategory': 'AD Sensitive Permissions', 'order': 103, 'badgeCode': 2, 'message': 'Gytpol detected Sensitive AD group membership changes.', 'suggestion': 'Review each item and filter out the irrelevant(s).', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'low', 'count': 5, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Domain Admins AD Group Membership Changed Over 30 Days', 'topicCode': 'gytDomain Admins', 'subcategory': 'AD Sensitive Permissions', 'order': 108, 'badgeCode': 2, 'message': 'Gytpol detected Sensitive AD group membership changes.', 'suggestion': 'Review each item and filter out the irrelevant(s).', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'low', 'count': 2, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Schema Admins AD Group Membership Changed Over 30 Days', 'topicCode': 'gytSchema Admins', 'subcategory': 'AD Sensitive Permissions', 'order': 118, 'badgeCode': 2, 'message': 'Gytpol detected Sensitive AD group membership changes.', 'suggestion': 'Review each item and filter out the irrelevant(s).', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'low', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Enterprise Admins AD Group Membership Changed Over 30 Days', 'topicCode': 'gytEnterprise Admins', 'subcategory': 'AD Sensitive Permissions', 'order': 113, 'badgeCode': 2, 'message': 'Gytpol detected Sensitive AD group membership changes.', 'suggestion': 'Review each item and filter out the irrelevant(s).', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'low', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'GPOs were changed in the last week', 'topicCode': 'gytGPChngLastWeek', 'subcategory': 'GP Auditing', 'order': 162, 'badgeCode': 1, 'message': 'No GPOs were changed in the past week.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Resource-Based Constrained Delegation on Domain Controller(s)', 'topicCode': 'gytRBCDDC', 'subcategory': 'SPN', 'order': 528, 'badgeCode': 1, 'message': 'No Resource-Based Constrained Delegation were found on Domain Controller(s).', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Disabled users with AdminCount = 1', 'topicCode': 'gytAdminCountUsersDisabled', 'subcategory': 'AD Sensitive Permissions', 'order': 122, 'badgeCode': 1, 'message': 'No disabled users were found with AdminCount=1.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Guest Account', 'topicCode': 'gytGuestAccount', 'subcategory': 'AD Sensitive Permissions', 'order': 15, 'badgeCode': 1, 'message': 'Guest account is disabled.', 'suggestion': 'It is highly recommended to disable the Guest account and monitor any activity with this account.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Schedule Task Password', 'topicCode': 'gytSchedulePasswords', 'subcategory': 'GP Compromised Data', 'order': 120, 'badgeCode': 1, 'message': 'No GPOs were found with task scheduler.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'GPOs were changed in the last month', 'topicCode': 'gytGPChngLastMonth', 'subcategory': 'GP Auditing', 'order': 163, 'badgeCode': 1, 'message': 'No GPOs were changed in the past month.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'AD Forest Anonymous Access', 'topicCode': 'gytAnonymousAccess', 'subcategory': 'AD Permissions', 'order': 190, 'badgeCode': 1, 'message': 'Anonymous access is set to disable.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': 'OU', 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'GPO with SID Account Under User Rights Assignment', 'topicCode': 'gytUnknownSIDwithinGPO', 'subcategory': 'GP Auditing', 'order': 135, 'badgeCode': 1, 'message': 'The GPOs have no Unknown Accounts under Computer Configuration-Policies-Windows Settings-Local Policies-User Rights Assignment.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'SQL SPN on Workstations', 'topicCode': 'gytSpnSqlWs', 'subcategory': 'SPN', 'order': 403, 'badgeCode': 1, 'message': 'No workstations were found with SQL SPN.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Domain Controllers Roles', 'topicCode': 'gytDCRoles', 'subcategory': 'Domain Infrastructure', 'order': 330, 'badgeCode': 1, 'message': 'All FSMO Roles are located on the same DC.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Computers with AdminCount = 1', 'topicCode': 'gytAdminCountComputers', 'subcategory': 'AD Sensitive Permissions', 'order': 123, 'badgeCode': 1, 'message': 'No computer accounts were found with AdminCount=1.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'High-Privilege Users Password Last Set', 'topicCode': 'gytPassLastSetAdmins', 'subcategory': 'AD Privilege Users', 'order': 500, 'badgeCode': 1, 'message': 'The password was changed in past 90 days.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 2, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'LAPS Permissions', 'topicCode': 'gytLAPSPermission', 'subcategory': 'AD Permissions', 'order': 220, 'badgeCode': 1, 'message': 'If you use LAPS in your organization - it is properly configured.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': 'LAPS', 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Domain Controllers GC', 'topicCode': 'gytDCGC', 'subcategory': 'Domain Infrastructure', 'order': 325, 'badgeCode': 1, 'message': 'All DCs (non RODC) are defined as Global Catalog.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Disabled computers with AdminCount = 1 have been found', 'topicCode': 'gytAdminCountComputersDisabled', 'subcategory': 'AD Sensitive Permissions', 'order': 124, 'badgeCode': 1, 'message': 'No disabled computers were found with AdminCount=1.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'RODC(s) Password Cached', 'topicCode': null, 'subcategory': 'AD Sensitive Permissions', 'order': 330, 'badgeCode': 1, 'message': 'No high privilege members were found with cached password on Read-Only-Domain-Controller(s).', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Fake Domain Controller', 'topicCode': 'gytFakeDc', 'subcategory': 'AD Sensitive Permissions', 'order': 1, 'badgeCode': 1, 'message': 'No Fake DC were found.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Computer(s) with LAPS Password Expired', 'topicCode': 'gytLAPSComputer', 'subcategory': 'AD Permissions', 'order': 240, 'badgeCode': 1, 'message': 'No computer accounts LAPS password expired.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'AD Forest Anonymous NSPI Access', 'topicCode': 'gytNSPIAnonymousAccess', 'subcategory': 'AD Permissions', 'order': 192, 'badgeCode': 1, 'message': 'Anonymous access via NSPI RPC operations is set to disable.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'SPN Shadow Admins', 'topicCode': 'gytSqlSpnAdmin', 'subcategory': 'SPN', 'order': 211, 'badgeCode': 1, 'message': 'No AD users with SQL SPN administrative rights were found.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'DCShadow Detection', 'topicCode': 'gytDCShadow', 'subcategory': 'AD Sensitive Permissions', 'order': 5, 'badgeCode': 1, 'message': 'DCShadow does not exist.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'GP Shortcut path Permissions', 'topicCode': 'gytShortcuts', 'subcategory': 'GP File Permissions', 'order': 230, 'badgeCode': 1, 'message': 'No GPOs were found with GPP Shortcut.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'DC Replication Status', 'topicCode': 'gytADReplicationDCs', 'subcategory': 'Domain Infrastructure', 'order': 335, 'badgeCode': 1, 'message': 'Replication Status is OK', 'suggestion': 'Check each line to see when was the last failure. You can run in the cmd repadmin /syncall to force DC synchronization. You must run the command with appropiate permissions.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Resource-Based Constrained Delegation on krbtgt', 'topicCode': 'gytRBCDkrbtgt', 'subcategory': 'SPN', 'order': 529, 'badgeCode': 1, 'message': 'No Resource-Based Constrained Delegation on krbtgt were found.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'GP File path Permissions', 'topicCode': 'gytFiles', 'subcategory': 'GP File Permissions', 'order': 225, 'badgeCode': 1, 'message': 'No GPOs were found with GPP Files.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Domain Functionality Level', 'topicCode': 'gytDCFunctionLevel', 'subcategory': 'Domain Infrastructure', 'order': 345, 'badgeCode': 1, 'message': 'The domain and forest functional level are high and as recommended.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'MSA & GMSA Password', 'topicCode': 'gytGMSAPass', 'subcategory': 'AD Policy Objects', 'order': 530, 'badgeCode': 1, 'message': 'All (Group) Managed Service Account (GMSA) computer objects accounts were changed their password in the past 30 days.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'SPN Shadow Users', 'topicCode': 'gytSqlSpnUser', 'subcategory': 'SPN', 'order': 212, 'badgeCode': 1, 'message': 'No AD users with SQL SPN user rights were found.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'GPOs were changed in the last 24 hours', 'topicCode': 'gytGPChngLastDay', 'subcategory': 'GP Auditing', 'order': 161, 'badgeCode': 1, 'message': 'No GPOs were changed in the last 24 hours.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Users with Constrained Delegation', 'topicCode': 'gytConstrainedDelegationUsers', 'subcategory': 'SPN', 'order': 196, 'badgeCode': 1, 'message': 'There are no users with constrained delegation.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'GP Script Permissions', 'topicCode': 'gytScripts', 'subcategory': 'GP File Permissions', 'order': 235, 'badgeCode': 1, 'message': 'No GPOs were found with Scripts.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Read-Only Domain Controllers', 'topicCode': null, 'subcategory': 'Domain Infrastructure', 'order': 350, 'badgeCode': 1, 'message': 'No RODCs have been found in the domain.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Domain Controllers OS List', 'topicCode': null, 'subcategory': 'Domain Infrastructure', 'order': 355, 'badgeCode': 1, 'message': 'The operating systems on the Domain Controllers is supported.', 'suggestion': 'Check if the DC(s) can be upgradable.', 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Active Directory Shadow SID Accounts', 'topicCode': 'gytShadowSID', 'subcategory': 'AD Permissions', 'order': 130, 'badgeCode': 1, 'message': 'No Active Directory Shadow SID Accounts were found.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': 'Active Directory', 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Users with Unconstrained Delegation', 'topicCode': 'gytUnconstrainedDelegationUsers', 'subcategory': 'SPN', 'order': 192, 'badgeCode': 1, 'message': 'There are no users with unconstrained delegation.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Computers with Unconstrained Delegation', 'topicCode': 'gytUnconstrainedDelegationComps', 'subcategory': 'SPN', 'order': 192, 'badgeCode': 1, 'message': 'There are no computers with unconstrained delegation.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'SID History: Users', 'topicCode': null, 'subcategory': 'AD Privilege Users', 'order': 530, 'badgeCode': 1, 'message': 'No SID History on users were found.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Domain Controllers List', 'topicCode': 'gytDCsList', 'subcategory': 'Domain Infrastructure', 'order': 320, 'badgeCode': 1, 'message': 'All DCs are set correctly in the Domain Controllers group.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'DC(s) with Constrained Delegation', 'topicCode': 'gytConstrainedDelegationDCs', 'subcategory': 'SPN', 'order': 190, 'badgeCode': 1, 'message': 'There are no domain controller(s) with constrained delegation.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Local User Password', 'topicCode': 'gytGPPUserPasswords', 'subcategory': 'GP Compromised Data', 'order': 125, 'badgeCode': 1, 'message': 'No GPOs were found with GPP Local Users and Groups.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Inactive SPNs', 'topicCode': 'gytInactiveSPNs', 'subcategory': 'SPN', 'order': 360, 'badgeCode': 1, 'message': 'All SPNS of type HTTP and MSSQLSvc are activated.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'OU Full Control Permissions', 'topicCode': 'gytOUFCPermissions', 'subcategory': 'AD Permissions', 'order': 210, 'badgeCode': 1, 'message': 'The AD has no anomalies in the permission on OUs and Containers.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': 'OU', 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Resource-Based Constrained Delegation', 'topicCode': 'gytRBCDGeneral', 'subcategory': 'SPN', 'order': 530, 'badgeCode': 1, 'message': 'No Resource-Based Constrained Delegation were found.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'SDDL Changes', 'topicCode': 'gytSDDLChanges', 'subcategory': 'AD Permissions', 'order': 190, 'badgeCode': 1, 'message': 'No object(s) whose default security descriptor has changed were found.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Duplicated SPNs', 'topicCode': 'gytDuplicateSPNs', 'subcategory': 'SPN', 'order': 365, 'badgeCode': 1, 'message': 'There are no duplicated within the SPNS.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null},
{'domain': 'domain.com', 'topic': 'Log4J Java Class Attribute(s)', 'topicCode': 'gytJavaClass', 'subcategory': 'AD Permissions', 'order': 188, 'badgeCode': 1, 'message': 'No Log4J java class AD-schema attributes were created.', 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'minOsType': null, 'settingName': null, 'registryPath': null, 'reference': null, 'badge': 'passed', 'count': 1, 'currentStates': null}
]
});
	mockData.gpoTopicsAdMessage = () => ({
'data': [
{'clientVersion': '2.33.5.0', 'fqdn': 'dc01.domain.com', 'ipAddress': '192.168.0.10', 'domain': 'domain.com', 'topic': null, 'message': null, 'badge': null, 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'gpo': 'User: ', 'gpoId': null, 'gpoStatus': null, 'subcategory': 'AD Sensitive Permissions', 'currentState': '["Last pwd set: ",""]', 'wmiFilter': null, 'somPath': '["Last logon dt: ",""]', 'addInfo': '{"DistinguishedName":"CN=Backup Operators,CN=Builtin,DC=domain,DC=com","PasswordNeverExpires":null,"MemberOf":"N/A","PasswordExpired":null}',  'createTime': '2024-04-07T11:35:06.5871756+00:00', 'modifyTime': null},
{'clientVersion': '2.33.5.0', 'fqdn': 'dc01.domain.com', 'ipAddress': '192.168.0.10', 'domain': 'domain.com', 'topic': null, 'message': null, 'badge': null, 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'gpo': 'User: Account Operators', 'gpoId': null, 'gpoStatus': null, 'subcategory': 'AD Sensitive Permissions', 'currentState': '["Last pwd set: ",""]', 'wmiFilter': null, 'somPath': '["Last logon dt: ",""]', 'addInfo': '{"DistinguishedName":"CN=Account Operators,CN=Builtin,DC=domain,DC=com","Members":"","MemberOf":"N/A"}', 'createTime': null, 'modifyTime': null},
{'clientVersion': '2.33.5.0', 'fqdn': 'dc01.domain.com', 'ipAddress': '192.168.0.10', 'domain': 'domain.com', 'topic': null, 'message': null, 'badge': null, 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'gpo': 'User: Administrator', 'gpoId': null, 'gpoStatus': null, 'subcategory': 'AD Sensitive Permissions', 'currentState': '["Last pwd set: ","2023-05-28T12:16:46+00:00"]', 'wmiFilter': null, 'somPath': '["Last logon dt: ","2023-06-20T08:42:36+00:00"]', 'addInfo': '{"DistinguishedName":"CN=Administrator,CN=Users,DC=domain,DC=com","PasswordNeverExpires":false,"MemberOf":"CN=Group Policy Creator Owners,CN=Users,DC=domain,DC=com; CN=Domain Admins,CN=Users,DC=domain,DC=com; CN=Enterprise Admins,CN=Users,DC=domain,DC=com; CN=Schema Admins,CN=Users,DC=domain,DC=com; CN=Administrators,CN=Builtin,DC=domain,DC=com","PasswordExpired":false}', 'createTime': null, 'modifyTime': null},
{'clientVersion': '2.33.5.0', 'fqdn': 'dc01.domain.com', 'ipAddress': '192.168.0.10', 'domain': 'domain.com', 'topic': null, 'message': null, 'badge': null, 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'gpo': 'User: Administrator', 'gpoId': null, 'gpoStatus': null, 'subcategory': 'AD Sensitive Permissions', 'currentState': '["Last pwd set: ","2023-05-28T12:16:46+00:00"]', 'wmiFilter': null, 'somPath': '["Last logon dt: ","2023-06-20T08:42:36+00:00"]', 'addInfo': '{"DistinguishedName":"CN=Administrator,CN=Users,DC=domain,DC=com","PasswordNeverExpires":false,"MemberOf":"CN=Group Policy Creator Owners,CN=Users,DC=domain,DC=com; CN=Domain Admins,CN=Users,DC=domain,DC=com; CN=Enterprise Admins,CN=Users,DC=domain,DC=com; CN=Schema Admins,CN=Users,DC=domain,DC=com; CN=Administrators,CN=Builtin,DC=domain,DC=com","PasswordExpired":false}', 'createTime': null, 'modifyTime': null},
{'clientVersion': '2.33.5.0', 'fqdn': 'dc01.domain.com', 'ipAddress': '192.168.0.10', 'domain': 'domain.com', 'topic': null, 'message': null, 'badge': null, 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'gpo': 'User: Administrator', 'gpoId': null, 'gpoStatus': null, 'subcategory': 'AD Sensitive Permissions', 'currentState': '["Last pwd set: ","2023-05-28T12:16:46+00:00"]', 'wmiFilter': null, 'somPath': '["Last logon dt: ","2023-06-20T08:42:36+00:00"]', 'addInfo': '{"DistinguishedName":"CN=Administrator,CN=Users,DC=domain,DC=com","PasswordNeverExpires":false,"MemberOf":"CN=Group Policy Creator Owners,CN=Users,DC=domain,DC=com; CN=Domain Admins,CN=Users,DC=domain,DC=com; CN=Enterprise Admins,CN=Users,DC=domain,DC=com; CN=Schema Admins,CN=Users,DC=domain,DC=com; CN=Administrators,CN=Builtin,DC=domain,DC=com","PasswordExpired":false}', 'createTime': null, 'modifyTime': null},
{'clientVersion': '2.33.5.0', 'fqdn': 'dc01.domain.com', 'ipAddress': '192.168.0.10', 'domain': 'domain.com', 'topic': null, 'message': null, 'badge': null, 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'gpo': 'User: Administrator', 'gpoId': null, 'gpoStatus': null, 'subcategory': 'AD Sensitive Permissions', 'currentState': '["Last pwd set: ","2023-05-28T12:16:46+00:00"]', 'wmiFilter': null, 'somPath': '["Last logon dt: ","2023-06-20T08:42:36+00:00"]', 'addInfo': '{"DistinguishedName":"CN=Administrator,CN=Users,DC=domain,DC=com","PasswordNeverExpires":false,"MemberOf":"CN=Group Policy Creator Owners,CN=Users,DC=domain,DC=com; CN=Domain Admins,CN=Users,DC=domain,DC=com; CN=Enterprise Admins,CN=Users,DC=domain,DC=com; CN=Schema Admins,CN=Users,DC=domain,DC=com; CN=Administrators,CN=Builtin,DC=domain,DC=com","PasswordExpired":false}', 'createTime': null, 'modifyTime': null},
{'clientVersion': '2.33.5.0', 'fqdn': 'dc01.domain.com', 'ipAddress': '192.168.0.10', 'domain': 'domain.com', 'topic': null, 'message': null, 'badge': null, 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'gpo': 'User: Administrators', 'gpoId': null, 'gpoStatus': null, 'subcategory': 'AD Sensitive Permissions', 'currentState': '["Last pwd set: ",""]', 'wmiFilter': null, 'somPath': '["Last logon dt: ",""]', 'addInfo': '{"DistinguishedName":"CN=Administrators,CN=Builtin,DC=domain,DC=com","Members":"CN=gytpolsvc,CN=Users,DC=domain,DC=com; CN=Domain Admins,CN=Users,DC=domain,DC=com; CN=Enterprise Admins,CN=Users,DC=domain,DC=com; CN=Mark,CN=Users,DC=domain,DC=com; CN=Administrator,CN=Users,DC=domain,DC=com","MemberOf":"N/A"}', 'createTime': null, 'modifyTime': null},
{'clientVersion': '2.33.5.0', 'fqdn': 'dc01.domain.com', 'ipAddress': '192.168.0.10', 'domain': 'domain.com', 'topic': null, 'message': null, 'badge': null, 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'gpo': 'User: Backup Operators', 'gpoId': null, 'gpoStatus': null, 'subcategory': 'AD Sensitive Permissions', 'currentState': '["Last pwd set: ",""]', 'wmiFilter': null, 'somPath': '["Last logon dt: ",""]', 'addInfo': '{"DistinguishedName":"CN=Backup Operators,CN=Builtin,DC=domain,DC=com","Members":"","MemberOf":"N/A"}', 'createTime': null, 'modifyTime': null},
{'clientVersion': '2.33.5.0', 'fqdn': 'dc01.domain.com', 'ipAddress': '192.168.0.10', 'domain': 'domain.com', 'topic': null, 'message': null, 'badge': null, 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'gpo': 'User: DNS Admins', 'gpoId': null, 'gpoStatus': null, 'subcategory': 'AD Sensitive Permissions', 'currentState': '["Last pwd set: ",""]', 'wmiFilter': null, 'somPath': '["Last logon dt: ",""]', 'addInfo': '{"DistinguishedName":"CN=Backup Operators,CN=Builtin,DC=domain,DC=com","Members":"","MemberOf":"N/A"}', 'createTime': null, 'modifyTime': null},
{'clientVersion': '2.33.5.0', 'fqdn': 'dc01.domain.com', 'ipAddress': '192.168.0.10', 'domain': 'domain.com', 'topic': null, 'message': null, 'badge': null, 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'gpo': 'User: Domain Admins', 'gpoId': null, 'gpoStatus': null, 'subcategory': 'AD Sensitive Permissions', 'currentState': '["Last pwd set: ",""]', 'wmiFilter': null, 'somPath': '["Last logon dt: ",""]', 'addInfo': '{"DistinguishedName":"CN=Domain Admins,CN=Users,DC=domain,DC=com","Members":"CN=Mark,CN=Users,DC=domain,DC=com; CN=Administrator,CN=Users,DC=domain,DC=com","MemberOf":"CN=Denied RODC Password Replication Group,CN=Users,DC=domain,DC=com; CN=Administrators,CN=Builtin,DC=domain,DC=com"}', 'createTime': null, 'modifyTime': null},
{'clientVersion': '2.33.5.0', 'fqdn': 'dc01.domain.com', 'ipAddress': '192.168.0.10', 'domain': 'domain.com', 'topic': null, 'message': null, 'badge': null, 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'gpo': 'User: Enterprise Admins', 'gpoId': null, 'gpoStatus': null, 'subcategory': 'AD Sensitive Permissions', 'currentState': '["Last pwd set: ",""]', 'wmiFilter': null, 'somPath': '["Last logon dt: ",""]', 'addInfo': '{"DistinguishedName":"CN=Enterprise Admins,CN=Users,DC=domain,DC=com","Members":"CN=Administrator,CN=Users,DC=domain,DC=com","MemberOf":"CN=Denied RODC Password Replication Group,CN=Users,DC=domain,DC=com; CN=Administrators,CN=Builtin,DC=domain,DC=com"}', 'createTime': null, 'modifyTime': null},
{'clientVersion': '2.33.5.0', 'fqdn': 'dc01.domain.com', 'ipAddress': '192.168.0.10', 'domain': 'domain.com', 'topic': null, 'message': null, 'badge': null, 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'gpo': 'User: gytpolsvc', 'gpoId': null, 'gpoStatus': null, 'subcategory': 'AD Sensitive Permissions', 'currentState': '["Last pwd set: ","2023-04-20T09:22:41+00:00"]', 'wmiFilter': null, 'somPath': '["Last logon dt: ","2023-06-20T08:42:11+00:00"]', 'addInfo': '{"DistinguishedName":"CN=gytpolsvc,CN=Users,DC=domain,DC=com","PasswordNeverExpires":true,"MemberOf":"CN=gytpolUsers,CN=Users,DC=domain,DC=com; CN=gytpolAdmins,CN=Users,DC=domain,DC=com; CN=Performance Log Users,CN=Builtin,DC=domain,DC=com; CN=Administrators,CN=Builtin,DC=domain,DC=com","PasswordExpired":false}', 'createTime': null, 'modifyTime': null},
{'clientVersion': '2.33.5.0', 'fqdn': 'dc01.domain.com', 'ipAddress': '192.168.0.10', 'domain': 'domain.com', 'topic': null, 'message': null, 'badge': null, 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'gpo': 'User: Mark', 'gpoId': null, 'gpoStatus': null, 'subcategory': 'AD Sensitive Permissions', 'currentState': '["Last pwd set: ","2022-06-14T08:43:51+00:00"]', 'wmiFilter': null, 'somPath': '["Last logon dt: ","2023-06-08T11:43:56+00:00"]', 'addInfo': '{"DistinguishedName":"CN=Mark,CN=Users,DC=domain,DC=com","PasswordNeverExpires":true,"MemberOf":"CN=gytpolUsers,CN=Users,DC=domain,DC=com; CN=gytpolAdmins,CN=Users,DC=domain,DC=com; CN=Domain Admins,CN=Users,DC=domain,DC=com; CN=Users,CN=Builtin,DC=domain,DC=com; CN=Administrators,CN=Builtin,DC=domain,DC=com","PasswordExpired":false}', 'createTime': null, 'modifyTime': null},
{'clientVersion': '2.33.5.0', 'fqdn': 'dc01.domain.com', 'ipAddress': '192.168.0.10', 'domain': 'domain.com', 'topic': null, 'message': null, 'badge': null, 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'gpo': 'User: Mark', 'gpoId': null, 'gpoStatus': null, 'subcategory': 'AD Sensitive Permissions', 'currentState': '["Last pwd set: ","2022-06-14T08:43:51+00:00"]', 'wmiFilter': null, 'somPath': '["Last logon dt: ","2023-06-08T11:43:56+00:00"]', 'addInfo': '{"DistinguishedName":"CN=Mark,CN=Users,DC=domain,DC=com","PasswordNeverExpires":true,"MemberOf":"CN=gytpolUsers,CN=Users,DC=domain,DC=com; CN=gytpolAdmins,CN=Users,DC=domain,DC=com; CN=Domain Admins,CN=Users,DC=domain,DC=com; CN=Users,CN=Builtin,DC=domain,DC=com; CN=Administrators,CN=Builtin,DC=domain,DC=com","PasswordExpired":false}', 'createTime': null, 'modifyTime': null},
{'clientVersion': '2.33.5.0', 'fqdn': 'dc01.domain.com', 'ipAddress': '192.168.0.10', 'domain': 'domain.com', 'topic': null, 'message': null, 'badge': null, 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'gpo': 'User: Print Operators', 'gpoId': null, 'gpoStatus': null, 'subcategory': 'AD Sensitive Permissions', 'currentState': '["Last pwd set: ",""]', 'wmiFilter': null, 'somPath': '["Last logon dt: ",""]', 'addInfo': '{"DistinguishedName":"CN=Print Operators,CN=Builtin,DC=domain,DC=com","Members":"","MemberOf":"N/A"}', 'createTime': null, 'modifyTime': null},
{'clientVersion': '2.33.5.0', 'fqdn': 'dc01.domain.com', 'ipAddress': '192.168.0.10', 'domain': 'domain.com', 'topic': null, 'message': null, 'badge': null, 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'gpo': 'User: Schema Admins', 'gpoId': null, 'gpoStatus': null, 'subcategory': 'AD Sensitive Permissions', 'currentState': '["Last pwd set: ",""]', 'wmiFilter': null, 'somPath': '["Last logon dt: ",""]', 'addInfo': '{"DistinguishedName":"CN=Schema Admins,CN=Users,DC=domain,DC=com","Members":"CN=Administrator,CN=Users,DC=domain,DC=com","MemberOf":"CN=Denied RODC Password Replication Group,CN=Users,DC=domain,DC=com"}', 'createTime': null, 'modifyTime': null},
{'clientVersion': '2.33.5.0', 'fqdn': 'dc01.domain.com', 'ipAddress': '192.168.0.10', 'domain': 'domain.com', 'topic': null, 'message': null, 'badge': null, 'suggestion': null, 'policyPath': null, 'recommendedState': null, 'gpo': 'User: Server Operators', 'gpoId': null, 'gpoStatus': null, 'subcategory': 'AD Sensitive Permissions', 'currentState': '["Last pwd set: ",""]', 'wmiFilter': null, 'somPath': '["Last logon dt: ",""]', 'addInfo': '{"DistinguishedName":"CN=Server Operators,CN=Builtin,DC=domain,DC=com","Members":"","MemberOf":"N/A"}', 'createTime': null, 'modifyTime': null}
],
'rowCount': 17,
'cacheTime': '2024-04-07T11:35:06.5871756+00:00',
'recalc': 0
});

	mockData.ADIgnoreList = () => ({
'data': [
{
'ruleId': 37,
'type': 'GPO Analyzer',
'topic': null,
'message': null,
'srcGPOId': 'bdf7f3f3-8062-4a2a-9bb3-7463813e0488',
'srcGPO': null,
'currentState': ['Link disabled.'],
'somPath': [
'GPO link location:',
'Frusman.local'
],
'addInfo': null,
'addDate': '2023-07-16T06:22:09.282249+00:00',
'numIgnoredAccumulated': 1,
'latestIgnored': '2023-07-31T05:36:05.344881+00:00'
},
{
'ruleId': 166,
'type': 'GPO Analyzer',
'topic': null,
'message': null,
'srcGPOId': null,
'srcGPO': null,
'currentState': [
'Full name: ',
'RANDOLPH_HENDRICKS'
],
'somPath': [
'Member: ',
'RANDOLPH_HENDRICKS'
],
'addInfo': {'EmailAddress': null, 'Created': '2022-09-21T05:31:01+00:00', 'Expiration': '', 'LastBadPasswordAttempt': '', 'Modified': '2022-09-21T06:11:54+00:00', 'PasswordLastSet': '2022-09-21T05:31:01+00:00', 'PasswordExpired': 'True', 'LastLogonDt': ''},
'addDate': '2023-12-18T14:09:05.452092+00:00',
'numIgnoredAccumulated': 1,
'latestIgnored': '2023-12-18T14:09:05.490915+00:00'
},
{
'ruleId': 232,
'type': null,
'topic': null,
'message': null,
'srcGPOId': null,
'srcGPO': null,
'currentState': ['Last login:  2023-06-20T11:42:36+03:00'],
'somPath': [
'DN: ',
'CN=Administrator,CN=Users,DC=domain,DC=com'
],
'addInfo': null,
'addDate': '2024-07-15T14:27:40.931593+00:00',
'numIgnoredAccumulated': 1,
'latestIgnored': '2024-07-15T14:27:41.083859+00:00'
},
{
'ruleId': 100,
'type': 'GPO Analyzer',
'topic': null,
'message': null,
'srcGPOId': null,
'srcGPO': null,
'currentState': [
'Last logon date: ',
'2022-07-10T06:07:11+00:00'
],
'somPath': [
'OU: ',
'domain.com\\Users'
],
'addInfo': {'Enabled': true, 'LastLogonDC': 'DC01.domain.com', 'AccountExpirationDate': '', 'PasswordExpired': 'True', 'MemberOf': 'N/A', 'FullPath': 'CN=user1,CN=Users,DC=domain,DC=com'},
'addDate': '2023-08-23T21:07:19.94865+00:00',
'numIgnoredAccumulated': 1,
'latestIgnored': '2023-08-23T21:07:20.171768+00:00'
},
{
'ruleId': 200,
'type': 'GPO Analyzer',
'topic': null,
'message': null,
'srcGPOId': null,
'srcGPO': null,
'currentState': [
'Last pwd set: ',
'2023-05-28T12:16:46+00:00'
],
'somPath': [
'Last logon dt: ',
'2023-06-20T08:42:36+00:00'
],
'addInfo': {'DistinguishedName': 'CN=Administrator,CN=Users,DC=domain,DC=com', 'PasswordNeverExpires': false, 'MemberOf': 'CN=Group Policy Creator Owners,CN=Users,DC=domain,DC=com; CN=Domain Admins,CN=Users,DC=domain,DC=com; CN=Enterprise Admins,CN=Users,DC=domain,DC=com; CN=Schema Admins,CN=Users,DC=domain,DC=com; CN=Administrators,CN=Builtin,DC=domain,DC=com', 'PasswordExpired': false},
'addDate': '2024-01-04T11:29:41.221714+00:00',
'numIgnoredAccumulated': 5,
'latestIgnored': '2024-01-04T11:29:41.227094+00:00'
},
{
'ruleId': 265,
'type': null,
'topic': null,
'message': null,
'srcGPOId': null,
'srcGPO': null,
'currentState': [
'Last pwd set: ',
''
],
'somPath': [
'Last logon dt: ',
''
],
'addInfo': {'DistinguishedName': 'CN=Backup Operators,CN=Builtin,DC=domain,DC=com', 'PasswordNeverExpires': null, 'MemberOf': 'N/A', 'PasswordExpired': null},
'addDate': '2024-07-22T18:17:00.97542+00:00',
'numIgnoredAccumulated': 1,
'latestIgnored': '2024-07-22T18:17:01.070789+00:00'
},
{'ruleId': 2, 'type': 'Benchmark', 'topic': null, 'message': null, 'srcGPOId': '31b2f340-016d-11d2-945f-00c04fb984f9', 'srcGPO': null, 'currentState': ['0'], 'somPath': ['gytpol.lab'], 'addInfo': null, 'addDate': '2023-06-25T10:48:54.171128+00:00', 'numIgnoredAccumulated': 1, 'latestIgnored': '2023-07-31T05:36:05.159717+00:00'},
{
'ruleId': 36,
'type': 'GPO Analyzer',
'topic': null,
'message': null,
'srcGPOId': null,
'srcGPO': null,
'currentState': ['Disabled User'],
'somPath': [
'Path: ',
'CN=Guest,CN=Users,DC=Frusman,DC=local'
],
'addInfo': {'Modified': '2022-09-11T12:14:45+00:00', 'PasswordLastSet': '', 'PasswordExpired': 'False', 'MemberOf': 'CN=CH-bel-distlist1,OU=AZR,OU=Tier 1,DC=Frusman,DC=local; CN=BR-computado-distlist1,OU=Domain Controllers,DC=Frusman,DC=local; CN=IR-ulanazeri-distlist1,OU=AZR,OU=Stage,DC=Frusman,DC=local; CN=Guests,CN=Builtin,DC=Frusman,DC=local'},
'addDate': '2023-07-16T06:20:27.649914+00:00',
'numIgnoredAccumulated': 1,
'latestIgnored': '2023-07-31T05:36:05.267432+00:00'
},
{
'ruleId': 233,
'type': null,
'topic': null,
'message': null,
'srcGPOId': null,
'srcGPO': null,
'currentState': [
'Foreign Object Type: ',
'user'
],
'somPath': [
'Path: ',
'CN=ALVA_WALLACE,OU=Groups,OU=AWS,OU=Tier 1,DC=Frusman,DC=local'
],
'addInfo': {'DisplayName': 'ALVA_WALLACE', 'Enabled': null, 'WhenCreated': '2024-03-14T07:31:12+00:00', 'WhenChanged': '2024-03-14T07:31:12+00:00', 'MemberOf': 'CN=KE-cascanuec-distlist1,OU=BDE,OU=Stage,DC=Frusman,DC=local; CN=LU-lad-admingroup1,OU=ServiceAccounts,OU=AZR,OU=Tier 2,DC=Frusman,DC=local; CN=KE-coordinac-distlist1,OU=AWS,OU=Tier 2,DC=Frusman,DC=local; CN=GA-ballita_7-distlist1,OU=FIN,OU=Stage,DC=Frusman,DC=local; CN=GU-est-distlist1,OU=SEC,OU=Tier 1,DC=Frusman,DC=local; CN=BE-nen-distlist1,OU=Intune Test,DC=Frusman,DC=local; CN=Domain Controllers,CN=Users,DC=Frusman,DC=local'},
'addDate': '2024-07-15T14:28:05.680623+00:00',
'numIgnoredAccumulated': 1,
'latestIgnored': '2024-07-15T14:28:05.68599+00:00'
},
{
'ruleId': 266,
'type': null,
'topic': null,
'message': null,
'srcGPOId': null,
'srcGPO': null,
'currentState': [
'Not ',
'defined'
],
'somPath': [
'Path: ',
'\\\\domain.com\\SYSVOL\\domain.com\\Policies\\PolicyDefinitions'
],
'addInfo': null,
'addDate': '2024-07-28T07:05:29.38481+00:00',
'numIgnoredAccumulated': 1,
'latestIgnored': '2024-07-28T07:05:29.389718+00:00'
},
{
'ruleId': 133,
'type': 'Benchmark',
'topic': null,
'message': null,
'srcGPOId': null,
'srcGPO': null,
'currentState': null,
'somPath': [
'No Linked GPO found',
'- none'
],
'addInfo': null,
'addDate': '2023-10-23T12:34:31.909283+00:00',
'numIgnoredAccumulated': 14683,
'latestIgnored': '2024-04-03T07:00:33.94387+00:00'
},
{
'ruleId': 267,
'type': null,
'topic': null,
'message': null,
'srcGPOId': null,
'srcGPO': null,
'currentState': [
'Current: ',
'not configured'
],
'somPath': [
'How to Enable ',
'ADAC'
],
'addInfo': null,
'addDate': '2024-07-28T07:13:31.576328+00:00',
'numIgnoredAccumulated': 5,
'latestIgnored': '2024-07-28T07:13:31.583009+00:00'
},
{'ruleId': 199, 'type': 'GPO Analyzer', 'topic': null, 'message': null, 'srcGPOId': null, 'srcGPO': null, 'currentState': ['Not configured.'], 'somPath': null, 'addInfo': null, 'addDate': '2024-01-04T11:29:15.961677+00:00', 'numIgnoredAccumulated': 1098, 'latestIgnored': '2024-04-03T07:56:41.118506+00:00'},
{
'ruleId': 34,
'type': 'GPO Analyzer',
'topic': null,
'message': null,
'srcGPOId': null,
'srcGPO': null,
'currentState': [
'Last pwd set: ',
'2022-10-12T22:33:54+-07:00'
],
'somPath': [
'Last logon dt: ',
'2022-12-12T13:51:39+-07:00'
],
'addInfo': {'DistinguishedName': 'CN=gustavo,CN=Users,DC=gytpol,DC=qa,DC=com', 'PasswordNeverExpires': true, 'MemberOf': 'CN=GytpolReaders,CN=Users,DC=gytpol,DC=qa,DC=com', 'PasswordExpired': false},
'addDate': '2023-07-16T06:03:25.525507+00:00',
'numIgnoredAccumulated': 1526,
'latestIgnored': '2023-11-03T14:38:52.283269+00:00'
},
{
'ruleId': 35,
'type': 'GPO Analyzer',
'topic': null,
'message': null,
'srcGPOId': null,
'srcGPO': null,
'currentState': [
'Last pwd set: ',
'2022-10-12T22:33:54+-07:00'
],
'somPath': [
'Last logon dt: ',
'2022-12-12T13:51:39+-07:00'
],
'addInfo': {'DistinguishedName': 'CN=gustavo,CN=Users,DC=gytpol,DC=qa,DC=com', 'PasswordNeverExpires': true, 'MemberOf': 'GytpolReaders', 'PasswordExpired': false, 'SPNs': 'MSSQLSvc1/gytpolserver-qa.gytpol.com', 'SPN_Status': 'Host: gytpolserver-qa - in the domain. Is Enabled: True;  '},
'addDate': '2023-07-16T06:05:03.749395+00:00',
'numIgnoredAccumulated': 1526,
'latestIgnored': '2023-11-03T14:38:53.141686+00:00'
}
],
'cacheTime': '2024-10-13T12:51:11.8894463+00:00',
'recalc': 0
});

	mockData.topAlerts = () => ({
data: [
{topicCode: 'gytSMBv1', red: 97845, green: 5451, potentialTimeSaving: 15500, potentialDollarsSaving: 5412},
{topicCode: 'gytSmbSignCommReqServer', red: 97845, green: 5451, potentialTimeSaving: 15500, potentialDollarsSaving: 5412},
{topicCode: 'gytSMBv1', red: 97845, green: 5451, potentialTimeSaving: 15500, potentialDollarsSaving: 5412},
{topicCode: 'gytSMBv1', red: 97845, green: 5451, potentialTimeSaving: 15500, potentialDollarsSaving: 5412}
]
});

	mockData.notifGetList = () => ({
'data':[
{'id':21, 'type':'offlineExport', 'source':'Action Center - 1 Rule - Disable SMBv1 Client (Mac) - by Asaf Lanzer 2026-01-01 11_13.csv', 'message':'', 'date':new Date(Date.now() - (Math.random()*1000000 |0)).toISOString(), 'dismissedBy':null, 'hasPayload':true, 'userName':'george@acme.com'},
{'id':25, 'type':'offlineExport', 'source':'Device Manifest - 2025-12-09 17_24.csv', 'message':'', 'date':new Date(Date.now() - (Math.random()*1000000 |0)).toISOString(), 'dismissedBy':null, 'hasPayload':true, 'userName':null},
{'id':20, 'type':'clientLog', 'source':'MACSIM4', 'message':'Sensor logs received', 'date':new Date(Date.now() - (Math.random()*1000000 |0)).toISOString(), 'dismissedBy':null, 'hasPayload':true, 'userName':'katyperry@acme.com'},
{'id':19, 'type':'clientLog', 'source':'SENSORSIM35', 'message':'Sensor logs received', 'date':new Date(Date.now() - (Math.random()*1000000 |0)).toISOString(), 'dismissedBy':{'user':'d@acme.com', 'userName':'donny', 'title':'dev'}, 'hasPayload':true, 'userName':'samyates@acme.com'},
{'id':18, 'type':'clientLog', 'source':'LINUXSIM10', 'message':'Sensor logs received', 'date':new Date(Date.now() - (Math.random()*1000000 |0)).toISOString(), 'dismissedBy':{'user':'d@acme.com', 'userName':'donny', 'title':'dev'}, 'hasPayload':true, 'userName':'george@acme.com'},
{'id':28, 'type':'offlineExport', 'source':'CIS Compliance 1_029 Standards - by brachi 2025-12-01 15_53.csv', 'message':'', 'date':new Date(Date.now() - (Math.random()*1000000 |0)).toISOString(), 'dismissedBy':{'user':'sam@servicenow.com', 'userName':'donny', 'title':'dev'}, 'hasPayload':false, 'userName':'samyates@acme.com'},
{'id':23, 'type':'offlineExport', 'source':'Device Manifest - 2025-12-09 17_24.csv', 'message':'', 'date':new Date(Date.now() - (Math.random()*1000000 |0)).toISOString(), 'dismissedBy': {'user':'kate@servicenow.com', 'userName':'donny', 'title':'dev'}, 'hasPayload':false, 'userName':'samyates@acme.com'}
]
});

	mockData.getversions = () => ({'data': [{'module': 'Analyzer', 'version': '2.4.3', 'timeBuilt': '2024-05-28T14:18:37.0000000+00:00', 'started': '2024-05-28T14:24:37.3084022+00:00', 'timeReported': '0001-01-01T00:00:00+00:00'}]});

	mockData.misconCheckRemediate = () => ({applicAlerts: Math.random() * 20000 | 0, applicDevices: +(Math.random() < 0.8) * Math.random() * 20000 | 0, applicNonRevert: +(Math.random() < 0.3) * Math.random() * 20000 | 0, 'notApplic': [...Math.random() < 0.7? [] :[{'count': 1, 'reasonCode': 'Client version is older than 1.2.0.0'}]], remedies: Object.keys(HA_Remedies), approvalService: '', approvalServiceError: ''});

	mockData.misconCheckRemediateMulti = req => ({
applicAlerts: Math.random() * 20000 | 0,
applicDevices: +(Math.random() < 0.8) * Math.random() * 20000 | 0,
applicNonRevert: +(Math.random() < 0.3) * Math.random() * 20000 | 0,
'notApplic': [
...Math.random() < 0.7? [] :[
{'count': 1, 'reasonCode': 'Client version is older than 1.2.0.0'},
{'reasonCode': 'oldPsVer', 'count': 4},
{'reasonCode': 'some ver long reason here written', 'count': 4353489}
]
],
remediesAvailable: (req.actions ?? []).flatMap(rmd => rmd.actionDatum ?? []).undup(),
approvalService: '',
approvalServiceError: ''
});
	mockData.relatedMisconCheckRemediateMulti = (_req: unknown) => ({'applicAlerts': 13, 'applicDevices': 13, 'applicNonRevert': 0, 'notApplic': [{'reasonCode': 'oldPsVer', 'count': 4}], 'remediesAvailable': ['enablePrintSpoolerLog']});

	// Patch remediation check (OS + App). UI composes the description sentence from these structured fields (opt b); one config branches on `kind`.
	// `selection` drives the "on N instance(s) (version range)" pill: versionFrom/To shown as a range when they differ.
	mockData.patchCheckRemediateMulti = req => {
		const org = req.actions?.[0]?.benchmarkOrg;
		const isOs = org === 'PATCH_VULN_ASSESSMENT' || org === 'OS_PATCH_MANAGEMENT';
		const isAppControl = org === 'APP_CONTROL';
		// Reflect per-patch reversibility so different selections show the right notice; KBs listed here can't be reverted.
		const nonRevertableKbs = new Set(['KB5066136']);
		const selectedIds = (req.actions ?? []).flatMap((a: any) => [
a.topicCode,
...(a.list ?? []),
...(a.listIds ?? [])
]).filter(Boolean);
		const hasReversible = !selectedIds.some(id => nonRevertableKbs.has(id));
		let remedy;
		if (isOs)
			remedy = {
actionDatum: 'download-and-install-os-patch',
				kind: 'os',
				title: 'Install KB5022913',
				product: 'Windows Kernel',
				currentVersion: '22H2',
				targetVersion: '23H2',
				patchType: 'Cumulative Update',
				source: 'Microsoft Update',
				reboot: true,
				hasReversible
};
		else if (isAppControl) {
			const product = req.actions?.[0]?.topicCode ?? 'Application';
			const slug = product.replace(/\W+/g, '_').toLowerCase().slice(0, 30);
			remedy = {
actionDatum: `patch_${slug}_latest`,
				kind: 'app',
				title: `Update ${product} to latest version`,
				product,
				currentVersion: '1.0.0',
				targetVersion: '2.0.0',
				packageName: `${slug}-setup.msi`,
				source: 'Vendor',
				reboot: false
};
		} else
			remedy = {
actionDatum: 'patch_7zip_x64_25_01',
				kind: 'app',
				title: 'Install 7-Zip (x64) v25.01',
				product: '7-Zip (x64)',
				currentVersion: '9.1.0',
				targetVersion: '25.01',
				packageName: '7zip-x64-25.01.msi',
				source: 'Vendor (7-zip.org)',
				reboot: false
};
		return {
			applicAlerts: isOs ? 2 : 1,
			applicDevices: isOs ? 3 : 1,
			applicNonRevert: 0,
			notApplic: [],
			remedies: [remedy],
			remediesAvailable: [remedy.actionDatum],
			selection: {instances: isOs ? 3 : 1, versionFrom: isOs ? '21H2' : remedy.currentVersion, versionTo: isOs ? '22H2' : remedy.currentVersion},
			approvalService: '',
			approvalServiceError: '',
		};
	};

	mockData.CompCheckRemediate = (req: {topicCode: string}) => ({
applicAlerts: Math.random() * 20000 | 0,
applicDevices: Math.random() * 20000 | 0,
applicNonRevert: Math.random() * 20000 | 0,
'notApplic': [{'count': 1, 'reasonCode': 'Client version is older than 1.2.0.0'}],
remedies: (() => {
const rems = Object.entries(Comp_remedies).filter(([
_rem,
def]: [string, {topics?: string[], topic?: string}
]) => (Array.isArray(def.topics) ? def.topics.includes(req.topicCode) : def.topic === req.topicCode)).map(([rem]) => rem); return rems.length ? rems : [req.topicCode];
})(),
approvalService: '',
approvalServiceError: ''
});
	mockData.genericCheckRemediate = () => ({'applicDevices': 1, 'notApplic': [], 'approvalService': null, 'approvalServiceError': null});

	mockData.statsSelTargets = () => ({
'selTargets': [
{
'groupId': 1001,
'devices': 824,
'new': 0,
'graph': [
1644,
1645,
1644,
1637,
1628,
1633,
1631,
1629,
1631,
1629,
1629,
1624,
1614,
1609,
1610,
1610,
1605,
1608,
1609,
1610,
1607,
1608,
1543,
1546,
1549,
1607,
1610,
1607,
1609,
1600
].map((value, gi, all) => ({date: new Date(Date.now() - (all.length - gi) * MS_DAY).toISOString(), value}))
},
{
'groupId': 1002,
'devices': 74,
'new': 0,
'graph': [
83,
83,
83,
83,
83,
83,
83,
83,
83,
83,
83,
83,
83,
83,
83,
83,
83,
83,
180,
83,
83,
78,
61,
61,
61,
77,
83,
83,
85,
85
].map((value, gi, all) => ({date: new Date(Date.now() - (all.length - gi) * MS_DAY).toISOString(), value}))
},
{
'groupId': 1003,
'devices': 824,
'new': 0,
'graph': [
1644,
1645,
1644,
1637,
1628,
1633,
1631,
1629,
1631,
1629,
1629,
1624,
1614,
1609,
1610,
1610,
1605,
1608,
1609,
1610,
1607,
1608,
1543,
1546,
1549,
1607,
1610,
1607,
1609,
1600
].map((value, gi, all) => ({date: new Date(Date.now() - (all.length - gi) * MS_DAY).toISOString(), value}))
},
{
'groupId': 1005,
'devices': 3,
'new': 0,
'graph': [
3,
3,
3,
3,
3,
3,
3,
3,
3,
3,
3,
3,
3,
3,
5,
6,
7,
8,
9,
10,
11,
12,
3,
3,
3,
3,
3,
3,
3,
3
].map((value, gi, all) => ({date: new Date(Date.now() - (all.length - gi) * MS_DAY).toISOString(), value}))
},
{
'groupId': 1006,
'devices': 71,
'new': 0,
'graph': [
80,
80,
80,
80,
80,
80,
80,
80,
80,
80,
80,
80,
80,
80,
80,
80,
80,
80,
81,
80,
80,
75,
58,
58,
58,
74,
80,
80,
82,
82
].map((value, gi, all) => ({date: new Date(Date.now() - (all.length - gi) * MS_DAY).toISOString(), value}))
}
],
'calcState': 0,
'cacheTime': '2024-06-30T10:15:32.2397739+00:00'
});

	mockData.permsGetRoles = () => ({
'data': [
{
'roleId': 2,
'roleName': 'Admin',
'perms': [{'groupId': 0, 'access': 'full'}],
'members': [
{'user': 'gus@acme.com', 'userName': null, 'userType': 'Local'},
{'user': 'ma@acme.com', 'userName': null, 'userType': 'Local'},
{'user': 'ba@acme.com', 'userName': null, 'userType': 'Local'},
{'user': 'to@gsd.com', 'userName': 'tomas', 'userType': 'Local'},
{'user': 'azuread_it@sd.com', 'userName': 'Nitay Sol', 'userType': 'External'},
{'user': 'ori@gytpol.com', 'userName': '', 'userType': 'Local'}
],
'log': [
{
'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null},
'date': '2024-09-09T06:45:33.119399Z',
'perms': [{'groupId': 0, 'access': 'full'}],
'members': [
'gus@acme.com',
'tl@acme.com',
'yon@acme.com',
'yu@g.com',
'ar@acme.com',
'ma@acme.com'
]
},
{
'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null},
'date': '2024-06-03T13:31:45.236564Z',
'perms': [{'groupId': 0, 'access': 'full'}],
'members': [
'gus@acme.com',
'ba@acme.com',
'tl@acme.com',
'yon@acme.com',
'yu@g.com'
]
},
{
'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null},
'date': '2024-06-26T07:08:40.244088Z',
'perms': [{'groupId': 0, 'access': 'full'}],
'members': [
'gus@acme.com',
'ba@acme.com',
'tl@acme.com',
'yon@acme.com',
'yu@g.com',
'ar@acme.com'
]
},
{
'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null},
'date': '2024-07-22T06:19:06.479059Z',
'perms': [{'groupId': 0, 'access': 'full'}],
'members': [
'gus@acme.com',
'tl@acme.com',
'yon@acme.com',
'yu@g.com',
'ar@acme.com'
]
},
{
'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null},
'date': '2025-05-27T09:54:55.556515Z',
'perms': [{'groupId': 0, 'access': 'full'}],
'members': [
'gus@acme.com',
'tl@acme.com',
'yon@acme.com',
'yu@g.com',
'ma@acme.com',
'ba@acme.com',
'to@gsd.com',
'al.o@gsad.com',
'ar@acme.com',
' it@sd.com',
'azuread_it@sd.com'
]
},
{
'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null},
'date': '2025-01-28T11:45:41.602743Z',
'perms': [{'groupId': 0, 'access': 'full'}],
'members': [
'gus@acme.com',
'tl@acme.com',
'yon@acme.com',
'yu@g.com',
'ar@acme.com',
'ma@acme.com',
'ba@acme.com',
'to@gsd.com',
'al.o@gsad.com'
]
},
{
'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null},
'date': '2025-01-28T11:39:37.886508Z',
'perms': [{'groupId': 0, 'access': 'full'}],
'members': [
'gus@acme.com',
'tl@acme.com',
'yon@acme.com',
'yu@g.com',
'ar@acme.com',
'ma@acme.com',
'ba@acme.com',
'to@gsd.com',
'al.o@gsad.com',
'niy@gasol.com'
]
},
{
'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null},
'date': '2025-01-21T10:26:21.150323Z',
'perms': [{'groupId': 0, 'access': 'full'}],
'members': [
'gus@acme.com',
'tl@acme.com',
'yon@acme.com',
'yu@g.com',
'ar@acme.com',
'ma@acme.com',
'ba@acme.com',
'to@gsd.com',
'al.o@gsad.com'
]
},
{
'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null},
'date': '2024-12-16T14:09:18.44865Z',
'perms': [{'groupId': 0, 'access': 'full'}],
'members': [
'gus@acme.com',
'tl@acme.com',
'yon@acme.com',
'yu@g.com',
'ar@acme.com',
'ma@acme.com',
'ba@acme.com',
'to@gsd.com'
]
},
{
'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null},
'date': '2024-10-06T13:06:29.006186Z',
'perms': [{'groupId': 0, 'access': 'full'}],
'members': [
'gus@acme.com',
'tl@acme.com',
'yon@acme.com',
'yu@g.com',
'ar@acme.com',
'ma@acme.com',
'ba@acme.com'
]
}
]
},
{
'roleId': 298,
'roleName': 'test',
'perms': [{'groupId': 1001, 'access': 'full'}],
'members': [{'user': 'azuread_sh2@gytpoldev.onmicrosoft.com', 'userName': 'sh Gutman', 'userType': 'External'}],
'log': [
{'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null}, 'date': '2024-06-26T07:10:56.023642Z', 'perms': [{'groupId': 1001, 'access': 'read'}], 'members': ['test@gytpol.com']},
{
'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null},
'date': '2024-06-26T11:50:52.312035Z',
'perms': [
{'groupId': 1001, 'access': 'full'},
{'groupId': 0, 'access': 'read'}
],
'members': [
'test@gytpol.com',
'ar@acme.com'
]
},
{
'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null},
'date': '2024-06-26T11:49:29.741377Z',
'perms': [{'groupId': 1001, 'access': 'read'}],
'members': [
'test@gytpol.com',
'ar@acme.com'
]
},
{
'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null},
'date': '2024-07-14T10:13:09.789268Z',
'perms': [{'groupId': 1001, 'access': 'full'}],
'members': [
'test@gytpol.com',
'ar@acme.com'
]
}
]
},
{
'roleId': 364,
'roleName': 'LinuxOnly',
'perms': [
{'groupId': 1010, 'access': 'full'},
{'groupId': 1011, 'access': 'full'},
{'groupId': 1014, 'access': 'full'}
],
'members': [{'user': 'azuread_gus@asd.com', 'userName': null, 'userType': 'External'}],
'log': []
},
{
'roleId': 365,
'roleName': 'ServerOnly',
'perms': [{'groupId': 1002, 'access': 'read'}],
'members': [{'user': 'azuread_test@g..com', 'userName': 'test test', 'userType': 'External'}],
'log': [
{
'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null},
'date': '2024-11-24T14:59:57.759666Z',
'perms': [{'groupId': 1002, 'access': 'read'}],
'members': [
'nitsan@gytpol.com',
'test@gytpol.com'
]
},
{
'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null},
'date': '2024-11-24T15:02:25.798886Z',
'perms': [{'groupId': 1002, 'access': 'read'}],
'members': [
'nitsan@gytpol.com',
'test@gytpol.com',
'gustavo+view@gytpol.com'
]
},
{'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null}, 'date': '2024-11-24T14:59:28.0188Z', 'perms': [{'groupId': 1002, 'access': 'read'}], 'members': ['nitsan@gytpol.com']}
]
},
{
'roleId': 366,
'roleName': 'GroupRole',
'perms': [{'groupId': 1024, 'access': 'full'}],
'members': [{'user': 'oktayaron_sh@gytpol.com', 'userName': 'sh Gutman', 'userType': 'External'}],
'log': [
{
'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null},
'date': '2024-06-26T11:49:12.302538Z',
'perms': [{'groupId': 1024, 'access': 'full'}],
'members': [
'ma@acme.com',
'yaron@gytpoldev.onmicrosoft.com'
]
}
]
},
{
'roleId': 398,
'roleName': 'Default',
'perms': [{'groupId': 0, 'access': 'full'}],
'members': [
{'user': 'sh@gytpol.com', 'userName': '', 'userType': 'Local'},
{'user': 'sh@gytpoldev.onmicrosoft.com', 'userName': 'yis yis', 'userType': 'Local'}
],
'log': [
{'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null}, 'date': '2024-06-26T11:48:28.136126Z', 'perms': [{'groupId': 0, 'access': 'full'}], 'members': ['ar@acme.com']},
{
'byUser': {'user': 'azuread_it@sd.com', 'userName': 'Nitay Sol', 'title': null},
'date': '2025-05-27T11:00:18.93535Z',
'perms': [{'groupId': 0, 'access': 'full'}],
'members': [
'amir@gytpol.com',
'sh@gytpol.com',
'sh@gytpoldev.onmicrosoft.com',
'banana@gytpol.com',
'azuread_nitay2@gytpoldev.onmicrosoft.com'
]
},
{
'byUser': {'user': 'nitay2@gytpoldev.onmicrosoft.com', 'userName': 'Nitay Sol', 'title': null},
'date': '2025-01-29T10:38:07.718813Z',
'perms': [{'groupId': 0, 'access': 'full'}],
'members': [
'amir@gytpol.com',
'banana@gytpol.com',
'sh@gytpol.com',
'sh@gytpoldev.onmicrosoft.com'
]
},
{
'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null},
'date': '2025-01-28T11:54:58.224598Z',
'perms': [{'groupId': 0, 'access': 'full'}],
'members': [
'amir@gytpol.com',
'banana@gytpol.com',
'sh@gytpol.com'
]
},
{
'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null},
'date': '2025-01-28T11:53:06.505731Z',
'perms': [{'groupId': 0, 'access': 'full'}],
'members': [
'amir@gytpol.com',
'sh@gytpoldev.onmicrosoft.com',
'banana@gytpol.com'
]
},
{'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null}, 'date': '2024-06-26T11:49:45.772012Z', 'perms': [{'groupId': 0, 'access': 'full'}], 'members': ['amir@gytpol.com']},
{
'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null},
'date': '2024-06-26T11:49:02.945829Z',
'perms': [{'groupId': 0, 'access': 'full'}],
'members': [
'ar@acme.com',
'amir@gytpol.com'
]
},
{'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null}, 'date': '2024-06-26T11:48:38.21232Z', 'perms': [{'groupId': 0, 'access': 'full'}], 'members': ['ar@acme.com']},
{'byUser': {'user': '(System)', 'userName': null, 'title': null}, 'date': '2024-06-03T13:31:24.684183Z', 'perms': [{'groupId': 0, 'access': 'full'}], 'members': ['yu@g.com']}
]
},
{
'roleId': 463,
'roleName': 'Teste12345',
'perms': [
{'groupId': 1010, 'access': 'read'},
{'groupId': 1388, 'access': 'full'}
],
'members': [{'user': 'azuread_yaron@gytpoldev.onmicrosoft.com', 'userName': 'Yaron Bialik', 'userType': 'External'}],
'log': [
{
'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null},
'date': '2024-12-19T09:00:42.841068Z',
'perms': [
{'groupId': 1010, 'access': 'read'},
{'groupId': 1388, 'access': 'full'}
],
'members': ['yaron@gytpoldev.onmicrosoft.com']
},
{'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null}, 'date': '2024-07-14T11:19:25.657915Z', 'perms': [{'groupId': 1010, 'access': 'read'}], 'members': ['yaron@gytpoldev.onmicrosoft.com']}
]
},
{
'roleId': 496,
'roleName': 'banana',
'perms': [{'groupId': 0, 'access': 'full'}],
'members': [{'user': 'azuread_nitay2@gytpoldev.onmicrosoft.com', 'userName': 'Nitay Sol', 'userType': 'External'}],
'log': [
{'byUser': {'user': 'azuread_it@sd.com', 'userName': 'Nitay Sol', 'title': null}, 'date': '2025-05-27T10:59:09.454247Z', 'perms': [{'groupId': 0, 'access': 'full'}], 'members': ['azuread_nitay2@gytpoldev.onmicrosoft.com']},
{'byUser': {'user': 'sh@gytpol.com', 'userName': 'sh Gutman', 'title': null}, 'date': '2024-11-19T13:45:00.545309Z', 'perms': [{'groupId': 0, 'access': 'full'}], 'members': []}
]
},
{'roleId': 529, 'roleName': '759e6035-41d1-41c4-9935-02b60c9ba918', 'perms': [{'groupId': 0, 'access': 'full'}], 'members': [{'user': 'azuread_sh@gytpoldev.onmicrosoft.com', 'userName': null, 'userType': 'External'}], 'log': [{'byUser': {'user': 'nitay2@gytpoldev.onmicrosoft.com', 'userName': 'Nitay Sol', 'title': null}, 'date': '2025-01-29T10:33:21.917218Z', 'perms': [{'groupId': 0, 'access': 'full'}], 'members': []}]},
{
'roleId': 562,
'roleName': 'YaronTestGroup',
'perms': [
{'groupId': 1002, 'access': 'full'},
{'groupId': 1003, 'access': 'full'}
],
'members': [],
'log': [
{
'byUser': {'user': 'azuread_sh@gytpoldev.onmicrosoft.com', 'userName': null, 'title': null},
'date': '2025-10-30T13:47:09.030844Z',
'perms': [
{'groupId': 1002, 'access': 'full'},
{'groupId': 1003, 'access': 'full'}
],
'members': []
},
{'byUser': {'user': 'gus@acme.com', 'userName': null, 'title': null}, 'date': '2025-07-13T15:00:06.112514Z', 'perms': [{'groupId': 1002, 'access': 'full'}], 'members': []}
]
}
]
});

	mockData.permsGetUsers = () => ({
'data': [
{'oUser': {'userType': 'External', 'email': 'gus@asd.com', 'user': 'azuread_gus@asd.com', 'userName': null, 'title': null}, 'roleId': 364, 'lastActivity': null, 'isRoleAssignedByExternalIdp': false},
{'oUser': {'userType': 'External', 'email': 'nitay1@gytpolDev.onmicrosoft.com', 'user': 'azuread_it@sd.com', 'userName': 'Nitay Sol', 'title': null}, 'roleId': 2, 'lastActivity': '2025-11-02T10:59:12.7677118+00:00', 'isRoleAssignedByExternalIdp': false},
{'oUser': {'userType': 'External', 'email': 'nitay2@gytpoldev.onmicrosoft.com', 'user': 'azuread_nitay2@gytpoldev.onmicrosoft.com', 'userName': 'Nitay Sol', 'title': null}, 'roleId': 496, 'lastActivity': null, 'isRoleAssignedByExternalIdp': false},
{'oUser': {'userType': 'External', 'email': 'sh@gytpol.com', 'user': 'azuread_sh2@gytpoldev.onmicrosoft.com', 'userName': 'sh Gutman', 'title': null}, 'roleId': 298, 'lastActivity': null, 'isRoleAssignedByExternalIdp': false},
{'oUser': {'userType': 'External', 'email': 'sh@gytpolDev.onmicrosoft.com', 'user': 'azuread_sh@gytpoldev.onmicrosoft.com', 'userName': null, 'title': null}, 'roleId': 529, 'lastActivity': '2025-11-02T09:27:51.1677753+00:00', 'isRoleAssignedByExternalIdp': false},
{'oUser': {'userType': 'External', 'email': 'test@gytpol.com', 'user': 'azuread_test@g..com', 'userName': 'test test', 'title': null}, 'roleId': 365, 'lastActivity': null, 'isRoleAssignedByExternalIdp': false},
{'oUser': {'userType': 'External', 'email': 'yaron@gytpoldev.onmicrosoft.com', 'user': 'azuread_yaron@gytpoldev.onmicrosoft.com', 'userName': 'Yaron Bialik', 'title': null}, 'roleId': 463, 'lastActivity': '2025-10-23T11:37:25.5333969+00:00', 'isRoleAssignedByExternalIdp': false},
{'oUser': {'userType': 'Local', 'email': 'ba@acme.com', 'user': 'ba@acme.com', 'userName': null, 'title': null}, 'roleId': 2, 'lastActivity': null, 'isRoleAssignedByExternalIdp': false},
{'oUser': {'userType': 'Local', 'email': 'gus@acme.com', 'user': 'gus@acme.com', 'userName': null, 'title': null}, 'roleId': 2, 'lastActivity': '2025-11-02T11:13:46.1822485+00:00', 'isRoleAssignedByExternalIdp': false},
{'oUser': {'userType': 'Local', 'email': 'ma@acme.com', 'user': 'ma@acme.com', 'userName': null, 'title': null}, 'roleId': 2, 'lastActivity': '2025-10-06T16:23:19.0091752+00:00', 'isRoleAssignedByExternalIdp': false},
{'oUser': {'userType': 'External', 'email': 'sh@gytpol.com', 'user': 'oktayaron_sh@gytpol.com', 'userName': 'sh Gutman', 'title': null}, 'roleId': 366, 'lastActivity': '2025-07-03T09:01:16.0669434+00:00', 'isRoleAssignedByExternalIdp': false},
{'oUser': {'userType': 'Local', 'email': 'ori@gytpol.com', 'user': 'ori@gytpol.com', 'userName': '', 'title': ''}, 'roleId': 2, 'lastActivity': '2025-10-30T14:39:36.3808905+00:00', 'isRoleAssignedByExternalIdp': false},
{'oUser': {'userType': 'Local', 'email': 'sh@gytpol.com', 'user': 'sh@gytpol.com', 'userName': '', 'title': ''}, 'roleId': 398, 'lastActivity': '2024-11-19T13:58:12.9714964+00:00', 'isRoleAssignedByExternalIdp': false},
{'oUser': {'userType': 'Local', 'email': 'sh@gytpoldev.onmicrosoft.com', 'user': 'sh@gytpoldev.onmicrosoft.com', 'userName': 'yis yis', 'title': null}, 'roleId': 398, 'lastActivity': '2025-07-01T10:00:03.3100285+00:00', 'isRoleAssignedByExternalIdp': false},
{'oUser': {'userType': 'Local', 'email': 'stam@gytpol.com', 'user': 'stam@gytpol.com', 'userName': 'asd asdaa', 'title': null}, 'roleId': -1, 'lastActivity': '2025-07-03T08:53:31.8317864+00:00', 'isRoleAssignedByExternalIdp': false},
{'oUser': {'userType': 'Local', 'email': 'to@gsd.com', 'user': 'to@gsd.com', 'userName': 'tomas', 'title': 'bro33'}, 'roleId': 2, 'lastActivity': '2025-07-24T14:26:08.4985997+00:00', 'isRoleAssignedByExternalIdp': false}
]
});

	mockData.misconTopicType = () => ({
data: [
{
'param':'MSMQ Service is Running and listening on port 1801; Has dependecies',
		flags: [
'remediated',
'mutedAlerts'
],
		'paramExtra':null,
		'device':'ALEX-ITSIK',
		'deviceId': 9101,
		installPath: 'C:\\Windows\\System32\\mqsvc.exe',
		installDate: '2023-05-12T08:30:00Z',
		'severity':'High',
		'updatedAt':'2024-06-18T09:12:44.392389Z',
		lastConnectedUserName: 'renee',
		'domain':'mendelson.local',
		'computerOu':'Computers/Alexandrovitz/All Companies',
		'addInfo':'{"Service_Status":"Running","Service_Display_Name":"Message Queuing","Service_Name":"MSMQ","Service_Startup_Type":"Automatic","Service_Name2":"MSMQ","Service_Dependencies":"Has dependecies: 1  ----------  Service: NetMsmqActivator, Status: Running ### ","occurrences":1}',
		'os':'Win 10 Pro',
		'clientVer':'2.32.1.0',
		'ip':'10.180.0.17',
		'mac':null,
		'hwInfo':{'HW_CPU':'4 x Intel(R) Core(TM) i5-4670S CPU @ 3.10GHz', 'HW_Model':'LENOVO 10A8S1MS00', 'HW_RAM':'7.89'},
		'scanTime':'2024-06-19T07:43:04.392389Z'
},
{
'updatedAt': '2026-02-11T09:14:07Z',
		'param':'MSMQ Service is Running and listening on port 1801; Has dependecies',
		flags: ['alertsNew'],
		'paramExtra':null,
		'device':'BAKARA-PC',
		'deviceId': 9102,
		installPath: 'C:\\Windows\\System32\\mqsvc.exe',
		installDate: '2023-06-01T10:15:00Z',
		'severity':'Medium',
		lastConnectedUserName: 'renee',
		'domain':'ovrs.co.il',
		'computerOu':'CN=Computers',
		'addInfo':'{"Service_Status":"Running","Service_Display_Name":"Message Queuing","Service_Name":"MSMQ","Service_Startup_Type":"Automatic","Service_Name2":"MSMQ","Service_Dependencies":"Has dependecies: 1  ----------  Service: NetMsmqActivator, Status: Running ### ","occurrences":1}',
		'os':'Win 10 Pro',
		'clientVer':'2.32.1.0',
		'ip':'172.20.24.130',
		'mac':null,
		'hwInfo':{'HW_CPU':'4 x Intel(R) Core(TM) i3-4130 CPU @ 3.40GHz', 'HW_Model':'LENOVO 10DS0027IV', 'HW_RAM':'3.91'},
		'scanTime':'2024-06-19T11:47:01.62951Z'
},
{
'updatedAt': '2026-03-12T09:14:07Z',
		'param':'MSMQ Service is Running and listening on port 1801; Has dependecies',
		flags: [],
		'paramExtra':null,
		'device':'EXCHSRV2',
		'deviceId': 9103,
		installPath: 'C:\\Windows\\System32\\mqsvc.exe',
		installDate: '2022-11-23T14:40:00Z',
		'severity':'High',
		lastConnectedUserName: 'renee',
		'domain':'ovrs.co.il',
		'computerOu':'Servers',
		'addInfo':'{"Service_Status":"Running","Service_Display_Name":"Message Queuing","Service_Name":"MSMQ","Service_Startup_Type":"Automatic","Service_Name2":"MSMQ","Service_Dependencies":"Has dependecies: 1  ----------  Service: NetMsmqActivator, Status: Running ### ","occurrences":1}',
		'os':'Win Server 2012 R2 Standard',
		'clientVer':'2.32.1.0',
		'ip':'141.226.2.113',
		'mac':null,
		'hwInfo':{'HW_CPU':'4 x Intel(R) Xeon(R) Gold 6342 CPU @ 2.80GHz', 'HW_Model':'VMware, Inc. VMware Virtual Platform', 'HW_RAM':'16'},
		'scanTime':'2024-06-18T22:59:37.993846Z'
},
{
'updatedAt': '2026-04-13T09:14:07Z',
		'param':'MSMQ Service is Running and listening on port 1801; Has dependecies',
		flags: [],
		'paramExtra':null,
		'device':'GEULAB',
		'deviceId': 9104,
		installPath: 'C:\\Windows\\System32\\mqsvc.exe',
		installDate: '2024-01-08T09:05:00Z',
		'severity':'High',
		lastConnectedUserName: 'renee',
		'domain':'ovrs.co.il',
		'computerOu':'Desktops',
		'addInfo':'{"Service_Status":"Running","Service_Display_Name":"Message Queuing","Service_Name":"MSMQ","Service_Startup_Type":"Automatic","Service_Name2":"MSMQ","Service_Dependencies":"Has dependecies: 4  ----------  Service: Maestro, Status: Running ### Service: BarTender Print Scheduler, Status: Running ### Service: BarTender Integration Service, Status: Running ### Service: BarTender System Service, Status: Running ### ","occurrences":1}',
		'os':'Win 11 Pro',
		'clientVer':'2.32.1.0',
		'ip':'141.226.18.59',
		'mac':null,
		'hwInfo':{'HW_CPU':'16 x Intel(R) Core(TM) i7-10700T CPU @ 2.00GHz', 'HW_Model':'LENOVO 11DUSBFD00', 'HW_RAM':'15.74'},
		'scanTime':'2024-06-19T14:57:39.692459Z'
},
{
'updatedAt': '2026-05-14T09:14:07Z',
		'param':'MSMQ Service is Running and listening on port 1801; Has dependecies',
		flags: [],
		'paramExtra':null,
		'device':'ITSRV',
		'deviceId': 9105,
		installPath: 'C:\\Windows\\System32\\mqsvc.exe',
		installDate: '2022-09-17T16:20:00Z',
		'severity':'High',
		lastConnectedUserName: 'renee',
		'domain':'chemovil.co.il',
		'computerOu':'Servers',
		'addInfo':'{"Service_Status":"Running","Service_Display_Name":"Message Queuing","Service_Name":"MSMQ","Service_Startup_Type":"Automatic","Service_Name2":"MSMQ","Service_Dependencies":"Has dependecies: 14  ----------  Service: TpWebHooks, Status: Stopped ### Service: TpTfsIntegrationPlugin, Status: Stopped ### Service: TpTestRunImportIntegrationPlugin, Status: Stopped ### Service: TPTaskCreator, Status: Stopped ### Service: TpSubversionIntegrationPlugin, Status: Stopped ### Service: TpSearchPlugin, Status: Stopped ### Service: TPPushNotifications, Status: Stopped ### Service: TPPopEmailIntegration, Status: Stopped ### Service: TpMercurialIntegrationPlugin, Status: Stopped ### Service: TPMashupManagerPlugin, Status: Stopped ### Service: TpGitIntegrationPlugin, Status: Stopped ### Service: TPFollowing, Status: Stopped ### Service: TPBugzillaIntegrationPlugin, Status: Stopped ### Service: NetMsmqActivator, Status: Running ### ","occurrences":1}',
		'os':'Win Server 2012 R2 Standard',
		'clientVer':'2.33.5.0',
		'ip':'200.1.1.21',
		'mac':null,
		'hwInfo':{'HW_CPU':'2 x Intel(R) Xeon(R) Gold 5318Y CPU @ 2.10GHz', 'HW_Model':'VMware, Inc. VMware Virtual Platform', 'HW_RAM':'4'},
		'scanTime':'2024-06-18T23:07:44.189805Z'
},
{
'updatedAt': '2026-06-15T09:14:07Z',
		'param':'MSMQ Service is Running and listening on port 1801; Has dependecies',
		flags: [],
		'paramExtra':null,
		'device':'LAVI',
		'deviceId': 9106,
		installPath: 'C:\\Windows\\System32\\mqsvc.exe',
		installDate: '2023-03-29T11:50:00Z',
		'severity':'High',
		lastConnectedUserName: 'renee',
		'domain':'ovrs.co.il',
		'computerOu':'Servers',
		'addInfo':'{"Service_Status":"Running","Service_Display_Name":"Message Queuing","Service_Name":"MSMQ","Service_Startup_Type":"Automatic","Service_Name2":"MSMQ","Service_Dependencies":"Has dependecies: 6  ----------  Service: Synerion_Lighthouse_SchedulingService_0, Status: Running ### Service: Synerion_Lighthouse_BackendService_0, Status: Running ### Service: Synerion_Lighthouse_AttendanceService_0, Status: Running ### Service: Synerion.Scheduler, Status: Running ### Service: NetMsmqActivator, Status: Running ### Service: MSMQTriggers, Status: Running ### ","occurrences":1}',
		'os':'Win Server 2019 Datacenter',
		'clientVer':'2.32.1.0',
		'ip':'141.226.2.208',
		'mac':null,
		'hwInfo':{'HW_CPU':'4 x Intel(R) Xeon(R) Gold 6248R CPU @ 3.00GHz', 'HW_Model':'VMware, Inc. VMware Virtual Platform', 'HW_RAM':'10'},
		'scanTime':'2024-06-19T00:30:03.511906Z'
},
{
'updatedAt': '2026-01-16T09:14:07Z',
		'param':'MSMQ Service is Running and listening on port 1801; Has dependecies',
		flags: [],
		'paramExtra':null,
		'device':'MAHSAN2',
		'deviceId': 9107,
		installPath: 'C:\\Windows\\System32\\mqsvc.exe',
		installDate: '2023-07-14T13:35:00Z',
		'severity':'High',
		lastConnectedUserName: 'renee',
		'domain':'ovrs.co.il',
		'computerOu':'Desktops',
		'addInfo':'{"Service_Status":"Running","Service_Display_Name":"Message Queuing","Service_Name":"MSMQ","Service_Startup_Type":"Automatic","Service_Name2":"MSMQ","Service_Dependencies":"Has dependecies: 1  ----------  Service: NetMsmqActivator, Status: Running ### ","occurrences":1}',
		'os':'Win 10 Pro',
		'clientVer':'2.32.1.0',
		'ip':'172.20.24.41',
		'mac':null,
		'hwInfo':{'HW_CPU':'4 x Intel(R) Core(TM) i3-4130 CPU @ 3.40GHz', 'HW_Model':'LENOVO 10AGS0GG00', 'HW_RAM':'7.8'},
		'scanTime':'2024-06-19T19:14:12.643257Z'
},
{
'updatedAt': '2026-02-17T09:14:07Z',
		'param':'MSMQ Service is Running and listening on port 1801; Has dependecies',
		flags: [],
		'paramExtra':null,
		'device':'OMS-APP',
		'deviceId': 9108,
		installPath: 'C:\\Windows\\System32\\mqsvc.exe',
		installDate: '2022-12-02T07:45:00Z',
		'severity':'High',
		'domain':'ovrs.co.il',
		'computerOu':'Servers',
		'addInfo':'{"Service_Status":"Running","Service_Display_Name":"Message Queuing","Service_Name":"MSMQ","Service_Startup_Type":"Automatic","Service_Name2":"MSMQ","Service_Dependencies":"Has dependecies: 1  ----------  Service: NetMsmqActivator, Status: Running ### ","occurrences":1}',
		'os':'Win Server 2019 Datacenter',
		'clientVer':'2.33.3.0',
		'ip':'141.226.2.192',
		'mac':null,
		'hwInfo':{'HW_CPU':'8 x Intel(R) Xeon(R) Gold 6248R CPU @ 3.00GHz', 'HW_Model':'VMware, Inc. VMware Virtual Platform', 'HW_RAM':'16'},
		'scanTime':'2024-06-19T00:24:01.19261Z'
},
{
'updatedAt': '2026-03-18T09:14:07Z',
		'param':'MSMQ Service is Running and listening on port 1801; Has dependecies',
		flags: [],
		'paramExtra':null,
		'device':'OVR-A0042',
		'deviceId': 9109,
		installPath: 'C:\\Windows\\System32\\mqsvc.exe',
		installDate: '2023-09-21T15:10:00Z',
		'severity':'High',
		'domain':'ovrs.co.il',
		'computerOu':'Desktops',
		'addInfo':'{"Service_Status":"Running","Service_Display_Name":"Message Queuing","Service_Name":"MSMQ","Service_Startup_Type":"Automatic","Service_Name2":"MSMQ","Service_Dependencies":"Has dependecies: 1  ----------  Service: NetMsmqActivator, Status: Running ### ","occurrences":1}',
		'os':'Win 10 Pro',
		'clientVer':'2.32.1.0',
		'ip':'172.20.24.106',
		'mac':null,
		'hwInfo':{'HW_CPU':'4 x Intel(R) Core(TM) i3-6100 CPU @ 3.70GHz', 'HW_Model':'LENOVO 10GQS1HE00', 'HW_RAM':'7.91'},
		'scanTime':'2024-06-19T10:55:14.173855Z'
},
{
'updatedAt': '2026-04-19T09:14:07Z',
		'param':'MSMQ Service is Running and listening on port 1801; Has dependecies',
		flags: [],
		'paramExtra':null,
		'device':'OVR-A0043',
		'deviceId': 9110,
		installPath: 'C:\\Windows\\System32\\mqsvc.exe',
		installDate: '2024-02-18T12:25:00Z',
		'severity':'High',
		'domain':'ovrs.co.il',
		'computerOu':'Desktops',
		'addInfo':'{"Service_Status":"Running","Service_Display_Name":"Message Queuing","Service_Name":"MSMQ","Service_Startup_Type":"Automatic","Service_Name2":"MSMQ","Service_Dependencies":"Has dependecies: 4  ----------  Service: Maestro, Status: Running ### Service: BarTender Print Scheduler, Status: Running ### Service: BarTender Integration Service, Status: Running ### Service: BarTender System Service, Status: Running ### ","occurrences":1}',
		'os':'Win 11 Pro',
		'clientVer':'2.32.1.0',
		'ip':'172.20.24.60',
		'mac':null,
		'hwInfo':{'HW_CPU':'6 x Intel(R) Core(TM) i5-8500 CPU @ 3.00GHz', 'HW_Model':'Dell Inc. OptiPlex 7060', 'HW_RAM':'7.8'},
		'scanTime':'2024-06-17T09:49:57.418031Z'
},
{
'updatedAt': '2026-05-20T09:14:07Z',
		'param':'MSMQ Service is Running and listening on port 1801; Has dependecies',
		flags: [],
		'paramExtra':null,
		'device':'OVR-HA0029',
		'deviceId': 9111,
		installPath: 'C:\\Windows\\System32\\mqsvc.exe',
		installDate: '2023-04-06T09:55:00Z',
		'severity':'High',
		'domain':'ovrs.co.il',
		'computerOu':'Desktops',
		'addInfo':'{"Service_Status":"Running","Service_Display_Name":"Message Queuing","Service_Name":"MSMQ","Service_Startup_Type":"Automatic","Service_Name2":"MSMQ","Service_Dependencies":"Has dependecies: 1  ----------  Service: NetMsmqActivator, Status: Running ### ","occurrences":1}',
		'os':'Win 10 Pro Education',
		'clientVer':'2.32.1.0',
		'ip':'141.226.18.32',
		'mac':null,
		'hwInfo':{'HW_CPU':'4 x Intel(R) Core(TM) i3-4130 CPU @ 3.40GHz', 'HW_Model':'LENOVO 10AGS0GG00', 'HW_RAM':'9.8'},
		'scanTime':'2024-06-18T04:21:52.708512Z'
},
{
'updatedAt': '2026-06-21T09:14:07Z',
		'param':'MSMQ Service is Running and listening on port 1801; Has dependecies',
		flags: [],
		'paramExtra':null,
		'device':'OVR-HA0046',
		'deviceId': 9112,
		installPath: 'C:\\Windows\\System32\\mqsvc.exe',
		installDate: '2022-10-30T14:05:00Z',
		'severity':'High',
		'domain':'ovrs.co.il',
		'computerOu':'Desktops',
		'addInfo':'{"Service_Status":"Running","Service_Display_Name":"Message Queuing","Service_Name":"MSMQ","Service_Startup_Type":"Automatic","Service_Name2":"MSMQ","Service_Dependencies":"Has dependecies: 4  ----------  Service: Maestro, Status: Running ### Service: BarTender Print Scheduler, Status: Running ### Service: BarTender Integration Service, Status: Running ### Service: BarTender System Service, Status: Running ### ","occurrences":1}',
		'os':'Win 11 Pro',
		'clientVer':'2.32.1.0',
		'ip':'141.226.18.9',
		'mac':null,
		'hwInfo':{'HW_CPU':'12 x 12th Gen Intel(R) Core(TM) i5-12500T', 'HW_Model':'LENOVO 11X2S03F00', 'HW_RAM':'15.69'},
		'scanTime':'2024-06-10T09:50:05.358201Z'
},
{
'updatedAt': '2026-01-22T09:14:07Z',
		'param':'MSMQ Service is Running and listening on port 1801; Has dependecies',
		flags: [],
		'paramExtra':null,
		'device':'PRINTERS',
		'deviceId': 9113,
		installPath: 'C:\\Windows\\System32\\mqsvc.exe',
		installDate: '2023-08-11T10:40:00Z',
		'severity':'High',
		'domain':'chemovil.co.il',
		'computerOu':'Printers/Servers',
		'addInfo':'{"Service_Status":"Running","Service_Display_Name":"Message Queuing","Service_Name":"MSMQ","Service_Startup_Type":"Automatic","Service_Name2":"MSMQ","Service_Dependencies":"Has dependecies: 1  ----------  Service: NetMsmqActivator, Status: Running ### ","occurrences":1}',
		'os':'Win Server 2016 Standard',
		'clientVer':'2.33.5.0',
		'ip':'200.1.1.61',
		'mac':null,
		'hwInfo':{'HW_CPU':'4 x Intel(R) Xeon(R) Gold 5318Y CPU @ 2.10GHz', 'HW_Model':'VMware, Inc. VMware Virtual Platform', 'HW_RAM':'12'},
		'scanTime':'2024-06-19T00:00:43.222141Z'
},
{
'updatedAt': '2026-02-23T09:14:07Z',
		'param':'MSMQ Service is Running and listening on port 1801; Has dependecies',
		flags: [],
		'paramExtra':null,
		'device':'TRMSRV19',
		'deviceId': 9114,
		installPath: 'C:\\Windows\\System32\\mqsvc.exe',
		installDate: '2024-03-25T08:15:00Z',
		'severity':'High',
		'domain':'ovrs.co.il',
		'computerOu':'Servers',
		'addInfo':'{"Service_Status":"Running","Service_Display_Name":"Message Queuing","Service_Name":"MSMQ","Service_Startup_Type":"Automatic","Service_Name2":"MSMQ","Service_Dependencies":"Has dependecies: 4  ----------  Service: Maestro, Status: Running ### Service: BarTender Print Scheduler, Status: Running ### Service: BarTender Integration Service, Status: Running ### Service: BarTender System Service, Status: Running ### ","occurrences":1}',
		'os':'Win Server 2019 Datacenter',
		'clientVer':'2.33.3.0',
		'ip':'141.226.2.200',
		'mac':null,
		'hwInfo':{'HW_CPU':'8 x Intel(R) Xeon(R) Gold 6248R CPU @ 3.00GHz', 'HW_Model':'VMware, Inc. VMware Virtual Platform', 'HW_RAM':'24'},
		'scanTime':'2024-06-17T20:55:43.671398Z'
}
],
	rowCount: 14
});

	mockData.altFTE = () => ({FTE: 120000, currency: 'GBP'});

	mockData.misconCombiAlerts = req => req.topicCode !== 'gytSMBv1'?
		{data: makeArr(req.len ?? PAGE_LEN).map(i => ({'param':`param-${(req.from ?? 0) + i}`, 'paramExtra':`paramEx-${(req.from ?? 0) + i}`, 'devices':Math.random()*200 |0, 'alertsBad':+(Math.random()>0.5) * Math.random()*20000 |0, 'alertsNew':+(Math.random()>0.5) * Math.random()*20000 |0, 'alertsOk':Math.random()*20000 |0, badDevices: +(Math.random()>0.5) * Math.random()*20000 |0, mutedAlerts: +(Math.random()>0.5) * Math.random()*20000 |0, mutedDevices: +(Math.random()>0.5) * Math.random()*20000 |0, okDevices: +(Math.random()>0.5) * Math.random()*20000 |0, pending: +(Math.random()>0.5) * Math.random()*20000 |0, 'repeated': +(Math.random()>0.5) * Math.random()*20000 |0, remediable: +(Math.random()>0.5) * Math.random()*20000 |0, remediatedAlerts: +(Math.random()>0.5) * Math.random()*20000 |0, remediatedDevices: +(Math.random()>0.5) * Math.random()*20000 |0, hasReversible: true, 'lastScan': Date.now() - (Math.random()*1000000 |0)})), rowCount: 320} :
		{
'data':[
{'param':'SMBv1 - was NOT used in last 90 days', 'paramExtra':null, 'devices':5004, 'alertsBad':5004, 'badDevices':5004, 'alertsOk':0, 'okDevices':0, 'repeated':0, 'pending':5004, 'remediable':5004, 'remediatedAlerts':0, 'remediatedDevices':0, 'mutedAlerts':0, 'mutedDevices':0, 'alertsNew':0},
{'param':'SMBv1', 'paramExtra':null, 'devices':1995, 'alertsBad':1995, 'badDevices':1995, 'alertsOk':0, 'okDevices':0, 'repeated':0, 'pending':1995, 'remediable':1995, 'remediatedAlerts':0, 'remediatedDevices':0, 'mutedAlerts':0, 'mutedDevices':0, 'alertsNew':0},
{'param':'SMBv1 - was used in last 90 days', 'paramExtra':null, 'devices':1469, 'alertsBad':1469, 'badDevices':1469, 'alertsOk':0, 'okDevices':0, 'repeated':0, 'pending':1469, 'remediable':1469, 'remediatedAlerts':0, 'remediatedDevices':0, 'mutedAlerts':0, 'mutedDevices':0, 'alertsNew':0},
{'param':'SMBv1 Enabled', 'paramExtra':null, 'devices':554, 'alertsBad':554, 'badDevices':554, 'alertsOk':0, 'okDevices':0, 'repeated':0, 'pending':554, 'remediable':554, 'remediatedAlerts':0, 'remediatedDevices':0, 'mutedAlerts':0, 'mutedDevices':0, 'alertsNew':0},
{'param':'SMBv1 Audit is missing and the device does NOT USE SMBv1', 'paramExtra':null, 'devices':488, 'alertsBad':488, 'badDevices':488, 'alertsOk':0, 'okDevices':0, 'repeated':0, 'pending':488, 'remediable':488, 'remediatedAlerts':0, 'remediatedDevices':0, 'mutedAlerts':0, 'mutedDevices':0, 'alertsNew':0},
{'param':'Enabled', 'paramExtra':null, 'devices':185, 'alertsBad':185, 'badDevices':185, 'alertsOk':0, 'okDevices':0, 'repeated':0, 'pending':185, 'remediable':185, 'remediatedAlerts':0, 'remediatedDevices':0, 'mutedAlerts':0, 'mutedDevices':0, 'alertsNew':0},
{'param':'Disabled', 'paramExtra':null, 'devices':261, 'alertsBad':0, 'badDevices':0, 'alertsOk':261, 'okDevices':261, 'repeated':0, 'pending':0, 'remediable':0, 'remediatedAlerts':0, 'remediatedDevices':0, 'mutedAlerts':0, 'mutedDevices':0, 'alertsNew':0},
{'param':null, 'paramExtra':null, 'devices':2539, 'alertsBad':0, 'badDevices':0, 'alertsOk':2539, 'okDevices':2539, 'repeated':0, 'pending':0, 'remediable':0, 'remediatedAlerts':0, 'remediatedDevices':0, 'mutedAlerts':0, 'mutedDevices':0, 'alertsNew':0}
].map(p => ({hasReversible: true, ...p})),
'rowCount':8
};

	mockData.misconCombiDevices = req => ({
		data: makeArr(req.len ?? PAGE_LEN).map(i => {
			const mutedAlerts = 0;
			const remediatedAlerts = +(Math.random()>0.5) * Math.random()*20000 |0;
			const alertsBad = Math.random()*200 |0;
			const alertsOk = Math.random()*200 |0;
			return {
				lastConnectedUserName: 'renee',
				device: `Device_management_main_building_cloud_circle_asceptional-${(req.from ?? 0) + i}`,
				deviceId: (req.from ?? 0) + i + 1,
				lastScan: new Date(Date.now() - Math.random()*MS_DAY).toISOString(),
				pending: 0,
				mutedAlerts,
				alertsNew: 0,
				repeated: +(Math.random()>0.5) * Math.random()*20000 |0,
				remediable: +(Math.random()>0.5) * Math.random()*20000 |0,
				remediatedAlerts,
				alertsBad,
				alertsOk,
				alertsTotal: alertsBad + alertsOk + mutedAlerts + remediatedAlerts,
				hasReversible: true,
				...(req.benchmarkOrg === 'CIS' && {benchmarkName: 'CIS_Ubuntu_Linux_22.04_LTS_Benchmark_v2.0.0-xccdf.xml'})
			};
		}),
		rowCount: 1000
	});

	mockData.misconAlertTotals = _v => ({'alertsRemediated': 23658, 'alertsRemediable': 7400, 'FTE': 110000, 'graph': makeArr(100).map(i => ({date: new Date(Date.now() - (100-i) * MS_DAY).toISOString(), 'devicesTotal': (i < 50? i : 50) * 1000, 'devicesBad': (i < 50? i : (100-i)) * 900, 'alertsBad': (i < 50? i : (100-i)) * 2000, 'remediatedAlerts': (i < 50? i : (100+i)) * 2000}))});
	mockData.misconCombiTotals = () => ({totalAlerts: Math.random()*200 |0, totalDevices: Math.random()*200 |0});

	mockData.misconGroupTotals = () => ({devices: 23423, devicesBad: 7684, alertsNew: 657});

	mockData.misconTasksByTopicOverview = req => ({data: (req.topics ?? []).map(topicCode => ({topicCode, remediable: Math.random()*10000|0, remediated: Math.random()*100|0, pending: Math.random()>0.7 ? Math.random()*100|0 : 0, repeated: Math.random()>0.7 ? Math.random()*5|0 : 0, failed: Math.random()>0.6 ? Math.random()*3|0 : 0}))});
	mockData.misconTasksByTopic = req => ({data: (req.topics ?? []).filter(_x => Math.random() > 0.5).map(topicCode => ({topicCode, remediable: Math.random()*10000|0, pending: Math.random()>0.7 ? Math.random()*100|0 : 0}))});
	mockData.misconTasksByAlert = (req: {params: {param: string, paramExtra: string}[]}) => ({data: req.params.map(({param, paramExtra}) => ({param, paramExtra, remediable: Math.random()*10000|0, remediated: Math.random()*100|0, pending: Math.random()>0.7 ? Math.random()*100|0 : 0, repeated: Math.random()>0.7 ? Math.random()*5|0 : 0, failed: Math.random()>0.6 ? Math.random()*3|0 : 0}))});
	mockData.misconTasksByDevice = (req: {devices: {device: string, deviceId: number}[]}) => ({data: req.devices.map(({device, deviceId}) => ({device, deviceId, remediable: Math.random()*10000|0, remediated: Math.random()*100|0, pending: Math.random()>0.7 ? Math.random()*100|0 : 0, repeated: Math.random()>0.7 ? Math.random()*5|0 : 0, failed: Math.random()>0.6 ? Math.random()*3|0 : 0}))});

	mockData.licenseCoverageGraph = () => ({
'data': [
{'date': '2024-10-24T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2024-10-25T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2024-10-26T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2024-10-27T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2024-10-28T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2024-10-29T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2024-10-30T00:00:00Z', 'registeredDevices': 20, 'licensedDevices': 2000, 'devicesCritical': 20, 'unsupportedCIS': 0},
{'date': '2024-10-31T00:00:00Z', 'registeredDevices': 18, 'licensedDevices': 2000, 'devicesCritical': 18, 'unsupportedCIS': 0},
{'date': '2024-11-01T00:00:00Z', 'registeredDevices': 20, 'licensedDevices': 2000, 'devicesCritical': 20, 'unsupportedCIS': 0},
{'date': '2024-11-02T00:00:00Z', 'registeredDevices': 20, 'licensedDevices': 2000, 'devicesCritical': 20, 'unsupportedCIS': 0},
{'date': '2024-11-03T00:00:00Z', 'registeredDevices': 20, 'licensedDevices': 2000, 'devicesCritical': 20, 'unsupportedCIS': 0},
{'date': '2024-11-04T00:00:00Z', 'registeredDevices': 20, 'licensedDevices': 2000, 'devicesCritical': 20, 'unsupportedCIS': 0},
{'date': '2024-11-05T00:00:00Z', 'registeredDevices': 26, 'licensedDevices': 2000, 'devicesCritical': 26, 'unsupportedCIS': 0},
{'date': '2024-11-06T00:00:00Z', 'registeredDevices': 26, 'licensedDevices': 2000, 'devicesCritical': 26, 'unsupportedCIS': 0},
{'date': '2024-11-07T00:00:00Z', 'registeredDevices': 26, 'licensedDevices': 2000, 'devicesCritical': 26, 'unsupportedCIS': 0},
{'date': '2024-11-08T00:00:00Z', 'registeredDevices': 26, 'licensedDevices': 2000, 'devicesCritical': 26, 'unsupportedCIS': 0},
{'date': '2024-11-09T00:00:00Z', 'registeredDevices': 26, 'licensedDevices': 2000, 'devicesCritical': 26, 'unsupportedCIS': 0},
{'date': '2024-11-10T00:00:00Z', 'registeredDevices': 26, 'licensedDevices': 2000, 'devicesCritical': 26, 'unsupportedCIS': 0},
{'date': '2024-11-11T00:00:00Z', 'registeredDevices': 25, 'licensedDevices': 2000, 'devicesCritical': 25, 'unsupportedCIS': 0},
{'date': '2024-11-12T00:00:00Z', 'registeredDevices': 25, 'licensedDevices': 2000, 'devicesCritical': 25, 'unsupportedCIS': 0},
{'date': '2024-11-13T00:00:00Z', 'registeredDevices': 26, 'licensedDevices': 2000, 'devicesCritical': 26, 'unsupportedCIS': 0},
{'date': '2024-11-14T00:00:00Z', 'registeredDevices': 26, 'licensedDevices': 2000, 'devicesCritical': 26, 'unsupportedCIS': 0},
{'date': '2024-11-15T00:00:00Z', 'registeredDevices': 26, 'licensedDevices': 2000, 'devicesCritical': 26, 'unsupportedCIS': 0},
{'date': '2024-11-16T00:00:00Z', 'registeredDevices': 26, 'licensedDevices': 2000, 'devicesCritical': 26, 'unsupportedCIS': 0},
{'date': '2024-11-17T00:00:00Z', 'registeredDevices': 26, 'licensedDevices': 2000, 'devicesCritical': 26, 'unsupportedCIS': 0},
{'date': '2024-11-18T00:00:00Z', 'registeredDevices': 25, 'licensedDevices': 2000, 'devicesCritical': 25, 'unsupportedCIS': 0},
{'date': '2024-11-19T00:00:00Z', 'registeredDevices': 19, 'licensedDevices': 2000, 'devicesCritical': 19, 'unsupportedCIS': 0},
{'date': '2024-11-20T00:00:00Z', 'registeredDevices': 19, 'licensedDevices': 2000, 'devicesCritical': 19, 'unsupportedCIS': 0},
{'date': '2024-11-21T00:00:00Z', 'registeredDevices': 19, 'licensedDevices': 2000, 'devicesCritical': 19, 'unsupportedCIS': 0},
{'date': '2024-11-22T00:00:00Z', 'registeredDevices': 20, 'licensedDevices': 2000, 'devicesCritical': 20, 'unsupportedCIS': 0},
{'date': '2024-11-23T00:00:00Z', 'registeredDevices': 20, 'licensedDevices': 2000, 'devicesCritical': 20, 'unsupportedCIS': 0},
{'date': '2024-11-24T00:00:00Z', 'registeredDevices': 20, 'licensedDevices': 2000, 'devicesCritical': 20, 'unsupportedCIS': 0},
{'date': '2024-11-25T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2024-11-26T00:00:00Z', 'registeredDevices': 22, 'licensedDevices': 2000, 'devicesCritical': 22, 'unsupportedCIS': 0},
{'date': '2024-11-27T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2024-11-28T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2024-11-29T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2024-11-30T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2024-12-01T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2024-12-02T00:00:00Z', 'registeredDevices': 23, 'licensedDevices': 2000, 'devicesCritical': 23, 'unsupportedCIS': 1},
{'date': '2024-12-03T00:00:00Z', 'registeredDevices': 23, 'licensedDevices': 2000, 'devicesCritical': 23, 'unsupportedCIS': 1},
{'date': '2024-12-04T00:00:00Z', 'registeredDevices': 23, 'licensedDevices': 2000, 'devicesCritical': 23, 'unsupportedCIS': 1},
{'date': '2024-12-05T00:00:00Z', 'registeredDevices': 23, 'licensedDevices': 2000, 'devicesCritical': 23, 'unsupportedCIS': 1},
{'date': '2024-12-06T00:00:00Z', 'registeredDevices': 22, 'licensedDevices': 2000, 'devicesCritical': 22, 'unsupportedCIS': 0},
{'date': '2024-12-07T00:00:00Z', 'registeredDevices': 22, 'licensedDevices': 2000, 'devicesCritical': 22, 'unsupportedCIS': 0},
{'date': '2024-12-08T00:00:00Z', 'registeredDevices': 22, 'licensedDevices': 2000, 'devicesCritical': 22, 'unsupportedCIS': 0},
{'date': '2024-12-09T00:00:00Z', 'registeredDevices': 23, 'licensedDevices': 2000, 'devicesCritical': 23, 'unsupportedCIS': 0},
{'date': '2024-12-10T00:00:00Z', 'registeredDevices': 23, 'licensedDevices': 2000, 'devicesCritical': 23, 'unsupportedCIS': 0},
{'date': '2024-12-11T00:00:00Z', 'registeredDevices': 23, 'licensedDevices': 2000, 'devicesCritical': 23, 'unsupportedCIS': 0},
{'date': '2024-12-12T00:00:00Z', 'registeredDevices': 24, 'licensedDevices': 2000, 'devicesCritical': 24, 'unsupportedCIS': 0},
{'date': '2024-12-13T00:00:00Z', 'registeredDevices': 25, 'licensedDevices': 2000, 'devicesCritical': 25, 'unsupportedCIS': 0},
{'date': '2024-12-14T00:00:00Z', 'registeredDevices': 25, 'licensedDevices': 2000, 'devicesCritical': 25, 'unsupportedCIS': 0},
{'date': '2024-12-15T00:00:00Z', 'registeredDevices': 25, 'licensedDevices': 2000, 'devicesCritical': 25, 'unsupportedCIS': 0},
{'date': '2024-12-16T00:00:00Z', 'registeredDevices': 24, 'licensedDevices': 2000, 'devicesCritical': 24, 'unsupportedCIS': 0},
{'date': '2024-12-17T00:00:00Z', 'registeredDevices': 23, 'licensedDevices': 2000, 'devicesCritical': 23, 'unsupportedCIS': 0},
{'date': '2024-12-18T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2024-12-19T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2024-12-20T00:00:00Z', 'registeredDevices': 22, 'licensedDevices': 2000, 'devicesCritical': 22, 'unsupportedCIS': 0},
{'date': '2024-12-21T00:00:00Z', 'registeredDevices': 22, 'licensedDevices': 2000, 'devicesCritical': 22, 'unsupportedCIS': 0},
{'date': '2024-12-22T00:00:00Z', 'registeredDevices': 22, 'licensedDevices': 2000, 'devicesCritical': 22, 'unsupportedCIS': 0},
{'date': '2024-12-23T00:00:00Z', 'registeredDevices': 22, 'licensedDevices': 2000, 'devicesCritical': 22, 'unsupportedCIS': 0},
{'date': '2024-12-24T00:00:00Z', 'registeredDevices': 19, 'licensedDevices': 2000, 'devicesCritical': 19, 'unsupportedCIS': 0},
{'date': '2024-12-25T00:00:00Z', 'registeredDevices': 19, 'licensedDevices': 2000, 'devicesCritical': 19, 'unsupportedCIS': 0},
{'date': '2024-12-26T00:00:00Z', 'registeredDevices': 19, 'licensedDevices': 2000, 'devicesCritical': 19, 'unsupportedCIS': 0},
{'date': '2024-12-27T00:00:00Z', 'registeredDevices': 20, 'licensedDevices': 2000, 'devicesCritical': 20, 'unsupportedCIS': 0},
{'date': '2024-12-28T00:00:00Z', 'registeredDevices': 20, 'licensedDevices': 2000, 'devicesCritical': 20, 'unsupportedCIS': 0},
{'date': '2024-12-29T00:00:00Z', 'registeredDevices': 20, 'licensedDevices': 2000, 'devicesCritical': 20, 'unsupportedCIS': 0},
{'date': '2024-12-30T00:00:00Z', 'registeredDevices': 20, 'licensedDevices': 2000, 'devicesCritical': 20, 'unsupportedCIS': 0},
{'date': '2024-12-31T00:00:00Z', 'registeredDevices': 20, 'licensedDevices': 2000, 'devicesCritical': 20, 'unsupportedCIS': 0},
{'date': '2025-01-01T00:00:00Z', 'registeredDevices': 19, 'licensedDevices': 2000, 'devicesCritical': 19, 'unsupportedCIS': 0},
{'date': '2025-01-02T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2025-01-03T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2025-01-04T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2025-01-05T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2025-01-06T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2025-01-07T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2025-01-08T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2025-01-09T00:00:00Z', 'registeredDevices': 20, 'licensedDevices': 2000, 'devicesCritical': 20, 'unsupportedCIS': 0},
{'date': '2025-01-10T00:00:00Z', 'registeredDevices': 19, 'licensedDevices': 2000, 'devicesCritical': 19, 'unsupportedCIS': 0},
{'date': '2025-01-11T00:00:00Z', 'registeredDevices': 19, 'licensedDevices': 2000, 'devicesCritical': 19, 'unsupportedCIS': 0},
{'date': '2025-01-12T00:00:00Z', 'registeredDevices': 19, 'licensedDevices': 2000, 'devicesCritical': 19, 'unsupportedCIS': 0},
{'date': '2025-01-13T00:00:00Z', 'registeredDevices': 19, 'licensedDevices': 2000, 'devicesCritical': 19, 'unsupportedCIS': 0},
{'date': '2025-01-14T00:00:00Z', 'registeredDevices': 19, 'licensedDevices': 2000, 'devicesCritical': 19, 'unsupportedCIS': 0},
{'date': '2025-01-15T00:00:00Z', 'registeredDevices': 19, 'licensedDevices': 2000, 'devicesCritical': 19, 'unsupportedCIS': 0},
{'date': '2025-01-16T00:00:00Z', 'registeredDevices': 20, 'licensedDevices': 2000, 'devicesCritical': 20, 'unsupportedCIS': 0},
{'date': '2025-01-17T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2025-01-18T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2025-01-19T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2025-01-20T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2025-01-21T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2025-01-22T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2025-01-23T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2025-01-24T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2025-01-25T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2025-01-26T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2025-01-27T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2025-01-28T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 0},
{'date': '2025-01-29T00:00:00Z', 'registeredDevices': 20, 'licensedDevices': 2000, 'devicesCritical': 20, 'unsupportedCIS': 0},
{'date': '2025-01-30T00:00:00Z', 'registeredDevices': 22, 'licensedDevices': 2000, 'devicesCritical': 22, 'unsupportedCIS': 0},
{'date': '2025-01-31T00:00:00Z', 'registeredDevices': 22, 'licensedDevices': 2000, 'devicesCritical': 22, 'unsupportedCIS': 0},
{'date': '2025-02-01T00:00:00Z', 'registeredDevices': 22, 'licensedDevices': 2000, 'devicesCritical': 22, 'unsupportedCIS': 0},
{'date': '2025-02-02T00:00:00Z', 'registeredDevices': 22, 'licensedDevices': 2000, 'devicesCritical': 22, 'unsupportedCIS': 8},
{'date': '2025-02-03T00:00:00Z', 'registeredDevices': 21, 'licensedDevices': 2000, 'devicesCritical': 21, 'unsupportedCIS': 8},
{'date': '2025-02-04T00:00:00Z', 'registeredDevices': 20, 'licensedDevices': 2000, 'devicesCritical': 20, 'unsupportedCIS': 7},
{'date': '2025-02-05T00:00:00Z', 'registeredDevices': 22, 'licensedDevices': 2000, 'devicesCritical': 22, 'unsupportedCIS': 7},
{'date': '2025-02-06T00:00:00Z', 'registeredDevices': 24, 'licensedDevices': 2000, 'devicesCritical': 24, 'unsupportedCIS': 7},
{'date': '2025-02-07T00:00:00Z', 'registeredDevices': 25, 'licensedDevices': 2000, 'devicesCritical': 25, 'unsupportedCIS': 7},
{'date': '2025-02-08T00:00:00Z', 'registeredDevices': 25, 'licensedDevices': 2000, 'devicesCritical': 25, 'unsupportedCIS': 7},
{'date': '2025-02-09T00:00:00Z', 'registeredDevices': 25, 'licensedDevices': 2000, 'devicesCritical': 25, 'unsupportedCIS': 7},
{'date': '2025-02-10T00:00:00Z', 'registeredDevices': 26, 'licensedDevices': 2000, 'devicesCritical': 26, 'unsupportedCIS': 8},
{'date': '2025-02-11T00:00:00Z', 'registeredDevices': 26, 'licensedDevices': 2000, 'devicesCritical': 26, 'unsupportedCIS': 8},
{'date': '2025-02-12T00:00:00Z', 'registeredDevices': 26, 'licensedDevices': 2000, 'devicesCritical': 26, 'unsupportedCIS': 8},
{'date': '2025-02-13T00:00:00Z', 'registeredDevices': 26, 'licensedDevices': 2000, 'devicesCritical': 26, 'unsupportedCIS': 8},
{'date': '2025-02-14T00:00:00Z', 'registeredDevices': 28, 'licensedDevices': 2000, 'devicesCritical': 28, 'unsupportedCIS': 10},
{'date': '2025-02-15T00:00:00Z', 'registeredDevices': 28, 'licensedDevices': 2000, 'devicesCritical': 28, 'unsupportedCIS': 10},
{'date': '2025-02-16T00:00:00Z', 'registeredDevices': 28, 'licensedDevices': 2000, 'devicesCritical': 28, 'unsupportedCIS': 10},
{'date': '2025-02-17T00:00:00Z', 'registeredDevices': 28, 'licensedDevices': 2000, 'devicesCritical': 28, 'unsupportedCIS': 3},
{'date': '2025-02-18T00:00:00Z', 'registeredDevices': 28, 'licensedDevices': 2000, 'devicesCritical': 28, 'unsupportedCIS': 3},
{'date': '2025-02-19T00:00:00Z', 'registeredDevices': 28, 'licensedDevices': 2000, 'devicesCritical': 28, 'unsupportedCIS': 3},
{'date': '2025-02-20T00:00:00Z', 'registeredDevices': 28, 'licensedDevices': 2000, 'devicesCritical': 28, 'unsupportedCIS': 3},
{'date': '2025-02-21T00:00:00Z', 'registeredDevices': 28, 'licensedDevices': 2000, 'devicesCritical': 28, 'unsupportedCIS': 3},
{'date': '2025-02-22T00:00:00Z', 'registeredDevices': 28, 'licensedDevices': 2000, 'devicesCritical': 28, 'unsupportedCIS': 3},
{'date': '2025-02-23T00:00:00Z', 'registeredDevices': 24, 'licensedDevices': 2000, 'devicesCritical': 24, 'unsupportedCIS': 3},
{'date': '2025-02-24T00:00:00Z', 'registeredDevices': 24, 'licensedDevices': 2000, 'devicesCritical': 24, 'unsupportedCIS': 3}
]
});
	mockData.execSummaryActions = () => ({
'graph': [
{'date': '2024-12-16T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2024-12-17T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2024-12-18T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2024-12-19T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2024-12-20T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2024-12-21T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2024-12-22T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2024-12-23T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2024-12-24T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2024-12-25T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2024-12-26T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2024-12-27T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2024-12-28T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2024-12-29T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2024-12-30T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2024-12-31T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-01T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-02T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-03T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-04T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-05T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-06T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-07T00:00:00Z', 'remediated': 67881, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-08T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-09T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-10T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-11T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-12T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-13T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-14T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-15T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-16T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-17T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-18T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-19T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-20T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-21T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-22T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-23T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-24T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-25T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-26T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-27T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-28T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-29T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-30T00:00:00Z', 'remediated': 67885, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-01-31T00:00:00Z', 'remediated': 67886, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-02-01T00:00:00Z', 'remediated': 67886, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-02-02T00:00:00Z', 'remediated': 67886, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-02-03T00:00:00Z', 'remediated': 67886, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-02-04T00:00:00Z', 'remediated': 67886, 'reverted': 12, 'muteAlerts': null},
{'date': '2025-02-05T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-06T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-07T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-08T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-09T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-10T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-11T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-12T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-13T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-14T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-15T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-16T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-17T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-18T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-19T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-20T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-21T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-22T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-23T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-24T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-25T00:00:00Z', 'remediated': 67885, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-26T00:00:00Z', 'remediated': 68411, 'reverted': 13, 'muteAlerts': null},
{'date': '2025-02-27T00:00:00Z', 'remediated': 68438, 'reverted': 15, 'muteAlerts': null},
{'date': '2025-02-28T00:00:00Z', 'remediated': 68461, 'reverted': 15, 'muteAlerts': null},
{'date': '2025-03-01T00:00:00Z', 'remediated': 68461, 'reverted': 15, 'muteAlerts': null},
{'date': '2025-03-02T00:00:00Z', 'remediated': 68461, 'reverted': 15, 'muteAlerts': null},
{'date': '2025-03-26T00:00:00Z', 'remediated': 68466, 'reverted': 15, 'muteAlerts': 363816},
{'date': '2025-03-27T00:00:00Z', 'remediated': 68466, 'reverted': 15, 'muteAlerts': 364180},
{'date': '2025-03-28T00:00:00Z', 'remediated': 68466, 'reverted': 15, 'muteAlerts': 365379},
{'date': '2025-03-29T00:00:00Z', 'remediated': 68466, 'reverted': 15, 'muteAlerts': 366470},
{'date': '2025-03-30T00:00:00Z', 'remediated': 68466, 'reverted': 15, 'muteAlerts': 366945},
{'date': '2025-03-31T00:00:00Z', 'remediated': 68466, 'reverted': 15, 'muteAlerts': 367090},
{'date': '2025-04-01T00:00:00Z', 'remediated': 68466, 'reverted': 15, 'muteAlerts': 368023}
],
'itMinutesSaved': 139989,
'error': null,
'remDevices': 62616,
'itMinutesSavedLastCalc': '2025-04-01T04:25:35.94802Z'
});
	mockData.execSummaryThreats = () => ({
'graph': [
{'date': '2024-10-24T00:00:00Z', 'high': 334, 'medium': 989, 'low': 17, 'passed': 578},
{'date': '2024-10-25T00:00:00Z', 'high': 334, 'medium': 989, 'low': 17, 'passed': 578},
{'date': '2024-10-26T00:00:00Z', 'high': 334, 'medium': 989, 'low': 17, 'passed': 578},
{'date': '2024-10-27T00:00:00Z', 'high': 334, 'medium': 989, 'low': 17, 'passed': 578},
{'date': '2024-10-28T00:00:00Z', 'high': 334, 'medium': 989, 'low': 17, 'passed': 578},
{'date': '2024-10-29T00:00:00Z', 'high': 334, 'medium': 989, 'low': 17, 'passed': 578},
{'date': '2024-10-30T00:00:00Z', 'high': 329, 'medium': 947, 'low': 17, 'passed': 567},
{'date': '2024-10-31T00:00:00Z', 'high': 322, 'medium': 836, 'low': 16, 'passed': 493},
{'date': '2024-11-01T00:00:00Z', 'high': 348, 'medium': 882, 'low': 18, 'passed': 575},
{'date': '2024-11-02T00:00:00Z', 'high': 348, 'medium': 882, 'low': 18, 'passed': 575},
{'date': '2024-11-03T00:00:00Z', 'high': 348, 'medium': 882, 'low': 18, 'passed': 575},
{'date': '2024-11-04T00:00:00Z', 'high': 380, 'medium': 910, 'low': 19, 'passed': 599},
{'date': '2024-11-05T00:00:00Z', 'high': 404, 'medium': 1494, 'low': 18, 'passed': 689},
{'date': '2024-11-06T00:00:00Z', 'high': 405, 'medium': 1494, 'low': 17, 'passed': 692},
{'date': '2024-11-07T00:00:00Z', 'high': 405, 'medium': 1494, 'low': 17, 'passed': 695},
{'date': '2024-11-08T00:00:00Z', 'high': 404, 'medium': 1494, 'low': 18, 'passed': 695},
{'date': '2024-11-09T00:00:00Z', 'high': 404, 'medium': 1494, 'low': 18, 'passed': 695},
{'date': '2024-11-10T00:00:00Z', 'high': 404, 'medium': 1494, 'low': 18, 'passed': 695},
{'date': '2024-11-11T00:00:00Z', 'high': 384, 'medium': 1479, 'low': 18, 'passed': 659},
{'date': '2024-11-12T00:00:00Z', 'high': 380, 'medium': 1477, 'low': 18, 'passed': 661},
{'date': '2024-11-13T00:00:00Z', 'high': 429, 'medium': 1493, 'low': 20, 'passed': 711},
{'date': '2024-11-14T00:00:00Z', 'high': 429, 'medium': 1495, 'low': 20, 'passed': 711},
{'date': '2024-11-15T00:00:00Z', 'high': 429, 'medium': 1496, 'low': 20, 'passed': 710},
{'date': '2024-11-16T00:00:00Z', 'high': 429, 'medium': 1496, 'low': 20, 'passed': 710},
{'date': '2024-11-17T00:00:00Z', 'high': 429, 'medium': 1496, 'low': 20, 'passed': 710},
{'date': '2024-11-18T00:00:00Z', 'high': 390, 'medium': 1471, 'low': 20, 'passed': 669},
{'date': '2024-11-19T00:00:00Z', 'high': 367, 'medium': 921, 'low': 20, 'passed': 580},
{'date': '2024-11-20T00:00:00Z', 'high': 364, 'medium': 921, 'low': 20, 'passed': 582},
{'date': '2024-11-21T00:00:00Z', 'high': 365, 'medium': 921, 'low': 20, 'passed': 583},
{'date': '2024-11-22T00:00:00Z', 'high': 396, 'medium': 951, 'low': 21, 'passed': 629},
{'date': '2024-11-23T00:00:00Z', 'high': 396, 'medium': 951, 'low': 21, 'passed': 629},
{'date': '2024-11-24T00:00:00Z', 'high': 396, 'medium': 952, 'low': 21, 'passed': 628},
{'date': '2024-11-25T00:00:00Z', 'high': 446, 'medium': 1019, 'low': 22, 'passed': 676},
{'date': '2024-11-26T00:00:00Z', 'high': 405, 'medium': 1010, 'low': 22, 'passed': 674},
{'date': '2024-11-27T00:00:00Z', 'high': 405, 'medium': 1010, 'low': 22, 'passed': 674},
{'date': '2024-11-28T00:00:00Z', 'high': 409, 'medium': 1159, 'low': 22, 'passed': 674},
{'date': '2024-11-29T00:00:00Z', 'high': 409, 'medium': 983, 'low': 21, 'passed': 673},
{'date': '2024-11-30T00:00:00Z', 'high': 410, 'medium': 881, 'low': 21, 'passed': 676},
{'date': '2024-12-01T00:00:00Z', 'high': 410, 'medium': 881, 'low': 21, 'passed': 676},
{'date': '2024-12-02T00:00:00Z', 'high': 491, 'medium': 1082, 'low': 24, 'passed': 768},
{'date': '2024-12-03T00:00:00Z', 'high': 514, 'medium': 1096, 'low': 23, 'passed': 771},
{'date': '2024-12-04T00:00:00Z', 'high': 514, 'medium': 1095, 'low': 23, 'passed': 769},
{'date': '2024-12-05T00:00:00Z', 'high': 515, 'medium': 1096, 'low': 23, 'passed': 769},
{'date': '2024-12-06T00:00:00Z', 'high': 481, 'medium': 1067, 'low': 23, 'passed': 726},
{'date': '2024-12-07T00:00:00Z', 'high': 481, 'medium': 1067, 'low': 23, 'passed': 726},
{'date': '2024-12-08T00:00:00Z', 'high': 481, 'medium': 1068, 'low': 23, 'passed': 726},
{'date': '2024-12-09T00:00:00Z', 'high': 501, 'medium': 1108, 'low': 25, 'passed': 770},
{'date': '2024-12-10T00:00:00Z', 'high': 475, 'medium': 1083, 'low': 24, 'passed': 772},
{'date': '2024-12-11T00:00:00Z', 'high': 472, 'medium': 1083, 'low': 24, 'passed': 764},
{'date': '2024-12-12T00:00:00Z', 'high': 521, 'medium': 1093, 'low': 25, 'passed': 799},
{'date': '2024-12-13T00:00:00Z', 'high': 511, 'medium': 1091, 'low': 27, 'passed': 799},
{'date': '2024-12-14T00:00:00Z', 'high': 511, 'medium': 1091, 'low': 27, 'passed': 799},
{'date': '2024-12-15T00:00:00Z', 'high': 511, 'medium': 1091, 'low': 27, 'passed': 799},
{'date': '2024-12-16T00:00:00Z', 'high': 499, 'medium': 1095, 'low': 26, 'passed': 787},
{'date': '2024-12-17T00:00:00Z', 'high': 479, 'medium': 1061, 'low': 25, 'passed': 746},
{'date': '2024-12-18T00:00:00Z', 'high': 455, 'medium': 924, 'low': 25, 'passed': 709},
{'date': '2024-12-19T00:00:00Z', 'high': 455, 'medium': 926, 'low': 25, 'passed': 709},
{'date': '2024-12-20T00:00:00Z', 'high': 463, 'medium': 1004, 'low': 25, 'passed': 722},
{'date': '2024-12-21T00:00:00Z', 'high': 463, 'medium': 1004, 'low': 25, 'passed': 722},
{'date': '2024-12-22T00:00:00Z', 'high': 463, 'medium': 1005, 'low': 26, 'passed': 720},
{'date': '2024-12-23T00:00:00Z', 'high': 463, 'medium': 1004, 'low': 27, 'passed': 720},
{'date': '2024-12-24T00:00:00Z', 'high': 419, 'medium': 916, 'low': 24, 'passed': 584},
{'date': '2024-12-25T00:00:00Z', 'high': 419, 'medium': 915, 'low': 24, 'passed': 584},
{'date': '2024-12-26T00:00:00Z', 'high': 406, 'medium': 913, 'low': 24, 'passed': 615},
{'date': '2024-12-27T00:00:00Z', 'high': 431, 'medium': 948, 'low': 26, 'passed': 659},
{'date': '2024-12-28T00:00:00Z', 'high': 431, 'medium': 948, 'low': 26, 'passed': 659},
{'date': '2024-12-29T00:00:00Z', 'high': 431, 'medium': 948, 'low': 26, 'passed': 659},
{'date': '2024-12-30T00:00:00Z', 'high': 430, 'medium': 949, 'low': 26, 'passed': 659},
{'date': '2024-12-31T00:00:00Z', 'high': 433, 'medium': 948, 'low': 26, 'passed': 657},
{'date': '2025-01-01T00:00:00Z', 'high': 379, 'medium': 884, 'low': 25, 'passed': 605},
{'date': '2025-01-02T00:00:00Z', 'high': 393, 'medium': 1003, 'low': 25, 'passed': 641},
{'date': '2025-01-03T00:00:00Z', 'high': 430, 'medium': 987, 'low': 25, 'passed': 688},
{'date': '2025-01-04T00:00:00Z', 'high': 430, 'medium': 987, 'low': 25, 'passed': 688},
{'date': '2025-01-05T00:00:00Z', 'high': 430, 'medium': 987, 'low': 25, 'passed': 688},
{'date': '2025-01-06T00:00:00Z', 'high': 432, 'medium': 988, 'low': 23, 'passed': 683},
{'date': '2025-01-07T00:00:00Z', 'high': 430, 'medium': 989, 'low': 23, 'passed': 683},
{'date': '2025-01-08T00:00:00Z', 'high': 425, 'medium': 984, 'low': 23, 'passed': 681},
{'date': '2025-01-09T00:00:00Z', 'high': 391, 'medium': 950, 'low': 23, 'passed': 624},
{'date': '2025-01-10T00:00:00Z', 'high': 364, 'medium': 910, 'low': 21, 'passed': 582},
{'date': '2025-01-11T00:00:00Z', 'high': 364, 'medium': 910, 'low': 21, 'passed': 582},
{'date': '2025-01-12T00:00:00Z', 'high': 364, 'medium': 910, 'low': 21, 'passed': 582},
{'date': '2025-01-13T00:00:00Z', 'high': 362, 'medium': 884, 'low': 20, 'passed': 582},
{'date': '2025-01-14T00:00:00Z', 'high': 361, 'medium': 910, 'low': 20, 'passed': 582},
{'date': '2025-01-15T00:00:00Z', 'high': 365, 'medium': 908, 'low': 19, 'passed': 587},
{'date': '2025-01-16T00:00:00Z', 'high': 405, 'medium': 947, 'low': 19, 'passed': 648},
{'date': '2025-01-17T00:00:00Z', 'high': 405, 'medium': 964, 'low': 20, 'passed': 666},
{'date': '2025-01-18T00:00:00Z', 'high': 405, 'medium': 964, 'low': 20, 'passed': 666},
{'date': '2025-01-19T00:00:00Z', 'high': 405, 'medium': 964, 'low': 20, 'passed': 666},
{'date': '2025-01-20T00:00:00Z', 'high': 418, 'medium': 966, 'low': 21, 'passed': 659},
{'date': '2025-01-21T00:00:00Z', 'high': 419, 'medium': 966, 'low': 21, 'passed': 662},
{'date': '2025-01-22T00:00:00Z', 'high': 426, 'medium': 971, 'low': 21, 'passed': 662},
{'date': '2025-01-23T00:00:00Z', 'high': 425, 'medium': 980, 'low': 21, 'passed': 662},
{'date': '2025-01-24T00:00:00Z', 'high': 373, 'medium': 893, 'low': 20, 'passed': 599},
{'date': '2025-01-25T00:00:00Z', 'high': 370, 'medium': 893, 'low': 20, 'passed': 596},
{'date': '2025-01-26T00:00:00Z', 'high': 368, 'medium': 891, 'low': 20, 'passed': 591},
{'date': '2025-01-27T00:00:00Z', 'high': 393, 'medium': 859, 'low': 20, 'passed': 627},
{'date': '2025-01-28T00:00:00Z', 'high': 372, 'medium': 885, 'low': 19, 'passed': 600},
{'date': '2025-01-29T00:00:00Z', 'high': 344, 'medium': 785, 'low': 17, 'passed': 590},
{'date': '2025-01-30T00:00:00Z', 'high': 419, 'medium': 912, 'low': 21, 'passed': 743},
{'date': '2025-01-31T00:00:00Z', 'high': 418, 'medium': 913, 'low': 21, 'passed': 746},
{'date': '2025-02-01T00:00:00Z', 'high': 418, 'medium': 913, 'low': 21, 'passed': 746},
{'date': '2025-02-02T00:00:00Z', 'high': 421, 'medium': 913, 'low': 21, 'passed': 755},
{'date': '2025-02-03T00:00:00Z', 'high': 396, 'medium': 876, 'low': 19, 'passed': 709},
{'date': '2025-02-04T00:00:00Z', 'high': 394, 'medium': 809, 'low': 20, 'passed': 681},
{'date': '2025-02-05T00:00:00Z', 'high': 457, 'medium': 897, 'low': 25, 'passed': 767},
{'date': '2025-02-06T00:00:00Z', 'high': 471, 'medium': 921, 'low': 25, 'passed': 810},
{'date': '2025-02-07T00:00:00Z', 'high': 496, 'medium': 937, 'low': 25, 'passed': 837},
{'date': '2025-02-08T00:00:00Z', 'high': 496, 'medium': 937, 'low': 25, 'passed': 837},
{'date': '2025-02-09T00:00:00Z', 'high': 548, 'medium': 993, 'low': 27, 'passed': 890},
{'date': '2025-02-10T00:00:00Z', 'high': 561, 'medium': 1065, 'low': 27, 'passed': 901},
{'date': '2025-02-11T00:00:00Z', 'high': 562, 'medium': 1061, 'low': 26, 'passed': 917},
{'date': '2025-02-12T00:00:00Z', 'high': 531, 'medium': 1004, 'low': 25, 'passed': 877},
{'date': '2025-02-13T00:00:00Z', 'high': 531, 'medium': 1004, 'low': 25, 'passed': 877},
{'date': '2025-02-14T00:00:00Z', 'high': 557, 'medium': 1131, 'low': 25, 'passed': 922},
{'date': '2025-02-15T00:00:00Z', 'high': 589, 'medium': 1182, 'low': 26, 'passed': 962},
{'date': '2025-02-16T00:00:00Z', 'high': 589, 'medium': 1183, 'low': 27, 'passed': 962},
{'date': '2025-02-17T00:00:00Z', 'high': 588, 'medium': 1196, 'low': 27, 'passed': 969},
{'date': '2025-02-18T00:00:00Z', 'high': 588, 'medium': 1196, 'low': 26, 'passed': 971},
{'date': '2025-02-19T00:00:00Z', 'high': 588, 'medium': 1196, 'low': 26, 'passed': 971},
{'date': '2025-02-20T00:00:00Z', 'high': 589, 'medium': 1251, 'low': 26, 'passed': 970},
{'date': '2025-02-21T00:00:00Z', 'high': 589, 'medium': 1251, 'low': 26, 'passed': 970},
{'date': '2025-02-22T00:00:00Z', 'high': 589, 'medium': 1251, 'low': 26, 'passed': 970},
{'date': '2025-02-23T00:00:00Z', 'high': 476, 'medium': 1119, 'low': 23, 'passed': 816},
{'date': '2025-02-24T10:33:46.252513Z', 'high': 476, 'medium': 1119, 'low': 23, 'passed': 807}
],
'potentialTimeSaving': 1141,
'error': null,
'potentialSavingLastCalc': '2025-02-23T16:02:06.884663Z'
});
	mockData.execSummaryBenchmarkAlerts = () => ({'graph': [{'date': '2024-12-07T00:00:00Z', 'level1': 1315533, 'level2': 1745950, 'stig': 9733}], 'potentialTimeSaving': 0, 'error': null, 'potentialSavingLastCalc': null});
	mockData.altGroupBy = () => ({
data: {
High: {
group: [
{by: 1014, devices: 50, autoRem: 12, remRules: 18, alerts: 15, remediated: 23, pending: 7},
{by: 1002, devices: 50, autoRem: 12, remRules: 18, alerts: 15, remediated: 23, pending: 7},
{by: 1001, devices: 50, autoRem: 12, remRules: 18, alerts: 15, remediated: 23, pending: 7},
{by: 1004, devices: 50, autoRem: 12, remRules: 18, alerts: 15, remediated: 23, pending: 7},
{by: 1003, devices: 50, autoRem: 12, remRules: 18, alerts: 15, remediated: 23, pending: 7}
],
badTopics: 324,
okTopics: 22,
remTopics:45,
newAlerts: 3,
itMinuets: 39543
},
Medium: {
group: [
{by: 1014, devices: 50, autoRem: 12, remRules: 18, alerts: 15, remediated: 23, pending: 7},
{by: 1002, devices: 50, autoRem: 12, remRules: 18, alerts: 15, remediated: 23, pending: 7},
{by: 1001, devices: 50, autoRem: 12, remRules: 18, alerts: 15, remediated: 23, pending: 7},
{by: 1004, devices: 50, autoRem: 12, remRules: 18, alerts: 15, remediated: 23, pending: 7},
{by: 1003, devices: 50, autoRem: 12, remRules: 18, alerts: 15, remediated: 23, pending: 7}
],
badTopics: 324,
okTopics: 22,
remTopics:45,
newAlerts: 3,
itMinuets: 39543
}
}
});
	mockData.remTopics = () => ({
'data': [
{'topicCode': 'gytPSVerIssue', remTasks: 32, 'okDevicesStart': 2, 'okDevicesEnd': 2, 'badDevicesStart': 7, 'badDevicesEnd': 5, 'alertsStart': 7, 'alertsEnd': 5},
{'topicCode': 'gytSSHv1', remTasks: 32, 'okDevicesStart': 0, 'okDevicesEnd': 0, 'badDevicesStart': 4, 'badDevicesEnd': 6, 'alertsStart': 4, 'alertsEnd': 6},
{remTasks: 32, 'topicCode': 'gytUsbMassStorage', 'okDevicesStart': 0, 'okDevicesEnd': 0, 'badDevicesStart': 4, 'badDevicesEnd': 8, 'alertsStart': 4, 'alertsEnd': 8},
{'topicCode': 'gytSMBv1', 'okDevicesStart': 5, 'okDevicesEnd': 5, 'badDevicesStart': 5, 'badDevicesEnd': 3, 'alertsStart': 5, 'alertsEnd': 3},
{'topicCode': 'gytLastAccessTime', 'okDevicesStart': 1, 'okDevicesEnd': 1, 'badDevicesStart': 8, 'badDevicesEnd': 7, 'alertsStart': 8, 'alertsEnd': 7}
]
});
	mockData.remTopicsBenchmark = () => ({
'data': [
{'topicCode': 'L1_Ensure_No_auto-restart_with_logged_on_users_for_scheduled_automatic_updates_installations_is_set_to_Disabled', 'remTasks': 1},
{'topicCode': 'L1_Ensure_Do_not_allow_password_expiration_time_longer_than_required_by_policy_is_set_to_Enabled', 'remTasks': 1},
{'topicCode': 'L1_Ensure_Security_Specify_the_maximum_log_file_size_KB_is_set_to_Enabled_196608_or_greater', 'remTasks': 1},
{'topicCode': 'L1_Ensure_Windows_Firewall_Private_Inbound_connections_is_set_to_Block_default', 'remTasks': 1},
{'topicCode': 'L1_Ensure_Notify_Unsafe_App_is_set_to_Enabled', 'remTasks': 1}
],
'lastCalc': '2025-01-16T04:00:49.254221Z'
});

	mockData.riskTopics = () => ({'data': [{'topicCode': null, 'badDevices': 0, 'okDevices': 0}], 'lastCalc': '2025-11-30T03:25:32.425433Z'});
	mockData.riskTopicsBenchmark = () => ({'data':[], 'lastCalc':null});

	mockData.gpoGpo = {displayName: 'Local Group Policy', affected: {users: Math.random()*1e4|0, devices: Math.random()*1e4|0}, metadata: {'domain': 'acme.com', 'activeDirectoryId': '31234-344'}};
    // mockData.gpoGposByDevices = req => ({data: makeArr(req.len).map(i => ({gpoId: req.from + i+"", gpoName: `Local GPO detected ${req.from + i}`, lastChanged: "2024-05-24T06:21:00.188624Z", devices: [Math.random()*1e5|0, Math.random()*1e5|0, Math.random()*1e5|0, Math.random()*1e5|0], settingCount: Math.random()*1e4|0})), rowCount: 150});
    // mockData.gpoGpoSettings = req => ({data: makeArr(req.len).map(i => ({id: req.from + i+"", settingName: `Network access: Do not allow anonymous enumeration of SAM accounts and shares ${req.from + i}`, ...req.api.afterLast("-") === "settings" && {path: "Windows Settings\\Security Settings", expected: "[0,1,2]", affects: Math.random() < 0.5? "Device" : "User"}, severities: [0, Math.random()*1e5|0, 0, Math.random()*1e5|0]})), rowCount: 150});
    // mockData.gpoGpoDevice = req => ({data: makeArr(15).map(_i => ({id: i+"", displayName: `Network access: Do not allow anonymous enumeration of SAM accounts and shares ${i}`, ...req.api.afterLast("-") !== "setting" && {path: "Windows Settings\\Security Settings", expected: "[0,1,2]"}, severity: "High"})), rowCount: 15});
	mockData.gpoGposByDevices = {
data: [
{
gpoId: 15,
gpoName: 'Default Domain Policy',
domain: 'acme.com',
userSettingCount: 16,
deviceSettingCount: 23,
lastChanged: '2025-02-24T09:50:23Z',
userSeverities: [
0,
254442,
0,
0
],
deviceSeverities: [
0,
6,
7,
2
]
},
{
gpoId: 13,
gpoName: 'Printer',
domain: 'alphaprod',
userSettingCount: 1,
deviceSettingCount: 5,
lastChanged: '2025-02-23T06:12:01Z',
userSeverities: [
0,
2,
0,
0
],
deviceSeverities: [
4,
6,
7,
2
]
},
{
gpoId: 17,
gpoName: 'RegistryEndpoints',
domain: 'contoso.com',
userSettingCount: 40,
deviceSettingCount: 1,
lastChanged: '2025-02-10T01:00:00Z',
userSeverities: [
0,
0,
0,
12
],
deviceSeverities: [
0,
0,
0,
0
]
},
{
gpoId: 18,
gpoName: 'Sensitive',
domain: 'fabrikam.local',
userSettingCount: 2,
deviceSettingCount: 80,
lastChanged: '2025-02-20T12:00:00Z',
userSeverities: [
0,
7,
0,
0
],
deviceSeverities: [
4,
99,
0,
2
]
},
{
gpoId: 19,
gpoName: 'Settings for Server',
domain: 'northwind.trade',
userSettingCount: 8,
deviceSettingCount: 13,
lastChanged: '2025-02-24T09:50:22Z',
userSeverities: [
0,
0,
0,
2
],
deviceSeverities: [
0,
0,
0,
2
]
},
{
gpoId: 11,
gpoName: '{0AD2C31B-52D0-45CF-917F-DA673E9FB4CC}',
domain: 'tailspin.corp',
userSettingCount: 7,
deviceSettingCount: 23,
lastChanged: '2025-01-01T00:00:00Z',
userSeverities: [
9,
0,
0,
0
],
deviceSeverities: [
11,
0,
0,
0
]
},
{
gpoId: 16,
gpoName: '{E4D73307-57E5-4021-9988-95CCA153B718}',
domain: 'woodgrove.dev',
userSettingCount: 28,
deviceSettingCount: 2,
lastChanged: '2025-02-19T16:58:34Z',
userSeverities: [
4,
1,
2,
0
],
deviceSeverities: [
4,
6,
99,
2
]
},
{
gpoId: 14,
gpoName: 'Default Domain Controllers Policy',
domain: 'adatum.net',
userSettingCount: 3,
deviceSettingCount: 55,
lastChanged: '2025-02-24T10:00:00Z',
userSeverities: [
4,
6,
7,
2
],
deviceSeverities: [
4,
6,
7,
2
]
}
]
};
	const gpoSettingNames = [
		'Allow Cortana',
'Path Exclusions',
'Turn on PowerShell Transcription',
'Process Exclusions',
		'Configure extension management settings',
'Extension management settings',
		'Configure the list of force-installed apps and extensions',
'Turn on convenience PIN sign-in',
		'Windows Defender Firewall: Protect all network connections',
		'Configure extension, app, and user script install sources',
'Software\\Policies\\Mozilla\\Firefox',
		'Do not display the lock screen',
'Prevent the usage of OneDrive for file storage',
		'Allow deleting browsing history on exit',
'Configure Open Microsoft Edge With',
'Do not allow web search'
	];
	const gpoExpectedValues = [
		'Action: Create, IP address: 192.168.0.201',
		'[{"name":"State","value":"Enabled"}]',
		'[0,1,2]'
	];

	// Three endpoints behind one key: /api/v2/gpo_gpo-{settings,devices,users} return different rows.
	mockData.gpoGpoSettings = req => {
		const sevs = () => [
0,
Math.random()*1e4 |0,
0,
Math.random()*1e4 |0
];
		const tab = (req.api ?? '').afterLast('-');
		if (tab === 'settings')
			return {
rowCount: 150,
				data: gpoSettingNames.map((settingName, i) => ({
					id: i + 1,
					settingKey: settingName,
					settingName,
					displayName: settingName,
					extensionName: 'Registry',
					path: 'Windows Settings\\Security Settings',
					expectedValue: gpoExpectedValues[i % 3],
					affects: i % 2 ? 'Device' : 'User',
					isDomainLevel: !(i % 4),
					severities: sevs()
				}))
};
		if (tab === 'users')
			return {
rowCount: 150,
				data: gpoSettingNames.map((displayName, i) => ({
					id: i + 1, displayName, userName: `user${i}@acme.com`, computerName: `DEVICE-${i}`, severities: sevs()
				}))
};
		return {rowCount: 150, data: gpoSettingNames.map((displayName, i) => ({id: i + 1, displayName, severities: sevs()}))};
	};
	mockData.gpoGpoDevice = req => ({data: makeArr(15).map(i => ({'id': i, 'setting': {'expectedValue': 'Action: Create, IP address: 192.168.0.201', 'errorId': 11002, 'settingName': 'Allow Cortana', 'errorName': 'GPP_ERROR', 'settingKey': 'AllowCortana', 'extensionName': 'Registry', 'displayName': 'Windows Settings\\Security Settings', 'settingPath': 'Computer Configuration\\Policies\\Administrative Templates\\Search', 'additionalInfo': {'Action': 'Create', 'GPO (another) name': 'Printer', 'GPP Error': 'The printer name is invalid.', 'GPP Error Code': '0x80070709', 'GPP Setting': '192.168.0.201', 'IP address': '192.168.0.201', 'Path': 'c:\\\\'}, 'severity': 'High'}, 'device': {'deviceId': 9115, 'ip': '10.0.0.27', 'deviceGuid':'d7b7e833-5330-7970-f66e-9ed1ddc2cb1d', 'name': 'SERVER2022', 'ou': 'Servers', 'os': 'Win Server 2022 Standard', 'mac': '00:15:5D:00:04:09', 'domain': 'alphaprod', 'sensorVersion': '2.38.2.0'}, ...((req.api ?? '').afterLast('-') === 'user' && {'user': {'id': 4021, 'name': 'j.doe', 'ou': 'Users', 'domain': 'alphaprod'}})})), rowCount: 15});

	mockData.feature_flags_get = () => ({'data':{'ff_license': {'value': {'hideUnlicensedModules': false}}, 'ff_rum':{'value':{'uiEnabled': true, 'allowCustomerData': true}}, 'ff_demo': {'value': {'demoEnabled': false}}, 'ff_v3_integrations': {'value': {'enabled': false}}, 'ff_linux_custom_cis': {'value': {'enabled': true}}, 'ff_blah':{'value':{'a':'b', 'c':'d', 'e':1234}}}});

	mockData.policyList = () => ({
'policies': [
{
dslVersion: '1.4.0',
'policyId': '0199c1a7-1111-7aaa-8bbb-aa0817740001',
'name': 'AlmaLinux 8 - test',
'baseBenchmark': 'AlmaLinux_OS_8-3.0.0',
'levels': [
'Level_1',
'Level_2'
],
'groups': [],
'lastEditedAt': '2026-06-20T10:00:00Z',
'lastEditedBy': {'user': 'yarden@gytpol.com', 'userName': 'Jordan', 'title': 'VP UI'},
'activeRevisionNumber': 1,
'committedDslLink': 'https://gytpol',
'uncommittedDslLink': null
},
{dslVersion: '1.4.0', 'policyId': '0198f0c6-9a9f-76d6-9e7f-a2aa6390457e', 'name': 'Windows - test', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'levels': ['Level_1'], 'groups': [], 'lastEditedAt': '2025-08-28T13:04:50.545154Z', 'lastEditedBy': {'user': 'sh@gytpol.com', 'userName': null, 'title': 'SKIBIDI MANAGER'}, 'activeRevisionNumber': 1, 'committedDslLink': 'https://gytpol', 'uncommittedDslLink': null},
{'policyId': '0198f0d9-3d8a-7bb7-a3bf-9d3f92073488', 'name': 'server2022', 'baseBenchmark': 'Windows_Server_2022-4.0.0', 'levels': ['Level_1'], 'groups': [{'groupId': 991, 'appliedDevices': 1}], 'lastEditedAt': '2025-08-28T13:29:05.3568682Z', 'lastEditedBy': {'user': 'ori@gytpol.com', 'userName': 'Ori Amir', 'title': 'Qa'}, 'activeRevisionNumber': 0, 'committedDslLink': 'https://gytpol', 'uncommittedDslLink': null},
{
'policyId': '07d82a9c-3869-42f5-8d23-02bb6ef7d04c',
'name': 'Ori-2025-test',
'baseBenchmark': 'Windows_Server_2025-1.0.0',
'levels': [
'Level_1',
'Level_2'
],
'groups': [{'groupId': 991, 'appliedDevices': 0}],
'lastEditedAt': '2025-08-24T07:52:43.5866746Z',
'lastEditedBy': {'user': 'ori@gytpol.com', 'userName': null, 'title': ''},
'activeRevisionNumber': 12,
'committedDslLink': 'https://gytpol',
'uncommittedDslLink': null
},
{
'policyId': '1b62cbc4-f457-49ba-acfe-969d00f0e1eb',
'name': 'Server 2008 - All Selected',
'baseBenchmark': 'Windows_Server_2008_R2-3.3.0',
'levels': [
'Level_1',
'Level_2'
],
'groups': [{'groupId': 1002, 'appliedDevices': 2}],
'lastEditedAt': '2025-08-20T08:59:38.8529864Z',
'lastEditedBy': {'user': 'sh@gytpol.com', 'userName': null, 'title': 'SKIBIDI MANAGER'},
'activeRevisionNumber': 0,
'committedDslLink': 'https://gytpol',
'uncommittedDslLink': null
},
{
'policyId': '3f6de599-bbf7-48b0-bcdb-cc1bbc1ed01e',
'name': 'Server 2012 R2 - Select All',
'baseBenchmark': 'Windows_Server_2012_R2-3.0.0',
'levels': [
'Level_1',
'Level_2'
],
'groups': [{'groupId': 1002, 'appliedDevices': 3}],
'lastEditedAt': '2025-08-20T08:58:47.8371829Z',
'lastEditedBy': {'user': 'sh@gytpol.com', 'userName': null, 'title': 'SKIBIDI MANAGER'},
'activeRevisionNumber': 0,
'committedDslLink': 'https://gytpol',
'uncommittedDslLink': null
},
{
'policyId': '58dbd6f5-38d7-4cef-a8d8-933c5e200d05',
'name': 'Windows 10 Standalone - Select All',
'baseBenchmark': 'Windows_10_Stand-alone-4.0.0',
'levels': [
'Level_1',
'Level_2'
],
'groups': [{'groupId': 1001, 'appliedDevices': 1}],
'lastEditedAt': '2025-08-24T11:48:29.0001768Z',
'lastEditedBy': {'user': 'sh@gytpol.com', 'userName': null, 'title': 'SKIBIDI MANAGER'},
'activeRevisionNumber': 1,
'committedDslLink': 'https://gytpol',
'uncommittedDslLink': 'https://gytpole'
},
{
'policyId': '601fb637-956b-457f-94e9-b3175f35d2a2',
'name': 'Server 2025 - Select All',
'baseBenchmark': 'Windows_Server_2025-1.0.0',
'levels': [
'Level_1',
'Level_2'
],
'groups': [
{'groupId': 991, 'appliedDevices': 0},
{'groupId': 1002, 'appliedDevices': 5}
],
'lastEditedAt': '2025-08-28T08:13:03.0917588Z',
'lastEditedBy': {'user': 'sh@gytpol.com', 'userName': null, 'title': 'SKIBIDI MANAGER'},
'activeRevisionNumber': 5,
'committedDslLink': 'https://gytpol',
'uncommittedDslLink': 'https://gytpol9'
},
{
'policyId': '63c28b62-3bf0-4019-8fb3-d01268bf6fe2',
'name': 'Server 2022 - Select All',
'baseBenchmark': 'Windows_Server_2022-4.0.0',
'levels': [
'Level_1',
'Level_2'
],
'groups': [
{'groupId': 991, 'appliedDevices': 1},
{'groupId': 1002, 'appliedDevices': 6}
],
'lastEditedAt': '2025-08-28T07:41:43.6399384Z',
'lastEditedBy': {'user': 'ori@gytpol.com', 'userName': 'Ori Amir', 'title': 'Qa'},
'activeRevisionNumber': 2,
'committedDslLink': 'https://gytpol',
'uncommittedDslLink': 'https://gytpold'
},
{
'policyId': '6eff5723-98a0-4932-9ce5-fd33555ce75e',
'name': 'Windows 10 enterprise - All Selected',
'baseBenchmark': 'Windows_10_Enterprise-4.0.0',
'levels': [
'Level_1',
'Level_2'
],
'groups': [{'groupId': 1001, 'appliedDevices': 1}],
'lastEditedAt': '2025-08-24T11:22:06.591706Z',
'lastEditedBy': {'user': 'sh@gytpol.com', 'userName': null, 'title': 'SKIBIDI MANAGER'},
'activeRevisionNumber': 1,
'committedDslLink': 'https://gytpol',
'uncommittedDslLink': 'https://gytpol'
},
{
'policyId': '8b175be0-477c-4f16-96b0-8b123e948989',
'name': 'Server 2019 - Select All',
'baseBenchmark': 'Windows_Server_2019-4.0.0',
'levels': [
'Level_1',
'Level_2'
],
'groups': [{'groupId': 1002, 'appliedDevices': 6}],
'lastEditedAt': '2025-08-20T08:58:09.4948083Z',
'lastEditedBy': {'user': 'sh@gytpol.com', 'userName': null, 'title': 'SKIBIDI MANAGER'},
'activeRevisionNumber': 2,
'committedDslLink': 'https://gytpol',
'uncommittedDslLink': null
},
{
'policyId': '8d966dcc-d184-4426-8610-8271fa8cc29d',
'name': 'Server 2022 another',
'baseBenchmark': 'Windows_Server_2022-4.0.0',
'levels': [
'Level_1',
'Level_2'
],
'groups': [{'groupId': 1002, 'appliedDevices': 6}],
'lastEditedAt': '2025-08-26T13:44:03.5349399Z',
'lastEditedBy': {'user': 'ori@gytpol.com', 'userName': 'Ori Amir', 'title': 'Qa'},
'activeRevisionNumber': 0,
'committedDslLink': 'https://gytpol',
'uncommittedDslLink': 'https://gytpol1'
},
{
'policyId': '97d1d5d2-3357-42e6-b78c-2c94b6ad309d',
'name': 'Windows 2016 - Select All',
'baseBenchmark': 'Windows_Server_2016-3.0.0',
'levels': [
'Level_1',
'Level_2'
],
'groups': [
{'groupId': 991, 'appliedDevices': 1},
{'groupId': 1002, 'appliedDevices': 5}
],
'lastEditedAt': '2025-08-28T07:55:52.340016Z',
'lastEditedBy': {'user': 'ori@gytpol.com', 'userName': 'Ori Amir', 'title': 'Qa'},
'activeRevisionNumber': 3,
'committedDslLink': 'https://gytpol',
'uncommittedDslLink': 'https://gytpola'
},
{
'policyId': 'af9aa7e0-8464-4029-921a-0b5185b8c714',
'name': 'Intune 10 - All Selected',
'baseBenchmark': 'Intune_for_Windows_10-4.0.0',
'levels': [
'Level_1',
'Level_2'
],
'groups': [{'groupId': 1001, 'appliedDevices': 1}],
'lastEditedAt': '2025-08-26T13:35:10.3450004Z',
'lastEditedBy': {'user': 'sh@gytpol.com', 'userName': null, 'title': 'SKIBIDI MANAGER'},
'activeRevisionNumber': 0,
'committedDslLink': 'https://gytpol',
'uncommittedDslLink': 'https://gytpolf'
},
{
'policyId': 'cba9940f-4418-4ea4-9d16-c5685c304aa3',
'name': 'Server-2019',
'baseBenchmark': 'Windows_Server_2019-4.0.0',
'levels': [
'Level_1',
'Level_2'
],
'groups': [{'groupId': 991, 'appliedDevices': 1}],
'lastEditedAt': '2025-08-27T12:49:28.1709548Z',
'lastEditedBy': {'user': 'ori@gytpol.com', 'userName': 'Ori Amir', 'title': 'Qa'},
'activeRevisionNumber': 0,
'committedDslLink': 'https://gytpol',
'uncommittedDslLink': null
},
{'policyId': 'da37eb15-0cc6-47f6-b2a0-af06c0568f1a', 'name': 'Azure edition Server 2022 - All Selected', 'baseBenchmark': 'Azure_Compute_Windows_Server_2022-1.0.0', 'levels': ['Level_1'], 'groups': [], 'lastEditedAt': '2025-08-21T11:42:30.0724771Z', 'lastEditedBy': {'user': 'sh@gytpol.com', 'userName': null, 'title': 'SKIBIDI MANAGER'}, 'activeRevisionNumber': 1, 'committedDslLink': 'https://gytpol', 'uncommittedDslLink': 'https://gytpolc'},
{
'policyId': 'e416985e-39c1-4b0f-af7b-86771dc797a7',
'name': 'doublerule-2019-test',
'baseBenchmark': 'Windows_Server_2019-4.0.0',
'levels': [
'Level_1',
'Level_2'
],
'groups': [],
'lastEditedAt': '2025-08-24T13:41:37.3849821Z',
'lastEditedBy': {'user': 'sh@gytpol.com', 'userName': null, 'title': 'SKIBIDI MANAGER'},
'activeRevisionNumber': 10,
'committedDslLink': 'https://gytpol',
'uncommittedDslLink': 'https://gytpolc'
},
{
'policyId': 'ee1af7b7-7f4c-4f85-a436-1a739cfd6d43',
'name': 'Intune Windows 11 - All Selected',
'baseBenchmark': 'Intune_for_Windows_11-4.0.0',
'levels': [
'Level_1',
'Level_2'
],
'groups': [
{'groupId': 991, 'appliedDevices': 1},
{'groupId': 1001, 'appliedDevices': 3}
],
'lastEditedAt': '2025-08-27T12:52:35.9720293Z',
'lastEditedBy': {'user': 'ori@gytpol.com', 'userName': 'Ori Amir', 'title': 'Qa'},
'activeRevisionNumber': 2,
'committedDslLink': 'https://gytpol',
'uncommittedDslLink': 'https://gytpol8'
}
]
});

	mockData.policyListNoGroups = () => ({
'policies': [
{
'policyId': '8cb819de-2806-4f7c-9e6c-b23bdcc85d78',
'name': "yardi's policy",
'baseBenchmark': 'CIS_Microsoft_Windows_10_Enterprise_Benchmark_v3.0.0-xccdf_dsl.json',
'levels': [
'Level_1',
'Level_2',
'STIG'
],
'groups': null,
'lastEditedAt': '2025-07-31T08:04:34.6194442Z',
'lastEditedBy': {'UserName': 'yarden@gytpol.com', 'DisplayName': null, 'Title': null, 'Groups': null},
'activeRevisionNumber': null,
'committedDslLink': null,
'uncommittedDslLink': null
}
]
});
	mockData.policyCommittedDsl = () => ({
'dsl_version': 'v1.0.0',
'asset_id': 'xccdf_org.cisecurity.benchmarks_benchmark_4.0.0_CIS_Microsoft_Windows_11_Stand-alone_Benchmark',
'asset_version': '4.0.0',
'asset_name': 'Windows 11 Stand-alone',
'external_config': {},
'detections': [
{
'type': 'detection',
'id': 'almalinux_os_8-3.0.0-1.7.4-ensure_access_to_etcmotd_is_configured',
'remediation': 'cis_almalinux_os_8-3.0.0-1.7.4',
'logic': {
'type': 'and',
'nodes': [
{'type': 'script_test', 'object': {'script_id': 'sce_nix_mode_chk_sh', 'timeout_seconds': 45, 'env': {'XCCDF_VALUE_REGEX': '/etc/motd:0133'}}, 'state': {'exit_code': 101}},
{'type': 'script_test', 'object': {'script_id': 'sce_nix_owner_chk_sh', 'timeout_seconds': 45, 'env': {'XCCDF_VALUE_REGEX': '/etc/motd:root'}}, 'state': {'exit_code': 101}},
{'type': 'script_test', 'object': {'script_id': 'sce_nix_group_chk_sh', 'timeout_seconds': 45, 'env': {'XCCDF_VALUE_REGEX': '/etc/motd:root'}}, 'state': {'exit_code': 101}}
]
}
},
{'type': 'detection', 'id': 'windows_11_stand_alone-4.0.0-2.2.1-l1_ensure_access_credential_manager_as_a_trusted_caller_is_set_to_no_one', 'remediation': 'default_userright_remediation', 'logic': {'type': 'and', 'nodes': [{'type': 'userright_test', 'existence': 'none_exist', 'object': {'userright': 'SE_TRUSTED_CREDMAN_ACCESS_NAME'}}]}},
{'type': 'detection', 'id': 'windows_11_stand_alone-4.0.0-1.1.1-l1_ensure_enforce_password_history_is_set_to_24_or_more_passwords', 'remediation': 'default_passwordpolicy_remediation', 'logic': {'type': 'and', 'nodes': [{'type': 'passwordpolicy_test', 'existence': 'at_least_one_exists', 'object': {'policy_name': 'password_hist_len'}, 'state': {'value': 24, 'value_operation': 'greater than or equal', 'value_type': 'int'}}]}},
{
'type': 'detection',
'id': 'windows_11_stand_alone-4.0.0-2.3.7.3-bl_ensure_interactive_logon_machine_account_lockout_threshold_is_set_to_10_or_fewer_invalid_logon_attempts_but_not_0',
'remediation': null,
'logic': {
'type': 'and',
'nodes': [
{'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'Software\\Microsoft\\Windows\\CurrentVersion\\Policies\\System', 'name': 'MaxDevicePasswordFailedAttempts'}, 'state': {'type': 'reg_dword', 'value': 10, 'value_type': 'int', 'value_operation': 'less than or equal'}},
{'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'Software\\Microsoft\\Windows\\CurrentVersion\\Policies\\System', 'name': 'MaxDevicePasswordFailedAttempts'}, 'state': {'type': 'reg_dword', 'value': 0, 'value_type': 'int', 'value_operation': 'greater than'}}
]
}
},
{'type': 'detection', 'id': 'windows_11_stand_alone-4.0.0-18.9.7.1.1-bl_ensure_prevent_installation_of_devices_using_drivers_that_match_these_device_setup_classes_is_set_to_enabled', 'remediation': 'default_registry_remediation', 'logic': {'type': 'and', 'nodes': [{'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'Software\\Policies\\Microsoft\\Windows\\DeviceInstall\\Restrictions', 'name': 'DenyDeviceClasses'}, 'state': {'type': 'reg_dword', 'value': 1, 'value_type': 'int'}}]}},
{'type': 'detection', 'id': 'windows_11_stand_alone-4.0.0-18.9.7.1.3-bl_ensure_prevent_installation_of_devices_using_drivers_that_match_these_device_setup_classes_also_apply_to_matching_devices_that_are_already_installed._is_set_to_true_checked', 'remediation': 'default_registry_remediation', 'logic': {'type': 'and', 'nodes': [{'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'Software\\Policies\\Microsoft\\Windows\\DeviceInstall\\Restrictions', 'name': 'DenyDeviceClassesRetroactive'}, 'state': {'type': 'reg_dword', 'value': 1, 'value_type': 'int'}}]}},
{'type': 'detection', 'id': 'windows_11_stand_alone-4.0.0-18.9.24.1-bl_ensure_enumeration_policy_for_external_devices_incompatible_with_kernel_dma_protection_is_set_to_enabled_block_all', 'remediation': 'default_registry_remediation', 'logic': {'type': 'and', 'nodes': [{'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'SOFTWARE\\Policies\\Microsoft\\Windows\\Kernel DMA Protection', 'name': 'DeviceEnumerationPolicy'}, 'state': {'type': 'reg_dword', 'value': 0, 'value_type': 'int'}}]}},
{'type': 'detection', 'id': 'windows_11_stand_alone-4.0.0-18.9.33.6.3-bl_ensure_allow_standby_states_s1_s3_when_sleeping_on_battery_is_set_to_disabled', 'remediation': 'default_registry_remediation', 'logic': {'type': 'and', 'nodes': [{'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'Software\\Policies\\Microsoft\\Power\\PowerSettings\\abfc2519-3608-4c2a-94ea-171b0ed546ab', 'name': 'DCSettingIndex'}, 'state': {'type': 'reg_dword', 'value': 0, 'value_type': 'int'}}]}},
{'type': 'detection', 'id': 'windows_11_stand_alone-4.0.0-18.9.33.6.4-bl_ensure_allow_standby_states_s1_s3_when_sleeping_plugged_in_is_set_to_disabled', 'remediation': 'default_registry_remediation', 'logic': {'type': 'and', 'nodes': [{'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'Software\\Policies\\Microsoft\\Power\\PowerSettings\\abfc2519-3608-4c2a-94ea-171b0ed546ab', 'name': 'ACSettingIndex'}, 'state': {'type': 'reg_dword', 'value': 0, 'value_type': 'int'}}]}},
{'type': 'detection', 'id': 'windows_11_stand_alone-4.0.0-18.10.10.1.1-bl_ensure_allow_access_to_bitlocker_protected_fixed_data_drives_from_earlier_versions_of_windows_is_set_to_disabled', 'remediation': 'default_registry_remediation', 'logic': {'type': 'and', 'nodes': [{'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'Software\\Policies\\Microsoft\\FVE', 'name': 'FDVDiscoveryVolumeType'}, 'state': {'type': 'reg_sz', 'value': 'none', 'value_type': 'string'}}]}}
],
'metadata': {'cis_metadata': {'benchmark_name': 'CIS_Microsoft_Windows_11_Stand-alone_Benchmark_v4.0.0-xccdf.xml'}},
'remediations': []
});

	mockData.policyUncommittedDSL = () => ({
'dsl_version': 'v1.0.0',
'asset_id': 'xccdf_org.cisecurity.benchmarks_benchmark_4.0.0_CIS_Microsoft_Windows_11_Stand-alone_Benchmark',
'asset_version': '4.0.0',
'asset_name': 'Windows 11 Stand-alone',
'external_config': {},
'detections': [
{
'type': 'detection',
'id': 'windows_11_stand_alone-4.0.0-2.3.7.3-bl_ensure_interactive_logon_machine_account_lockout_threshold_is_set_to_10_or_fewer_invalid_logon_attempts_but_not_0',
'remediation': null,
'logic': {
'type': 'and',
'nodes': [
{'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'Software\\Microsoft\\Windows\\CurrentVersion\\Policies\\System', 'name': 'MaxDevicePasswordFailedAttempts'}, 'state': {'type': 'reg_dword', 'value': 10, 'value_type': 'int', 'value_operation': 'less than or equal'}},
{'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'Software\\Microsoft\\Windows\\CurrentVersion\\Policies\\System', 'name': 'MaxDevicePasswordFailedAttempts'}, 'state': {'type': 'reg_dword', 'value': 0, 'value_type': 'int', 'value_operation': 'greater than'}}
]
}
},
{'type': 'detection', 'id': 'windows_11_stand_alone-4.0.0-18.9.7.1.1-bl_ensure_prevent_installation_of_devices_using_drivers_that_match_these_device_setup_classes_is_set_to_enabled', 'remediation': 'default_registry_remediation', 'logic': {'type': 'and', 'nodes': [{'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'Software\\Policies\\Microsoft\\Windows\\DeviceInstall\\Restrictions', 'name': 'DenyDeviceClasses'}, 'state': {'type': 'reg_dword', 'value': 1, 'value_type': 'int'}}]}},
{'type': 'detection', 'id': 'windows_11_stand_alone-4.0.0-18.9.7.1.3-bl_ensure_prevent_installation_of_devices_using_drivers_that_match_these_device_setup_classes_also_apply_to_matching_devices_that_are_already_installed._is_set_to_true_checked', 'remediation': 'default_registry_remediation', 'logic': {'type': 'and', 'nodes': [{'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'Software\\Policies\\Microsoft\\Windows\\DeviceInstall\\Restrictions', 'name': 'DenyDeviceClassesRetroactive'}, 'state': {'type': 'reg_dword', 'value': 1, 'value_type': 'int'}}]}},
{'type': 'detection', 'id': 'windows_11_stand_alone-4.0.0-18.9.24.1-bl_ensure_enumeration_policy_for_external_devices_incompatible_with_kernel_dma_protection_is_set_to_enabled_block_all', 'remediation': 'default_registry_remediation', 'logic': {'type': 'and', 'nodes': [{'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'SOFTWARE\\Policies\\Microsoft\\Windows\\Kernel DMA Protection', 'name': 'DeviceEnumerationPolicy'}, 'state': {'type': 'reg_dword', 'value': 0, 'value_type': 'int'}}]}},
{'type': 'detection', 'id': 'windows_11_stand_alone-4.0.0-18.9.33.6.3-bl_ensure_allow_standby_states_s1_s3_when_sleeping_on_battery_is_set_to_disabled', 'remediation': 'default_registry_remediation', 'logic': {'type': 'and', 'nodes': [{'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'Software\\Policies\\Microsoft\\Power\\PowerSettings\\abfc2519-3608-4c2a-94ea-171b0ed546ab', 'name': 'DCSettingIndex'}, 'state': {'type': 'reg_dword', 'value': 0, 'value_type': 'int'}}]}},
{'type': 'detection', 'id': 'windows_11_stand_alone-4.0.0-18.9.33.6.4-bl_ensure_allow_standby_states_s1_s3_when_sleeping_plugged_in_is_set_to_disabled', 'remediation': 'default_registry_remediation', 'logic': {'type': 'and', 'nodes': [{'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'Software\\Policies\\Microsoft\\Power\\PowerSettings\\abfc2519-3608-4c2a-94ea-171b0ed546ab', 'name': 'ACSettingIndex'}, 'state': {'type': 'reg_dword', 'value': 0, 'value_type': 'int'}}]}},
{'type': 'detection', 'id': 'windows_11_stand_alone-4.0.0-18.10.10.1.1-bl_ensure_allow_access_to_bitlocker_protected_fixed_data_drives_from_earlier_versions_of_windows_is_set_to_disabled', 'remediation': 'default_registry_remediation', 'logic': {'type': 'and', 'nodes': [{'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'Software\\Policies\\Microsoft\\FVE', 'name': 'FDVDiscoveryVolumeType'}, 'state': {'type': 'reg_sz', 'value': 'none', 'value_type': 'string'}}]}},
{'type': 'detection', 'id': 'windows_11_stand_alone-4.0.0-2.3.7.2-l1_ensure_interactive_logon_dont_display_last_signed_in_is_set_to_enabled', 'remediation': 'default_registry_remediation', 'logic': {'type': 'and', 'nodes': [{'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'Software\\Microsoft\\Windows\\CurrentVersion\\Policies\\System', 'name': 'DontDisplayLastUserName'}, 'state': {'type': 'reg_dword', 'value': 1, 'value_type': 'int'}}]}}
],
'metadata': {'cis_metadata': {'benchmark_name': 'CIS_Microsoft_Windows_11_Stand-alone_Benchmark_v4.0.0-xccdf.xml'}},
'remediations': []
});

	mockData.policyRuleCompliance = () => ({
'data': [
{'ruleId': 'almalinux_os_8-3.0.0-1.7.4-ensure_access_to_etcmotd_is_configured', 'ruleName': 'Ensure access to /etc/motd is configured', 'policyId': '0199c1a7-1111-7aaa-8bbb-aa0817740001', 'policyName': 'AlmaLinux 8 - test', 'baseBenchmark': 'AlmaLinux_OS_8-3.0.0', 'devicesOk': 1, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.1.1-bl_ensure_allow_access_to_bitlocker_protected_fixed_data_drives_from_earlier_versions_of_windows_is_set_to_disabled', 'ruleName': "(BL) Ensure 'Allow access to BitLocker-protected fixed data drives from earlier versions of Windows' is set to 'Disabled'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 2, 'devicesBad': 0, 'devicesRemediable': 0, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-2.2.1-l1_ensure_access_credential_manager_as_a_trusted_caller_is_set_to_no_one', 'ruleName': 'windows_11_stand_alone-4.0.0-2.2.1-l1_ensure_access_credential_manager_as_a_trusted_caller_is_set_to_no_one', 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 2, 'devicesBad': 0, 'devicesRemediable': 0, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.2.1-bl_ensure_allow_enhanced_pins_for_startup_is_set_to_enabled', 'ruleName': "(BL) Ensure 'Allow enhanced PINs for startup' is set to 'Enabled'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 1, 'devicesBad': 1, 'devicesRemediable': 1, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.2.2-bl_ensure_allow_secure_boot_for_integrity_validation_is_set_to_enabled', 'ruleName': "(BL) Ensure 'Allow Secure Boot for integrity validation' is set to 'Enabled'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 1, 'devicesBad': 1, 'devicesRemediable': 1, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.9.33.6.3-bl_ensure_allow_standby_states_s1_s3_when_sleeping_on_battery_is_set_to_disabled', 'ruleName': "(BL) Ensure 'Allow standby states (S1-S3) when sleeping (on battery)' is set to 'Disabled'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.9.33.6.4-bl_ensure_allow_standby_states_s1_s3_when_sleeping_plugged_in_is_set_to_disabled', 'ruleName': "(BL) Ensure 'Allow standby states (S1-S3) when sleeping (plugged in)' is set to 'Disabled'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 2, 'devicesBad': 0, 'devicesRemediable': 0, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.1.3-bl_ensure_choose_how_bitlocker_protected_fixed_drives_can_be_recovered_allow_data_recovery_agent_is_set_to_enabled_true', 'ruleName': "(BL) Ensure 'Choose how BitLocker-protected fixed drives can be recovered: Allow data recovery agent' is set to 'Enabled: True'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.1.2-bl_ensure_choose_how_bitlocker_protected_fixed_drives_can_be_recovered_is_set_to_enabled', 'ruleName': "(BL) Ensure 'Choose how BitLocker-protected fixed drives can be recovered' is set to 'Enabled'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.1.6-bl_ensure_choose_how_bitlocker_protected_fixed_drives_can_be_recovered_omit_recovery_options_from_the_bitlocker_setup_wizard_is_set_to_enabled_true', 'ruleName': "(BL) Ensure 'Choose how BitLocker-protected fixed drives can be recovered: Omit recovery options from the BitLocker setup wizard' is set to 'Enabled: True'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.1.5-bl_ensure_choose_how_bitlocker_protected_fixed_drives_can_be_recovered_recovery_key_is_set_to_enabled_allow_256_bit_recovery_key_or_higher', 'ruleName': "(BL) Ensure 'Choose how BitLocker-protected fixed drives can be recovered: Recovery Key' is set to 'Enabled: Allow 256-bit recovery key' or higher", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 0, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.1.4-bl_ensure_choose_how_bitlocker_protected_fixed_drives_can_be_recovered_recovery_password_is_set_to_enabled_allow_48_digit_recovery_password_or_higher', 'ruleName': "(BL) Ensure 'Choose how BitLocker-protected fixed drives can be recovered: Recovery Password' is set to 'Enabled: Allow 48-digit recovery password' or higher", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 0, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.2.4-bl_ensure_choose_how_bitlocker_protected_operating_system_drives_can_be_recovered_allow_data_recovery_agent_is_set_to_enabled_false', 'ruleName': "(BL) Ensure 'Choose how BitLocker-protected operating system drives can be recovered: Allow data recovery agent' is set to 'Enabled: False'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 1, 'devicesBad': 1, 'devicesRemediable': 1, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.2.3-bl_ensure_choose_how_bitlocker_protected_operating_system_drives_can_be_recovered_is_set_to_enabled', 'ruleName': "(BL) Ensure 'Choose how BitLocker-protected operating system drives can be recovered' is set to 'Enabled'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.2.7-bl_ensure_choose_how_bitlocker_protected_operating_system_drives_can_be_recovered_omit_recovery_options_from_the_bitlocker_setup_wizard_is_set_to_enabled_true', 'ruleName': "(BL) Ensure 'Choose how BitLocker-protected operating system drives can be recovered: Omit recovery options from the BitLocker setup wizard' is set to 'Enabled: True'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.2.6-bl_ensure_choose_how_bitlocker_protected_operating_system_drives_can_be_recovered_recovery_key_is_set_to_enabled_do_not_allow_256_bit_recovery_key', 'ruleName': "(BL) Ensure 'Choose how BitLocker-protected operating system drives can be recovered: Recovery Key' is set to 'Enabled: Do not allow 256-bit recovery key'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.2.5-bl_ensure_choose_how_bitlocker_protected_operating_system_drives_can_be_recovered_recovery_password_is_set_to_enabled_require_48_digit_recovery_password', 'ruleName': "(BL) Ensure 'Choose how BitLocker-protected operating system drives can be recovered: Recovery Password' is set to 'Enabled: Require 48-digit recovery password'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.3.3-bl_ensure_choose_how_bitlocker_protected_removable_drives_can_be_recovered_allow_data_recovery_agent_is_set_to_enabled_true', 'ruleName': "(BL) Ensure 'Choose how BitLocker-protected removable drives can be recovered: Allow data recovery agent' is set to 'Enabled: True'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.3.2-bl_ensure_choose_how_bitlocker_protected_removable_drives_can_be_recovered_is_set_to_enabled', 'ruleName': "(BL) Ensure 'Choose how BitLocker-protected removable drives can be recovered' is set to 'Enabled'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.3.6-bl_ensure_choose_how_bitlocker_protected_removable_drives_can_be_recovered_omit_recovery_options_from_the_bitlocker_setup_wizard_is_set_to_enabled_true', 'ruleName': "(BL) Ensure 'Choose how BitLocker-protected removable drives can be recovered: Omit recovery options from the BitLocker setup wizard' is set to 'Enabled: True'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.3.5-bl_ensure_choose_how_bitlocker_protected_removable_drives_can_be_recovered_recovery_key_is_set_to_enabled_do_not_allow_256_bit_recovery_key', 'ruleName': "(BL) Ensure 'Choose how BitLocker-protected removable drives can be recovered: Recovery Key' is set to 'Enabled: Do not allow 256-bit recovery key'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.3.4-bl_ensure_choose_how_bitlocker_protected_removable_drives_can_be_recovered_recovery_password_is_set_to_enabled_do_not_allow_48_digit_recovery_password', 'ruleName': "(BL) Ensure 'Choose how BitLocker-protected removable drives can be recovered: Recovery Password' is set to 'Enabled: Do not allow 48-digit recovery password'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.1.7-bl_ensure_configure_use_of_hardware_based_encryption_for_fixed_data_drives_is_set_to_disabled', 'ruleName': "(BL) Ensure 'Configure use of hardware-based encryption for fixed data drives' is set to 'Disabled'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.2.8-bl_ensure_configure_use_of_hardware_based_encryption_for_operating_system_drives_is_set_to_disabled', 'ruleName': "(BL) Ensure 'Configure use of hardware-based encryption for operating system drives' is set to 'Disabled'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.3.7-bl_ensure_configure_use_of_hardware_based_encryption_for_removable_data_drives_is_set_to_disabled', 'ruleName': "(BL) Ensure 'Configure use of hardware-based encryption for removable data drives' is set to 'Disabled'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.1.8-bl_ensure_configure_use_of_passwords_for_fixed_data_drives_is_set_to_disabled', 'ruleName': "(BL) Ensure 'Configure use of passwords for fixed data drives' is set to 'Disabled'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-1.1.1-l1_ensure_enforce_password_history_is_set_to_24_or_more_passwords', 'ruleName': 'windows_11_stand_alone-4.0.0-1.1.1-l1_ensure_enforce_password_history_is_set_to_24_or_more_passwords', 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.3.8-bl_ensure_configure_use_of_passwords_for_removable_data_drives_is_set_to_disabled', 'ruleName': "(BL) Ensure 'Configure use of passwords for removable data drives' is set to 'Disabled'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.1.9-bl_ensure_configure_use_of_smart_cards_on_fixed_data_drives_is_set_to_enabled', 'ruleName': "(BL) Ensure 'Configure use of smart cards on fixed data drives' is set to 'Enabled'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.1.10-bl_ensure_configure_use_of_smart_cards_on_fixed_data_drives_require_use_of_smart_cards_on_fixed_data_drives_is_set_to_enabled_true', 'ruleName': "(BL) Ensure 'Configure use of smart cards on fixed data drives: Require use of smart cards on fixed data drives' is set to 'Enabled: True'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.3.9-bl_ensure_configure_use_of_smart_cards_on_removable_data_drives_is_set_to_enabled', 'ruleName': "(BL) Ensure 'Configure use of smart cards on removable data drives' is set to 'Enabled'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.3.10-bl_ensure_configure_use_of_smart_cards_on_removable_data_drives_require_use_of_smart_cards_on_removable_data_drives_is_set_to_enabled_true', 'ruleName': "(BL) Ensure 'Configure use of smart cards on removable data drives: Require use of smart cards on removable data drives' is set to 'Enabled: True'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.3.12-bl_ensure_deny_write_access_to_removable_drives_not_protected_by_bitlocker_do_not_allow_write_access_to_devices_configured_in_another_organization_is_set_to_enabled_false', 'ruleName': "(BL) Ensure 'Deny write access to removable drives not protected by BitLocker: Do not allow write access to devices configured in another organization' is set to 'Enabled: False'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.3.11-bl_ensure_deny_write_access_to_removable_drives_not_protected_by_bitlocker_is_set_to_enabled', 'ruleName': "(BL) Ensure 'Deny write access to removable drives not protected by BitLocker' is set to 'Enabled'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.4-bl_ensure_disable_new_dma_devices_when_this_computer_is_locked_is_set_to_enabled', 'ruleName': "(BL) Ensure 'Disable new DMA devices when this computer is locked' is set to 'Enabled'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.9.24.1-bl_ensure_enumeration_policy_for_external_devices_incompatible_with_kernel_dma_protection_is_set_to_enabled_block_all', 'ruleName': "(BL) Ensure 'Enumeration policy for external devices incompatible with Kernel DMA Protection' is set to 'Enabled: Block All'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-2.3.7.3-bl_ensure_interactive_logon_machine_account_lockout_threshold_is_set_to_10_or_fewer_invalid_logon_attempts_but_not_0', 'ruleName': "(BL) Ensure 'Interactive logon: Machine account lockout threshold' is set to '10 or fewer invalid logon attempts, but not 0'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 0, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.9.7.1.3-bl_ensure_prevent_installation_of_devices_using_drivers_that_match_these_device_setup_classes_also_apply_to_matching_devices_that_are_already_installed._is_set_to_true_checked', 'ruleName': "(BL) Ensure 'Prevent installation of devices using drivers that match these device setup classes: Also apply to matching devices that are already installed.' is set to 'True' (checked)", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.9.7.1.1-bl_ensure_prevent_installation_of_devices_using_drivers_that_match_these_device_setup_classes_is_set_to_enabled', 'ruleName': "(BL) Ensure 'Prevent installation of devices using drivers that match these device setup classes' is set to 'Enabled'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.2.11-bl_ensure_require_additional_authentication_at_startup_allow_bitlocker_without_a_compatible_tpm_is_set_to_enabled_false', 'ruleName': "(BL) Ensure 'Require additional authentication at startup: Allow BitLocker without a compatible TPM' is set to 'Enabled: False'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0},
{'ruleId': 'windows_11_stand_alone-4.0.0-18.10.10.2.10-bl_ensure_require_additional_authentication_at_startup_is_set_to_enabled', 'ruleName': "(BL) Ensure 'Require additional authentication at startup' is set to 'Enabled'", 'policyId': '019bfa51-3577-762b-84ff-64932c7d549f', 'policyName': 'win11-standalone', 'baseBenchmark': 'Windows_11_Stand-alone-4.0.0', 'devicesOk': 0, 'devicesBad': 2, 'devicesRemediable': 2, 'devicesMuted': 0}
].map((r, i) => ({...r, alertsNew: i % 3? 0 : r.devicesBad, repeated: i % 3? r.devicesBad : 0, pending: +!(i % 4), remediatedAlerts: +!(i % 5)})),
'rowCount': 40
});

	mockData.policyDeviceCompliance = req => ({
data: makeArr(req.len ?? PAGE_LEN).map(i => ({
device: `Device ${(req.from ?? 0) + i}`,
deviceId: (req.from ?? 0) + i + 1,
'policyId': 'P-2001',
'policyName': 'Windows Baseline',
'compliant': !!(i % 2),
'remediable': true,
'remediated': false,
'muted': !(i % 7),
'new': !(i % 2) && !(i % 3),
'pending': !(i % 5),
'repeated': !(i % 2) && !!(i % 3),
'addInfo': [
{'and': [{'and': [{'node_result': {'type': 'passwordpolicy_test', 'existence': 'at_least_one_exists', 'object': {'policy_name': 'password_hist_len'}, 'state': {'value': 0, 'value_operation': 'greater than or equal'}}, 'status': 'failed'}]}]},
{
'and': [
{'node_result': {'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'SOFTWARE\\Policies\\Microsoft\\Windows\\NetworkProvider\\HardenedPaths', 'name': '\\\\*\\NETLOGON'}}, 'status': 'failed'},
{'description': 'Evaluation skipped due to short-circuit', 'node_result': {}, 'status': 'skipped'}
]
},
{'and': [{'description': "failed to read registry path 'LOCAL_MACHINE\\SOFTWARE\\Policies\\Microsoft\\Windows Defender\\Policy Manager\\AllowBehaviorMonitoring': Access is denied.", 'node_result': {}, 'status': 'error'}]},
{
'or': [
{'node_result': {'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'Software\\Policies\\Microsoft\\Windows\\DataCollection', 'name': 'AllowTelemetry_PolicyManager'}}, 'status': 'failed'},
{'node_result': {'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'Software\\Policies\\Microsoft\\Windows\\DataCollection', 'name': 'AllowTelemetry_PolicyManager'}}, 'status': 'failed'}
]
},
{'and': [{'node_result': {'type': 'registry_test', 'existence': 'at_least_one_exists', 'object': {'hive': 'HKEY_LOCAL_MACHINE', 'key': 'Software\\Microsoft\\Windows\\CurrentVersion\\Policies\\System', 'name': 'LegalNoticeText'}, 'state': {'type': 'reg_sz', 'value': '', 'value_entity_check': '', 'value_operation': 'pattern match', 'value_type': 'string'}}, 'status': 'failed'}]}
][i % 4]
})),
rowCount: 1000
});

    // Severities-aware (RND-11162): honors the severities param like the real backend; resolved rows carry severity "Passed" ("Resolved" is reserved in the BE).
	mockData.cves = ({severities}: {severities?: string[]} = {}) => {
		const mkCve = (i: number, severity: string, cvss: number, product: string, description: string, devicesBad: number, devicesOk: number) => ({
			topicCode: `CVE-2023-12${34 + i}`,
			description,
			severity,
			cvss,
			product,
			param: `${124 + i}`,
			cisakev: !(i % 3),
			publishDate: '2026-01-29T08:44:09.164Z',
			devicesBad,
			devicesOk,
			repeated: i % 3,
			mutedAlerts: i % 4 ? 0 : 3,
			alertsNew: i % 6 ? 0 : 3,
			remediable: devicesBad,
			hasReversible: true,
		});
		const rows = [
			...makeArr(3).map(i => mkCve(i, 'High', 9.8, '7-Zip (x64)', '7-Zip before 25.01 Does Not Always Properly Handle Symbolic Links During Extraction', 2, 1)),
			...makeArr(2).map(i => mkCve(i + 3, 'Medium', 6.5, 'VLC media player', 'VLC media player heap buffer overflow in MMS parsing', 1, 0)),
			...makeArr(2).map(i => mkCve(i + 5, 'Low', 3.1, 'PuTTY', 'PuTTY terminal escape sequence information disclosure', 1, 0)),
			...makeArr(2).map(i => mkCve(i + 7, 'Passed', 7.5, 'Google Chrome', 'Chrome V8 type confusion - fixed by version update', 0, 1))   // Resolved.
		];
		const data = !severities?.length ? rows : rows.filter(r => severities.includes(r.severity));
		return {severitiesTotal: {High: 3, Medium: 2, Low: 2, Passed: 2}, data, rowCount: data.length};
	};
	mockData.vulnOverview = () => ({
summary: {app: {high: 5, medium: 5, low: 3, kev: 5}, os: {high: 3, medium: 5, low: 5, kev: 2}, devices: {total: 69, high: 31, medium: 22, low: 16}},
topApps: [
{name: 'Microsoft Outlook', high: 4, medium: 2, low: 1, total: 7},
{name: 'Windows SmartScreen', high: 3, medium: 2, low: 0, total: 5},
{name: 'Microsoft Hyper-V', high: 1, medium: 2, low: 1, total: 4},
{name: 'Windows Error Reporting', high: 0, medium: 2, low: 1, total: 3},
{name: 'Windows CLFS', high: 1, medium: 0, low: 1, total: 2}
],
topOs: [
{name: 'Windows Server 2022', high: 2, medium: 2, low: 1, total: 5},
{name: 'Windows 11 21H2', high: 1, medium: 2, low: 1, total: 4},
{name: 'Windows 11 23H2', high: 1, medium: 1, low: 1, total: 3},
{name: 'Windows 10 22H2', high: 0, medium: 1, low: 1, total: 2},
{name: 'Windows Server 2019', high: 1, medium: 0, low: 0, total: 1}
],
recentKev: [
{topicCode: 'CVE-2024-49138', description: 'Windows Common Log File System Driver Elevation of Privilege Vulnerability', param: '49138', benchmarkOrg: 'APP_VULN_ASSESSMENT', product: 'Windows CLFS', cvss: 7.8, severity: 'High', publishDate: '2024-12-10T00:00:00Z'},
{topicCode: 'CVE-2024-38113', description: 'Windows SmartScreen Security Feature Bypass Vulnerability', param: '38113', benchmarkOrg: 'PATCH_VULN_ASSESSMENT', product: 'Windows SmartScreen', cvss: 8.8, severity: 'High', publishDate: '2024-07-09T00:00:00Z'},
{topicCode: 'CVE-2024-26229', description: 'Windows Error Reporting Service Elevation of Privilege Vulnerability', param: '26229', benchmarkOrg: 'APP_VULN_ASSESSMENT', product: 'Windows Error Reporting', cvss: 7.0, severity: 'High', publishDate: '2024-04-09T00:00:00Z'},
{topicCode: 'CVE-2024-21412', description: 'Windows SmartScreen Security Feature Bypass Vulnerability', param: '21412', benchmarkOrg: 'APP_VULN_ASSESSMENT', product: 'Windows SmartScreen', cvss: 8.1, severity: 'High', publishDate: '2024-02-13T00:00:00Z'},
{topicCode: 'CVE-2023-23397', description: 'Microsoft Outlook Elevation of Privilege Vulnerability', param: '23397', benchmarkOrg: 'APP_VULN_ASSESSMENT', product: 'Microsoft Outlook', cvss: 9.8, severity: 'High', publishDate: '2023-03-14T00:00:00Z'}
]
});
    // Severities-aware (RND-11162): each row filters by its own severity; "Passed" rows are the resolved ones.
	mockData.cveDevices = ({severities} = {}) => {
		const rows = [
			{device: 'Device 1', severity: 'High', deviceId: 123, lastScan: '2023-09-25T14:48:00Z', lastConnectedUserName: 'John Doe', alertsTotal: 4, alertsBad: 3, mutedAlerts: 1, alertsNew: 1, alertsOk: 0, remediatedAlerts: 0, pending: 0, remediable: 2, repeated: 1, hasReversible: true},
			{device: 'Device 3', severity: 'Medium', deviceId: 125, lastScan: '2023-09-24T08:30:00Z', lastConnectedUserName: 'Sam Poe', alertsTotal: 1, alertsBad: 1, mutedAlerts: 0, alertsNew: 0, alertsOk: 0, remediatedAlerts: 0, pending: 1, remediable: 1, repeated: 0, hasReversible: true},
			{device: 'Device 2', severity: 'Passed', deviceId: 124, lastScan: '2023-09-26T10:12:00Z', lastConnectedUserName: 'Jane Roe', alertsTotal: 2, alertsBad: 0, mutedAlerts: 0, alertsNew: 0, alertsOk: 1, remediatedAlerts: 2, pending: 0, remediable: 0, repeated: 0, hasReversible: true}   // Resolved - renders green.
		];
		const data = rows.filter(r => !severities?.length || severities.includes(r.severity));
		return {rowCount: data.length, calcState: 0, severitiesTotal: {High: 1, Medium: 1, Low: 0, Passed: 1}, data};
	};
    // Severities-aware (RND-11162): each version filters by its own severity; the updated "Passed" version is the resolved instance.
	mockData.cveAlerts = ({severities} = {}) => {
		const rows = [
			{param: '104', paramExtra: '9.1.0', devices: 2, severity: 'High', alertsBad: 1, badDevices: 1, alertsOk: 0, okDevices: 0, repeated: 2, pending: 2, remediable: 1, remediatedAlerts: 0, remediatedDevices: 0, mutedAlerts: 1, mutedDevices: 1, alertsNew: 0, hasReversible: true},
			{param: '104', paramExtra: '9.0.5', devices: 1, severity: 'Medium', alertsBad: 1, badDevices: 1, alertsOk: 0, okDevices: 0, repeated: 0, pending: 0, remediable: 1, remediatedAlerts: 0, remediatedDevices: 0, mutedAlerts: 0, mutedDevices: 0, alertsNew: 1, hasReversible: true},
			{param: '104', paramExtra: '9.2.0', devices: 2, severity: 'Passed', alertsBad: 0, badDevices: 0, alertsOk: 1, okDevices: 1, repeated: 0, pending: 0, remediable: 0, remediatedAlerts: 2, remediatedDevices: 2, mutedAlerts: 0, mutedDevices: 0, alertsNew: 0, hasReversible: true}   // Resolved (updated version) - renders green.
		];
		const data = rows.filter(r => !severities?.length || severities.includes(r.severity));
		return {data, rowCount: data.length, severitiesTotal: {High: 1, Medium: 1, Low: 0, Passed: 1}};
	};
	mockData.cveAlertInfo = () => ({'data': [{'version': '1.0.2', 'device': 'SERVER2012', 'deviceId': 9116, 'deviceGuid':'5089b6c2-d390-4c92-a630-c7d790e93762', 'severity': ['High'], 'domain': 'domain.gytpol.com', 'computerOu': 'CN=Computers', 'addInfo': '{"NTFS Permissions":"BUILTIN\\\\\\\\Administrators = Allow,FullControl; ..."}', 'os': 'Win Server 2012 R2 Standard', 'ip': 'string', 'mac': '00:1A:2B:3C:4D:5E', 'hwInfo': {'HW_CPU': 'Intel(R) Xeon(R) CPU E5-2690 v2 @ 3.00GHz', 'HW_RAM': '32 GB', 'HW_Model': 'Dell PowerEdge R720'}, 'scanTime': '2025-02-24T08:23:23.240955Z'}]});

	mockData.appControl = () => ({
'data':[
{
'topicCode':'Adobe Systems Inc. | Adobe Reader',
'product':'Adobe Reader',
'vendor':'Adobe Systems Inc.',
'severity':'High',
'categories':[
'Unclassified',
'some large category blabla',
'extra category'
],
'devicesOk':0,
'devicesBad':1,
'remediable':1,
'mutedAlerts':1,
'alertsNew':2,
'remediatedAlerts':2
},
{
'topicCode':'VideoLAN | VLC',
'product':'VLC',
'vendor':'VideoLAN',
'severity':'High',
'categories':['Unclassified'],
'devicesOk':0,
'devicesBad':1,
'remediable':0,
'mutedAlerts':0,
'alertsNew':0,
'remediatedAlerts':3
},
{
'topicCode':'VideoLAN | VLC media player',
'product':'VLC media player',
'vendor':'VideoLAN',
'severity':'High',
'categories':['Unclassified'],
'devicesOk':0,
'devicesBad':1,
'remediable':1,
'mutedAlerts':0,
'alertsNew':0,
'remediatedAlerts':0
},
{'topicCode':'AnyDesk Software GmbH | AnyDesk', 'product':'AnyDesk', 'vendor':'AnyDesk Software GmbH', 'severity':'Low', 'categories':['Remote Desktop Control'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Apple Inc. | Apple Music', 'product':'Apple Music', 'vendor':'Apple Inc.', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | BitLocker Drive Encryption', 'product':'BitLocker Drive Encryption', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Encryption'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Apple Inc. | Calculator', 'product':'Calculator', 'vendor':'Apple Inc.', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Apple Inc. | Calendar', 'product':'Calendar', 'vendor':'Apple Inc.', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{
'topicCode':'The Comet Authors | Comet',
'product':'Comet',
'vendor':'The Comet Authors',
'severity':'Low',
'categories':[
'Antiphishing',
'Browser'
],

'devicesOk':0,
'devicesBad':1,
'remediable':0,
'mutedAlerts':0,
'alertsNew':0,
'remediatedAlerts':0
},
{'topicCode':'Microsoft Corporation | Company Portal', 'product':'Company Portal', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'CrowdStrike, Inc. | CrowdStrike Device Control', 'product':'CrowdStrike Device Control', 'vendor':'CrowdStrike, Inc.', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{
'topicCode':'CrowdStrike, Inc. | CrowdStrike Falcon',
'product':'CrowdStrike Falcon',
'vendor':'CrowdStrike, Inc.',
'severity':'Low',
'categories':[
'Antimalware',
'Firewall',
'Health Agent'
],

'devicesOk':0,
'devicesBad':2,
'remediable':1,
'mutedAlerts':0,
'alertsNew':0,
'remediatedAlerts':0
},
{'topicCode':'CrowdStrike, Inc. | CrowdStrike Firmware Analysis', 'product':'CrowdStrike Firmware Analysis', 'vendor':'CrowdStrike, Inc.', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'CrowdStrike, Inc. | CrowdStrike Sensor Platform', 'product':'CrowdStrike Sensor Platform', 'vendor':'CrowdStrike, Inc.', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'CrowdStrike, Inc. | CrowdStrike Windows Sensor', 'product':'CrowdStrike Windows Sensor', 'vendor':'CrowdStrike, Inc.', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | DiagnosticsHub_CollectionService', 'product':'DiagnosticsHub_CollectionService', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | DirectX', 'product':'DirectX', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Apple Inc. | FaceTime', 'product':'FaceTime', 'vendor':'Apple Inc.', 'severity':'Low', 'categories':['Messenger'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Apple Inc. | FileVault', 'product':'FileVault', 'vendor':'Apple Inc.', 'severity':'Low', 'categories':['Encryption'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Apple Inc. | Find My', 'product':'Find My', 'vendor':'Apple Inc.', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{
'topicCode':'Mozilla Corporation | Firefox',
'product':'Firefox',
'vendor':'Mozilla Corporation',
'severity':'Low',
'categories':[
'Antiphishing',
'Browser'
],

'devicesOk':0,
'devicesBad':1,
'remediable':1,
'mutedAlerts':0,
'alertsNew':0,
'remediatedAlerts':0
},
{'topicCode':'Apple Inc. | Gatekeeper', 'product':'Gatekeeper', 'vendor':'Apple Inc.', 'severity':'Low', 'categories':['Antimalware'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'The Git Development Community | Git', 'product':'Git', 'vendor':'The Git Development Community', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Google Inc. | Go', 'product':'Go', 'vendor':'Google Inc.', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{
'topicCode':'Google Inc. | Google Chrome',
'product':'Google Chrome',
'vendor':'Google Inc.',
'severity':'Low',
'categories':[
'Antiphishing',
'Browser'
],

'devicesOk':0,
'devicesBad':2,
'remediable':2,
'mutedAlerts':0,
'alertsNew':0,
'remediatedAlerts':0
},
{'topicCode':'gytpol | gytpolClient x64', 'product':'gytpolClient x64', 'vendor':'gytpol', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Apple Inc. | iCloud', 'product':'iCloud', 'vendor':'Apple Inc.', 'severity':'Low', 'categories':['Cloud Storage'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft | Kits Configuration Installer', 'product':'Kits Configuration Installer', 'vendor':'Microsoft', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Apple Inc. | Mac OS X Builtin Firewall', 'product':'Mac OS X Builtin Firewall', 'vendor':'Apple Inc.', 'severity':'Low', 'categories':['Firewall'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Apple Inc. | Mail', 'product':'Mail', 'vendor':'Apple Inc.', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Apple Inc. | Maps', 'product':'Maps', 'vendor':'Apple Inc.', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{
'topicCode':'Apple Inc. | Messages',
'product':'Messages',
'vendor':'Apple Inc.',
'severity':'Low',
'categories':[
'Messenger',
'Web Conference'
],

'devicesOk':0,
'devicesBad':1,
'remediable':0,
'mutedAlerts':0,
'alertsNew':0,
'remediatedAlerts':0
},
{'topicCode':'Microsoft Corporation | Microsoft 3D Viewer', 'product':'Microsoft 3D Viewer', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft AutoUpdate', 'product':'Microsoft AutoUpdate', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Patch Management'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{
'topicCode':'Microsoft Corporation | Microsoft Edge',
'product':'Microsoft Edge',
'vendor':'Microsoft Corporation',
'severity':'Low',
'categories':[
'Antiphishing',
'Browser'
],

'devicesOk':0,
'devicesBad':1,
'remediable':2,
'mutedAlerts':0,
'alertsNew':0,
'remediatedAlerts':0
},
{'topicCode':'Microsoft Corporation | Microsoft Edge WebView2 Runtime', 'product':'Microsoft Edge WebView2 Runtime', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft Intune Agent', 'product':'Microsoft Intune Agent', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Patch Management'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft .NET Framework 4', 'product':'Microsoft .NET Framework 4', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft Paint 3D', 'product':'Microsoft Paint 3D', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft Store', 'product':'Microsoft Store', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft Update Health Tools', 'product':'Microsoft Update Health Tools', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft Visual C++ 2015-2022 Redistributable', 'product':'Microsoft Visual C++ 2015-2022 Redistributable', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft Visual C++ 2015-2022 Redistributable (x64) - 14.44.35211', 'product':'Microsoft Visual C++ 2015-2022 Redistributable (x64) - 14.44.35211', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft Visual C++ 2015-2022 Redistributable (x86) - 14.44.35211', 'product':'Microsoft Visual C++ 2015-2022 Redistributable (x86) - 14.44.35211', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft Visual C++ 2022 Minimum Runtime', 'product':'Microsoft Visual C++ 2022 Minimum Runtime', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft Visual C++ 2022 X64 Additional Runtime - 14.44.35211', 'product':'Microsoft Visual C++ 2022 X64 Additional Runtime - 14.44.35211', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft Visual C++ 2022 X64 Debug Runtime - 14.44.35211', 'product':'Microsoft Visual C++ 2022 X64 Debug Runtime - 14.44.35211', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft Visual C++ 2022 X64 Minimum Runtime - 14.44.35211', 'product':'Microsoft Visual C++ 2022 X64 Minimum Runtime - 14.44.35211', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft Visual C++ 2022 X86 Additional Runtime - 14.44.35211', 'product':'Microsoft Visual C++ 2022 X86 Additional Runtime - 14.44.35211', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft Visual C++ 2022 X86 Debug Runtime - 14.44.35211', 'product':'Microsoft Visual C++ 2022 X86 Debug Runtime - 14.44.35211', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft Visual C++ 2022 X86 Minimum Runtime - 14.44.35211', 'product':'Microsoft Visual C++ 2022 X86 Minimum Runtime - 14.44.35211', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft Visual Studio', 'product':'Microsoft Visual Studio', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft Visual Studio Installer', 'product':'Microsoft Visual Studio Installer', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft Visual Studio Setup Configuration', 'product':'Microsoft Visual Studio Setup Configuration', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft Visual Studio Setup WMI Provider', 'product':'Microsoft Visual Studio Setup WMI Provider', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Microsoft XML Parser', 'product':'Microsoft XML Parser', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':2, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Mozilla | Mozilla Firefox (1.0)', 'product':'Mozilla Firefox (1.0)', 'vendor':'Mozilla', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Mozilla | Mozilla Thunderbird (1.0)', 'product':'Mozilla Thunderbird (1.0)', 'vendor':'Mozilla', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Joyent, Inc. | Node.js Current', 'product':'Node.js Current', 'vendor':'Joyent, Inc.', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Notepad', 'product':'Notepad', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':2, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Oracle and/or its affiliates | Oracle VM VirtualBox Guest Additions 7.0.18', 'product':'Oracle VM VirtualBox Guest Additions 7.0.18', 'vendor':'Oracle and/or its affiliates', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'OpenBSD | Packet Filter', 'product':'Packet Filter', 'vendor':'OpenBSD', 'severity':'Low', 'categories':['Firewall'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Paint', 'product':'Paint', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Python Software Foundation | Python 3.14.3', 'product':'Python 3.14.3', 'vendor':'Python Software Foundation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Apple Inc. | QuickTime Player', 'product':'QuickTime Player', 'vendor':'Apple Inc.', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Remedio | Remedio Sensor', 'product':'Remedio Sensor', 'vendor':'Remedio', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Apple Inc. | Reminders', 'product':'Reminders', 'vendor':'Apple Inc.', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Remote Desktop Connection', 'product':'Remote Desktop Connection', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Remote Desktop Control'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Rustup: the Rust toolchain installer', 'product':'Rustup: the Rust toolchain installer', 'vendor':'', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{
'topicCode':'Apple Inc. | Safari',
'product':'Safari',
'vendor':'Apple Inc.',
'severity':'Low',
'categories':[
'Antiphishing',
'Browser'
],

'devicesOk':0,
'devicesBad':1,
'remediable':1,
'mutedAlerts':0,
'alertsNew':0,
'remediatedAlerts':0
},
{'topicCode':'Apple Inc. | Siri', 'product':'Siri', 'vendor':'Apple Inc.', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{
'topicCode':'Skype Technologies S.A. | Skype',
'product':'Skype',
'vendor':'Skype Technologies S.A.',
'severity':'Low',
'categories':[
'Messenger',
'Web Conference'
],

'devicesOk':0,
'devicesBad':1,
'remediable':1,
'mutedAlerts':0,
'alertsNew':0,
'remediatedAlerts':0
},
{
'topicCode':'Slack Technologies, Inc. | Slack',
'product':'Slack',
'vendor':'Slack Technologies, Inc.',
'severity':'Low',
'categories':[
'Messenger',
'Web Conference'
],

'devicesOk':0,
'devicesBad':1,
'remediable':0,
'mutedAlerts':0,
'alertsNew':0,
'remediatedAlerts':0
},
{'topicCode':'Apple Inc. | Software Update', 'product':'Software Update', 'vendor':'Apple Inc.', 'severity':'Low', 'categories':['Patch Management'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Apple Inc. | TextEdit', 'product':'TextEdit', 'vendor':'Apple Inc.', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Apple Inc. | Time Machine', 'product':'Time Machine', 'vendor':'Apple Inc.', 'severity':'Low', 'categories':['Backup'], 'devicesOk':0, 'devicesBad':1, 'remediable':0, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Universal CRT Redistributable', 'product':'Universal CRT Redistributable', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | vcpp_crt.redist.clickonce', 'product':'vcpp_crt.redist.clickonce', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Visual Studio Build Tools 2022 (2)', 'product':'Visual Studio Build Tools 2022 (2)', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'VideoLAN Team | VLC media player 1.0.0', 'product':'VLC media player 1.0.0', 'vendor':'VideoLAN Team', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | vs_communitymsires', 'product':'vs_communitymsires', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | vs_communitysharedmsi', 'product':'vs_communitysharedmsi', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | vs_communityx64msi', 'product':'vs_communityx64msi', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | vs_CoreEditorFonts', 'product':'vs_CoreEditorFonts', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | vs_filehandler_amd64', 'product':'vs_filehandler_amd64', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | vs_filehandler_x86', 'product':'vs_filehandler_x86', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | vs_FileTracker_Singleton', 'product':'vs_FileTracker_Singleton', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | vs_githubprotocolhandlermsi', 'product':'vs_githubprotocolhandlermsi', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | vs_minshellinteropmsi', 'product':'vs_minshellinteropmsi', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | vs_minshellinteropsharedmsi', 'product':'vs_minshellinteropsharedmsi', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | vs_minshellmsi', 'product':'vs_minshellmsi', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | vs_minshellmsires', 'product':'vs_minshellmsires', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | vs_minshellsharedmsi', 'product':'vs_minshellsharedmsi', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | vs_minshellx64msi', 'product':'vs_minshellx64msi', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | VS Script Debugging Common', 'product':'VS Script Debugging Common', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | vs_vswebprotocolselectormsi', 'product':'vs_vswebprotocolselectormsi', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Unclassified'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{
'topicCode':'WhatsApp LLC | WhatsApp',
'product':'WhatsApp',
'vendor':'WhatsApp LLC',
'severity':'Low',
'categories':[
'Messenger',
'Web Conference'
],

'devicesOk':0,
'devicesBad':1,
'remediable':0,
'mutedAlerts':0,
'alertsNew':0,
'remediatedAlerts':0
},
{'topicCode':'Microsoft Corporation | Windows Backup and Restore', 'product':'Windows Backup and Restore', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Backup'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Windows Defender', 'product':'Windows Defender', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Antimalware'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0},
{'topicCode':'Microsoft Corporation | Windows File History', 'product':'Windows File History', 'vendor':'Microsoft Corporation', 'severity':'Low', 'categories':['Backup'], 'devicesOk':0, 'devicesBad':1, 'remediable':1, 'mutedAlerts':0, 'alertsNew':0, 'remediatedAlerts':0}
].map((d, i) => ({...d, 'patchable': i % 3 !== 0})),
'severitiesTotal':{'High':3, 'Medium':0, 'Low':110, 'Uninstalled':0},
'categories':[
'Antimalware',
'Antiphishing',
'Backup',
'Browser',
'Cloud Storage',
'Encryption',
'Firewall',
'Health Agent',
'Messenger',
'Patch Management',
'Remote Desktop Control',
'Unclassified',
'VPN Client',
'Web Conference'
],
'calcState':0,
'cacheTime':'2026-03-15T15:50:45.4009354+00:00',
'rowCount':113
});
	mockData.appControl = (orig => () => {        // inject fake wasNotUsedSince values into the appControl mock so the new "Last Used" column has something to show.
		const now = Date.now();
		const hoursAgo = (h: number) => new Date(now - h * 3600 * 1000).toISOString();
		const daysFromNow = (d: number) => new Date(now + d * 24 * 3600 * 1000).toISOString();
		const samples = [
			hoursAgo(3),                                                 // recent: ~3h ago → "<1d"
			hoursAgo(20),                                                // recent: ~20h ago → "<1d"
			// Both fields are omitempty on the wire, so "no data" is an absent key, not a null.
			'2026-04-25T10:30:00Z',
'2026-03-15T08:00:00Z',
'2025-12-01T12:00:00Z',
'N/A',
undefined
		];
		const eolSamples = [
			daysFromNow(-30),                                            // reached → red icon
			daysFromNow(90),                                             // within 6 months → hourglass icon
			daysFromNow(-400),
daysFromNow(800),
undefined               // reached, far future (ok), no data
		];
		const rsp = orig();
		return {
...rsp,
			data: rsp.data.map((d, i) => ({
				...d,
				wasNotUsedSince: samples[i % samples.length],
				endOfLifeDate: eolSamples[i % eolSamples.length],
				patchable: d.patchable ?? (i % 3 !== 0),                     // "patchable" now rides on the main app-control row (not a separate by-topic call).
				...(i % 20 === 5 && {severity: 'Complied'})                  // ~5% of rows flipped to "Complied".
			}))
};
	})(mockData.appControl);
    // Per-topic lazy stats — return every topic; useFetchTaskStats keys by topicCode and picks only the requested ones.
	mockData.appControlCvesByTopic = req => ({
data: (req.topics ?? []).map(t => ({
topicCode: t,
cves:  [
'CVE-2026-58052',
'CVE-2026-48101',
'CVE-2026-48102',
'CVE-2026-48095',
'CVE-2025-11001'
],
cveCount: 17
}))
});
	mockData.appControlPatchableByTopic = req => ({data: (req.topics ?? []).map(t => ({topicCode: t, patchable: true}))});
	mockData.fieldCategories = () => ([
'Unclassified',
'Browser',
'Storage',
'Productivity',
'Developer',
'Communication',
'Media',
'Archive',
'Security'
]);
	mockData.fieldApiSeverities = () => ({'High': 20, 'Medium': 22, 'Low': 333, 'Uninstalled': 15});
	mockData.appControlInstances = () => ({
rowCount: 4,
calcState: 0,
severitiesTotal: mockData.fieldApiSeverities(),
data: [
{param: '144.0.3719.59', repeated: 0, patchable: true, alertsNew: 1, remediatedAlerts: 0, remediatedDevices: 0, mutedDevices: 0, mutedAlerts: 1, vulnerabilities: 8, severity: 'Medium', alertsBad: 1, alertsOk: 0, badDevices: 45, okDevices: 5, pending: 0, remediable: 0, wasNotUsedSince: new Date(Date.now() - 3 * 3600 * 1000).toISOString(), endOfLifeDate: '2024-01-09T00:00:00Z'},
{'patchable': true, param: '143.0.3650.96', repeated: 0, alertsNew: 0, remediatedAlerts: 1, remediatedDevices: 1, mutedDevices: 0, mutedAlerts: 0, vulnerabilities: 7, severity: 'Low', alertsBad: 0, alertsOk: 1, badDevices: 2, okDevices: 30, pending: 0, remediable: 0, wasNotUsedSince: '2026-03-15T08:00:00Z', endOfLifeDate: '2023-11-14T00:00:00Z'},
{'patchable': false, param: '143.0.3650.66', repeated: 1, alertsNew: 0, remediatedAlerts: 0, remediatedDevices: 0, mutedDevices: 0, mutedAlerts: 0, vulnerabilities: 3, severity: 'Low', alertsBad: 0, alertsOk: 1, badDevices: 5, okDevices: 10, pending: 0, remediable: 0, wasNotUsedSince: '2025-12-01T12:00:00Z'},
{'patchable': false, param: '142.0.3595.136', repeated: 0, alertsNew: 1, remediatedAlerts: 1, remediatedDevices: 2, mutedDevices: 0, mutedAlerts: 0, vulnerabilities: 0, severity: 'High', alertsBad: 100, alertsOk: 13, badDevices: 0, okDevices: 0, pending: 0, remediable: 0, endOfLifeDate: '2023-09-19T00:00:00Z'}
]
});
	mockData.appControlOverview = () => ({
calcState: 0,
		cacheTime: new Date(Date.now() - 12 * 3600 * 1000).toISOString(),
		kpis: {applications: 2310, vendors: 263, critical: 51, medium: 1},
		categories: [
{name: 'Developer', count: 512},
{name: 'Productivity', count: 52},
{name: 'Remote Desktop Control', count: 35},
{name: 'Storage', count: 22},
{name: 'Utilities', count: 21},
{name: 'Other', count: 1693}
],
		eol: {expired: 151, within90Days: 1, within6Months: 66, healthy: 174, unknown: 1918},
		lastUsed: {active: 287, over30Days: 64, over60Days: 11, over90Days: 1, over120Days: 1, over180Days: 1, noData: 1959}, // Lists mirror a representative slice of the real BE (~top 50, ungrouped version/arch variants) so the UI collapse -> top 10 is exercised.
		rareApps: {
total: 2310,
items: [
{topicCode: 'Igor Pavlov | 7-Zip 22.01 (x64)', product: '7-Zip 22.01 (x64)', vendor: 'Igor Pavlov', installDevices: 1},
{topicCode: 'Igor Pavlov | 7-Zip 24.05 (x64)', product: '7-Zip 24.05 (x64)', vendor: 'Igor Pavlov', installDevices: 1},
{topicCode: 'Igor Pavlov | 7-Zip 26.00 (x64)', product: '7-Zip 26.00 (x64)', vendor: 'Igor Pavlov', installDevices: 1},
{topicCode: 'Igor Pavlov | 7-Zip 26.01 (x64)', product: '7-Zip 26.01 (x64)', vendor: 'Igor Pavlov', installDevices: 1},
{topicCode: 'Igor Pavlov | 7-Zip 4.65 (x64 edition)', product: '7-Zip 4.65 (x64 edition)', vendor: 'Igor Pavlov', installDevices: 1},
{topicCode: 'Microsoft Corporation | AD LDS Instance iSiteDirectoryService', product: 'AD LDS Instance iSiteDirectoryService', vendor: 'Microsoft Corporation', installDevices: 1},
{topicCode: 'Amazon Web Services | AWS Command Line Interface v2', product: 'AWS Command Line Interface v2', vendor: 'Amazon Web Services', installDevices: 1},
{topicCode: 'Microsoft | Accessibility Insights For Windows v1.1', product: 'Accessibility Insights For Windows v1.1', vendor: 'Microsoft', installDevices: 1},
{topicCode: 'ActiveState | ActivePerl', product: 'ActivePerl', vendor: 'ActiveState', installDevices: 1},
{topicCode: 'Microsoft | AdlCopy', product: 'AdlCopy', vendor: 'Microsoft', installDevices: 1},
{topicCode: 'Adobe | Adobe Acrobat DC (64-bit)', product: 'Adobe Acrobat DC (64-bit)', vendor: 'Adobe', installDevices: 1},
{topicCode: 'Adobe Systems Inc. | Adobe Acrobat DC Continuous', product: 'Adobe Acrobat DC Continuous', vendor: 'Adobe Systems Inc.', installDevices: 1},
{topicCode: 'Adobe Systems Inc. | Adobe Creative Cloud', product: 'Adobe Creative Cloud', vendor: 'Adobe Systems Inc.', installDevices: 1},
{topicCode: 'AdoptOpenJDK | AdoptOpenJDK JRE 8', product: 'AdoptOpenJDK JRE 8', vendor: 'AdoptOpenJDK', installDevices: 1},
{topicCode: 'AdoptOpenJDK | AdoptOpenJDK JRE with Hotspot 8u292-b10 (x64)', product: 'AdoptOpenJDK JRE with Hotspot 8u292-b10 (x64)', vendor: 'AdoptOpenJDK', installDevices: 1},
{topicCode: 'The Apache Software Foundation | Apache Tomcat 11.0 Tomcat11 (remove only)', product: 'Apache Tomcat 11.0 Tomcat11 (remove only)', vendor: 'The Apache Software Foundation', installDevices: 1},
{topicCode: 'Microsoft Corporation | Application Verifier (x64)', product: 'Application Verifier (x64)', vendor: 'Microsoft Corporation', installDevices: 1},
{topicCode: 'GitHub, Inc. | Atom', product: 'Atom', vendor: 'GitHub, Inc.', installDevices: 1},
{topicCode: 'Audacity Team | Audacity 3.2.5', product: 'Audacity 3.2.5', vendor: 'Audacity Team', installDevices: 1},
{topicCode: 'Audacity Team | Audacity 3.7.3', product: 'Audacity 3.7.3', vendor: 'Audacity Team', installDevices: 1},
{topicCode: 'Audacity Team | Audacity 3.7.6', product: 'Audacity 3.7.6', vendor: 'Audacity Team', installDevices: 1},
{topicCode: 'Azul Systems, Inc. | Azul Zulu JDK 21', product: 'Azul Zulu JDK 21', vendor: 'Azul Systems, Inc.', installDevices: 1},
{topicCode: 'Azul Systems, Inc. | Azul Zulu JDK 21.42.19 (21.0.7), 64-bit', product: 'Azul Zulu JDK 21.42.19 (21.0.7), 64-bit', vendor: 'Azul Systems, Inc.', installDevices: 1},
{topicCode: 'Apple Inc. | Safari', product: 'Safari', vendor: 'Apple Inc.', installDevices: 1},
{topicCode: 'Apple, Inc. | Numbers', product: 'Numbers', vendor: 'Apple, Inc.', installDevices: 1},
{topicCode: 'Apple | Keynote', product: 'Keynote', vendor: 'Apple', installDevices: 1},
{topicCode: 'Apple Inc. | Xcode', product: 'Xcode', vendor: 'Apple Inc.', installDevices: 1},
{topicCode: 'Brave Software Inc. | Brave', product: 'Brave', vendor: 'Brave Software Inc.', installDevices: 1}
]
},
		eolApps: {
expired: 151,
within90Days: 1,
items: [
{topicCode: 'Microsoft Corporation | Microsoft .NET Framework 4 Multi-Targeting Pack', product: 'Microsoft .NET Framework 4 Multi-Targeting Pack', vendor: 'Microsoft Corporation', endOfLifeDate: '2016-01-12T00:00:00Z'},
{topicCode: 'Microsoft Corporation | Microsoft .NET Framework 4.5 Multi-Targeting Pack', product: 'Microsoft .NET Framework 4.5 Multi-Targeting Pack', vendor: 'Microsoft Corporation', endOfLifeDate: '2016-01-12T00:00:00Z'},
{topicCode: 'Microsoft Corporation | Microsoft .NET Framework 4.5.1 Multi-Targeting Pack', product: 'Microsoft .NET Framework 4.5.1 Multi-Targeting Pack', vendor: 'Microsoft Corporation', endOfLifeDate: '2016-01-12T00:00:00Z'},
{topicCode: 'Microsoft Corporation | Microsoft .NET Framework 4.5.1 Multi-Targeting Pack (ENU)', product: 'Microsoft .NET Framework 4.5.1 Multi-Targeting Pack (ENU)', vendor: 'Microsoft Corporation', endOfLifeDate: '2016-01-12T00:00:00Z'},
{topicCode: 'Microsoft Corporation | Microsoft .NET Framework 4.5.1 SDK', product: 'Microsoft .NET Framework 4.5.1 SDK', vendor: 'Microsoft Corporation', endOfLifeDate: '2016-01-12T00:00:00Z'},
{topicCode: 'Microsoft Corporation | Microsoft Office Shared MUI (English) 2007', product: 'Microsoft Office Shared MUI (English) 2007', vendor: 'Microsoft Corporation', endOfLifeDate: '2017-10-10T00:00:00Z'},
{topicCode: 'Microsoft Corporation | Microsoft Office Visual Web Developer 2007', product: 'Microsoft Office Visual Web Developer 2007', vendor: 'Microsoft Corporation', endOfLifeDate: '2017-10-10T00:00:00Z'},
{topicCode: 'Microsoft Corporation | Microsoft .NET Core 5.0 SDK', product: 'Microsoft .NET Core 5.0 SDK', vendor: 'Microsoft Corporation', endOfLifeDate: '2019-06-27T00:00:00Z'},
{topicCode: 'Microsoft Corporation | Microsoft .NET Version Manager (x64) 1.0.0-rc1', product: 'Microsoft .NET Version Manager (x64) 1.0.0-rc1', vendor: 'Microsoft Corporation', endOfLifeDate: '2019-06-27T00:00:00Z'},
{topicCode: 'OpenSSL Software Foundation Inc | OpenSSL', product: 'OpenSSL', vendor: 'OpenSSL Software Foundation Inc', endOfLifeDate: '2019-12-31T00:00:00Z'},
{topicCode: 'Python Software Foundation | Python 2.7', product: 'Python 2.7', vendor: 'Python Software Foundation', endOfLifeDate: '2020-01-01T00:00:00Z'},
{topicCode: 'Python Software Foundation | Python 2.7.18 (64-bit)', product: 'Python 2.7.18 (64-bit)', vendor: 'Python Software Foundation', endOfLifeDate: '2020-01-01T00:00:00Z'},
{topicCode: 'Microsoft Corporation | Microsoft Access Database Engine 2010', product: 'Microsoft Access Database Engine 2010', vendor: 'Microsoft Corporation', endOfLifeDate: '2020-10-13T00:00:00Z'},
{topicCode: 'Notepad++ Team | Notepad++', product: 'Notepad++', vendor: 'Notepad++ Team', endOfLifeDate: '2021-06-17T00:00:00Z'},
{topicCode: 'Notepad++ Team | Notepad++ (64-bit x64)', product: 'Notepad++ (64-bit x64)', vendor: 'Notepad++ Team', endOfLifeDate: '2021-06-17T00:00:00Z'},
{topicCode: 'The Wireshark developer community | Wireshark', product: 'Wireshark', vendor: 'The Wireshark developer community', endOfLifeDate: '2021-11-22T00:00:00Z'},
{topicCode: 'Oracle Corporation | Java', product: 'Java', vendor: 'Oracle Corporation', endOfLifeDate: '2022-03-31T00:00:00Z'},
{topicCode: 'Microsoft Corporation | Microsoft .NET Framework 4.6 SDK', product: 'Microsoft .NET Framework 4.6 SDK', vendor: 'Microsoft Corporation', endOfLifeDate: '2022-04-26T00:00:00Z'},
{topicCode: 'Microsoft Corporation | Microsoft .NET Framework 4.6.1 Developer Pack', product: 'Microsoft .NET Framework 4.6.1 Developer Pack', vendor: 'Microsoft Corporation', endOfLifeDate: '2022-04-26T00:00:00Z'},
{topicCode: 'Microsoft Corporation | Microsoft .NET Framework 4.6.2 SDK', product: 'Microsoft .NET Framework 4.6.2 SDK', vendor: 'Microsoft Corporation', endOfLifeDate: '2022-04-26T00:00:00Z'},
{topicCode: 'Microsoft Corporation | Microsoft Visual C++ 2012 x64 Additional Runtime - 11.0.51106', product: 'Microsoft Visual C++ 2012 x64 Additional Runtime - 11.0.51106', vendor: 'Microsoft Corporation', endOfLifeDate: '2023-01-10T00:00:00Z'},
{topicCode: 'Microsoft Corporation | Microsoft Visual C++ 2012 x64 Minimum Runtime - 11.0.51106', product: 'Microsoft Visual C++ 2012 x64 Minimum Runtime - 11.0.51106', vendor: 'Microsoft Corporation', endOfLifeDate: '2023-01-10T00:00:00Z'}
]
},
		unusedApps: {
unusedOver90Days: 1,
items: [
{topicCode: 'Omnissa | Omnissa Horizon Agent', product: 'Omnissa Horizon Agent', vendor: 'Omnissa', wasNotUsedSince: '2026-01-13T09:37:48Z'},
{topicCode: 'Unity Technologies Inc. | Unity Hub 2.4.4', product: 'Unity Hub 2.4.4', vendor: 'Unity Technologies Inc.', wasNotUsedSince: '2026-05-18T11:48:43Z'},
{topicCode: 'Citrix Systems, Inc. | Citrix Web Helper', product: 'Citrix Web Helper', vendor: 'Citrix Systems, Inc.', wasNotUsedSince: '2026-05-18T15:28:52Z'},
{topicCode: 'Nuance Communications Inc. | Dragon Medical Practice Edition', product: 'Dragon Medical Practice Edition', vendor: 'Nuance Communications Inc.', wasNotUsedSince: '2026-05-19T06:36:50Z'},
{topicCode: 'Scooter Software | Beyond Compare 5.0.6', product: 'Beyond Compare 5.0.6', vendor: 'Scooter Software', wasNotUsedSince: '2026-05-24T19:14:41Z'},
{topicCode: 'Python Software Foundation | Python 3.13.7 pip Bootstrap (64-bit)', product: 'Python 3.13.7 pip Bootstrap (64-bit)', vendor: 'Python Software Foundation', wasNotUsedSince: '2026-05-26T20:25:57Z'},
{topicCode: 'Python Software Foundation | Python 3.8.0 pip Bootstrap (64-bit)', product: 'Python 3.8.0 pip Bootstrap (64-bit)', vendor: 'Python Software Foundation', wasNotUsedSince: '2026-05-26T20:25:57Z'},
{topicCode: 'Python Software Foundation | Python 3.12.10 pip Bootstrap (64-bit)', product: 'Python 3.12.10 pip Bootstrap (64-bit)', vendor: 'Python Software Foundation', wasNotUsedSince: '2026-05-26T20:28:41Z'},
{topicCode: 'Python Software Foundation | Python 3.13.3 pip Bootstrap (64-bit)', product: 'Python 3.13.3 pip Bootstrap (64-bit)', vendor: 'Python Software Foundation', wasNotUsedSince: '2026-05-27T15:33:06Z'},
{topicCode: 'JetBrains s.r.o. | IntelliJ IDEA Community Edition 2024.3.4.1', product: 'IntelliJ IDEA Community Edition 2024.3.4.1', vendor: 'JetBrains s.r.o.', wasNotUsedSince: '2026-05-31T21:29:41Z'},
{topicCode: 'The Git Development Community | Git', product: 'Git', vendor: 'The Git Development Community', wasNotUsedSince: '2026-06-01T21:36:15Z'},
{topicCode: 'Adobe Systems Inc. | Adobe Acrobat DC Continuous', product: 'Adobe Acrobat DC Continuous', vendor: 'Adobe Systems Inc.', wasNotUsedSince: '2026-06-05T00:02:46Z'},
{topicCode: 'Alexander Roshal | WinRAR', product: 'WinRAR', vendor: 'Alexander Roshal', wasNotUsedSince: '2026-06-10T20:11:33Z'},
{topicCode: 'win.rar GmbH | WinRAR 7.20 (64-bit)', product: 'WinRAR 7.20 (64-bit)', vendor: 'win.rar GmbH', wasNotUsedSince: '2026-06-10T20:11:33Z'},
{topicCode: 'The Audacity Team | Audacity', product: 'Audacity', vendor: 'The Audacity Team', wasNotUsedSince: '2026-06-12T04:15:01Z'},
{topicCode: 'Audacity Team | Audacity 3.7.7', product: 'Audacity 3.7.7', vendor: 'Audacity Team', wasNotUsedSince: '2026-06-12T04:15:01Z'},
{topicCode: 'Microsoft Corporation | Microsoft Power BI Desktop', product: 'Microsoft Power BI Desktop', vendor: 'Microsoft Corporation', wasNotUsedSince: '2026-06-12T04:15:01Z'},
{topicCode: 'Martin Prikryl | WinSCP', product: 'WinSCP', vendor: 'Martin Prikryl', wasNotUsedSince: '2026-06-12T14:11:06Z'},
{topicCode: 'JetBrains s.r.o. | PhpStorm 2025.2.4', product: 'PhpStorm 2025.2.4', vendor: 'JetBrains s.r.o.', wasNotUsedSince: '2026-06-14T17:35:33Z'},
{topicCode: 'JetBrains s.r.o. | PhpStorm 2026.1.3', product: 'PhpStorm 2026.1.3', vendor: 'JetBrains s.r.o.', wasNotUsedSince: '2026-06-14T17:35:33Z'},
{topicCode: 'Igor Pavlov | 7-Zip', product: '7-Zip', vendor: 'Igor Pavlov', wasNotUsedSince: '2026-06-18T21:15:19Z'},
{topicCode: 'Docker, Inc. | Docker Desktop', product: 'Docker Desktop', vendor: 'Docker, Inc.', wasNotUsedSince: '2026-06-21T14:31:06Z'},
{topicCode: 'Docker, Inc. | Docker Engine', product: 'Docker Engine', vendor: 'Docker, Inc.', wasNotUsedSince: '2026-06-21T14:31:06Z'},
{topicCode: 'Notepad++ Team | Notepad++', product: 'Notepad++', vendor: 'Notepad++ Team', wasNotUsedSince: '2026-06-22T15:24:27Z'}
]
}
});
	mockData.appControlDevices = () => ({
'rowCount': 4,
'calcState': 0,
severitiesTotal: mockData.fieldApiSeverities(),
'data': [
{'severity': 'High', 'device': 'WIN-11', 'deviceId': 1, 'alertsBad': 1, 'alertsOk': 0, 'lastScan': '2026-02-16T15:07:49Z', 'repeated': 0, 'pending': 0, 'remediable': 0, 'remediatedAlerts': 0, 'mutedAlerts': 1, 'alertsNew': 1, 'lastConnectedUserName': 'WIN-10\\vboxuser', 'wasNotUsedSince': new Date(Date.now() - 3 * 3600 * 1000).toISOString()},
{'severity': 'Passed', 'device': 'WIN-10', 'deviceId': 2, 'alertsBad': 0, 'alertsOk': 1, 'lastScan': '2026-02-15T10:22:00Z', 'repeated': 0, 'pending': 0, 'remediable': 0, 'remediatedAlerts': 1, 'mutedAlerts': 0, 'alertsNew': 0, 'lastConnectedUserName': 'WIN-10\\admin', 'wasNotUsedSince': '2026-03-15T08:00:00Z'},
{'severity': 'Passed', 'device': 'MAC-OS', 'deviceId': 3, 'alertsBad': 0, 'alertsOk': 1, 'lastScan': '2026-01-30T09:00:00Z', 'repeated': 0, 'pending': 0, 'remediable': 0, 'remediatedAlerts': 0, 'mutedAlerts': 0, 'alertsNew': 0, 'lastConnectedUserName': 'macuser', 'wasNotUsedSince': '2025-12-01T12:00:00Z'},
{'severity': 'Passed', 'device': 'LINUX-01', 'deviceId': 4, 'alertsBad': 0, 'alertsOk': 1, 'lastScan': '2026-02-10T11:11:00Z', 'repeated': 0, 'pending': 0, 'remediable': 0, 'remediatedAlerts': 0, 'mutedAlerts': 0, 'alertsNew': 0, 'lastConnectedUserName': 'root'}
]
});

	// Sample Microsoft "known issues" for a patch (mirrors the DemoOverlays sample so dev and demo read the same).
	const patchKnownIssuesSample = [
		{title: 'Some devices might fail to shut down or hibernate', description: "This issue affects some Secure Launch-capable PCs with Virtual Secure Mode enabled after installing Jan '26 updates.", osBuild: 'OS Build 20348.4648', originatingKb: 'KB5073457', originatingDate: '2026-01-13', status: 'Resolved', resolvedKb: 'KB5075906', resolvedDate: '2026-02-10 10:00 PT'},
		{title: 'Apps might become unresponsive when saving files to cloud-backed storage', description: 'Affected apps include Outlook, which can become unresponsive when accessing PST files stored on Microsoft OneDrive.', osBuild: 'OS Build 20348.4648', originatingKb: 'KB5073457', originatingDate: '2026-01-13', status: 'Resolved', resolvedKb: 'KB5078136', resolvedDate: '2026-01-23 14:00 PT'},
		{title: 'Connection and authentication failures in Azure Virtual Desktop and Windows 365', description: 'January 2026 Windows update causes Windows App credential prompt failures on Azure Virtual Desktop and Windows 365.', osBuild: 'OS Build 20348.4648', originatingKb: 'KB5073457', originatingDate: '2026-01-13', status: 'Resolved', resolvedKb: 'KB5077800', resolvedDate: '2026-01-17 14:00 PT'}
	];

    // Param-aware: the overview Top-5 card queries with osFamily (incl. the cross-OS "Applications" bucket) and categoriesInclude.
	mockData.patchManagement = (req = {}) => ({
		rowCount: req.publishedEnd
			? Math.round(2043 * Math.max(0.05, 0.6 - (Date.now() - new Date(req.publishedEnd).getTime()) / MS_DAY * 0.005))
			: 2043,
		categories: {
			'All': 2031,
			'Critical Updates': 4,
			'Definition Updates': 3,
			'Feature Packs': 1,
			'Security Updates': 28,
			'Update Rollups': 1,
			'Updates': 383
		},
		data: [
			{
topicCode: 'KB5066131',
title: 'KB5066131',
version: '1234',
severity: 'Critical',
cves: ['CVE-2025-55248'],
cveCount: 1,
os: [
'Win 11 Enterprise',
'Win Server 2025 Datacenter'
],
osFamily: 'Windows',
description: '2025-10 Cumulative Update for .NET Framework 3.5 and 4.8.1 for Microsoft server operating system version 24H2 for x64 (KB5066131)',
category: 'Security Updates',
source: 'WSUS or Configuration Manager',
rebootRequired: true,
publishDate: '2025-10-14T00:00:00Z',
devicesOk: 16,
devicesBad: 3,
mutedAlerts: 2,
patchable: true,
hasReversible: true
},
			{topicCode: 'KB5066136', title: 'KB5066136', version: '', severity: 'Critical', cves: ['CVE-2025-55248'], cveCount: 1, os: ['Win Server 2016 Datacenter'], osFamily: 'Windows', description: '2025-10 Cumulative Update for .NET Framework 4.8 for Windows Server 2016 for x64 (KB5066136)', category: 'Security Updates', source: 'Windows Update', rebootRequired: true, publishDate: '2025-10-13T00:00:00Z', devicesOk: 0, devicesBad: 3, knownIssues: patchKnownIssuesSample, mutedAlerts: 0, patchable: true, hasReversible: false},
			{topicCode: 'KB5066738', title: 'KB5066738', version: '', severity: 'Critical', cves: ['CVE-2025-55248'], cveCount: 1, os: ['Win Server 2019 Datacenter'], osFamily: 'Macos', description: '2025-10 Cumulative Update for .NET Framework 3.5 and 4.7.2 for Windows 10 Version 1809 for ARM64 (KB5066738)', category: 'Security Updates', source: 'Apple Software Update', rebootRequired: true, publishDate: '2025-10-13T00:00:00Z', devicesOk: 0, devicesBad: 7, mutedAlerts: 5, patchable: false, hasReversible: true},
			{topicCode: 'KB5066743', title: 'KB5066743', version: '', severity: 'Critical', cves: ['CVE-2025-55248'], cveCount: 1, os: ['Win Server 2022 Datacenter'], osFamily: 'Windows', description: '2025-10 Cumulative Update for .NET Framework 3.5, 4.8 and 4.8.1 for Microsoft server operating system version 21H2 for x64 (KB5066743)', category: 'Security Updates', source: 'Microsoft Update', rebootRequired: true, publishDate: '2025-10-13T00:00:00Z', devicesOk: 0, devicesBad: 3, knownIssues: [patchKnownIssuesSample[0]], mutedAlerts: 0, patchable: true},
			{topicCode: 'KB5075902', title: 'KB5075902', version: '', severity: 'Critical', cves: [], cveCount: 0, os: ['Win Server 2016 Datacenter'], osFamily: 'Windows', description: '2026-02 Servicing Stack Update for Windows Server 2016 for x64-based Systems (KB5075902)', category: 'Security Updates', source: 'WSUS or Configuration Manager', rebootRequired: true, publishDate: '2026-02-09T00:00:00Z', devicesOk: 0, devicesBad: 3, mutedAlerts: 0, patchable: true},
			{
topicCode: 'KB5078740',
title: 'KB5078740',
version: '',
severity: 'Critical',
cves: [
'CVE-2026-26132',
'CVE-2026-26128',
'CVE-2026-26111',
'CVE-2026-25190',
'CVE-2026-25188'
],
cveCount: 39,
os: ['Win Server 2025 Datacenter'],
osFamily: 'Windows',
description: '2026-03 Cumulative Update for Microsoft server operating system version 24H2 for x64-based Systems (KB5078740) (26100.32522)',
category: 'Security Updates',
source: 'Windows Update',
rebootRequired: true,
publishDate: '2026-03-10T00:00:00Z',
devicesOk: 0,
devicesBad: 3,
mutedAlerts: 12,
patchable: true
},
			{
topicCode: 'KB5078752',
title: 'KB5078752',
version: '',
severity: 'Critical',
cves: [
'CVE-2026-26128',
'CVE-2026-26111',
'CVE-2026-25189',
'CVE-2026-25190',
'CVE-2026-25188'
],
cveCount: 41,
os: ['Win Server 2019 Datacenter'],
osFamily: 'Windows',
description: '',
category: '',
source: 'WSUS or Configuration Manager',
devicesOk: 0,
devicesBad: 7,
mutedAlerts: 0,
patchable: true
},
			{
topicCode: 'KB5078766',
title: 'KB5078766',
version: '',
severity: 'Critical',
cves: [
'CVE-2026-26132',
'CVE-2026-26128',
'CVE-2026-26111',
'CVE-2026-25190',
'CVE-2026-25189'
],
cveCount: 41,
os: ['Win Server 2022 Datacenter'],
osFamily: 'Windows',
description: '2026-03 Cumulative Update for Microsoft server operating system version 21H2 for x64-based Systems (KB5078766)',
category: 'Security Updates',
source: 'Windows Update',
rebootRequired: true,
publishDate: '2026-03-09T00:00:00Z',
devicesOk: 0,
devicesBad: 3,
mutedAlerts: 0,
patchable: true
},
			{
topicCode: 'KB5078938',
title: 'KB5078938',
version: '',
severity: 'Critical',
cves: [
'CVE-2026-26128',
'CVE-2026-26111',
'CVE-2026-25190',
'CVE-2026-25188',
'CVE-2026-25187'
],
cveCount: 36,
os: ['Win Server 2016 Datacenter'],
osFamily: 'Windows',
description: '',
category: '',
source: 'Microsoft Update',
devicesOk: 0,
devicesBad: 3,
mutedAlerts: 0,
patchable: true
},
			{topicCode: 'snapd', title: 'snapd 2.74.1', version: '2.74.1', severity: 'Medium', cves: ['CVE-2019-11840'], cveCount: 1, os: ['Ubuntu 20.04'], osFamily: 'Linux', description: 'Vi IMproved - Common files\n Vim is an almost compatible version of the UNIX editor Vi.\n .\n This package contains files shared by all non GUI-enabled vim variants\n available in Debian.  Examples of such shared files are: manpages and\n configuration files.', category: 'Security Updates', source: 'Snap', rebootRequired: false, publishDate: '2026-06-15T00:00:00Z', devicesOk: 0, devicesBad: 94, mutedAlerts: 2, patchable: false},
			{topicCode: 'binutils', title: 'binutils 2.27-44.base.el7_9.1', version: '2.27-44.base.el7_9.1', severity: 'Low', cves: [], cveCount: 0, os: ['Redhat 7.9'], osFamily: 'Linux', description: 'Binutils is a collection of binary utilities, including ar (for\ncreating, modifying and extracting from archives), as (a family of GNU\nassemblers), gprof (for displaying call graph profile data), ld (the\nGNU linker), nm (for listing symbols from object files), objcopy (for\ncopying and translating object files), objdump (for displaying\ninformation from object files), ranlib (for generating an index for\nthe contents of an archive), readelf (for displaying detailed\ninformation about binary files), size (for listing the section sizes\nof an object or archive file), strings (for listing printable strings\nfrom files), strip (for discarding symbols), and addr2line (for\nconverting addresses to file and line).', category: 'Updates', source: 'YUM', rebootRequired: false, devicesOk: 0, devicesBad: 104, mutedAlerts: 0, patchable: false},
			{topicCode: 'KB5062554', title: 'KB5062554', version: '', severity: 'Complied', cves: ['CVE-2025-47981'], cveCount: 1, os: ['Win 11 Enterprise'], osFamily: 'Windows', description: '2026-07 Cumulative Update for Windows 11 Version 23H2 for x64-based Systems (KB5062554)', category: 'Security Updates', source: 'Windows Update', rebootRequired: true, publishDate: '2026-07-08T00:00:00Z', devicesOk: 42, devicesBad: 0, mutedAlerts: 0, patchable: false},
            // App patches — the cross-OS "Applications" bucket on the overview (osFamily is the bucket; the os column keeps the real OSes). Device counts match the dashboard mock's Applications breakdown. Phase 3 patches Windows OS only, so app rows stay visibility-only (patchable: false).
			{
topicCode: 'Google Chrome',
title: 'Google Chrome',
productName: 'Google Chrome',
vendor: 'Google Inc.',
version: '138.0.7204.97',
severity: 'Critical',
cves: [
'CVE-2026-6558',
'CVE-2026-6601',
'CVE-2026-6603'
],
cveCount: 7,
os: [
'Win 11 Enterprise',
'macOS 15.2'
],
osFamily: 'Applications',
description: 'Update Google Chrome to 138.0.7204.97 — fixes 7 vulnerabilities including a V8 type confusion exploited in the wild.',
category: 'Multimedia',
source: 'Vendor',
rebootRequired: false,
publishDate: '2026-06-24T00:00:00Z',
devicesOk: 779,
devicesBad: 92,
mutedAlerts: 4,
patchable: false
},
			{
topicCode: 'Microsoft Edge',
title: 'Microsoft Edge',
productName: 'Microsoft Edge',
vendor: 'Microsoft Corporation',
version: '137.0.3296.62',
severity: 'Critical',
cves: [
'CVE-2026-6710',
'CVE-2026-6712'
],
cveCount: 3,
os: [
'Win 10 Enterprise',
'Win 11 Enterprise'
],
osFamily: 'Applications',
description: 'Update Microsoft Edge to 137.0.3296.62 — inherited Chromium security fixes.',
category: 'Productivity',
source: 'Vendor',
rebootRequired: false,
publishDate: '2026-06-26T00:00:00Z',
devicesOk: 1231,
devicesBad: 1,
mutedAlerts: 0,
patchable: false
},
			{
topicCode: 'Claude Desktop',
title: 'Claude Desktop',
productName: 'Claude Desktop',
vendor: 'Anthropic',
version: '1.8.2',
severity: 'Medium',
cves: [],
cveCount: 0,
os: [
'Win 11 Enterprise',
'macOS 15.2'
],
osFamily: 'Applications',
description: 'Update Claude Desktop to 1.8.2 — Electron runtime security update.',
category: 'Application Updates',
source: 'Vendor',
rebootRequired: false,
publishDate: '2026-06-18T00:00:00Z',
devicesOk: 12,
devicesBad: 45,
mutedAlerts: 0,
patchable: false
},
			{
topicCode: 'Notepad++',
title: 'Notepad++',
productName: 'Notepad++',
vendor: 'Notepad++ Team',
version: '8.8.5',
severity: 'Medium',
cves: ['CVE-2025-49144'],
cveCount: 1,
os: [
'Win 10 Enterprise',
'Win 11 Enterprise'
],
osFamily: 'Applications',
description: 'Update Notepad++ to 8.8.5 — fixes installer binary-planting privilege escalation.',
category: 'Utilities',
source: 'Vendor',
rebootRequired: false,
publishDate: '2026-06-10T00:00:00Z',
devicesOk: 1010,
devicesBad: 0,
mutedAlerts: 0,
patchable: false
},
			{
topicCode: 'Python',
title: 'Python',
productName: 'Python',
vendor: 'Python Software Foundation',
version: '3.14.4',
severity: 'Low',
cves: ['CVE-2026-1148'],
cveCount: 2,
os: [
'Win 11 Enterprise',
'Ubuntu 22.04'
],
osFamily: 'Applications',
description: 'Update Python to 3.14.4 — tarfile path-traversal hardening.',
category: 'Developer',
source: 'Vendor',
rebootRequired: false,
publishDate: '2026-06-03T00:00:00Z',
devicesOk: 864,
devicesBad: 4,
mutedAlerts: 0,
patchable: false
}
		].filter(r => (!req.osFamily || r.osFamily === req.osFamily)
            && (!req.categoriesInclude?.length || req.categoriesInclude.includes(r.category)))
			.map(p => ({hasReversible: true, ...p})),   // Backend now sends hasReversible per patch; default true, rows may override.
		severitiesTotal: {Critical: 10, Medium: 1, Low: 333, Installed: 1699, Complied: 42}
	});

	mockData.patchManagementDashboard = () => {
        // Distinct shapes per scope: Windows climbs with big swings, Linux declines (remediation), macOS is small and spiky, Applications drifts down slowly.
		const seriesDefs = {
			Windows: {base: 320, slope: 7, amp: 110, freq: 3, noise: 40},
			Linux: {base: 260, slope: -5, amp: 70, freq: 5, noise: 25},
			macOS: {base: 45, slope: 2, amp: 30, freq: 2.2, noise: 15},
			Applications: {base: 180, slope: -3, amp: 45, freq: 4, noise: 20}
		};
		const series = (osFamily: keyof typeof seriesDefs) => {
			const {
				base, slope, amp, freq, noise
			} = seriesDefs[osFamily];
			const point = (i: number) => ({
				date: new Date(Date.now() - (29 - i) * MS_DAY).toISOString(),
				deviceCount: Math.max(0, Math.round(base + Math.sin(i / freq) * amp + (i * slope) + (Math.random() - 0.5) * noise))
			});
			return {osFamily, data: makeArr(30).map(point)};
		};
        // Backend emits abbreviated month (e.g. "2026-Jun"); derive from now so the mock never goes stale.
		const monthAbbrs = [
'Jan',
'Feb',
'Mar',
'Apr',
'May',
'Jun',
'Jul',
'Aug',
'Sep',
'Oct',
'Nov',
'Dec'
];
		const releaseMonth = (d: Date) => `${d.getFullYear()}-${monthAbbrs[d.getMonth()]}`;
		const overdueForOver = (...counts: number[]) => [
7,
30,
60,
90,
120
].map((days, i) => ({days, overdueCount: counts[i]}));
		const now = new Date();
		const prevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
		return {
			patchTuesday: {
				releaseMonth: releaseMonth(now),
				mostCritical: {
					kbId: 5060526,
					title: 'Windows Routing and Remote Access Service (RRAS) Remote Code Execution Vulnerability',
					cves: [
'CVE-2026-33064',
'CVE-2026-33065',
'CVE-2026-33066'
],
					cvss: 9.8
				},
				mostRelevant: {kbId: 5060999, title: '2026-06 Cumulative Update for Windows 11 23H2', devicesAffected: 60},
				remediation: {releaseMonth: releaseMonth(prevMonth), percentRemediated: 54, devicesStillExposed: 37, totalDevices: 80}
			},
			insights: [
				{osFamily: 'Windows', data: {deviceExposures: 512, missingPatches: 1840, totalPatchesCount: 1712, overdueForOver: overdueForOver(1690, 1650, 1600, 1541, 1400), highestRisk: {topicCode: 'KB5060526', version: '', cvss: 9.8, devicesAffected: 120}, overdueCount: 37}},
				{osFamily: 'Linux', data: {deviceExposures: 1200, missingPatches: 282, totalPatchesCount: 264, overdueForOver: overdueForOver(190, 141, 88, 46, 12), highestRisk: {topicCode: 'linux-image-6.5.0-28', version: '2.56.4-169.el8_10', cvss: 8.8, devicesAffected: 47}}},
				{osFamily: 'macOS', data: {deviceExposures: 240, missingPatches: 3, totalPatchesCount: 3, overdueForOver: overdueForOver(2, 1, 1, 0, 0)}},
				{osFamily: 'Applications', data: {deviceExposures: 695, missingPatches: 14, totalPatchesCount: 0}}      // App scope has no overdue/highest-risk breakdown from the backend (optional keys omitted, never null).
			],
			unpatchedSeries: [
series('Windows'),
series('Linux'),
series('macOS'),
				// App scope reports a shorter, sharply-declining series; map real counts onto recent days so the mock stays current.
				{
osFamily: 'Applications',
data: [
3289,
3287,
3277,
3272,
3238,
3156,
3141,
2816,
2178,
1316
].map((deviceCount, i, arr) => ({
					date: new Date(Date.now() - (arr.length - 1 - i) * MS_DAY).toISOString(),
					deviceCount
				}))
}
],
			breakdown: [
				{
					osFamily: 'Windows',
					data: [
						{category: 'Security Updates', patchedDevices: 150, unpatchedDevices: 850},  // 15% - red.
						{category: 'Updates', patchedDevices: 270, unpatchedDevices: 630},           // 30% - red.
						{category: '', patchedDevices: 45, unpatchedDevices: 55},                    // 45% - orange.
						{category: 'Definition Updates', patchedDevices: 75, unpatchedDevices: 25},  // 75% - yellow.
						{category: 'Update Rollups', patchedDevices: 95, unpatchedDevices: 5}        // 95% - green.
					]
				},
				{
					osFamily: 'Linux',
					data: [
						{category: '', patchedDevices: 25, unpatchedDevices: 75},                    // 25% - red.
						{category: 'Updates', patchedDevices: 55, unpatchedDevices: 45},             // 55% - orange.
						{category: 'Security Updates', patchedDevices: 85, unpatchedDevices: 15}     // 85% - yellow.
					]
				},
				{
					osFamily: 'macOS',
					data: [
						{category: 'Updates', patchedDevices: 40, unpatchedDevices: 60},             // 40% - orange.
						{category: 'Security Updates', patchedDevices: 88, unpatchedDevices: 12}     // 88% - yellow.
					]
				},
				{
					osFamily: 'Applications',                                                       // Demo-only scope; categories mirror app patch rows.
					data: [
						{category: 'Developer', patchedDevices: 864, unpatchedDevices: 4},              // 99% - green.
						{category: 'Productivity', patchedDevices: 1231, unpatchedDevices: 1},          // 99% - green.
						{category: 'Utilities', patchedDevices: 1010, unpatchedDevices: 0},             // 100% - green.
						{category: 'Multimedia', patchedDevices: 779, unpatchedDevices: 92},            // 89% - yellow.
						{category: 'Remote Desktop Control', patchedDevices: 956, unpatchedDevices: 11} // 98% - green.
					]
				}
			]
		};
	};
	mockData.appControlInfo = () => ({
'description': 'A cross-platform web browser developed by Google, built on the Chromium engine. Provides fast browsing, built-in security features, and support for web standards.',
'license': 'Commercial',
'categories': [
'Application Software',
'Web Browser'
],
'cves': [
'CVE-2025-8580',
'CVE-2025-8432',
'CVE-2025-7569',
'CVE-2025-4586',
'CVE-2025-8862'
]
});
	mockData.appControlCves = () => {
		const severities = [
'High',
'Medium',
'Low'
];

		const data = makeArr(12).map((_, index) => {
			const severity = severities[Math.floor(Math.random() * severities.length)];

			const cvss =
				severity === 'High'
					? +(7 + Math.random() * 3).toFixed(1)     // 7.0–10.0
					: severity === 'Medium'
						? +(4 + Math.random() * 3).toFixed(1) // 4.0–6.9
						: +(Math.random() * 4).toFixed(1);    // 0.0–3.9

			return {
				cve: `CVE-2024-520${index}`,
				severity,
				cvss,
			};
		});

		const severitiesTotal = {High: 0, Medium: 0, Low: 0};

		data.forEach(d => severitiesTotal[d.severity as keyof typeof severitiesTotal]++);

		return {
			rowCount: 1000,
			calcState: 0,
			severitiesTotal,
			data,
		};
	};
	mockData.appControlCvesDetails = (cve?: string) => ([
{cve: 'CVE-2024-5200', publishDate: '2024-05-14T00:00:00Z', description: 'Does not always properly handle symbolic links during extraction.', severity: 'Medium', cvss: 4.3, cvssVector: 'CVSS:3.1/AV:L/AC:L/PR:N/UI:R/S:C/C:N/I:L/A:N', impactScore: 1.4, exploitabilityScore: 1.8, cisakev: false},
{cve: 'CVE-2024-5201', publishDate: '2024-05-21T00:00:00Z', description: 'Improper input validation may allow a crafted request to trigger an unintended state change.', severity: 'Low', cvss: 3.1, cvssVector: 'CVSS:3.1/AV:N/AC:L/PR:L/UI:N/S:U/C:N/I:L/A:N', impactScore: 1.4, exploitabilityScore: 1.6, cisakev: false},
{cve: 'CVE-2024-5202', publishDate: '2024-06-11T00:00:00Z', description: 'A boundary check issue can lead to information exposure in certain configurations.', severity: 'High', cvss: 8.2, cvssVector: 'CVSS:3.1/AV:N/AC:L/PR:N/UI:N/S:U/C:H/I:N/A:N', impactScore: 3.6, exploitabilityScore: 3.9, cisakev: true}
].find(t => cve ? t.cve === cve : true) || mockData.appControlCvesDetails());

	mockData.version_timestamp = () => ({timestamp: 123});

    // deviceInformation is a function; merge the App Control / Vulnerabilities mock into its returned object (RND-10531).
	const baseDeviceInformation = mockData.deviceInformation;

    // Single-device App Control tab (RND-10531): apps split by view; each row mirrors the App Control item minus device-aggregate fields, plus version.
	const deviceApps = [
{
view: 'Applications',
data: [
{
topicCode: '100000001',
installPath: 'C:\\Program Files\\Google\\Chrome\\Application',
installDate: '2023-11-20T09:14:00Z',
product: 'Google Chrome',
vendor: 'Google LLC',
version: '120.0.6099.110',
severity: 'High',
categories: ['Browser'],
cves: [
'CVE-2024-2883',
'CVE-2024-4671',
'CVE-2023-7024'
],
cveCount: 3,
wasNotUsedSince: null
},
{topicCode: '100000002', installPath: 'C:\\Program Files (x86)\\Microsoft\\Edge\\Application', installDate: '2023-12-05T14:32:00Z', product: 'Microsoft Edge', vendor: 'Microsoft Corporation', version: '120.0.2210.91', severity: 'High', categories: ['Browser'], cves: ['CVE-2024-21412'], cveCount: 1, wasNotUsedSince: '2024-03-15'},
{
topicCode: '100000003',
installPath: 'C:\\Program Files (x86)\\Adobe\\Acrobat Reader DC\\Reader',
installDate: '2024-01-15T11:05:00Z',
product: 'Adobe Acrobat Reader',
vendor: 'Adobe Inc.',
version: '23.006.20360',
severity: 'High',
categories: ['PDF Viewer'],
cves: [
'CVE-2024-20745',
'CVE-2024-20740',
'CVE-2024-20738'
],
cveCount: 3,
wasNotUsedSince: null
},
{topicCode: '100000004', installPath: 'C:\\Program Files\\7-Zip', installDate: '2023-09-02T08:20:00Z', product: '7-Zip', vendor: 'Igor Pavlov', version: '23.01', severity: 'Low', categories: ['Compression'], cves: [], cveCount: 0, wasNotUsedSince: '2024-01-10'},
{
topicCode: '100000005',
installPath: 'C:\\Program Files\\VideoLAN\\VLC',
installDate: '2024-02-10T16:45:00Z',
product: 'VLC Media Player',
vendor: 'VideoLAN',
version: '3.0.20',
severity: 'Medium',
categories: ['Media Player'],
cves: [
'CVE-2023-47359',
'CVE-2023-47360'
],
cveCount: 2,
wasNotUsedSince: null
},
{topicCode: '100000006', installPath: 'C:\\Program Files\\Python311', installDate: '2023-10-18T13:00:00Z', product: 'Python 3.11', vendor: 'Python Software Foundation', version: '3.11.7', severity: 'Medium', categories: ['Development'], cves: ['CVE-2023-44487'], cveCount: 1, wasNotUsedSince: null},
{
topicCode: '100000007',
installPath: 'C:\\Program Files\\nodejs',
installDate: '2023-12-22T10:30:00Z',
product: 'Node.js',
vendor: 'OpenJS Foundation',
version: '20.10.0',
severity: 'Low',
categories: [
'Development',
'Runtime'
],
cves: [],
cveCount: 0,
wasNotUsedSince: '2024-04-20'
},
{
topicCode: '100000008',
installPath: 'C:\\Windows\\System32\\OpenSSH',
installDate: '2023-08-14T07:55:00Z',
product: 'OpenSSH',
vendor: 'OpenBSD Project',
version: '9.5p1',
severity: 'Low',
categories: [
'Security',
'Remote Access'
],
cves: [],
cveCount: 0,
wasNotUsedSince: null
}
]
},
{
view: 'System and Drivers',
data: [
{topicCode: '100000101', installPath: 'C:\\Windows\\System32\\DriverStore\\FileRepository\\igdlh64.inf_amd64', installDate: '2024-03-01T12:00:00Z', product: 'Intel Graphics Driver', vendor: 'Intel', version: '31.0.101.4502', severity: 'Medium', categories: ['System and Drivers'], cves: ['CVE-2024-21766'], cveCount: 1, wasNotUsedSince: null},
{
topicCode: '100000102',
installPath: 'C:\\Windows\\System32\\ntoskrnl.exe',
installDate: '2024-04-09T05:10:00Z',
product: 'Windows Kernel',
vendor: 'Microsoft',
version: '10.0.19045',
severity: 'High',
categories: ['System and Drivers'],
cves: [
'CVE-2024-38063',
'CVE-2024-30088'
],
cveCount: 2,
wasNotUsedSince: null
}
]
}
];

    // Single-device Vulnerabilities tab (RND-10531): CVEs split by benchmarkOrg; each row mirrors the CVE item minus device-aggregate fields.
	const deviceVulns = [
{
benchmarkOrg: 'APP_VULN_ASSESSMENT',
data: [
{topicCode: 'CVE-2024-4671', param: 'Google Chrome', product: 'Google Chrome', cvss: 9.6, severity: 'High', cisakev: true, publishDate: '2024-05-09', description: 'Use after free in Visuals in Google Chrome.'},
{topicCode: 'CVE-2024-2883', param: 'Google Chrome', product: 'Google Chrome', cvss: 8.8, severity: 'High', cisakev: false, publishDate: '2024-03-27', description: 'Use after free in ANGLE in Google Chrome.'},
{topicCode: 'CVE-2024-20746', param: 'Adobe Acrobat Reader', product: 'Adobe Acrobat Reader', cvss: 7.8, severity: 'High', cisakev: false, publishDate: '2024-03-19', description: 'Out-of-bounds write in Adobe Acrobat Reader.'},
{topicCode: 'CVE-2024-20745', param: 'Adobe Acrobat Reader', product: 'Adobe Acrobat Reader', cvss: 6.5, severity: 'Medium', cisakev: false, publishDate: '2024-03-19', description: 'Out-of-bounds read in Adobe Acrobat Reader.'},
{topicCode: 'CVE-2023-44487', param: 'Python HTTP Server', product: 'Python HTTP Server', cvss: 5.3, severity: 'Medium', cisakev: true, publishDate: '2023-10-10', description: 'HTTP/2 rapid reset denial of service (Python HTTP Server).'},
{topicCode: 'CVE-2024-3094', param: 'XZ Utils', product: 'XZ Utils', cvss: 4, severity: 'Low', cisakev: false, publishDate: '2024-03-29', description: 'Malicious code in the XZ Utils upstream tarballs.'}
]
},
{
benchmarkOrg: 'PATCH_VULN_ASSESSMENT',
data: [
{topicCode: 'CVE-2024-38063', param: 'Windows 11', product: '', cvss: 9.8, severity: 'High', cisakev: true, publishDate: '2024-08-13', description: 'Windows TCP/IP remote code execution vulnerability.'},
{topicCode: 'CVE-2023-38180', param: 'Windows 11', product: '', cvss: 4.7, severity: 'Low', cisakev: false, publishDate: '2023-08-08', description: '.NET Core and Visual Studio denial of service vulnerability.'}
]
}
];
	// Single-device Patches tab: OS/app patches missing on the device, taken straight from device_information (mirrors the App Control / Vulnerabilities lists).
	const deviceOsPatches = [
{topicCode: 'grub2-tools-extra', title: 'grub2-tools-extra', version: '2.06-94.el9_5', severity: 'Low', cves: [], cveCount: 0, description: ' The GRand Unified Bootloader (GRUB) is a highly configurable and customizable bootloader with modular architecture. This subpackage provides tools for support of all platforms.', category: '', rebootRequired: false, publishDate: '2025-02-20T00:00:00Z', source: 'DNF'},
{topicCode: 'grub2-tools-minimal', title: 'grub2-tools-minimal', version: '2.06-94.el9_5', severity: 'Medium', cves: [], cveCount: 0, description: ' The GRand Unified Bootloader (GRUB) is a highly configurable and customizable bootloader with modular architecture. This subpackage provides tools for support of all platforms.', category: 'Security Updates', rebootRequired: false, publishDate: '2025-02-20T00:00:00Z', source: 'DNF'},
{topicCode: 'grub2-tools-efi', title: 'grub2-tools-efi', version: '2.06-94.el9_5', severity: 'Low', cves: [], cveCount: 0, description: ' The GRand Unified Bootloader (GRUB) is a highly configurable and customizable bootloader with modular architecture. This subpackage provides tools for support of EFI platforms.', category: '', rebootRequired: false, publishDate: '2025-02-20T00:00:00Z', source: 'DNF'},
{
topicCode: 'grub2-tools',
title: 'grub2-tools',
version: '2.06-94.el9_5',
severity: 'Critical',
cves: [
'CVE-2024-1048',
'CVE-2023-4692'
],
cveCount: 2,
description: ' The GRand Unified Bootloader (GRUB) is a highly configurable and customizable bootloader with modular architecture. This subpackage provides tools for support of all platforms.',
category: 'Security Updates',
rebootRequired: true,
publishDate: '2025-02-20T00:00:00Z',
source: 'DNF'
},
{topicCode: 'libldb', title: 'libldb', version: '4.23.5-8.el9_8', severity: 'Low', cves: [], cveCount: 0, description: 'An extensible library that implements an LDAP like API to access remote LDAP servers, or use local tdb databases.', category: '', rebootRequired: false, publishDate: '2026-04-21T00:00:00Z', source: 'DNF'}
	];

	// Only augment when a base deviceInformation mock exists (dev builds); on demo-only builds there's no base, so leave it unset rather than serving a deviceInfo-less object.
	if (baseDeviceInformation)
		mockData.deviceInformation = (...args) => ({...baseDeviceInformation(...args), deviceApps, deviceVulns, deviceOsPatches});

	const clientUpdateBatches = mockData.mochClientUpdateBatch().data;
	mockData.mochClientUpdateBatch = () => ({data: [...clientUpdateBatches]});      // fresh array each fetch.

	mockData.healthClientAdd = async (rule) => {
		await new Promise(resolve => setTimeout(resolve, 1000));
		const existing = clientUpdateBatches.find(batch => batch.ruleId === rule.ruleId);
		// Naming the row up front keeps the returned ruleId off `clientUpdateBatches.at(-1)`, which is possibly-undefined under strict TS.
		const batch: ClientUpdateListResponseItem = existing ?? {
			afterTime: 0,
applyScheme: 'asap',
channel: 'stable',
groupId: 0,
isEnabled: true,
			ruleName: null,
timezone: 0,
weekDay: null,
window: 0,
			...rule,
			ruleId: rule.ruleId || (Math.random() * 1e4 | 0),
			log: [{byUser: 'you@acme.com', date: new Date().toISOString(), operation: 'create'}],
			groupName: rule.groupName ?? null,
			isGroupDeleted: false,
			numComputers: Math.random() * 500 | 0,
			numToUpdate: 0,
		};
		if (existing)
			Object.assign(existing, rule);
		else
			clientUpdateBatches.push(batch);
		return {result: 'success', ruleId: batch.ruleId};
	};
}

if (isTalDemo || import.meta.env.VITE_ENV === 'dev') {
	mockData.altAchvs =() => ({'activeDevices': {'devicesNum': 0, 'remediationsNum': 0, 'estimatedTimeSaved': 0, 'estimatedDollarsSaved': 0}, 'inactiveDevices': {'devicesNum': 2, 'remediationsNum': 3, 'estimatedTimeSaved': 6, 'estimatedDollarsSaved': 6}, lastRemTime: '2025-06-06T13:13:29.166799Z', 'potentialTimeSaved': 0, 'potentialDollarsSaved': 0, 'calcState': 0, 'cacheTime': '2024-11-04T15:32:40.5468738+00:00'});

	mockData.mochActionResult = (i, req = {}) => {
 const from = req.from ?? 0, id = from + i; const statuses = [
'success',
'pending-reboot',
'success',
'pending',
'failed',
'success',
'pending-reboot'
]; const status = statuses[id % statuses.length]; const done = status !== 'pending'; return {
taskId: id,
deviceId: id,
deviceGuid: `guid-${id}`,
device: `DC-${String(id + 1).padStart(3, '0')}`,
param: null,
status,
result: status === 'failed' ? 'Installation failed (0x800f0922).' : status === 'pending-reboot' ? 'Installed \u2014 awaiting device restart to complete.' : null,
isRevertable: status === 'success' || status === 'pending-reboot',
initiatedTime: '2026-07-18T09:30:00Z',
resultTime: done ? '2026-07-18T10:12:00Z' : null,
os: 'Win Server 2019 Datacenter',
domain: 'a.bc.com',
computerOu: 'Domain Controllers',
clientVer: '2.37.7.0',
scanTime: '2026-07-18T11:00:00Z',
hwInfo: {HW_CPU: '4 x Intel(R) Xeon(R)', HW_Model: 'Virtual Machine', HW_RAM: '8'},
log: [
{byUser: {user: 'miki.h@remedio.io', userName: 'Miki H'}, date: '2026-07-18T09:30:00Z', operation: 'create'},
...(done ? [{byUser: {user: 'miki.h@remedio.io', userName: 'Miki H'}, date: '2026-07-18T10:12:00Z', operation: status === 'failed' ? 'remediation-failed' : status === 'pending-reboot' ? 'remediation-pending-reboot' : 'remediation-success'}] : [])
]
};
};

	mockData.mochRemediationCis = (rsp: {data: unknown[], rowCount: number}) => ({
data: [
...[
{'ruleId': 109, 'state': 'active', 'actionType': 'remediate', 'actionDatum': null, 'errorString': null, 'errorDate': null, 'remark': null, 'latestActivity': '2024-07-18T09:31:37.480618Z', 'taskStatusCounts': {'pending': 23, 'success': 1936, 'reverting': 0, 'reverted': 0, 'cancelled': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0}, 'user': 'george@man', 'applyScheme': 'asap', 'afterTime': 0, 'timezone': 180, 'weekDay': 'Sunday', 'window': 0, 'criteria': {'actionType': 'remediate', 'actionDatum': null, 'by': 'devices', 'topicCode': 'L1_Ensure_Enable_Structured_Exception_Handling_Overwrite_Protection_SEHOP_is_set_to_Enabled', 'selTarget': null, 'deviceId': 0, 'param': null, 'paramExtra': null, 'isExactParam': false, 'benchmarkOrg': 'CIS', 'benchmarkVer': null, 'benchmarkProfiles': ['xccdf_org.cisecurity.benchmarks_profile_Level_1_L1_-_CorporateEnterprise_Environment_general_use'], 'listParamExtra': null, 'severities': null, 'groupId': 0, 'domain': null, 'os': null, 'computerOu': null, 'device': null, 'ip': null, 'clientVer': null, 'isListExclude': false, 'list': [], 'listIds': [], 'socket': null, 'recalc': 0, 'from': 0, 'len': 0, 'exportName': null}, 'approvalRequestId': null, 'approvalRequestIdExtra': null},
{'ruleId': 163, 'state': 'active', 'actionType': 'remediate', 'actionDatum': null, 'errorString': null, 'errorDate': null, 'remark': null, 'latestActivity': '2024-07-18T08:56:26.887825Z', 'taskStatusCounts': {'pending': 23, 'success': 1936, 'reverting': 0, 'reverted': 0, 'cancelled': 0, 'failed': 0, 'revertFailed': 0, 'revertCancelled': 0}, 'user': 'george@man', 'applyScheme': 'asap', 'afterTime': 0, 'timezone': 180, 'weekDay': 'Sunday', 'window': 0, 'criteria': {'actionType': 'remediate', 'actionDatum': null, 'by': 'devices', 'topicCode': 'L1_Ensure_Notify_antivirus_programs_when_opening_attachments_is_set_to_Enabled', 'selTarget': null, 'deviceId': 0, 'param': null, 'paramExtra': null, 'isExactParam': false, 'benchmarkOrg': 'CIS', 'benchmarkVer': null, 'benchmarkProfiles': ['xccdf_org.cisecurity.benchmarks_profile_Level_1_L1_-_CorporateEnterprise_Environment_general_use'], 'listParamExtra': null, 'severities': null, 'groupId': 0, 'domain': null, 'os': null, 'computerOu': null, 'device': null, 'ip': null, 'clientVer': null, 'isListExclude': false, 'list': [], 'listIds': [], 'socket': null, 'recalc': 0, 'from': 0, 'len': 0, 'exportName': null}, 'approvalRequestId': null, 'approvalRequestIdExtra': null}
],
...rsp.data.slice(2)
],
rowCount: rsp.rowCount
});
}
